// Translation files for the application
export const translations = {
  el: {
    // Header
    appTitle: 'Radio Solutions On Air',
    home: 'Αρχική',
    aboutUs: 'Σχετικά',
    logout: 'Έξοδος',
    generate: 'Δημιουργία',
    renewSubscription: 'Ανανέωση Συνδρομής',
    waiting: 'Αναμονή',
    contentCreationInProgress: 'Δημιουργία Περιεχομένου σε εξέλιξη...',
    pleaseWaitDontClose: 'Παρακαλώ περιμένετε. Μην κλείσετε την εφαρμογή.',
    
    // About Page
    radioSolutionsApps: 'Radio Solutions Apps',
    forRadioProfessionals: 'Για Ιδιοκτήτες, Διευθυντές, Παραγωγούς, Playlisters & Ομάδες Πωλήσεων',
    dataYouNeed: 'Τα Δεδομένα που Χρειάζεστε, τα Εργαλεία που Αξίζετε',
    analyticsContentCharts: 'Analytics, Content & Charts για τον σύγχρονο ραδιοφωνικό σταθμό.',
    radioFinallyMeasured: 'Radio finally measured.',
    goToHome: 'Πάμε στην Αρχική',
    goToApp: 'Μετάβαση',
    contactUs: 'Επικοινωνήστε μαζί μας',
    ourTools: 'Τα Εργαλεία μας',
    toolsSuiteDescription: 'Μια ολοκληρωμένη σουίτα εργαλείων σχεδιασμένη αποκλειστικά για ραδιοφωνικούς σταθμούς',
    timeSaving: 'Εξοικονόμηση Χρόνου',
    timeSavingDesc: 'Αυτοματοποιήστε την παραγωγή περιεχομένου και εστιάστε στο on-air κομμάτι.',
    professionalResults: 'Επαγγελματικά Αποτελέσματα',
    professionalResultsDesc: 'Περιεχόμενο υψηλής ποιότητας έτοιμο για άμεση χρήση στον αέρα.',
    reliableData: 'Αξιόπιστα Δεδομένα',
    reliableDataDesc: 'Ενημερωμένα charts και στατιστικά από αξιόπιστες πηγές.',
    readyToStart: 'Έτοιμοι να ξεκινήσετε;',
    signUpToday: 'Εγγραφείτε σήμερα και αποκτήστε πρόσβαση σε όλα τα εργαλεία μας',
    viewPackages: 'Δείτε τα Πακέτα',
    freeTrial: 'Δωρεάν Δοκιμή',
    onAirContent: 'Έτοιμο On Air Περιεχόμενο',
    songInfo: 'Πληροφορίες Τραγουδιών',
    dailyContent: 'Ημερήσιο Περιεχόμενο',
    onAirContentDesc: 'Έτοιμο περιεχόμενο για ραδιοφωνικές εκπομπές. Ζώδια, καιρός, trends, αστείες ειδήσεις και πολλά άλλα.',
    
    // About Page - Demo Section
    toolsForRadio: 'Τα εργαλεία για το ραδιόφωνο,',
    withoutHeadache: 'χωρίς πονοκέφαλο',
    suiteForProfessionals: 'Η σουίτα απευθύνεται σε επαγγελματίες του ραδιοφώνου.',
    normalIfDifficult: 'Αν στην αρχή σου φαίνεται λίγο δύσκολη, είναι απολύτως φυσιολογικό 😉',
    freeDemo: 'δωρεάν περιήγηση',
    freeDemoText: 'Γι\' αυτό προσφέρουμε {freeDemo} για να σου δείξουμε απλά και πρακτικά πώς μπορείς να χρησιμοποιήσεις τα tools στην καθημερινότητά σου.',
    wantDemo: 'Θέλω demo',
    noTechKnowledge: 'Δεν χρειάζονται τεχνικές γνώσεις. Σου τα δείχνουμε όλα βήμα-βήμα.',
    seeToolsInAction: 'Δες τα Εργαλεία σε Δράση',
    allInOneTool: 'Analytics, Daypart Analysis, Playlist Decisions - όλα σε ένα εργαλείο',
    
    // Email Popup
    popupTitle: 'Θέλεις να βελτιώσεις πραγματικά τον ραδιοφωνικό σου σταθμό;',
    popupPlatformOffers: 'Τι προσφέρει η πλατφόρμα:',
    popupOnAirContent: 'Έτοιμο περιεχόμενο για εκπομπές',
    popupSongFinder: 'Βρες πληροφορίες για κάθε τραγούδι',
    popupTopCharts: 'Τα δημοφιλέστερα τραγούδια στο ελληνικό ραδιόφωνο',
    popupPlaylistAnalyzer: 'Ανάλυση playlist ανά ώρα και ημέρα',
    popupSongsAnalyzer: 'Μάθε ποια τραγούδια κρατούν τους ακροατές',
    popupCalculators: 'Υπολογισμός καμπανιών & ακροατών',
    popupEmailPlaceholder: 'Το email σου...',
    popupSubmitting: 'Αποστολή...',
    popupSubmitButton: 'Θέλω να μάθω περισσότερα',
    popupBottomTagline: 'Θα λάβεις άμεσα πληροφορίες για το πώς μπορείς να βελτιώσεις τον σταθμό σου.',
    popupSuccessTitle: 'Ευχαριστούμε!',
    popupSuccessMessage: 'Θα λάβεις σύντομα περισσότερες πληροφορίες.',
    continueWithoutSignup: 'Συνέχεια χωρίς εγγραφή',
    
    // Tool Subtitles
    campaignMetricsSubtitle: 'Μετρητής Καμπάνιας',
    audienceMetricsSubtitle: 'Μετρητής Ακροατών',
    airplayChartsSubtitle: 'Charts Ελληνικού Ραδιοφώνου',
    playlistAnalysisSubtitle: 'Ανάλυση Playlist',
    daypartAnalysisSubtitle: 'Ανάλυση ανά Ζώνη',
    ourStationsSubtitle: 'Οι Σταθμοί μας',
    
    // Tool Descriptions
    campaignAnalyzerDesc: 'Υπολογίστε την αποτελεσματικότητα των διαφημιστικών σας καμπανιών. Αναλύστε την απήχηση, το reach και τα αναμενόμενα αποτελέσματα με βάση επιστημονικά δεδομένα.',
    listenerCalculatorDesc: 'Εκτιμήστε τον αριθμό των ακροατών σας με βάση διάφορες παραμέτρους. Ιδανικό για μέτρηση ακροαματικότητας και αναφορές σε διαφημιζόμενους.',
    radioTopSongsDesc: 'Τα Top 1000 τραγούδια από το ελληνικό ραδιόφωνο. Ενημερωμένα δεδομένα με ελληνικά και διεθνή hits, παίξιμο ανά εβδομάδα και trend analysis.',
    playlistAnalyzerDesc: 'Αναλύστε το playlist του σταθμού σας. Ανεβάστε CSV αρχεία και δείτε στατιστικά για τα τραγούδια, τους καλλιτέχνες και τη διάρκεια.',
    daypartAnalyzerDesc: 'Προηγμένη ανάλυση Playlist ανά ωριαία ζώνη. Δείτε ποια τραγούδια ταιριάζουν καλύτερα σε κάθε ώρα της ημέρας.',
    daypartAnalyzerTitle: 'Playlist Daypart Analyzer',
    daypartAnalysisSubtitle: 'Ανάλυση Playlist ανά Ζώνη',
    daypartFeature1: 'Ανάλυση Playlist ανά ώρα',
    daypartFeature2: 'Βαθμολόγηση τραγουδιών',
    daypartFeature3: 'PDF αναφορές',
    ourStationsDesc: 'Demo stations με διάφορα music formats για δημιουργία playlists σε ραδιοφωνικούς σταθμούς και In-Store επιχειρήσεις.',
    
    // Navigation Menu Labels
    navInfo: 'Πληροφορίες',
    navOnAirContent: 'On Air Κείμενα',
    navSongFinder: 'Song Finder',
    navCampaignCalculator: 'Campaign Calculator',
    navListenersCalculator: 'Listeners Calculator',
    navTopRadioCharts: 'Top Radio Charts',
    navStations: 'Σταθμοί',
    navPlaylistAnalyzer: 'Playlist Analyzer',
    navDaypartAnalyzer: 'Playlist Daypart Analyzer',
    navSongsAnalyzer: 'Songs Analyzer',
    navSongsAnalyzerPro: 'Songs Analyzer PRO',
    navContact: 'Επικοινωνία',
    navAdmin: 'Διαχείριση',
    navPackets: 'Πακέτα',
    navServices: 'Υπηρεσίες',
    readMore: 'Διαβάστε Περισσότερα',

    // ── Top Artists Chart (Phase B, 2026-02-24) ─────────────
    topArtistsTitle: 'Top Artists',
    topArtistsSubtitle: 'Οι πιο παιγμένοι καλλιτέχνες στα ελληνικά ραδιόφωνα.',
    topArtistsScopeGreece: 'Ελλάδα',
    topArtistsScopeGlobal: 'Global',
    topArtistsRangeWeekly: 'Τελευταίες 7 ημέρες',
    topArtistsRangeLastWeek: 'Προηγούμενη εβδομάδα',
    topArtistsRangeThisMonth: 'Αυτόν τον μήνα',
    topArtistsRangeLastMonth: 'Προηγούμενος μήνας',
    topArtistsRange3m: '3 μήνες',
    topArtistsRange6m: '6 μήνες',
    topArtistsRange12m: '12 μήνες',
    topArtistsSearchPlaceholder: 'Αναζήτηση καλλιτέχνη…',
    topArtistsExcel: 'Excel',
    topArtistsExcelDone: 'Το Excel κατέβηκε',
    topArtistsExcelFailed: 'Αποτυχία εξαγωγής Excel',
    topArtistsColArtist: 'Καλλιτέχνης',
    topArtistsColPlays: 'Plays',
    topArtistsColStations: 'Σταθμοί',
    topArtistsCountLabel: 'καλλιτέχνες',
    topArtistsEmpty: 'Δεν βρέθηκαν καλλιτέχνες για την περίοδο αυτή.',
    topArtistsApiError: 'Πρόβλημα σύνδεσης',
    topArtistsRetry: 'Δοκιμάστε ξανά',
    topArtistsTrendLoading: 'Φόρτωση ιστορικού…',
    topArtistsTrendHistory: 'Ιστορικό plays',
    topArtistsMovement: 'Movement',
    topArtistsMovement7d: '7d vs προηγούμενα 7d',
    topArtistsRecent7d: 'Πρόσφατα 7d',
    topArtistsPrevious7d: 'Προηγ. 7d',
    topArtistsInsufficientData: 'Ανεπαρκή δεδομένα',
    topArtistsTopSong: 'Top τραγούδι',
    topArtistsNoTopSong: 'Δεν βρέθηκε top τραγούδι για την περίοδο',
    topArtistsSeeAlsoPeoples: "Δείτε επίσης: The People's Chart →",
    topArtistsSeoDescription: 'Οι κορυφαίοι καλλιτέχνες στα ελληνικά ραδιόφωνα — real-time airplay data.',

    // ── Services Page (v2.10.2 / 2026-06-15) ─────────────────────
    servicesTitle: 'Υπηρεσίες',
    servicesEyebrow: 'Υπηρεσίες · Services',
    servicesHeroTitle: 'Music Scheduling & Log Optimization',
    servicesHeroDesc: 'Πέρα από τα εργαλεία μας, παρέχουμε εξειδικευμένες υπηρεσίες που βοηθούν τους ραδιοφωνικούς σταθμούς να αυξήσουν την ακροαματικότητα, να βελτιώσουν το πρόγραμμά τους και να ενισχύσουν τα έσοδά τους.',
    servicesCtaFreeEval: 'Ζητήστε Δωρεάν Αξιολόγηση',
    servicesPreviewDesc: 'Πέρα από τα εργαλεία μας, παρέχουμε εξειδικευμένες υπηρεσίες που βοηθούν τους ραδιοφωνικούς σταθμούς να αυξήσουν την ακροαματικότητα, να βελτιώσουν το πρόγραμμά τους και να ενισχύσουν τα έσοδά τους.',
    servicesOurServices: 'Οι Υπηρεσίες μας',
    servicesOurServicesSub: 'Επαγγελματική τεχνογνωσία από έμπειρους συνεργάτες του ραδιοφωνικού χώρου',
    svcIncludes: 'Περιλαμβάνει:',
    svcLearnMore: 'Μάθετε Περισσότερα',
    svc1Title: 'Music Programming & Format Consulting',
    svc1Desc: 'Βελτιστοποίηση μουσικού προγράμματος με βάση το format, τον ανταγωνισμό και τις προτιμήσεις του κοινού της περιοχής σας.',
    svc1Bullet1: 'Ανάλυση format',
    svc1Bullet2: 'Μουσική στρατηγική',
    svc1Bullet3: 'Διαχείριση rotations',
    svc1Bullet4: 'Competitive analysis',
    svc1Bullet5: 'Δημιουργία μουσικών clocks',
    svc1Bullet6: 'Βελτιστοποίηση rotations',
    svc1Bullet7: 'Category management',
    svc1Bullet8: 'Daypart scheduling',
    svc1Bullet9: 'Weekly music review',
    svc2Title: 'Audience & Market Analysis',
    svc2Desc: 'Αναλύουμε την αγορά και τις μουσικές τάσεις ώστε ο σταθμός να λαμβάνει καλύτερες αποφάσεις.',
    svc2Bullet1: 'Ανάλυση ανταγωνισμού',
    svc2Bullet2: 'Monitoring μουσικών τάσεων',
    svc2Bullet3: 'Αναφορές νέων κυκλοφοριών',
    svc2Bullet4: 'Στρατηγικές διαφοροποίησης',
    svc3Title: 'Radio Station Growth Consulting',
    svc3Desc: 'Συμβουλευτική ανάπτυξης για αύξηση ακροαματικότητας, εμπορικής αξίας και αναγνωρισιμότητας.',
    svc3Bullet1: 'Branding σταθμού',
    svc3Bullet2: 'Positioning',
    svc3Bullet3: 'Διαγωνισμοί και promotions',
    svc3Bullet4: 'Social media strategy',
    svc3Bullet5: 'Listener engagement',
    svc4Title: 'Ongoing Programming Support',
    svc4Desc: 'Συνεχής συνεργασία και υποστήριξη για σταθμούς που θέλουν εξωτερικό συνεργάτη προγραμματισμού.',
    svc4Bullet1: 'Εβδομαδιαία επικοινωνία',
    svc4Bullet2: 'Αξιολόγηση μουσικού προγράμματος',
    svc4Bullet3: 'Προτάσεις βελτίωσης',
    svc4Bullet4: 'Υποστήριξη παραγωγών',
    svc4Bullet5: 'Παρακολούθηση αποτελεσμάτων',
    servicesOurProcess: 'Η Διαδικασία μας',
    servicesOurProcessSub: 'Πώς προσφέρουμε τις υπηρεσίες μας για να ενισχύσουμε τον ήχο του σταθμού σας',
    svcProcessStep1Title: 'Ανακάλυψη',
    svcProcessStep1Desc: 'Ξεκινάμε κατανοώντας το format, το κοινό και τους στόχους σας μέσα από αναλυτική συζήτηση.',
    svcProcessStep2Title: 'Στρατηγική',
    svcProcessStep2Desc: 'Σχεδιάζουμε εξατομικευμένη στρατηγική προγραμματισμού προσαρμοσμένη στις ανάγκες σας.',
    svcProcessStep3Title: 'Υλοποίηση',
    svcProcessStep3Desc: 'Εφαρμόζουμε τη στρατηγική, βελτιστοποιώντας logs, βιβλιοθήκη και clocks για μέγιστη απόδοση.',
    svcProcessStep4Title: 'Βελτίωση',
    svcProcessStep4Desc: 'Συνεχής ανατροφοδότηση και προσαρμογή ώστε ο ήχος του σταθμού να μένει πάντα βελτιστοποιημένος.',
    svcBenefitsTitle: 'Τα οφέλη για τον σταθμό σας',
    svcBenefitsSub: 'Συγκεκριμένα αποτελέσματα που θα δείτε μετά τη συνεργασία μαζί μας',
    svcBenefit1: 'Μεγαλύτερη ακροαματικότητα',
    svcBenefit2: 'Περισσότερος χρόνος παραμονής των ακροατών στη συχνότητα',
    svcBenefit3: 'Αύξηση διαφημιστικής αξίας και εσόδων',
    svcBenefit4: 'Μουσική που κρατά το κοινό συντονισμένο',
    svcBenefit5: 'Λιγότερες αποχωρήσεις ακροατών λόγω κουραστικών επιλογών',
    svcBenefit6: 'Καλύτερες αποφάσεις μέσα από δεδομένα και αναλύσεις',
    svcBenefit7: 'Ξεκάθαρη διαφοροποίηση από τον ανταγωνισμό',
    svcBenefit8: 'Συνεχής βελτίωση του μουσικού προγράμματος',
    svcCtaEyebrow: 'Έτοιμοι να βελτιώσετε τον σταθμό σας;',
    svcCtaTitle: 'Θέλετε να βελτιώσετε το πρόγραμμα του σταθμού σας;',
    svcCtaDesc: 'Συζητήστε μαζί μας και θα αξιολογήσουμε δωρεάν το format, τη μουσική στρατηγική και τις δυνατότητες ανάπτυξης του σταθμού σας.',

    // Services Results / Case Study (animated counters)
    svcResultsEyebrow: 'Αποτελέσματα · Case Studies',
    svcResultsTitle: 'Μετρήσιμα αποτελέσματα για τους σταθμούς-πελάτες μας',
    svcResultsSub: 'Μέσοι όροι βελτίωσης μετά από 3-6 μήνες συνεργασίας με την ομάδα μας',
    svcResultMetric1: 'Αύξηση TSL (Time Spent Listening)',
    svcResultMetric2: 'Αύξηση ακροαματικότητας',
    svcResultMetric3: 'Μείωση early drop',
    svcResultMetric4: 'Σταθμοί που μας εμπιστεύονται',
    svcResultsDisclaimer: 'Αποτελέσματα βασισμένα σε αναλύσεις δεδομένων ακρόασης σταθμών που χρησιμοποιούν τις υπηρεσίες μας. Τα στοιχεία μπορεί να διαφέρουν ανάλογα με το format και την αγορά.',
    svcTestimonialQuote: '«Η συνεργασία με τη Radio Solutions ανέβασε σημαντικά το TSL του σταθμού μας και μας έδωσε καθαρή εικόνα για το ποια τραγούδια λειτουργούν πραγματικά με το κοινό μας.»',
    svcTestimonialAuthor: 'Πρόγραμμα Director',
    svcTestimonialStation: 'Συνεργαζόμενος ραδιοφωνικός σταθμός',
    
    // Tool Features
    campaignFeature1: 'Υπολογισμός ROI',
    campaignFeature2: 'Ανάλυση εμβέλειας',
    campaignFeature3: 'Προβλέψεις απόδοσης',
    listenerFeature1: 'Ακριβείς εκτιμήσεις',
    listenerFeature2: 'Αναλυτικές αναφορές',
    listenerFeature3: 'Σύγκριση περιόδων',
    radioSongsFeature1: 'Ελληνικά & Διεθνή',
    radioSongsFeature2: 'Εβδομαδιαία ενημέρωση',
    radioSongsFeature3: 'Ιστορικά δεδομένα',
    playlistFeature1: 'Εισαγωγή CSV',
    playlistFeature2: 'Αναλυτικά στατιστικά',
    playlistFeature3: 'Εξαγωγή αναφορών',
    daypartFeature1: 'Ωριαία ανάλυση',
    daypartFeature2: 'Σύστημα βαθμολόγησης',
    daypartFeature3: 'Αναφορές PDF',
    stationsFeature1: 'Ποικιλία Music Formats',
    stationsFeature2: 'Radio & In-Store Playlists',
    stationsFeature3: 'Demo Ακρόαση',
    onAirFeature1: '40+ θεματικές ενότητες',
    onAirFeature2: 'Καθημερινή ενημέρωση',
    onAirFeature3: 'Άμεση χρήση on air',
    
    // On Air Content Page
    onAirPageTitle: 'Έτοιμο Περιεχόμενο για το Ραδιόφωνο',
    onAirPageSubtitle: 'Κάντε κλικ σε μια κατηγορία για να δείτε τις ενότητες',
    translatedContent: 'Μεταφρασμένο περιεχόμενο διαθέσιμο',
    originalContent: 'Εμφάνιση αρχικού περιεχομένου',
    sectionsAvailable: 'ενότητες διαθέσιμες',
    sections: 'Ενότητες',
    updates: 'Ενημερώσεις',
    ready: 'Έτοιμο',
    refresh: 'Ανανέωση',
    loadingContent: 'Φόρτωση περιεχομένου...',
    
    // Categories
    zodiacLifestyle: 'Ζώδια & Lifestyle',
    zodiacLifestyleDesc: 'Ζώδια της ημέρας, Sex & Relationships, Υγεία & Ευεξία, Οικονομικά tips',
    newsTrends: 'Ειδήσεις & Trends',
    newsTrendsDesc: 'Weird News, Good News, Sports News, Daily Trends, Καιρός, Research Says',
    entertainmentGames: 'Διασκέδαση & Παιχνίδια',
    entertainmentGamesDesc: 'Ραδιοφωνικά contests, Παιχνίδια λέξεων, Debates, Αλήθεια ή Μύθος',
    musicCharts: 'Μουσική & Charts',
    musicChartsDesc: 'Apple Music Greece, YouTube Trending, Σαν Σήμερα στη Μουσική',
    
    // Common
    loading: 'Φόρτωση...',
    save: 'Αποθήκευση',
    cancel: 'Ακύρωση',
    close: 'Κλείσιμο',
    submit: 'Υποβολή',
    download: 'Λήψη',
    upload: 'Ανέβασμα',
    search: 'Αναζήτηση',
    filter: 'Φίλτρο',
    all: 'Όλα',
    yes: 'Ναι',
    no: 'Όχι',
    back: 'Επιστροφή',
    next: 'Επόμενο',
    previous: 'Προηγούμενο',
    admin: 'Διαχειριστής',
    
    // Access Loading States
    accessLoading: 'Φόρτωση δικαιωμάτων πρόσβασης... Παρακαλώ περιμένετε.',
    accessSlow: 'Η σύνδεση καθυστερεί λίγο... Προσπαθούμε ξανά. Συνήθως χρειάζεται μέχρι 10 δευτερόλεπτα.',
    accessRetrying: 'Επανάληψη σύνδεσης (προσπάθεια {count}/3)...',
    accessUsingCache: 'Αργή σύνδεση. Χρησιμοποιούμε προσωρινά αποθηκευμένα δεδομένα.',
    accessError: 'Δεν ήταν δυνατή η σύνδεση. Παρακαλώ ανανεώστε τη σελίδα.',
    
    // Welcome Popup
    welcomeTitle: 'Καλώς ήρθατε!',
    welcomeSubtitle: 'Κάνε κάθε εκπομπή σου must listen!',
    alreadyHaveAccount: 'Έχω ήδη λογαριασμό - Σύνδεση',
    loginHere: 'Σύνδεση εδώ',
    justWantToTry: 'Θέλετε μόνο να δοκιμάσετε;',
    freeTrial24h: '48ωρη Δωρεάν Δοκιμή',
    createAccountFirst: 'Δημιουργήστε λογαριασμό για να αγοράσετε πακέτο',
    startFreeTrial: 'Είσοδος / Εγγραφή',
    dontLookLikeOthers: 'Μην μοιάζετε με όλους τους άλλους',
    becomeReferenceStation: 'Γίνετε ο σταθμός αναφοράς',
    makeEveryBroadcast: 'Κάνε κάθε εκπομπή σου',
    mustListen: 'must listen',
    tryFor24Hours: 'Δοκίμασέ το για 48 ώρες',
    clickAnywhereToClose: 'Πατήστε οπουδήποτε έξω ή ESC για να κλείσετε',
    measureOptimizePerform: 'Μέτρηση. Βελτιστοποίηση. Απόδοση.',
    welcomeDescription: 'Η πρώτη εφαρμογή που μετατρέπει το ραδιόφωνο σε μετρήσιμο media channel: campaign performance, audience data, playlist intelligence και daily on-air content.',
    radioFinallyMeasured: 'Επιτέλους μετρήσιμο ραδιόφωνο.',
    
    // Login
    login: 'Σύνδεση',
    username: 'Όνομα χρήστη',
    password: 'Κωδικός',
    forgotPassword: 'Ξέχασα τον κωδικό μου',
    loginError: 'Σφάλμα σύνδεσης',
    serverStarting: 'Ο server ξεκινάει... Παρακαλώ περιμένετε 10 δευτερόλεπτα και δοκιμάστε ξανά.',
    serverStartingPleaseWait: '⏳ Ο server ξεκινάει... Παρακαλώ περιμένετε 10 δευτερόλεπτα και δοκιμάστε ξανά.',
    rememberMe: 'Να με θυμάσαι',
    twoFactorAuth: 'Επαλήθευση 2FA',
    enterOTP: 'Εισάγετε τον κωδικό 2FA',
    verify: 'Επαλήθευση',
    invalid2FA: 'Μη έγκυρος κωδικός 2FA',
    invalid2FACode: 'Μη έγκυρος κωδικός 2FA',
    verificationError: 'Σφάλμα επαλήθευσης',
    or: 'ή',
    continueWithGoogle: 'Συνέχεια με Google',
    week: 'Εβδομάδα',
    noWeeksForMonth: 'Δεν υπάρχουν διαθέσιμες εβδομάδες για {{month}}',
    noWeeksForYear: 'Δεν υπάρχουν διαθέσιμες εβδομάδες για το έτος {{year}}',
    chartsSavedWeekly: 'Τα charts αποθηκεύονται κάθε εβδομάδα',
    
    // Canonical Conflict Resolver
    loadConflictsError: 'Σφάλμα κατά τη φόρτωση conflicts',
    errorGeneric: 'Σφάλμα',
    resolveError: 'Σφάλμα επίλυσης',
    overrideError: 'Σφάλμα override',
    previewError: 'Σφάλμα preview',
    autoResolveError: 'Σφάλμα auto-resolve',
    cleanupPreviewError: 'Σφάλμα cleanup preview',
    cleanupError: 'Σφάλμα cleanup',
    repairPreviewError: 'Σφάλμα repair preview',
    repairError: 'Σφάλμα repair',
    refreshPreviewError: 'Σφάλμα refresh preview',
    refreshError: 'Σφάλμα refresh',
    loadingConflicts: 'Φόρτωση conflicts...',
    searchingUserDb: 'Αναζήτηση στο User DB...',
    conflictDescription: 'μέχρι να επιλυθούν χειροκίνητα. Επιλέξτε το canonical entry με τα περισσότερα plays ή το πιο σωστό',
    
    // Trial Signup
    trialAccount: 'Δοκιμαστικός Λογαριασμός',
    trialAccountDesc: '48ωρη δωρεάν πρόσβαση σε όλες τις λειτουργίες',
    accountAccess: 'Είσοδος / Εγγραφή',
    newUserTrialDesc: 'Νέος χρήστης; Δημιούργησε λογαριασμό με 48ωρη δωρεάν πρόσβαση!',
    email: 'Email',
    confirmPassword: 'Επιβεβαίωση Κωδικού',
    chooseUsername: 'Επιλέξτε username',
    minChars: 'Τουλάχιστον 6 χαρακτήρες',
    repeatPassword: 'Επαναλάβετε τον κωδικό',
    createTrialAccount: 'Δημιουργία Δοκιμαστικού Λογαριασμού',
    creatingAccount: 'Δημιουργία...',
    allFieldsRequired: 'Όλα τα πεδία είναι υποχρεωτικά',
    passwordsDontMatch: 'Οι κωδικοί δεν ταιριάζουν',
    passwordTooShort: 'Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες',
    trialCreatedSuccess: 'Ο δοκιμαστικός λογαριασμός δημιουργήθηκε επιτυχώς!',
    trialExpiresIn: 'Η δοκιμή λήγει σε 48 ώρες',
    saveCredentials: 'Αποθηκεύστε τα στοιχεία σας:',
    
    // Signup Form
    createYourAccount: 'Δημιουργήστε τον λογαριασμό σας',
    createAccount: 'Δημιουργία Λογαριασμού',
    musicFormat: 'Μουσικό Format',
    stationName: 'Ονομασία Σταθμού',
    stationNamePlaceholder: 'π.χ. Radio Athens',
    frequency: 'Συχνότητα',
    frequencyPlaceholder: 'π.χ. 95.5 FM',
    region: 'Περιοχή',
    selectRegion: 'Επιλέξτε περιοχή',
    acceptTerms: 'Αποδέχομαι τους όρους χρήσης',
    alreadyHaveAccountQuestion: 'Έχετε ήδη λογαριασμό;',
    trialPeriod24h: 'Δοκιμαστική Περίοδος 24 Ωρών',
    freeAccessFor24h: 'Δωρεάν πρόσβαση για 48 ώρες μετά την εγγραφή!',
    fullAccessAllFeatures: 'Πλήρης πρόσβαση σε όλα τα features',
    noCreditCardForTrial: 'Χωρίς πιστωτική κάρτα για το trial',
    noAutoCharge: 'Δεν υπάρχει αυτόματη χρέωση',
    afterTrialExpires: 'Μετά τη λήξη της δοκιμής',
    afterTrialInfo: 'Μετά τις 48 ώρες, επιλέξτε ένα πακέτο συνδρομής για να συνεχίσετε την πρόσβαση.',
    noAutoChargeYouChoose: 'Καμία αυτόματη χρέωση - Επιλέγετε εσείς!',
    viewPackages: 'Δείτε τα Πακέτα',
    hours: 'Ώρες',
    expires: 'Λήξη',
    whatIsIncluded: 'Τι περιλαμβάνεται',
    fullAccess: 'Πλήρης πρόσβαση σε όλες τις λειτουργίες',
    radioContentCreation: 'Δημιουργία ραδιοφωνικού περιεχομένου',
    chatbotSupport: 'Chatbot υποστήριξη',
    accountLocksAfter: 'Μετά τις 48 ώρες ο λογαριασμός κλειδώνει',
    redirectingToLogin: 'Θα μεταφερθείτε αυτόματα στη σελίδα σύνδεσης...',
    idealForDemo: 'Ιδανικό για demo σε υποψήφιους πελάτες',
    
    // Content
    contentFor: 'Περιεχόμενο για',
    sections: 'ενότητες',
    exportPDF: 'Εξαγωγή PDF',
    userGuide: 'Οδηγός Χρήστη',
    contentDate: 'Περιεχόμενο',
    createdAt: 'Δημιουργήθηκε',
    viewMode: 'Τρόπος Προβολής',
    categoriesView: 'Κατηγορίες',
    classicView: 'Κλασική',
    clickToViewSections: 'Κλικ για προβολή ενοτήτων',
    
    // Categories - NEW 9 CATEGORIES
    morningCategory: '☀️ Πρωινό (06:00-10:00)',
    daytimeCategory: '🌤️ Daytime (10:00-16:00)',
    afternoonCategory: '🌅 Απόγευμα (16:00-19:00)',
    eveningCategory: '🌙 Βράδυ (19:00-24:00)',
    weekendCategory: '🎉 Σαββατοκύριακο',
    zodiacLifestyleCategory: '✨ Ζώδια & Lifestyle',
    newsEntertainmentCategory: '📰 News & Entertainment',
    gamesFunCategory: '🎮 Games & Fun',
    chartsCategory: '🎵 Charts',
    
    // Old categories (kept for backwards compatibility)
    information: 'Πληροφόρηση',
    entertainment: 'Ψυχαγωγία',
    music: 'Μουσική',
    lifestyle: 'Lifestyle',
    special: 'Ειδικά',
    contestsGames: 'Διαγωνισμοί & Παιχνίδια',
    dialoguesDiscussions: 'Διάλογοι & Συζητήσεις',
    chartsMusic: 'Charts & Music',
    
    // Footer
    quickLinks: 'Γρήγοροι Σύνδεσμοι',
    campaignAnalyzer: 'Μετρητής Καμπάνιας',
    listenerCalculator: 'Μετρητής Ακροατών',
    playlistAnalyzer: 'Αναλυτής Playlist',
    daypartAnalyzer: 'Αναλυτής Daypart',
    ourStations: 'Οι σταθμοί μας',
    radioTopSongs: 'Top Ραδιοφωνικά Τραγούδια',
    contact: 'Επικοινωνία',
    radioContentCreation: 'Δημιουργία ραδιοφωνικού περιεχομένου',
    legalPrivacy: 'Νομικά & Απόρρητο',
    privacyPolicy: 'Πολιτική Απορρήτου',
    termsOfService: 'Όροι Χρήσης',
    cookiePolicy: 'Πολιτική Cookies',
    cookieSettings: 'Ρυθμίσεις Cookies',
    allRightsReserved: 'Με την επιφύλαξη παντός δικαιώματος',
    gdprCompliant: 'Συμμόρφωση GDPR',
    euDataProtection: 'Προστασία Δεδομένων ΕΕ',
    gdprNotice: 'Τα προσωπικά σας δεδομένα προστατεύονται σύμφωνα με τον GDPR (ΕΕ 2016/679) και την ελληνική νομοθεσία.',
    loginForMoreOptions: 'Συνδεθείτε για περισσότερες επιλογές',
    
    // Pricing
    pricing: 'Πακέτα & Συνδρομές',
    monthly: 'Μηνιαία',
    annual: 'Ετήσια',
    subscribe: 'Εγγραφή',
    popular: 'Δημοφιλές',
    chooseYourPackage: 'Επιλέξτε το Πακέτο σας',
    pricingDescription: 'Αποκτήστε πρόσβαση σε premium εργαλεία για τον ραδιοφωνικό σταθμό σας',
    currentPlan: 'Τρέχον Πλάνο',
    upgrade: 'Αναβάθμιση',
    downgrade: 'Υποβάθμιση',
    per: 'ανά',
    month: 'μήνα',
    year: 'έτος',
    selectWeek: 'Επιλέξτε Εβδομάδα',
    previousWeek: 'Προηγούμενη Εβδομάδα',
    nextWeek: 'Επόμενη Εβδομάδα',
    optional: 'προαιρετικό',
    savePercent: 'Εξοικονόμηση',
    featuresIncluded: 'Περιλαμβάνει',
    
    // Cookies
    cookiesTitle: 'Χρησιμοποιούμε Cookies',
    cookiesDesc: 'Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας.',
    cookiesFullDesc: 'Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας. Ορισμένα cookies είναι απαραίτητα για τη λειτουργία της ιστοσελίδας.',
    acceptAll: 'Αποδοχή Όλων',
    reject: 'Απόρριψη',
    settings: 'Ρυθμίσεις',
    necessaryCookies: 'Απαραίτητα Cookies',
    necessaryCookiesDesc: 'Απαραίτητα για τη βασική λειτουργία της ιστοσελίδας.',
    required: 'ΑΠΑΙΤΟΥΝΤΑΙ',
    analyticsCookies: 'Στατιστικά Cookies',
    analyticsCookiesDesc: 'Μας βοηθούν να κατανοούμε πώς χρησιμοποιείτε την ιστοσελίδα (Google Analytics).',
    functionalCookies: 'Λειτουργικά Cookies',
    functionalCookiesDesc: 'Θυμούνται τις προτιμήσεις σας και βελτιώνουν την εμπειρία χρήστη.',
    thirdPartyCookies: 'Cookies Τρίτων',
    thirdPartyCookiesDesc: 'Χρησιμοποιούνται από εξωτερικές υπηρεσίες (π.χ. YouTube videos).',
    saveSettings: 'Αποθήκευση Ρυθμίσεων',
    
    // Daypart Analyzer
    daypartTitle: 'Daypart Performance Analyzer',
    morning: 'Πρωί',
    drive: 'Drive Time',
    night: 'Βράδυ',
    overnight: 'Νύχτα',
    analyze: 'Ανάλυση',
    results: 'Αποτελέσματα',
    genreDistribution: 'Κατανομή Είδους',
    decadeDistribution: 'Κατανομή Δεκαετίας',
    
    // Labels
    power: 'POWER',
    secondary: 'SECONDARY',
    currents: 'CURRENTS',
    spreadMore: 'SPREAD MORE',
    slowDown: 'SLOW DOWN',
    sleeper: 'SLEEPER',
    cut: 'CUT',
    
    // Homepage Cards
    campaignAnalyzerDesc: 'Εργαλείο βελτιστοποίησης ραδιοφωνικών καμπανιών',
    campaignAnalyzerInfo: 'Υπολογίστε GRPs, Reach και Frequency για την καμπάνια σας με βάση την κατηγορία brand, τη θέση στην αγορά και τη διάρκεια.',
    campaignAnalyzerFullDesc: 'Ο Αναλυτής Καμπάνιας είναι ένα επαγγελματικό εργαλείο σχεδιασμού ραδιοφωνικών διαφημιστικών καμπανιών. Υπολογίζει αυτόματα τα GRPs (Gross Rating Points), το Reach (ποσοστό κοινού που εκτίθεται στο μήνυμα) και τη Frequency (μέσος αριθμός επαφών ανά άτομο). Με βάση την κατηγορία του brand σας και τη θέση στην αγορά, προτείνει τον βέλτιστο αριθμό spots για μέγιστη αποτελεσματικότητα.',
    openCampaignAnalyzer: 'Άνοιγμα Αναλυτή Καμπάνιας',
    listenerCalculatorDesc: 'Εργαλείο υπολογισμού ακροατών με βάση dayparts & εβδομαδιαία δεδομένα',
    listenerCalculatorInfo: 'Υπολογίστε ποσοστά ακρόασης, CI 95%, και εκτίμηση ακροατών με FPC correction για κάθε ημέρα και χρονική ζώνη.',
    listenerCalculatorFullDesc: 'Ο Μετρητής Ακροατών μετατρέπει τα ποσοστά ακρόασης σε πραγματικούς αριθμούς ακροατών. Χρησιμοποιεί στατιστικές μεθόδους (FPC correction, Confidence Intervals 95%) για ακριβείς εκτιμήσεις. Εισάγετε τα δεδομένα rating ανά ημέρα και χρονική ζώνη (daypart) και λάβετε αναλυτικά αποτελέσματα για το κοινό του σταθμού σας.',
    openListenerCalculator: 'Άνοιγμα Μετρητή Ακροατών',
    playlistAnalyzerDesc: 'Εργαλείο ανάλυσης απόδοσης playlist με προηγμένο scoring engine',
    playlistAnalyzerInfo: 'Αναλύστε λεπτομερώς την απόδοση του playlist σας με βάση TLH, Performances και Frequency.',
    playlistAnalyzerFullDesc: 'Ο Playlist Analyzer αναλύει την απόδοση κάθε τραγουδιού στο playlist του σταθμού σας. Φορτώστε ένα CSV με δεδομένα TLH (Time Listening Hours), Performances και Frequency. Το σύστημα υπολογίζει scores και προτείνει αποφάσεις όπως POWER (πολύ καλή απόδοση), SECONDARY (καλή), CURRENTS (νέα κυκλοφορία) ή CUT (αφαίρεση).',
    openPlaylistAnalyzer: 'Άνοιγμα Playlist Analyzer',
    daypartAnalyzerDesc: 'Αναλυτής απόδοσης ανά χρονική ζώνη',
    daypartAnalyzerInfo: 'Αναλύστε την απόδοση του playlist σας ανά daypart (πρωί, μεσημέρι, απόγευμα, βράδυ).',
    daypartAnalyzerFullDesc: 'Ο Daypart Analyzer είναι η premium έκδοση του Playlist Analyzer. Αναλύει την απόδοση κάθε τραγουδιού ανά χρονική ζώνη: Morning (06:00-10:00), Midday (10:00-15:00), Drive (15:00-19:00), Evening (19:00-24:00) και Overnight (00:00-06:00). Ιδανικό για σταθμούς που θέλουν να βελτιστοποιήσουν το rotation ανά ώρα.',
    songInfoFullDesc: 'Το εργαλείο Πληροφορίες Τραγουδιών αναζητά πληροφορίες για οποιοδήποτε τραγούδι: έτος κυκλοφορίας, δισκογραφική εταιρεία, συνθέτες, στιχουργούς, καλλιτέχνη/γκρουπ, και προτείνει κείμενα εκφώνησης (liners) για τους παραγωγούς. Απλά γράψτε τον τίτλο του τραγουδιού και πατήστε αναζήτηση.',
    openDaypartAnalyzer: 'Άνοιγμα Daypart Analyzer',
    premiumFeature: 'PREMIUM',
    upgradeToAccess: 'Αναβαθμίστε για πρόσβαση',
    
    // Misc
    copyright: 'ΙΔΙΟΚΤΗΣΙΑ RADIO SOLUTIONS',
    copyrightTitle: 'ΙΔΙΟΚΤΗΣΙΑ RADIO SOLUTIONS',
    copyrightNotice: 'Το περιεχόμενο αυτό παρέχεται αποκλειστικά σε εγγεγραμμένους συνδρομητές. Η κοινοποίηση ή διανομή σε τρίτους απαγορεύεται αυστηρά και διώκεται νομικά.',
    generateNewContent: 'Δημιούργησε Νέο Περιεχόμενο για καλύτερα αποτελέσματα!',
    contentCreationDuration: 'Διάρκεια δημιουργίας: ~15 λεπτά | Αυτόματα: 00:01 καθημερινά',
    downloadAsPDF: 'Κατέβασε ως PDF',
    userInstructions: 'Οδηγίες Χρήσης',
    waitForPdfDownload: 'Παρακαλώ περιμένετε έως 10\'\' για ολοκλήρωση download PDF',
    generationDuration: 'Διάρκεια δημιουργίας: ~15 λεπτά | Αυτόματα: 00:01 καθημερινά',
    waitForPDF: 'Παρακαλούμε περιμένετε έως 10\'\' για ολοκλήρωση download PDF',
    pdfPassword: 'Κωδικός ανοίγματος: το username σου',
    newContentAvailable: 'Νέο περιεχόμενο διαθέσιμο!',
    pageWillRefresh: 'Η σελίδα θα ανανεωθεί αυτόματα σε 5 δευτερόλεπτα...',
    refreshNow: 'Ανανέωση Τώρα',
    multiLanguage: 'Πολυγλωσσικό',
    
    // Playlist Analyzer
    playlistAnalyzerTitle: 'Playlist Performance Analyzer',
    uploadCSV: 'Ανέβασμα CSV',
    selectCSV: 'Επιλογή CSV',
    changeFile: 'Αλλαγή',
    loadingFile: 'Φόρτωση...',
    tracksLoaded: 'Φορτώθηκαν τραγούδια',
    radioFormat: 'Radio Format',
    formatAffectsWeights: 'Το format επηρεάζει τα βάρη και τους πολλαπλασιαστές εποχής',
    step1SelectFormat: 'Βήμα 1: Επιλέξτε Format → Βήμα 2: Ανεβάστε CSV',
    selectFormatFirst: 'Πρώτα επιλέξτε το σωστό Radio Format και μετά ανεβάστε το αρχείο CSV για καλύτερα αποτελέσματα.',
    startAnalysis: 'Έναρξη Ανάλυσης',
    analyzing: 'Ανάλυση...',
    analysisComplete: 'Ανάλυση ολοκληρώθηκε!',
    analysisError: 'Σφάλμα κατά την ανάλυση',
    networkError: 'Σφάλμα σύνδεσης. Παρακαλώ δοκιμάστε ξανά.',
    exportToPDF: 'Εξαγωγή PDF',
    creatingPDF: 'Δημιουργία PDF...',
    pdfCreated: 'PDF δημιουργήθηκε!',
    errorDownloadingPDF: 'Σφάλμα λήψης PDF',
    passwordToOpen: 'Κωδικός ανοίγματος: το username σου',
    tracksAndDecisions: 'Tracks & Αποφάσεις',
    genres: 'Είδη',
    decades: 'Δεκαετίες',
    searchArtistTitle: 'Αναζήτηση Artist ή Title...',
    clear: 'Καθαρισμός',
    tracks: 'tracks',
    instructions: 'Οδηγίες',
    csvFileStructure: 'Δομή Αρχείου CSV',
    csvMustContain: 'Το αρχείο CSV πρέπει να περιέχει τις παρακάτω στήλες.',
    artistName: 'Όνομα καλλιτέχνη',
    trackTitle: 'Τίτλος τραγουδιού',
    frequency: 'Συχνότητα',
    performances: 'Αναπαραγωγές',
    columnExplanation: 'Επεξήγηση Στηλών',
    missingColumns: 'Τι γίνεται αν λείπουν στήλες;',
    scoringProcess: 'Διαδικασία Βαθμολόγησης',
    whatDataMeans: 'Τι Σημαίνουν τα Δεδομένα',
    radioFormatsAdjustments: 'Τύποι Ραδιοφώνου & Προσαρμογές',
    decisionLabels: 'Ετικέτες Απόφασης',
    analyzingTracks: 'Ανάλυση τραγουδιών με format',
    largeFileWarning: 'μεγάλο αρχείο - μπορεί να χρειαστεί ~30-60 δευτερόλεπτα',
    mediumFileWarning: '~20-30 δευτερόλεπτα',
    analysisTimeout: 'Η ανάλυση διήρκεσε πάρα πολύ (>5 λεπτά). Δοκιμάστε με μικρότερο CSV.',
    analysisRetrying: 'Η ανάλυση χρειάζεται περισσότερο χρόνο... Επανάληψη',
    analysisLargeFileFailed: 'Το μεγάλο αρχείο απέτυχε μετά από πολλές προσπάθειες. Δοκιμάστε να χωρίσετε το CSV σε μικρότερα μέρη.',
    noTracksInPlaylist: 'Δεν υπάρχουν tracks στο playlist',
    noTracks: 'Δεν υπάρχουν tracks',
    totalTracks: 'Σύνολο Tracks',
    avgScore: 'Μέσος Βαθμός',
    power: 'Power',
    sleeper: 'Sleeper',
    totalPerformances: 'Σύνολο Αναπαραγωγών',
    uploadingFile: 'Ανέβασμα αρχείου',
    importingTracks: 'Εισαγωγή τραγουδιών στη βάση...',
    enrichmentComplete: 'Εμπλουτισμός Ολοκληρώθηκε',
    added: 'Προστέθηκαν',
    newSongs: 'νέα τραγούδια',
    updated: 'Ενημερώθηκαν',
    existing: 'υπάρχοντα',
    totalInDb: 'Σύνολο στη βάση',
    importError: 'Σφάλμα κατά την εισαγωγή',
    tryAgain: 'Προσπαθήστε ξανά',
    pleaseUploadCSV: 'Παρακαλώ ανεβάστε αρχείο CSV',
    uploadError: 'Σφάλμα κατά το ανέβασμα του αρχείου',
    pleaseUploadCSVFirst: 'Παρακαλώ ανεβάστε πρώτα ένα αρχείο CSV',
    pleaseAnalyzeFirst: 'Παρακαλώ κάντε πρώτα ανάλυση',
    loadingCSVFile: 'Φόρτωση αρχείου CSV... Παρακαλώ περιμένετε',
    columns: 'Στήλες',
    analysisSummary: 'Σύνοψη Ανάλυσης',
    totalRecords: 'Συνολικές Εγγραφές',
    uniqueTracks: 'Μοναδικά Τραγούδια',
    period: 'Περίοδος',
    daypartDistribution: 'Κατανομή Dayparts',
    // Admin section
    adminDbEnrichment: 'Admin: Εμπλουτισμός Βάσης Τραγουδιών',
    songsInDb: 'τραγούδια',
    artistsInDb: 'καλλιτέχνες',
    songsWithYear: 'με έτος',
    uploadCsvInstructions: 'Ανεβάστε CSV με στήλες: Artist, Title, Year (προαιρετικά: Genre)',
    importInProgress: 'Εισαγωγή σε εξέλιξη...',
    addSongs: 'Προσθήκη Τραγουδιών',
    // Step notification
    step1SelectFormat: 'Βήμα 1: Επιλέξτε Format → Βήμα 2: Ανεβάστε CSV',
    selectFormatFirst: 'Πρώτα επιλέξτε το σωστό Radio Format και μετά ανεβάστε το αρχείο CSV για καλύτερα αποτελέσματα.',
    exportPDF: 'Εξαγωγή PDF',
    // Help modal
    eraMultiplier: 'Πολλαπλασιαστής Εποχής - Bonus για τραγούδια που ταιριάζουν στο format',
    newReleaseBonus: 'Bonus Νέας Κυκλοφορίας - +10% για τραγούδια ≤90 ημερών',
    // Decision explanations
    decContinue: 'ΣΥΝΕΧΙΣΤΕ - Οι ακροατές το λατρεύουν!',
    decMaintain: 'ΔΙΑΤΗΡΗΣΤΕ - Οι ακροατές σας μένουν',
    decMaintainGood: 'ΔΙΑΤΗΡΗΣΤΕ - Καλή αποδοχή ακρόασης',
    decReduce: 'ΜΕΙΩΣΤΕ - Λιγότερες μεταδόσεις/εβδομάδα',
    decRemove: 'ΑΦΑΙΡΕΣΤΕ - Οι ακροατές σας αλλάζουν σταθμό!',
    decTired: 'Οι ακροατές το έχουν κουραστεί! ΜΕΙΩΣΤΕ ΤΗ ΣΥΧΝΟΤΗΤΑ!',
    decSecondLine: 'ΔΕΥΤΕΡΗ ΓΡΑΜΜΗ - Μην τα επιλέγετε σε prime ζώνες',
    decLessPerDay: 'ΛΙΓΟΤΕΡΕΣ ΜΕΤΑΔΟΣΕΙΣ/ΗΜΕΡΑ',
    // Explanation translations for track results - GREEK
    decContinueAction: 'ΣΥΝΕΧΙΣΤΕ',
    decMaintainAction: 'ΔΙΑΤΗΡΗΣΤΕ',
    decReduceAction: 'ΜΕΙΩΣΤΕ',
    decRemoveAction: 'ΑΦΑΙΡΕΣΤΕ',
    decIncreaseAction: 'ΑΥΞΗΣΤΕ',
    decReduceImmediately: 'ΜΕΙΩΣΤΕ ΑΜΕΣΑ',
    decListenersLoveIt: 'Οι ακροατές το λατρεύουν',
    decListenersStay: 'Οι ακροατές σας μένουν',
    decGoodAcceptance: 'Καλή αποδοχή ακρόασης',
    decReduceFrequency: 'Αραιώστε τη συχνότητα',
    decFewerPlaysWeek: 'Λιγότερες μεταδόσεις/εβδομάδα',
    decNoPrimeZones: 'Μην τα επιλέγετε σε prime ζώνες',
    decListenersSwitch: 'Οι ακροατές σας αλλάζουν σταθμό',
    decListenersTired: 'Οι ακροατές το έχουν κουραστεί',
    decSleeperDesc: 'Παίζει λίγο αλλά όταν παίζει, οι ακροατές το αγαπούν',
    decExcellentPerformance: 'Εξαιρετική απόδοση',
    decTopTrack: 'Top τραγούδι',
    decVeryGoodPerformance: 'Πολύ καλή απόδοση',
    decKeepIt: 'Κρατήστε το',
    decStableChoice: 'Σταθερή επιλογή',
    decPlaysTooOften: 'Παίζει πολύ συχνά',
    decLowInterest: 'Χαμηλό ενδιαφέρον ακροατών',
    decHiddenHit: 'Κρυμμένο hit',
    decLikedButRare: 'Αρέσει πολύ αλλά παίζει λίγο',
    decIncreasePlaybacks: 'Αυξήστε τις αναπαραγωγές',
    decReduceSignificantly: 'Μειώστε σημαντικά τη συχνότητα',
    decContinueStrategy: 'Συνεχίστε με την τρέχουσα στρατηγική',
    decNewRelease: 'Νέα κυκλοφορία',
    decDoesntFitFormat: 'δεν ταιριάζει στο format',
    decBetterInOtherFormat: 'Θα απέδιδε καλύτερα σε άλλο format',
    
    // Playlist Help Modal
    helpCsvStructure: 'Δομή Αρχείου CSV',
    helpCsvMustContain: 'Το αρχείο CSV πρέπει να περιέχει τις παρακάτω στήλες:',
    helpColumnExplanation: 'Επεξήγηση Στηλών:',
    helpArtistName: 'Όνομα καλλιτέχνη (υποχρεωτικό)',
    helpTrackTitle: 'Τίτλος τραγουδιού (υποχρεωτικό)',
    helpFrequency: 'Συχνότητα αναπαραγωγής (αριθμός)',
    helpPerformances: 'Συνολικές αναπαραγωγές (αριθμός)',
    helpTLH: 'Total Listening Hours (δεκαδικός αριθμός)',
    helpMissingColumns: 'Τι γίνεται αν λείπουν στήλες;',
    helpMissingArtistTitle: 'Το τραγούδι ΔΕΝ θα συμπεριληφθεί στην ανάλυση',
    helpMissingNumeric: 'Θα θεωρηθεί 0 (μηδέν)',
    helpAllNumericMissing: 'Η βαθμολογία θα είναι 0 - το τραγούδι θα εμφανίζεται ως "CUT"',
    helpTip: 'Συμβουλή: Για ακριβή ανάλυση, βεβαιωθείτε ότι όλες οι στήλες έχουν τιμές. Τουλάχιστον το TLH είναι κρίσιμο!',
    helpScoringProcess: 'Διαδικασία Βαθμολόγησης (9 Βήματα)',
    helpStep1: 'Κανονικοποίηση (0-1) - Μετατροπή τιμών σε κλίμακα 0 έως 1',
    helpStep2: 'Βασικά Βάρη - TLH 55%, Performances 30%, Frequency 15%',
    helpStep3: 'Προσαρμογή Format - Βάρη ανάλογα με τον τύπο ραδιοφώνου',
    helpStep4: 'Πολλαπλασιαστής Εποχής - Bonus για τραγούδια που ταιριάζουν στο format',
    helpStep5: 'Bonus Νέας Κυκλοφορίας - +10% για τραγούδια ≤90 ημερών',
    helpStep6: 'Ποινή Rotation - Μείωση για υπερβολικά συχνή αναπαραγωγή',
    helpStep7: 'Ποινή Απόρριψης - Μείωση αν οι ακροατές αλλάζουν σταθμό',
    helpStep8: 'Ποινή Κόπωσης - Μείωση όταν πέφτει το TLH',
    helpStep9: 'Τελική Βαθμολογία - Κλιμάκωση 0-100',
    helpDataMeaning: 'Τι Σημαίνουν τα Δεδομένα',
    helpTLHDesc: 'Πόση ώρα ακούν συνολικά οι ακροατές το τραγούδι. Υψηλό TLH = αρέσει πολύ!',
    helpPerformancesDesc: 'Πόσες φορές έπαιξε το τραγούδι στο πρόγραμμα',
    helpFrequencyDesc: 'Πόσο συχνά παίζει (φορές/ημέρα ή εβδομάδα)',
    helpYearDesc: 'Έτος κυκλοφορίας (από MusicBrainz/Discogs)',
    helpGenreDesc: 'Είδος μουσικής (Pop, Rock, Λαϊκό, κλπ)',
    helpRadioFormats: 'Τύποι Ραδιοφώνου & Προσαρμογές',
    helpFormatIntro: 'Κάθε format δίνει διαφορετική έμφαση στα δεδομένα:',
    helpDecisionLabels: 'Κύριες Ετικέτες Απόφασης (RANKING-BASED)',
    helpDecisionIntro: 'Βάσει της θέσης κατάταξης, όχι απόλυτου score:',
    helpStrictMode: 'STRICT Mode (HOT AC, GHR, Greek Mainstream): 62.5% ενεργά, 37.5% CUT',
    helpRelaxedMode: 'RELAXED Mode (GOLD, AC): 57% ενεργά, 43% CUT',
    helpPowerLabel: 'Top 2-2.5%',
    helpSecondaryLabel: 'Επόμενα 4-5%',
    helpCurrentsLabel: 'Επόμενα 8-10%',
    helpSpreadMoreLabel: 'Επόμενα 16-17.5%',
    helpSlowDownLabel: 'Επόμενα 24-27.5%',
    helpRiskLabel: 'Επόμενα 37.5-46%',
    helpCutLabel: 'Υπόλοιπα (37.5-43%)',
    helpGotIt: 'Κατάλαβα, ας ξεκινήσουμε!',
    
    // Help Modal - Special Labels
    helpSpecialLabels: 'Ειδικές Ετικέτες',
    helpSpecialLabelsIntro: 'Βάσει της σχέσης Frequency & TLH:',
    helpSleeperTitle: 'Κρυμμένο Διαμάντι',
    helpSleeperCriteria: 'Κριτήρια: Χαμηλή συχνότητα (<35%) + Υψηλό TLH (≥55%)',
    helpSleeperAction: 'Παίζει λίγο αλλά όταν παίζει, οι ακροατές το αγαπούν! ΑΥΞΗΣΤΕ ΤΟ!',
    helpOverplayedTitle: 'Υπερβολική Αναπαραγωγή',
    helpOverplayedCriteria: 'Κριτήρια: Υψηλή συχνότητα (≥65%) + Χαμηλό TLH (<45%)',
    helpOverplayedAction: 'Οι ακροατές το έχουν κουραστεί! ΜΕΙΩΣΤΕ ΤΗ ΣΥΧΝΟΤΗΤΑ!',
    helpCsvFormat: 'Μορφή Αρχείου CSV',
    helpCsvFormatDesc: 'Το αρχείο CSV πρέπει να περιέχει τις εξής στήλες:',
    helpCsvExample: 'Παράδειγμα:',
    helpCsvStructureIntro: 'Το αρχείο CSV πρέπει να περιέχει τις παρακάτω στήλες. Τα ονόματα στηλών μπορεί να είναι με κεφαλαία ή πεζά.',
    
    // Daypart Analyzer specific
    daypartAnalyzerTitle: 'Daypart Performance Analyzer',
    usageInstructions: 'Οδηγίες Χρήσης',
    daypartIntro: 'Το Playlist Daypart Analyzer αναλύει την απόδοση του playlist σας ανά χρονική ζώνη. Ανεβάστε το playlist CSV του σταθμού σας και δείτε ποια τραγούδια έχουν την καλύτερη απόδοση σε κάθε ώρα της ημέρας.',
    csvUpload: 'Ανέβασμα Αρχείου CSV',
    csvMustContainFields: 'Το CSV πρέπει απαραίτητα να περιέχει τις εξής στήλες:',
    csvFlexibleFormat: 'Απαιτούμενες στήλες:',
    csvOptional: 'προαιρετικά',
    csvColumnOrderNote: 'Η σειρά των στηλών δεν έχει σημασία. Αναγνωρίζονται διάφορες ονομασίες (π.χ. Artist, Performer, Καλλιτέχνης)',
    allFieldsRequired: 'Όλα τα πεδία είναι απαραίτητα για ακριβή αποτελέσματα ανάλυσης',
    selectRadioFormat: 'Επιλογή Radio Format',
    selectYourFormat: 'Επιλέξτε το format του σταθμού σας:',
    timeZones: 'Χρονικές Ζώνες (Dayparts)',
    evaluationCategories: 'Κατηγορίες Αξιολόγησης',
    powerDesc: 'Κορυφαία τραγούδια - παίξτε τα συχνά!',
    secondaryDesc: 'Δεύτερη γραμμή - καλή απόδοση',
    currentsDesc: 'Τρέχοντα hits - καλή ροή',
    spreadMoreDesc: 'Αυξήστε τη συχνότητα',
    slowDownDesc: 'Μειώστε τη συχνότητα',
    sleeperDesc: 'Χαμηλή απόδοση - παρακολούθηση',
    cutDesc: 'Υποψήφιο για αφαίρεση',
    csvFormat: 'Μορφή CSV',
    daypartHowItWorks: 'Πώς λειτουργεί',
    daypartHowItWorksDesc: 'Ο Daypart Analyzer αναλύει την απόδοση των τραγουδιών του σταθμού σας ανά χρονική ζώνη (Morning, Drive, Night, Overnight). Με βάση τα δεδομένα TLH και Listeners, υπολογίζει scores και προτείνει αποφάσεις (POWER, SECONDARY, CURRENTS, κλπ) για κάθε τραγούδι.',
    genreDecadeAnalysis: 'Ανάλυση Genre & Decade',
    eachDaypartShows: 'Κάθε daypart εμφανίζει επίσης:',
    requiresAdminEnrichment: 'Απαιτείται εμπλουτισμός βάσης δεδομένων από τον Admin',
    exportResults: 'Εξαγωγή Αποτελεσμάτων',
    afterAnalysisExport: 'Μετά την ανάλυση, μπορείτε να εξάγετε τα αποτελέσματα σε:',
    tips: 'Συμβουλές',
    tip1: 'Χρησιμοποιήστε δεδομένα τουλάχιστον μιας εβδομάδας για καλύτερα αποτελέσματα',
    tip2: 'Προσαρμόστε τα weights ανά daypart στις "Ρυθμίσεις" ανάλογα με τις προτεραιότητές σας',
    tip3: 'Ελέγχετε το GOLD Analysis για τα "χρυσά" τραγούδια του σταθμού σας',
    gotItLetsStart: 'Κατάλαβα, ας ξεκινήσω!',
    
    // Radio Top Songs
    radioTopSongsTitle: 'Top Radio Songs',
    weeklyChart: 'Εβδομαδιαίο Chart',
    position: 'Θέση',
    artist: 'Καλλιτέχνης',
    title: 'Τίτλος',
    lastWeek: 'Προηγ.',
    weeksOnChart: 'Εβδομάδες',
    chartInfo: 'Πληροφορίες Chart',
    uploadNewChart: 'Ανέβασμα Νέου Chart',
    noChartData: 'Δεν υπάρχουν δεδομένα chart',
    allSongs: 'Όλα',
    greekSongs: 'Ελληνικά',
    internationalSongs: 'Διεθνή',
    totalSongs: 'Σύνολο Τραγουδιών',
    source: 'Πηγή',
    searchSongsArtists: 'Αναζητήστε τραγούδια & καλλιτέχνες • Δείτε ιστορικά charts',
    browseChartsByWeek: 'Περιηγηθείτε στα charts ανά εβδομάδα και μήνα του έτους',
    discoverMore: 'Ανακαλύψτε Περισσότερα',
    searchSongArtist: 'Αναζήτηση τραγουδιού ή καλλιτέχνη...',
    display: 'Εμφάνιση',
    saveCurrentChart: 'Αποθήκευση Τρέχοντος Chart',
    noChartDataForWeek: 'Δεν βρέθηκαν δεδομένα για την επιλεγμένη εβδομάδα. Φόρτωση τρέχοντος chart...',
    
    // Maintenance/Loading Screen
    preparingForYou: 'Ετοιμάζουμε τα πάντα για εσάς!',
    remainingTime: 'Υπολειπόμενος χρόνος',
    ready: 'Έτοιμο!',
    pageWillRefreshAuto: 'Η σελίδα θα ανανεωθεί αυτόματα σε λίγα δευτερόλεπτα...',
    completed: 'ολοκληρωμένο',
    contentBeingCreated: 'Το ραδιοφωνικό σας περιεχόμενο δημιουργείται αυτή τη στιγμή. Παρακαλώ περιμένετε...',
    whatsHappening: 'Τι συμβαίνει;',
    systemCreatingContent: 'Το σύστημα δημιουργεί φρέσκο, επαγγελματικό ραδιοφωνικό περιεχόμενο',
    estimatedDuration: 'Εκτιμώμενη διάρκεια',
    minutes: 'λεπτά',
    pageRefreshAuto: 'Η σελίδα θα ανανεωθεί αυτόματα όταν ολοκληρωθεί',
    tipKeepTabOpen: 'Συμβουλή: Κρατήστε αυτή την καρτέλα ανοιχτή - η ανανέωση θα γίνει αυτόματα',
    
    // Pricing Page
    features: 'Λειτουργίες',
    price: 'Τιμή',
    perMonth: '/μήνα',
    perYear: '/έτος',
    currentPackage: 'Τρέχον Πακέτο',
    select: 'Επιλογή',
    pleaseWait: 'Περιμένετε...',
    faq: 'Συχνές Ερωτήσεις',
    canChangePackage: 'Μπορώ να αλλάξω πακέτο;',
    canChangePackageAnswer: 'Ναι, μπορείτε να αναβαθμίσετε ή να υποβαθμίσετε το πακέτο σας οποιαδήποτε στιγμή. Η διαφορά θα προστεθεί ή θα αφαιρεθεί από την επόμενη χρέωση.',
    paymentMethods: 'Τι τρόποι πληρωμής υποστηρίζονται;',
    paymentMethodsAnswer: 'Δεχόμαστε όλες τις πιστωτικές/χρεωστικές κάρτες (Visa, Mastercard, American Express) μέσω της ασφαλούς πλατφόρμας Stripe.',
    hasTrial: 'Υπάρχει δοκιμαστική περίοδος;',
    hasTrialAnswer: 'Ναι! Όλοι οι νέοι χρήστες έχουν δωρεάν πρόσβαση για 48 ώρες σε όλες τις λειτουργίες.',
    paymentCancelled: 'Η πληρωμή ακυρώθηκε',
    checkEmailConfirmation: 'Ελέγξτε το email σας για επιβεβαίωση πληρωμής',
    paymentSuccess: 'Η πληρωμή ολοκληρώθηκε επιτυχώς!',
    sessionExpired: 'Η συνεδρία πληρωμής έληξε',
    pleaseLoginFirst: 'Παρακαλώ συνδεθείτε πρώτα',
    chargeForUpgrade: 'Χρέωση €{amount} για αναβάθμιση',
    errorCreatingPayment: 'Σφάλμα κατά τη δημιουργία πληρωμής',
    errorLoadingPackages: 'Σφάλμα φόρτωσης πακέτων',
    
    // Soft Locks / Feature Gate
    lockedFeature: 'Κλειδωμένη Λειτουργία',
    upgradeForAccess: 'Αναβάθμιση για Πρόσβαση',
    orTryFree24h: 'Ή δοκιμάστε δωρεάν για 48 ώρες',
    upgradeForAccessFeature: 'Αναβαθμίστε το πακέτο σας για πρόσβαση σε αυτή τη λειτουργία.',
    
    // Feature Info (locked cards)
    categoriesOnAirTitle: 'Κατηγορίες Θεμάτων On Air',
    categoriesOnAirDesc: '9 κατηγορίες φρέσκου περιεχομένου - Πρωινό, Daytime, Απόγευμα, Βράδυ, Σαββατοκύριακο, Ζώδια, News, Entertainment, Charts. Νέο κάθε μέρα!',
    campaignAnalyzerTitleLong: 'Μετρητής Καμπάνιας',
    campaignAnalyzerDescLong: 'Υπολογίστε την απόδοση των διαφημιστικών σας καμπανιών. Δείτε reach, frequency, GRP και εκτιμώμενα έσοδα.',
    listenerCalculatorTitleLong: 'Μετρητής Ακροατών',
    listenerCalculatorTitle: 'Μετρητής Ακροατών',
    listenerCalculatorDescLong: 'Υπολογίστε το πραγματικό κοινό του σταθμού σας. Εκτιμήσεις ακροατών ανά ζώνη και ημέρα.',
    radioTopSongsTitleLong: 'Radio Top Songs',
    radioTopSongsDescLong: 'Βρείτε τα κορυφαία τραγούδια για τον σταθμό σας. Ελληνικά & Διεθνή charts με έξυπνες προτάσεις.',
    playlistAnalyzerTitleLong: 'Playlist Analyzer',
    playlistAnalyzerDescLong: 'Αναλύστε το playlist σας με βάση δεκαετίες, είδη και performance. Αξιολόγηση τραγουδιών POWER/SLEEPER.',
    daypartAnalyzerTitleLong: 'Daypart Analyzer',
    daypartAnalyzerDescLong: 'Αναλύστε την απόδοση του playlist σας ανά ζώνη (πρωί, μεσημέρι, βράδυ). Genre & Decade distribution.',
    peoplesChartTitle: "The People's Chart",
    peoplesChartDesc: 'To Top 300 chart που διαμορφώνουν οι ακροατές. Βαθμολόγηση βάσει retention, plays και early drop από τους καλύτερους σταθμούς.',
    monthlySupportTitle: 'Μηνιαία Υποστήριξη',
    monthlySupportDesc: 'Τεχνική υποστήριξη μέσω email και chat με απάντηση εντός 24 ωρών.',
    prioritySupportTitle: 'Προτεραιότητα Υποστήριξης',
    prioritySupportDesc: 'Άμεση τεχνική υποστήριξη με προτεραιότητα. Απάντηση εντός 4 ωρών.',
    
    // Access Banner
    adminFullAccess: 'Διαχειριστής - Πλήρης Πρόσβαση',
    trialPeriod: 'Δοκιμαστική Περίοδος',
    hoursRemaining: 'απομένουν',
    freeAccess: 'Δωρεάν Πρόσβαση',
    subscriber: 'Συνδρομητής',
    subscriptionExpired: 'Η συνδρομή σας έληξε',
    noActiveSubscription: 'Χωρίς ενεργή συνδρομή',
    
    // Help Modals
    helpGuide: 'Οδηγός',
    helpInstructions: 'Οδηγίες',
    howItWorks: 'Πώς λειτουργεί',
    helpListenerCalculator: 'Οδηγός Μετρητή Ακροατών',
    helpPlaylistAnalyzer: 'Οδηγός Playlist Analyzer',
    helpDaypartAnalyzer: 'Οδηγός Daypart Analyzer',
    
    // Campaign Calculator Page
    campaignAnalyzerPageTitle: 'Αναλυτής Καμπάνιας',
    campaignAnalyzerPageDesc: 'Εργαλείο βελτιστοποίησης ραδιοφωνικών καμπανιών',
    brandCategoryLabel: 'ΚΑΤΗΓΟΡΙΑ BRAND (ΑΛΦΑΒΗΤΙΚΑ)',
    marketPositionLabel: 'ΚΑΤΑΣΤΑΣΗ/ΘΕΣΗ BRAND ΣΤΗΝ ΑΓΟΡΑ',
    radioPrimaryLabel: 'ΡΑΔΙΟΦΩΝΟ ΩΣ ΚΥΡΙΟ ΜΕΣΟ;',
    campaignDurationLabel: 'ΔΙΑΡΚΕΙΑ ΚΑΜΠΑΝΙΑΣ (ΕΝΕΡΓΕΣ ΕΒΔΟΜΑΔΕΣ)',
    pleaseSelect: 'Παρακαλώ επιλέξτε',
    spotsPerDay: 'Spots ανά Ημέρα',
    adjustSpotsPerDay: 'Προσαρμόστε τον αριθμό spots για κάθε ημέρα της εβδομάδας',
    totalSpotsWeek: 'Σύνολο Spots/Εβδομάδα',
    calculateCampaign: 'Υπολογισμός Καμπάνιας',
    weeklyGRPs: 'Εβδομαδιαία GRPs',
    totalGRPs: 'Συνολικά GRPs',
    estimatedReach: 'Reach',
    avgFrequency: 'Μέση Συχνότητα',
    weeklyProgress: 'Εβδομαδιαία Εξέλιξη',
    dailyDistribution: 'Κατανομή Ημερών (Εβδ. 1)',
    strategicRecommendations: 'Στρατηγικές Συστάσεις',
    scenarioComparison: 'Σύγκριση Σεναρίων',
    exportPDFBtn: 'Εξαγωγή σε PDF',
    pleaseWaitPDF: 'Παρακαλώ περιμένετε...',
    fillAllFields: 'Παρακαλώ συμπληρώστε όλα τα πεδία',
    calculateFirst: 'Παρακαλώ κάνετε πρώτα υπολογισμό πατώντας "Υπολογισμός"',
    waitForPDFGen: 'Παρακαλούμε περιμένετε έως 10\'\' για τη δημιουργία του αρχείου...',
    pleaseWait: 'Παρακαλώ περιμένετε...',
    exportCompleted: 'Η εξαγωγή ολοκληρώθηκε!',
    exportError: 'Σφάλμα κατά την εξαγωγή σε PDF',
    // Day names
    monday: 'Δευτέρα',
    tuesday: 'Τρίτη',
    wednesday: 'Τετάρτη',
    thursday: 'Πέμπτη',
    friday: 'Παρασκευή',
    saturday: 'Σάββατο',
    sunday: 'Κυριακή',
    // Brand categories
    foodDrinks: 'Τρόφιμα & Ποτά',
    technology: 'Τεχνολογία',
    fashionBeauty: 'Μόδα & Ομορφιά',
    automobiles: 'Αυτοκίνητα',
    services: 'Υπηρεσίες',
    retail: 'Λιανική Πώληση',
    // Market positions
    marketLeader: 'Ηγέτης Αγοράς',
    challenger: 'Challenger',
    newEntry: 'Νέα Είσοδος',
    // Campaign durations
    weeks2: '2 εβδομάδες',
    weeks4: '4 εβδομάδες',
    weeks8: '8 εβδομάδες',
    weeks12: '12 εβδομάδες',
    weekLabel: 'Εβδ.',
    weekFull: 'Εβδομάδα',
    historicalData: 'Ιστορικά Δεδομένα',
    showMore: 'Εμφάνιση Περισσότερων',
    noResultsFor: 'Δεν βρέθηκαν αποτελέσματα για',
    chartSavedSuccess: 'Chart αποθηκεύτηκε επιτυχώς!',
    year: 'Έτος',
    songsCount: 'Τραγούδια',
    noDataToSave: 'Δεν υπάρχουν δεδομένα για αποθήκευση',
    adminOnlyFeature: 'Πρέπει να συνδεθείτε ως admin για αυτή τη λειτουργία',
    adminOnlySaveChart: 'Μόνο admin χρήστες μπορούν να αποθηκεύσουν charts',
    saveFailed: 'Αποτυχία αποθήκευσης. Δοκιμάστε ξανά.',
    spots: 'spots',
    recommendations: 'Συστάσεις & Βελτιώσεις',
    totalSpots: 'Συνολικά Spots',
    // Recommendations - Dynamic messages with placeholders
    criticalLowFreq: 'ΚΡΙΤΙΚΟ: Πολύ Χαμηλή Συχνότητα',
    criticalLowFreqMsg: 'Η τρέχουσα συχνότητα είναι ανεπαρκής. Το μήνυμα δεν θα αποτυπωθεί στη μνήμη του κοινού.',
    criticalLowFreqMsgDynamic: 'Η τρέχουσα συχνότητα ({freq}) είναι ανεπαρκής. Το μήνυμα δεν θα αποτυπωθεί στη μνήμη του κοινού.',
    recIncreaseSpotsTo: 'Προτείνεται αύξηση σε {newWeeklySpots} spots/εβδομάδα ({extraSpots} επιπλέον spots) για να φτάσετε Frequency {targetFreq} και {newGRPs} GRPs.',
    warningHighFreq: 'Προσοχή: Πολύ Υψηλή Συχνότητα',
    warningHighFreqMsg: 'Η συχνότητα είναι πολύ υψηλή. Κίνδυνος "ad fatigue" και σπατάλης budget.',
    warningHighFreqMsgDynamic: 'Η συχνότητα ({freq}) είναι πολύ υψηλή. Κίνδυνος "ad fatigue" και σπατάλης budget.',
    recReduceSpotsTo: 'Μπορείτε να μειώσετε σε {newWeeklySpots} spots/εβδομάδα και να εξοικονομήσετε κόστος διατηρώντας Frequency στο {targetFreq}.',
    suggestionIncrease: 'Πρόταση: Αύξηση Αποτελεσματικότητας',
    suggestionIncreaseMsg: 'Τα GRPs σας είναι κάτω από το ιδανικό επίπεδο (400+).',
    suggestionIncreaseMsgDynamic: 'Τα GRPs σας ({grps}) είναι κάτω από το ιδανικό επίπεδο (400+). Για καλύτερη απόδοση:',
    recOptionsAB: '• ΕΠΙΛΟΓΗ Α: Αυξήστε τη διάρκεια σε {option1_weeks} εβδομάδες → ~{option1_newGRPs} GRPs\n• ΕΠΙΛΟΓΗ Β: Προσθέστε {option2_spotsIncrease} spots/εβδ ({option2_newWeeklySpots} total) → ~{option2_newGRPs} GRPs',
    excellentGRPs: 'Εξαιρετικά Υψηλά GRPs',
    excellentGRPsMsg: 'Τα GRPs σας είναι εξαιρετικά! Έχετε μέγιστη κάλυψη.',
    excellentGRPsMsgDynamic: 'Τα GRPs σας ({grps}) είναι εξαιρετικά! Έχετε μέγιστη κάλυψη.',
    recWatchSaturation: 'Προσέξτε τον κορεσμό του κοινού. Μπορείτε να διατηρήσετε τα ίδια επίπεδα ή να μειώσετε ελαφρώς για οικονομία.',
    optimalCampaign: 'Βέλτιστη Καμπάνια!',
    optimalCampaignMsg: 'Τα GRPs σας και η Frequency είναι στο ιδανικό εύρος.',
    optimalCampaignMsgDynamic: 'Τα GRPs σας ({grps}) και η Frequency ({freq}) είναι στο ιδανικό εύρος.',
    recWellDesigned: 'Η καμπάνια σας είναι καλά σχεδιασμένη και θα έχει αποτελεσματική απόδοση. Συνεχίστε με αυτή τη στρατηγική!',
    strongCampaign: 'Πολύ Ισχυρή Καμπάνια!',
    strongCampaignMsg: 'Τα GRPs σας είναι υψηλά. Θα έχετε κυριαρχία στην κατηγορία σας.',
    strongCampaignMsgDynamic: 'Τα GRPs σας ({grps}) είναι υψηλά. Θα έχετε κυριαρχία στην κατηγορία σας.',
    recExcellentStrategy: 'Εξαιρετική στρατηγική για brand awareness και market dominance!',
    perfectCampaign: 'Άριστη Καμπάνια!',
    perfectCampaignMsg: 'Όλες οι μετρήσεις σας είναι στα βέλτιστα επίπεδα.',
    recBestBalance: 'Η καμπάνια σας έχει την καλύτερη δυνατή ισορροπία κόστους-απόδοσης!',
    // Scenarios
    lessSpots: 'Λιγότερα Spots (-30%)',
    currentStrategy: 'Τρέχουσα Στρατηγική',
    shorterDuration: 'Μικρότερη Διάρκεια (-2 εβδ.)',
    lower: 'Χαμηλότερη',
    optimal: 'Βέλτιστη',
    medium: 'Μέτρια',
    scenario: 'Σενάριο',
    efficiency: 'Αποδοτικότητα',
    // Frequency & GRP Levels
    yourCampaign: 'Η καμπάνια σας',
    freqInsufficient: 'Ανεπαρκής',
    freqVeryLow: 'Πολύ χαμηλή',
    freqIdeal: 'ΙΔΑΝΙΚΗ - καλή awareness',
    freqVeryGood: 'Πολύ καλή - ισχυρή ανάκληση',
    freqHigh: 'Υψηλή - καλή αλλά προσοχή στο κόστος',
    freqTooHigh: 'Πολύ υψηλή - κίνδυνος "ad fatigue"',
    grpLevels: 'Επίπεδα GRPs (Gross Rating Points)',
    grpVeryLow: 'Πολύ χαμηλά - ανεπαρκής κάλυψη',
    grpLow: 'Χαμηλά - ελάχιστη επίδραση στην αγορά',
    grpGood: 'Καλά - αρχική awareness, κατάλληλα για διατήρηση',
    grpVeryGood: 'Πολύ καλά - ισχυρή παρουσία, αποτελεσματική καμπάνια',
    grpHigh: 'Υψηλά - κυριαρχία στην κατηγορία',
    grpVeryHigh: 'Πολύ υψηλά - μέγιστη κάλυψη, προσοχή στον κορεσμό',
    
    // Listener Calculator Page
    listenerCalcTitle: 'Μετρητής Ακροατών',
    listenerCalcDesc: 'Εργαλείο εκτίμησης πραγματικής ακροαματικότητας',
    whatIsCalculator: 'Τι είναι ο Μετρητής;',
    listenerCalcGuide: 'Οδηγός Μετρητή Ακροατών',
    listenerCalcWhat: 'Τι είναι ο Μετρητής Ακροατών & τι κάνει',
    listenerCalcWhatDesc: 'Ο Μετρητής Ακροατών είναι ένα εργαλείο εκτίμησης πραγματικής ακροαματικότητας streaming ανά:',
    listenerCalcItems: 'Ημέρα,Daypart (ζώνη ώρας),Εβδομάδα,Συνδυασμό ημερών & dayparts',
    listenerCalcNote: 'Δεν μετρά απλώς raw συνδέσεις.',
    listenerCalcStatistical: 'Χρησιμοποιεί στατιστική αναγωγή ώστε από ένα δείγμα ακροατών να υπολογίζει:',
    listenerCalcMetrics: 'Ποσοστό ακροαματικότητας,Εκτιμώμενο πλήθος πραγματικών ακροατών,Εύρος αξιοπιστίας (Confidence Interval 95%),Τάση (trend) σε εβδομαδιαία βάση',
    listenerCalcTool: 'Αυτό μετατρέπει τα δεδομένα streaming από «αριθμούς» σε εργαλείο λήψης αποφάσεων.',
    streamingAnalyticsTitle: 'Αναλυτής Streaming Δεδομένων',
    streamingAnalyticsDesc: 'Ανεβάστε το CSV από τον streaming provider για λεπτομερή ανάλυση ακροαματικότητας',
    listenerCalcAnalysis: 'Ανάλυση & επεξήγηση ενδείξεων',
    sampleTitle: 'Sample (Δείγμα)',
    sampleDesc: 'Ο αριθμός χρηστών που καταγράφηκαν (π.χ. listeners, sessions, survey responses).',
    sampleTip: 'Όσο μεγαλύτερο το sample, τόσο μεγαλύτερη η ακρίβεια.',
    positiveTitle: 'Positive (Θετικά)',
    positiveDesc: 'Ο αριθμός χρηστών που πληρούν το κριτήριο (π.χ. άκουσαν πάνω από Χ χρόνο).',
    positiveTip: 'Φιλτράρει τα "τυχαία clicks" από τους πραγματικούς ακροατές.',
    populationTitle: 'Population (Πληθυσμός)',
    populationDesc: 'Η συνολική εκτίμηση του δυνητικού πληθυσμού (π.χ. μοναδικοί ακροατές stream).',
    populationTip: 'Χρησιμοποιείται για την αναγωγή του ποσοστού σε πραγματικό αριθμό ακροατών.',
    percentageTitle: 'Ποσοστό (%)',
    percentageDesc: 'Positive / Sample',
    percentageTip: 'Δείχνει πόσο ισχυρό είναι κάθε daypart σε σχέση με το σύνολο.',
    estimatedListenersTitle: 'Εκτίμηση Ακροατών',
    estimatedListenersDesc: 'Ποσοστό × Πληθυσμός',
    estimatedListenersTip: 'Ο πιο κρίσιμος δείκτης: Πόσα άτομα πραγματικά ακούν τον σταθμό σε αυτή τη ζώνη.',
    ciTitle: 'CI 95% (Confidence Interval)',
    ciDesc: 'Στατιστικό εύρος αξιοπιστίας. Παράδειγμα: 18% – 22%',
    ciTip: 'Σημαίνει ότι με 95% βεβαιότητα, η πραγματική ακροαματικότητα βρίσκεται μέσα σε αυτό το εύρος.',
    fpcTitle: 'FPC – Finite Population Correction',
    fpcDesc: 'Χρησιμοποιείται όταν το δείγμα είναι μεγάλο και ο πληθυσμός είναι πεπερασμένος.',
    fpcTip: 'Βελτιώνει δραστικά την ακρίβεια των αποτελεσμάτων.',
    trendTitle: 'Weekly Trend (Γράφημα)',
    trendDesc: 'Απεικονίζει την εξέλιξη ακροαματικότητας ανά ημέρα, πτώσεις & αυξήσεις.',
    trendTip: 'Εντοπίζει πότε κάτι ΔΕΝ λειτουργεί.',
    howHelpsTitle: 'Πώς βοηθά έναν ραδιοφωνικό σταθμό',
    costReduction: 'Μείωση κόστους',
    costReductionItems: 'Εντοπισμός dayparts με χαμηλή απόδοση,Μείωση άσκοπων εξόδων σε παραγωγές που δεν αποδίδουν,Στοχευμένες αλλαγές αντί για γενικές επενδύσεις',
    audienceIncrease: 'Αύξηση ακροαματικότητας',
    audienceIncreaseItems: 'Βελτιστοποίηση playlist ανά ζώνη,Προσαρμογή περιεχομένου ανά ώρα,Ενίσχυση δυνατών dayparts,Διόρθωση αδύναμων πριν χαθεί το κοινό',
    playlistAdaptation: 'Προσαρμογή playlist & περιεχομένου',
    playlistAdaptationItems: 'Άλλο μουσικό flow στο morning,Άλλο στο drive,Άλλο στο overnight',
    playlistAdaptationNote: 'Ο μετρητής δείχνει πού κουράζεται ο ακροατής.',
    proDataTitle: 'Επαγγελματικά δεδομένα για διαφημιστές',
    proDataItems: 'Απόδειξη απόδοσης ανά ώρα,Αξιόπιστα νούμερα,Επιχειρήματα για καλύτερες χρεώσεις',
    understoodClose: 'Κατάλαβα, κλείσιμο',
    
    // Contact Form
    contactTitle: 'Επικοινωνία',
    contactDesc: 'Συμπληρώστε τη φόρμα για να επικοινωνήσετε μαζί μας',
    firstName: 'Όνομα',
    lastName: 'Επίθετο',
    stationName: 'Όνομα Σταθμού',
    region: 'Περιοχή',
    phone: 'Τηλέφωνο',
    email: 'Email',
    message: 'Μήνυμα',
    attachFile: 'Επισύναψη αρχείου',
    sendMessage: 'Αποστολή Μηνύματος',
    sending: 'Αποστολή...',
    messageSent: 'Το μήνυμά σας στάλθηκε επιτυχώς!',
    messageError: 'Υπήρξε σφάλμα κατά την αποστολή του μηνύματος',
    requiredField: 'Αυτό το πεδίο είναι υποχρεωτικό',
    invalidEmail: 'Παρακαλώ εισάγετε έγκυρο email',
    invalidPhone: 'Παρακαλώ εισάγετε έγκυρο τηλέφωνο',
    selectRegion: 'Επιλέξτε περιοχή',
    contactInfo: 'Στοιχεία Επικοινωνίας',
    nameRequired: 'Το όνομα είναι υποχρεωτικό',
    lastNameRequired: 'Το επίθετο είναι υποχρεωτικό',
    enterRealName: 'Παρακαλώ εισάγετε το πραγματικό σας όνομα',
    enterRealLastName: 'Παρακαλώ εισάγετε το πραγματικό σας επίθετο',
    minChars: 'Πρέπει να έχει τουλάχιστον 2 χαρακτήρες',
    enterValidName: 'Παρακαλώ εισάγετε έγκυρο όνομα',
    stationRequired: 'Το όνομα σταθμού είναι υποχρεωτικό',
    regionRequired: 'Η περιοχή είναι υποχρεωτική',
    phoneRequired: 'Το τηλέφωνο είναι υποχρεωτικό',
    emailRequired: 'Το email είναι υποχρεωτικό',
    businessEmailRequired: 'Παρακαλώ χρησιμοποιήστε επαγγελματικό email',
    messageRequired: 'Το μήνυμα είναι υποχρεωτικό',
    minMessageLength: 'Το μήνυμα πρέπει να έχει τουλάχιστον 10 χαρακτήρες',
    fileTooLarge: 'Το αρχείο είναι πολύ μεγάλο (μέγιστο 5MB)',
    invalidFileType: 'Μη έγκυρος τύπος αρχείου',
    regionCyprus: 'Κύπρος',
    regionAttica: 'Αττική',
    regionThessaloniki: 'Θεσσαλονίκη',
    regionCentralMacedonia: 'Κεντρική Μακεδονία',
    regionWestMacedonia: 'Δυτική Μακεδονία',
    regionEastMacedoniaThrace: 'Ανατολική Μακεδονία και Θράκη',
    regionEpirus: 'Ήπειρος',
    regionThessaly: 'Θεσσαλία',
    regionIonianIslands: 'Ιόνιοι Νήσοι',
    regionWestGreece: 'Δυτική Ελλάδα',
    regionCentralGreece: 'Στερεά Ελλάδα',
    regionPeloponnese: 'Πελοπόννησος',
    regionNorthAegean: 'Βόρειο Αιγαίο',
    regionSouthAegean: 'Νότιο Αιγαίο',
    regionCrete: 'Κρήτη',
    
    // Our Stations
    ourStationsTitle: 'Οι Σταθμοί Μας',
    ourStationsDesc: 'Demo stations με διάφορα music formats για δημιουργία playlists σε ραδιοφωνικούς σταθμούς και In-Store επιχειρήσεις.',
    listenLive: 'Ακούστε Ζωντανά',
    visitWebsite: 'Επίσκεψη Website',
    
    // SongInfo
    songInfoTitle: 'Πληροφορίες Τραγουδιών',
    songInfoDesc: 'Αναζητήστε πληροφορίες και προτάσεις εκφώνησης για τραγούδια',
    artistLabel: 'Καλλιτέχνης',
    titleLabel: 'Τίτλος',
    searchSongInfo: 'Αναζήτηση Πληροφοριών',
    searching: 'Αναζήτηση...',
    tipLatinChars: 'Χρησιμοποιήστε λατινικούς χαρακτήρες για καλύτερα αποτελέσματα',
    radioAnnouncement: 'Πρόταση Εκφώνησης',
    announcementTip: 'Χρησιμοποιήστε αυτό το κείμενο ως οδηγό για την παρουσίαση του τραγουδιού',
    fillArtistTitle: 'Παρακαλώ συμπληρώστε Artist και Title',
    fillArtistTitleSearch: 'Συμπληρώστε Artist και Title για αναζήτηση',
    infoFound: 'Βρέθηκαν πληροφορίες!',
    searchError: 'Σφάλμα αναζήτησης. Δοκιμάστε ξανά.',
    exampleArtist: 'π.χ. Σάκης Ρουβάς',
    exampleTitle: 'π.χ. 1992',
    
    // DaypartAnalyzer & Gold Analysis
    specialAnalysisForTracks: 'Ειδική ανάλυση για τραγούδια',
    withAvailableYear: 'με διαθέσιμο έτος',
    recommendations: 'Συστάσεις',
    goldHitDesc: 'Κορυφαία gold - Διατηρήστε σε rotation',
    goldKeeperDesc: 'Αξιόλογα - Συνεχίστε κανονικά',
    goldRotateDesc: 'OK απόδοση - Κανονική rotation',
    goldRestDesc: 'Κούρασαν - Διάλειμμα 1-2 μήνες',
    goldDropDesc: 'Χαμηλή απόδοση - Αντικαταστήστε',
    
    // Early Hit Predictor
    ehpTitle: 'Early Hit Predictor',
    ehpSubtitle: 'Πρόβλεψη Ραδιοφωνικών Επιτυχιών',
    ehpDescription: 'Το Early Hit Predictor εντοπίζει τραγούδια που δείχνουν πρώιμα σημάδια ραδιοφωνικής επιτυχίας. Το σύστημα εστιάζει στο τι είναι νέο στο ραδιόφωνο, όχι απαραίτητα νέες κυκλοφορίες.',
    ehpDescription2: 'Χρησιμοποιώντας τη συμπεριφορά της πρώτης εβδομάδας στο ραδιόφωνο σε πολλούς σταθμούς, εκτιμά την πιθανότητα ένα τραγούδι να εξελιχθεί σε radio hit.',
    ehpMetricsTitle: 'Επεξήγηση Μετρικών',
    ehpScoreLabel: 'EHP Score',
    ehpScoreDesc: 'Σύνθετη βαθμολογία (0-100) που συνδυάζει station spread, play velocity, TLH και daypart spread. Υψηλότερο = μεγαλύτερη πιθανότητα επιτυχίας.',
    ehpDaypartLabel: 'Daypart Spread',
    ehpDaypartDesc: 'Σε πόσα dayparts παίζεται το τραγούδι (1-5: Morning, Midday, Afternoon, Drive, Night). Μεγαλύτερο spread = ευρύτερη αποδοχή.',
    ehpRcsLabel: 'RCS Score',
    ehpRcsDesc: 'Release Confidence Score - πόσο πιθανό είναι να είναι νέα κυκλοφορία vs catalog. Βασίζεται σε radio age, velocity και station adoption.',
    ehpClarificationTitle: 'Σημαντική Διευκρίνιση',
    ehpClarification: '"Νέο στο ραδιόφωνο" δεν σημαίνει πάντα "νέα κυκλοφορία". Σημαίνει την πρώτη ουσιαστική υιοθέτηση από ραδιοφωνικούς σταθμούς.',
    ehpNote: 'Αυτό είναι εργαλείο πρόβλεψης — όχι κατάταξη chart.',
    ehpFooterNote: 'Το Early Hit Predictor είναι εργαλείο υποστήριξης αποφάσεων για επαγγελματίες μουσικής, όχι κατάταξη απόδοσης ή reporting chart.',
    ehpCategoryFilter: 'Κατηγορία',
    ehpRefresh: 'Ανανέωση',
    ehpNoResults: 'Δεν βρέθηκαν προβλέψεις',
    ehpNoResultsCategory: 'Δεν υπάρχουν τραγούδια στην κατηγορία',
    ehpNoResultsGeneral: 'Δεν υπάρχουν τραγούδια που πληρούν τα κριτήρια επιλεξιμότητας αυτή τη στιγμή.',
    ehpDetails: 'Λεπτομέρειες',
    ehpClose: 'Κλείσιμο',
    ehpCategoryStrong: 'STRONG',
    ehpCategoryGood: 'GOOD',
    ehpCategoryWeak: 'WEAK',
    ehpCategoryAll: 'Όλα',
    ehpStrongTooltip: 'Υψηλή πιθανότητα να γίνει radio hit με βάση την πρώιμη ραδιοφωνική συμπεριφορά.',
    ehpGoodTooltip: 'Δείχνει θετικά σημάδια, αλλά χρειάζεται περαιτέρω υποστήριξη.',
    ehpWeakTooltip: 'Χαμηλή πιθανότητα με βάση την τρέχουσα ραδιοφωνική ανταπόκριση.',
    ehpNewRelease: 'Νέα Κυκλοφορία',
    ehpRecentRelease: 'Πρόσφατη Κυκλοφορία',
    ehpCatalog: 'Catalog',
    ehpUnknownDate: 'Άγνωστη ημ/νία',
    ehpPlays: 'Plays',
    ehpTlh: 'TLH',
    ehpRcs: 'RCS',
    ehpDayparts: 'Dayparts',
    ehpSignalsNote: 'Supporting signals — χρησιμοποιούνται για να εξηγήσουν την πρόβλεψη, όχι για κατάταξη.',
    
    // Compare Stations Page
    compareStationsTitle: 'Σύγκριση Ραδιοφωνικών Σταθμών',
    compareStationsSubtitle: 'Σύγκριση απόδοσης σταθμών',
    compareStationsDesc: 'Συγκρίνετε πώς δύο ραδιοφωνικοί σταθμοί αποδίδουν με την ίδια μουσική, με βάση την αντίδραση του κοινού.',
    selectStation: 'Επιλέξτε σταθμό',
    noStationsAvailable: 'Δεν υπάρχουν διαθέσιμοι σταθμοί',
    selectTwoStations: 'Επιλέξτε δύο διαφορετικούς σταθμούς για να ξεκινήσετε τη σύγκριση.',
    compareButton: 'Σύγκριση Σταθμών',
    comparing: 'Σύγκριση...',
    noCommonSongs: 'Δεν βρέθηκαν κοινά τραγούδια μεταξύ των δύο σταθμών.',
    noUniqueSongs: 'Δεν υπάρχουν μοναδικά τραγούδια.',
    playlistsCompletelyDifferent: 'Οι playlists είναι εντελώς διαφορετικές.',
    songs: 'τραγούδια',
    plays: 'plays',
    commonSongsPerformance: 'Απόδοση Κοινών Τραγουδιών',
    playlistDifferentiation: 'Διαφοροποίηση Playlist',
    uniqueTo: 'Μοναδικά στο',
    daypartBreakdown: 'Ανάλυση ανά Ζώνη Ώρας',
    daypartListenerReaction: 'Αντίδραση ακροατών ανά χρονική ζώνη',
    daypartComparisonNote: 'Σύγκριση αντίδρασης ακροατών ανά χρονική ζώνη (daypart) με βάση τα κοινά τραγούδια.',
    aggregateMetricsNote: 'Τα παραπάνω metrics είναι aggregate ανά σταθμό. Δεν υπάρχει κατάταξη ή "νικητής".',
    clickForDaypart: 'Κάντε κλικ σε ένα τραγούδι για να δείτε το daypart breakdown',
    stationComparisonDisclaimer: 'Συγκρίνει σταθμούς μεταξύ τους — όχι τραγούδια εντός ενός σταθμού. Δεν χρησιμοποιούνται ετικέτες κατάταξης (POWER, GOLD, κτλ).',
    noAccessCompare: 'Δεν έχετε πρόσβαση στη σύγκριση σταθμών',
    
    // Compare Stations - Description boxes
    whatIsCompareStations: 'Τι είναι το Compare Stations',
    compareStationsDescP1: 'Το εργαλείο Compare Stations σας επιτρέπει να συγκρίνετε πώς αποδίδουν δύο ραδιοφωνικοί σταθμοί με το κοινό τους κατά την ίδια χρονική περίοδο.',
    compareStationsDescP2: 'Η σύγκριση βασίζεται σε μετρικές αντίδρασης ακροατών (listener reaction metrics) — όχι απλώς σε ραδιοφωνικές μεταδόσεις — και χρησιμοποιεί ενοποιημένες ταυτότητες τραγουδιών για αποφυγή διπλότυπων ή ασυνεπών αποτελεσμάτων.',
    selectStationsAndPeriod: 'Επιλογή Σταθμών & Χρονικής Περιόδου',
    timePeriod: 'Χρονική Περίοδος',
    contactForAccess: 'Για να αποκτήσετε πρόσβαση στη σύγκριση σταθμών, επικοινωνήστε μαζί μας.',
    contact: 'Επικοινωνία',
    
    // Time windows
    previousWeek: 'Προηγούμενη Εβδομάδα',
    last7Days: 'Τελευταίες 7 Ημέρες',
    last14Days: 'Τελευταίες 14 Ημέρες',
    last30Days: 'Τελευταίες 30 Ημέρες',
    thisMonth: 'Αυτός ο Μήνας',
    lastMonth: 'Προηγούμενος Μήνας',
    
    // Radio Chart / People's Chart
    radioChartTitle: 'The People\'s Chart',
    radioChartSubtitle: 'Τα τραγούδια που οι ακροατές ακούνε μέχρι τέλους',
    radioChartDesc: 'Chart βασισμένο σε listener retention, όχι απλά plays.',
    noDataFound: 'Δεν βρέθηκαν δεδομένα',
    noDataForPeriod: 'Δεν βρέθηκαν δεδομένα για αυτή την περίοδο',
    chartComingSoon: 'Σύντομα διαθέσιμο!',
    chartUnderConstruction: 'Το chart που διαμορφώνουν οι ακροατές βρίσκεται υπό κατασκευή.',
    chartFromListeners: 'Προκύπτει από τους ακροατές που ακούνε ολόκληρα τα τραγούδια, από τους καλύτερους ραδιοφωνικούς σταθμούς της χώρας.',
    chartTopSongsDesc: 'τραγούδια που οι ακροατές δεν αλλάζουν σταθμό - ακούν μέχρι τέλους, στους καλύτερους σταθμούς της χώρας',
    chartDescription: 'Top 300 - Κατάταξη βάσει ακρόασης σε ελληνικούς ραδιοσταθμούς',
    clickSongForTrend: 'Κάντε κλικ σε τραγούδι για 30-ημερο trend',
    loginForFull300: 'Συνδεθείτε για το πλήρες Top 300',
    periodYesterday: 'Χθες',
    periodPrevWeek: 'Προηγ. Εβδομάδα (Δευ-Κυρ)',
    period2Weeks: '2 Εβδομάδες',
    period3Weeks: '3 Εβδομάδες',
    period4Weeks: '4 Εβδομάδες (Μήνας)',
    howChartCalculated: 'Πώς υπολογίζεται το Chart',
    howChartRanked: 'Πώς υπολογίζεται η κατάταξη:',
    scoredBy3Factors: 'Κάθε τραγούδι βαθμολογείται με βάση 3 παράγοντες:',
    retentionDesc: 'Πόσοι ακροατές παρέμειναν μέχρι το τέλος',
    playsDesc: 'Πόσες φορές μεταδόθηκε σε όλους τους σταθμούς',
    earlyDropDesc: 'Πόσοι έφυγαν νωρίς (χαμηλότερο = καλύτερο)',
    excelDownloaded: 'Excel αρχείο κατέβηκε επιτυχώς!',
    excelDownloadError: 'Σφάλμα λήψης Excel',
    connectionError: 'Σφάλμα σύνδεσης',
    chartLoadError: 'Σφάλμα φόρτωσης chart',
    stationsCount: 'σταθμοί',
    artistColumn: 'Καλλιτέχνης',
    titleColumn: 'Τίτλος',
    stationsColumn: 'Σταθμοί',
    wantFullTop300: 'Θέλετε να δείτε όλο το Top 300;',
    getAccessDesc: 'Αποκτήστε πρόσβαση στο πλήρες chart με 300 τραγούδια, λεπτομερή στατιστικά και ημερήσια ανάλυση ανά σταθμό.',
    viewPackagesBtn: 'Δείτε τα πακέτα',
    loginBtn: 'Σύνδεση',
    freeTrial24hNew: 'Δωρεάν δοκιμή 48 ωρών για νέους χρήστες',
    plays7Days: 'plays (7 ημέρες)',
    dayColumn: 'Ημέρα',
    timesColumn: 'Ώρες',
    
    // Songs Analyzer
    songsAnalyzerTitle: 'Songs Analyzer',
    songsAnalyzerSubtitle: 'Αναλυτικά στοιχεία τραγουδιών ανά σταθμό',
    songsAnalyzerMetricsNote: 'Τα metrics βασίζονται σε ανάλυση σταθερότητας και συμπεριφοράς του stream. Δεν περιλαμβάνονται πραγματικοί concurrent listeners.',
    liveAudienceTooltip: 'Τα metrics βασίζονται σε πραγματικούς concurrent listeners από τον streaming server του σταθμού.\nΗ ανάλυση αποτυπώνει την πραγματική αντίδραση του κοινού σε κάθε τραγούδι.',
    noAccessSongsAnalyzer: 'Δεν έχετε πρόσβαση',
    noDataForPeriodSongs: 'Δεν υπάρχουν δεδομένα για την επιλεγμένη περίοδο',
    selectYesterdayForDaypart: 'Επιλέξτε "Χθες" ή άλλη περίοδο για να δείτε την ανάλυση ανά ζώνη ώρας.',
    noDataForDaypart: 'Δεν υπάρχουν δεδομένα για αυτή τη ζώνη ώρας',
    noDataDayparts: 'Δεν υπάρχουν δεδομένα dayparts για την επιλεγμένη περίοδο',
    
    // Early Hit Predictor
    ehpNoResults: 'Δεν βρέθηκαν προβλέψεις',
    ehpNoSongsInCategory: 'Δεν υπάρχουν τραγούδια στην κατηγορία',
    ehpNoEligibleSongs: 'Δεν υπάρχουν τραγούδια που πληρούν τα κριτήρια επιλεξιμότητας αυτή τη στιγμή.',

    // v2.9.203 — Plays vs Behavior Comparison (About page hero)
    pvbWhyDifferent: 'Γιατί διαφέρουμε',
    pvbTitlePartA: 'Απλή Καταγραφή Τραγουδιών',
    pvbVs: 'vs',
    pvbTitlePartB: 'Συμπεριφορά Ακροατών',
    pvbDescription: 'Η καταγραφή των plays δείχνει μόνο τι μεταδόθηκε. Η ανάλυση συμπεριφοράς ακροατών αποκαλύπτει',
    pvbWhatReallyWorks: 'τι πραγματικά λειτουργεί',
    pvbDescriptionEnd: ', τι κρατά το κοινό συντονισμένο και ποιες αποφάσεις οδηγούν σε αύξηση ακροαματικότητας και εσόδων.',
    pvbRetentionStat: 'Αύξηση παραμονής ακροατών στη συχνότητα έως',
    pvbTraditionalApproach: 'Παραδοσιακή προσέγγιση',
    pvbSimpleSongTrackingPlays: 'Απλή Καταγραφή Τραγουδιών (Plays)',
    pvbFullAnalysis: 'Πλήρης Ανάλυση',
    pvbSongAndBehavior: 'Τραγούδι + Συμπεριφορά Ακροατών',
    pvbPlays1: 'Πόσες φορές έπαιξε ένα τραγούδι',
    pvbPlays2: 'Playlist & Rotation δεδομένα μόνο',
    pvbPlays3: 'Καμία εικόνα για την ανταπόκριση του κοινού',
    pvbPlays4: 'Άγνωστη η επίδραση στους ακροατές',
    pvbPlays5: 'Αποφάσεις βασισμένες σε υποθέσεις',
    pvbPlays6: 'Μετρά τι έπαιξε',
    pvbPlays7: 'Ιστορική καταγραφή',
    pvbPlays8: 'Στατιστικά playlist',
    pvbPlays9: 'Δεν δείχνει γιατί ανεβαίνει ή πέφτει η ακροαματικότητα',
    pvbPlays10: 'Περιορισμένη αξιοποίηση δεδομένων',
    pvbBehavior1: 'Καταγραφή συμπεριφοράς ακροατών σε πραγματικό χρόνο',
    pvbBehavior2: 'Engagement του ακροατή σε κάθε στιγμή',
    pvbBehavior3: 'Μέτρηση Tune-in, Engagement, Tune-out και Retention',
    pvbBehavior4: 'Ανάλυση μέσα στο δικό σας format, schedule, programming και market',
    pvbBehavior5: 'Data-driven αποφάσεις βασισμένες σε πραγματικά δεδομένα',
    pvbBehavior6: 'Μετρά τι άρεσε και τι απέδωσε',
    pvbBehavior7: 'Real-time insights',
    pvbBehavior8: 'Στατιστικά κοινού και συμπεριφοράς',
    pvbBehavior9: 'Εντοπίζει τι επηρεάζει την ακροαματικότητα',
    pvbBehavior10: 'Πλήρης αξιοποίηση δεδομένων για ανάπτυξη σταθμού',
    pvbWantToKnowA: 'Θέλετε να γνωρίζετε',
    pvbWhatReallyLiked: 'τι αρέσει πραγματικά',
    pvbWantToKnowB: 'στους ακροατές σας;',
    pvbContactPromo: 'Επικοινωνήστε με τη Radio Solutions για παρουσίαση του συστήματος ανάλυσης συμπεριφοράς ακροατών.',
    pvbRequestDemo: 'Ζητήστε Παρουσίαση',
    pvbTrustedByA: 'Μας εμπιστεύονται',
    pvbStations: 'σταθμοί',

    // v2.9.203 — Songs Analyzer common UI
    saStreamUrlSuggestion: 'Πρόταση Stream URL',
    saSongs: 'Τραγούδια',
    burnWeek: "Εβδομάδα {{from}} - {{to}} · {{n}} τραγούδια",
    burnPeriodNote: "Τελευταία πλήρης εβδομάδα (Δευτέρα-Κυριακή)",
    burnSearch: "Αναζήτηση…",
    burnPage: "Σελίδα {{p}} / {{n}}",
    burnLoading: "Φόρτωση…",
    burnError: "Δεν ήταν δυνατή η φόρτωση.",
    burnPending: "Η εβδομαδιαία ανάλυση Burn ετοιμάζεται. Ενημερώνεται κάθε Δευτέρα μετά τα μεσάνυχτα.",
    burnEmpty: "Δεν υπάρχουν δεδομένα για την τελευταία πλήρη εβδομάδα.",
    burnNoAudience: "Δεν υπάρχουν αξιόπιστα στοιχεία ακροατών για αυτόν τον σταθμό.",
    burnAudienceWarn: "Λίγα spins με μετρήσεις ακροατών αυτή την εβδομάδα: ενδεικτικά αποτελέσματα.",
    burnColArtist: "Καλλιτέχνης",
    burnColTitle: "Τίτλος",
    burnColYear: "Έτος",
    burnColSpins: "Spins",
    burnCol4w: "4 εβδ.",
    burnColBurn: "Burn",
    burnColDelta: "Delta",
    burnColTrend: "Τάση",
    burnColStatus: "Κατάσταση",
    burnTapHint: "Πατήστε την ετικέτα κατάστασης για εξήγηση.",
    burnStIncreasing: "Αυξάνεται",
    burnStStable: "Σταθερό",
    burnStDecreasing: "Μειώνεται",
    burnStHighExposure: "Υψηλή έκθεση",
    burnTipHighWeeks: "Στο πάνω επίπεδο spins του σταθμού: {{n}} από τις 4 εβδομάδες.",
    burnTipStationChoice: "Δείχνει την επιλογή του σταθμού, όχι την αντίδραση των ακροατών.",
    burnAdvIncreasing: "Ο σταθμός το παίζει όλο και περισσότερο.",
    burnAdvStable: "Ο σταθμός κρατά τα ίδια spins.",
    burnAdvDecreasing: "Ο σταθμός ήδη μειώνει τα spins.",
    burnAdvHighExposure: "Πολλές εβδομάδες στο πάνω επίπεδο: κίνδυνος κούρασης. Αν υπάρχουν στοιχεία ακροατών, ελέγξτε το Audience.",
    burnAirplayNote: "Airplay: δείχνει μόνο την επιλογή του σταθμού (spins). Δεν μετρά ακροατές.",
    burnTipWeekSpins: "Αυτή την εβδομάδα ({{from}}-{{to}}): {{spins}} spins, {{diff}}.",
    burnTipMore: "{{n}} περισσότερα από την προηγούμενη",
    burnTipLess: "{{n}} λιγότερα από την προηγούμενη",
    burnTipSame: "ίδια με την προηγούμενη",
    burnTipWeekLoss: "Αυτή την εβδομάδα ({{from}}-{{to}}): όταν παίζει, φεύγει το {{d}}% των ακροατών.",
    burnTipWeekGain: "Αυτή την εβδομάδα ({{from}}-{{to}}): όταν παίζει, έρχονται {{d}}% περισσότεροι ακροατές.",
    burnSortHint: "Πατήστε τίτλο στήλης για ταξινόμηση.",
    burnLegendAirplay: "Burn 0-100 = πίεση rotation: πόσα spins δίνει ο σταθμός σε σχέση με τα πιο παιγμένα του, πόσες εβδομάδες το κράτησε στο πάνω επίπεδο και πόσο έπεσαν τα spins από την κορυφή του μήνα. Δεν μετρά την αντίδραση των ακροατών.",
    burnLegendAudience: "Audience: Delta = μέση μεταβολή ακροατών όσο παίζει το τραγούδι. Πράσινο/κίτρινο/κόκκινο = καλύτερο/μεσαίο/χειρότερο τρίτο του σταθμού. Τάση = σύγκριση με τις 3 προηγούμενες εβδομάδες.",
    burnStBurning: "Καίγεται",
    burnStTiring: "Κουράζει",
    burnStRising: "Ανεβαίνει",
    burnStSteady: "Σταθερό",
    burnStLosing: "Χάνει ακροατές",
    burnStNeutral: "Ουδέτερο",
    burnStHolding: "Κρατά ακροατές",
    burnTipLowSample: "Μόνο {{n}} από {{total}} spins είχαν μέτρηση ακροατών.",
    burnAdvBurning: "Τι να κάνετε: μειώστε τα spins ή ξεκουράστε το για λίγο.",
    burnAdvTiring: "Τι να κάνετε: μην αυξήσετε τα spins, παρακολουθήστε το.",
    burnAdvRising: "Τι να κάνετε: έχει δυναμική, μπορεί να πάρει περισσότερα spins.",
    burnAdvSteady: "Τι να κάνετε: καμία αλλαγή.",
    burnAdvLosing: "Τι να κάνετε: ελέγξτε την ώρα μετάδοσης ή μειώστε τα spins.",
    burnAdvNeutral: "Τι να κάνετε: καμία άμεση αλλαγή.",
    burnAdvHolding: "Τι να κάνετε: αποδίδει καλά, κρατήστε το.",
    saBroadcasts: 'Μεταδόσεις',
    saTabAll: 'Σύνολο',
    saTabPrefecture: 'Νομός',
    saListenerStats: 'Στατιστικά Ακροατών',
    saMoreStations: 'Θέλετε πρόσβαση σε περισσότερους σταθμούς;',
    saMoreStationsDesc: 'Επικοινωνήστε μαζί μας για να προσθέσουμε επιπλέον σταθμούς στον λογαριασμό σας.',
    saContact: 'Επικοινωνία',
    saExcel: 'Excel',
    saMetadataOnly: 'Metadata-only',
    saYesterdayFull: 'Χθες (✅ Πλήρες)',

    // v2.9.203 — Compare Stations page
    csTitle: 'Compare Radio Stations',
    csSubtitle: 'Σύγκριση απόδοσης σταθμών',
    csWhatIs: 'Τι είναι το Compare Stations',
    csWhatIsP1: 'Το εργαλείο Compare Stations σας επιτρέπει να συγκρίνετε πώς δύο ραδιοφωνικοί σταθμοί αποδίδουν με το κοινό τους στην ίδια χρονική περίοδο.',
    csWhatIsP2: 'Η σύγκριση βασίζεται σε μετρικές αντίδρασης ακροατών — όχι μόνο στις μεταδόσεις — και χρησιμοποιεί ενιαία song identities για αποφυγή διπλοεγγραφών ή ασυνεπών αποτελεσμάτων.',
    csSelectStations: 'Επιλογή Σταθμών & Χρονικής Περιόδου',
    csModeStation: 'Σταθμός vs Σταθμός',
    csModeGroup: 'Όμιλος vs Όμιλος',
    csModeCategory: 'Κατηγορία vs Κατηγορία',
    csCategoryA: 'Κατηγορία Α',
    csCategoryB: 'Κατηγορία Β',
    csTimePeriod: 'Χρονική Περίοδος',
    csSelectCategory: 'Επιλέξτε Κατηγορία',
    csPeriod7d: '7 ημέρες',
    csPeriod14d: '14 ημέρες',
    csPeriod30d: '30 ημέρες',
    csCompareBtn: 'Compare Stations',
    csSelectTwo: 'Επιλέξτε δύο διαφορετικούς σταθμούς για να ξεκινήσει η σύγκριση.',

    // v2.9.205 — Performance Score Section (Music Performance)
    perfLoading: 'Φόρτωση...',
    perfNoData: 'Δεν έχουμε αρκετά στοιχεία ακόμα',
    perfNoDataMsg: 'Μάζεψε λίγη περισσότερη δραστηριότητα και θα σου πούμε πώς τα πας.',
    perfTierLocal: 'Περιοχή σου',
    perfTierFormat: 'Ίδιο format πανελλαδικά',
    perfTierNational: 'Εθνικός μέσος',
    perfTierPersonal: 'Προσωπική πρόοδος',
    perfPeriodLabel: 'Περίοδος:',
    perfPeriodFull: 'Προηγούμενη πλήρη εβδομάδα',
    perfPeriodTip: 'Για σταθερή σύγκριση χρησιμοποιείται πάντα η τελευταία ολοκληρωμένη εβδομάδα',
    perfPersonalDescA: 'Προσωπική πρόοδος',
    perfPersonalDescB: '— βλέπεις την εξέλιξή σου εβδομάδα με εβδομάδα.',
    perfCompareNationalA: 'Σύγκριση με τον',
    perfCompareNationalB: 'εθνικό μέσο όρο',
    perfCompareNationalC: 'όλων των σταθμών στην πλατφόρμα.',
    perfCompareAvgA: 'Σύγκριση με τον',
    perfCompareAvgB: 'μέσο όρο',
    perfCompareAvgC: 'των',
    perfActivity: 'Πόσο συχνά παίζεις',
    perfVariety: 'Ποικιλία μουσικής',
    perfYou: 'Εσύ:',
    perfPerWeek: '/εβδομάδα',
    perfAvgNational: 'Εθνικός μέσος:',
    perfAvgLocal: 'Μέσος περιοχής σου:',
    perfAvgFormat: 'Μέσος ίδιου format:',
    perfAvgGeneric: 'Μέσος όρος:',
    perfAvgPin: 'μέσος',
    perfAvgTooltip: 'Μέσος όρος',
    perfAdvice: 'Συμβουλή',
    perfDow: ['Κυρ','Δευ','Τρι','Τετ','Πεμ','Παρ','Σαβ'],

    // v2.9.205 — Daypart Legend / Songs Analyzer Daypart view
    daypartMetrics: 'Daypart Metrics',
    daypartSubtitle: 'Αντίδραση Ακροατών ανά Ζώνη Ώρας',
    daypartGuide: 'Οδηγός',
    daypartMorning: 'Πρωί',
    daypartMidday: 'Μεσημέρι',
    daypartAfternoon: 'Απόγευμα',
    daypartDrive: 'Drive Time',
    daypartEvening: 'Βράδυ',
    daypartNight: 'Νύχτα',
    daypartPlays: 'plays',
    daypartSongsCount: 'τραγούδια',
    daypartSearch: 'Αναζήτηση τραγουδιού ή καλλιτέχνη...',
    daypartColPlays: 'Plays',
    daypartColSongs: 'Τραγούδια',
    daypartColTLH: 'TLH',
    daypartSortHint: 'Κλικ στους τίτλους για ταξινόμηση',

    // v2.9.205 — Era Chart
    eraChartTitle: 'Era Chart',
    eraChartSubtitle: 'Κατανομή ανά δεκαετία και έτος. Κλικ σε μπάρα για φιλτράρισμα στο «Σύνολο».',
    eraChartPlays: 'plays',
    eraChartUnique: 'unique',
    eraChartTogglePlays: 'Plays',
    eraChartToggleVariety: 'Variety',
    eraChartYears: 'έτη',
    eraChartYear: 'έτος',
    eraChartUnknownYear: 'Άγνωστο έτος',
    eraChartFooterPlays: 'Δείκτης: μεταδόσεις · Σύνολο:',
    eraChartFooterUnique: 'Δείκτης: unique τραγούδια · Σύνολο:',

    // v2.9.205 — Playlist Chart / Top Artists / Common columns
    colArtist: 'Καλλιτέχνης',
    colTitle: 'Τίτλος',
    colPlays: 'Plays',
    colAvgListeners: 'Avg Ακρ.',
    colTLH: 'TLH',
    colRetention: 'Ret%',
    colEarly: 'Early',
    colLSI: 'LSI',
    colScore: 'Score',
    colAImpact: 'A.Impact',
    colYear: 'Έτος',
    colRank: 'Rank',
    topArtistsDiffSongs: 'διαφορετικά τραγούδια',
    playlistApply: 'Εφαρμογή',
    playlistPrevWeek: 'Προηγ. Εβδομάδα',
    dowShort: ['Δευ','Τρι','Τετ','Πεμ','Παρ','Σαβ','Κυρ'],
    // ─── i18n Batch #3 (v2.10.0+) — Songs Analyzer subcomponents ───
    i18nB3_morning_06_10: 'Πρωί 06-10',
    i18nB3_midday_10_15: 'Μεσημέρι 10-15',
    i18nB3_drive_15_19: 'Απόγευμα 15-19',
    i18nB3_night_22_06: 'Νύχτα 22-06',
    i18nB3_all_day: 'Ολη μέρα',
    i18nB3_our_avg: 'Δικά μας Avg',
    i18nB3_numbers: 'Αριθμοί',
    i18nB3_listener_stats: 'Στατιστικά Ακροατών',
    i18nB3_your_audience: 'Το κοινό σου',
    i18nB3_hour: 'Ωρα',
    i18nB3_listeners: 'ακροατές',
    i18nB3_avg_short: 'μ.ο.',
    i18nB3_loyal: 'Πιστό',
    i18nB3_passing: 'Περαστικό',
    i18nB3_normal: 'Φυσιολογικό',
    i18nB3_audience_exact: 'Ακριβή δεδομένα από τον server του σταθμού',
    i18nB3_audience_estimate: 'Ο server δεν δίνει πλήρη στοιχεία — η τιμή είναι εκτίμηση',
    i18nB3_audience_unavailable: 'Ο server του σταθμού σου δεν μας δίνει αυτή την πληροφορία ακόμα.',
    i18nB3_audience_renewal: 'κάθε ώρα έρχεται νέο κοινό (εκτίμηση)',
    i18nB3_unknown_year: 'Άγνωστο έτος',
    i18nB3_expand: 'Επέκταση',
    i18nB3_collapse: 'Σύμπτυξη',
    i18nB3_day_mon: 'Δευ',
    i18nB3_day_tue: 'Τρι',
    i18nB3_day_wed: 'Τετ',
    i18nB3_day_thu: 'Πεμ',
    i18nB3_day_fri: 'Παρ',
    i18nB3_day_sat: 'Σαβ',
    i18nB3_day_sun: 'Κυρ',
    i18nB3_next_song: 'Επόμενο τραγούδι',
    i18nB3_prev_song: 'Προηγούμενο τραγούδι',
    i18nB3_genre_artistic: 'Έντεχνη',
    i18nB3_genre_intl: 'Διεθνής / Ξένη',
    i18nB3_genre_greek: 'Ελληνική',
    i18nB3_genre_mixed: 'Μικτή',
    i18nB3_genre_rock: 'Ροκ',
    i18nB3_group: 'Όμιλος',
    i18nB3_group_vs_group: 'Όμιλος vs Όμιλος',
    i18nB3_genre: 'Κατηγορία',
    i18nB3_genre_vs_genre: 'Κατηγορία vs Κατηγορία',
    i18nB3_close: 'Κλείσιμο',
    i18nB3_select_station: 'Επιλογή σταθμού',
    i18nB3_stations: 'Σταθμοί',
    i18nB3_station: 'Σταθμός',
    i18nB3_station_vs_station: 'Σταθμός vs Σταθμός',
    i18nB3_compare: 'Σύγκριση',
    i18nB3_not_run_yet: 'Δεν έτρεξε ακόμα',
    i18nB3_start_year_search: 'Εκκίνηση αναζήτησης ετών',
    i18nB3_just_now: 'Μόλις τώρα',
    i18nB3_never: 'Ποτέ',
    i18nB3_running: 'Τρέχει...',
    i18nB3_now: 'Τώρα!',
    i18nB3_your_performance: 'Η επίδοσή σου',
    i18nB3_export_timeline_excel: 'Εξαγωγή timeline σε Excel (.xlsx)',
    i18nB3_confirmed_fp: 'Επιβεβαιωμένο από audio fingerprint',
    i18nB3_hide_gaps_hint: 'Κρύβει μικρά κενά που οφείλονται σε duration mismatches/crossfades. Default 5min.',
    i18nB3_async_analysis_in_progress: 'Ασύγχρονη ανάλυση σε εξέλιξη...',
    i18nB3_upload_csv_first: 'Παρακαλώ ανεβάστε πρώτα ένα αρχείο CSV',
    i18nB3_connection_error_retry: 'Σφάλμα σύνδεσης. Παρακαλώ δοκιμάστε ξανά.',
    i18nB3_too_many_requests: 'Υπερβολικά πολλά αιτήματα, επαναπροσπάθεια σε 3s...',
    // ── Clock View (Programming Clocks) — added 2026-06-15
    clkView_listView: 'Λίστα',
    clkView_clockView: 'Ρολόι',
    clkView_hourFrom: 'Από ώρα',
    clkView_hourTo: 'Έως ώρα',
    clkView_exportPdf: 'Εξαγωγή PDF',
    clkView_exportingPdf: 'Δημιουργία PDF…',
    clkView_loadingClocks: 'Φόρτωση ρολογιών…',
    clkView_noActiveHours: 'Δεν υπάρχουν ενεργές ώρες προγραμματισμού για αυτή την ημερομηνία.',
    clkView_emptyHour: 'Δεν υπάρχει περιεχόμενο για αυτή την ώρα.',
    clkView_songs: 'τραγούδια',
    clkView_breaks: 'κενά',
    clkView_song: 'Τραγούδι',
    clkView_break: 'Κενό / Διάλειμμα',
    clkView_listenersStart: 'Έναρξη',
    clkView_listenersEnd: 'Τέλος',
    clkView_listenersPeak: 'Κορυφή',
    clkView_listenersAvg: 'Μ.Ο.',
    clkView_retention: 'Διατήρηση',
    clkView_earlyDrop: 'Πρώιμη Αποχώρηση',
    clkView_lsi: 'Δείκτης Ακρόασης',
    clkView_score: 'Σκορ',
    clkView_severitySevereLoss: 'Σοβαρή απώλεια',
    clkView_severitySignificantLoss: 'Σημαντική απώλεια',
    clkView_severityMinorLoss: 'Μικρή απώλεια',
    clkView_severityStable: 'Σταθερό',
    clkView_severityMinorGain: 'Μικρή αύξηση',
    clkView_severityStrongGain: 'Σημαντική αύξηση',
    clkView_severityUnknown: 'Άγνωστο',
    clkView_netHour: 'Σύνολο ώρας',
    clkView_categoryPower: 'POWER',
    clkView_categorySecondary: 'SECONDARY',
    clkView_categoryCurrents: 'CURRENTS',
    clkView_categoryRecurrents: 'RECURRENTS',
    clkView_categoryGold: 'GOLD',
    clkView_categorySlowDown: 'SLOW DOWN',
    clkView_categoryCut: 'CUT',
    clkView_legendTitle: 'Υπόμνημα',
    clkView_legendSongCategories: 'Κατηγορίες Τραγουδιών',
    clkView_legendBreakSeverity: 'Σοβαρότητα Διαλείμματος',
    clkView_legendBreaksSingle: 'Διαλείμματα',
    clkView_listenersUnit: 'ακροατές',
    clkView_clickToSee: 'Κάντε κλικ σε ένα κομμάτι του ρολογιού για λεπτομέρειες',
    clkView_sparklineTitle: 'Ακροατές ανά 5 λεπτά',
    clkView_min: 'ελάχ',
    clkView_max: 'μέγ',
    clkView_thisHourLabel: 'Αυτή η ώρα',
    clkView_legendSongs: 'Τραγούδια',
    clkView_song: 'Μουσική',
    clkView_legendHelp: 'Κάντε κλικ σε ένα κομμάτι για λεπτομέρειες',
    clkView_talk: 'Ομιλία',
    clkView_talks: 'ομιλίες',
    clkView_breakHint: '1-4 λεπτά στα slots :25 :30 :55 :00',
    clkView_talkHint: 'εκτός παραπάνω',
    clkView_noData: 'χωρίς δεδομένα',
    clkView_noDataHint: 'περιεχόμενο εκτός μουσικής — προς διερεύνηση',
    // ─── Classifier Shadow Report (v2.13.0) ───
    clfReport_title: 'Αναφορά Classifier (Σκιά)',
    clfReport_subtitle: 'Αξιολόγηση inaSpeechSegmenter σε πραγματικά Shazam attempts',
    clfReport_gateMode: 'Mode',
    clfReport_classifierReady: 'classifier ενεργός',
    clfReport_classifierUnavail: 'classifier μη διαθέσιμος',
    clfReport_refresh: 'Ανανέωση',
    clfReport_downloadCsv: 'Λήψη CSV',
    clfReport_musicPct: 'Music %',
    clfReport_speechPct: 'Speech %',
    clfReport_speechMusicPct: 'Speech + Music %',
    clfReport_noisePct: 'Noise %',
    clfReport_potentialReduction: 'Δυνητική Μείωση Fingerprints',
    clfReport_potentialReduction_hint: 'Πόσα Shazam calls θα γλιτώναμε αν ενεργοποιούσαμε το gating τώρα.',
    clfReport_actualReduction: 'Πραγματική Μείωση Fingerprints',
    clfReport_actualReduction_hint: 'Active Gating ΕΝΕΡΓΟ: Πόσα Shazam calls γλιτώθηκαν στο τρέχον παράθυρο. SKIPPED / σύνολο πραγματικών calls.',
    clfReport_callsSaved: 'Shazam Calls Saved',
    clfReport_callsSaved_hint: 'Πραγματικός αριθμός κλήσεων που μπλοκαρίστηκαν από το active gating (column SKIPPED του cross-table).',
    // v2.13.19 (2026-02) — Content Mix view (per-station weekly breakdown).
    contentMix_tabLabel: 'Περιεχόμενο',
    contentMix_currentWeek: 'Τρέχουσα Εβδομάδα',
    contentMix_previousWeek: 'Προηγούμενη Εβδομάδα',
    contentMix_loading: 'Φόρτωση…',
    contentMix_noSamples: 'Δεν υπάρχουν διαθέσιμες πληροφορίες',
    contentMix_music: 'Μουσική',
    contentMix_speech: 'Ομιλία',
    contentMix_mixed: 'Μεικτό (DJ/Διαφ.)',
    contentMix_adsEstimate: 'Διαφ. (εκτίμηση)',
    contentMix_ads_hint: 'Heuristic: συνεχόμενα speech+music samples διάρκειας 20-40s = πιθανές διαφημίσεις.',
    contentMix_coverage: 'Κάλυψη',
    contentMix_coverage_hint: 'Ποσοστό samples που ταξινομήθηκαν με επιτυχία (όχι timeout/error).',
    contentMix_hourlyTable: 'Ανά ώρα',
    contentMix_disclaimer: 'Mixed = ομιλία πάνω σε μουσικό χαλί (DJ talkover ή διαφημίσεις). Η εκτίμηση διαφημίσεων (~) βασίζεται σε runs 20-40s — directional, όχι ακριβής μέτρηση.',
    contentMix_covTitle: 'Κάλυψη παρακολούθησης',
    contentMix_covGapsLabel: 'Εκτός παρακολούθησης',
    contentMix_covNoGaps: 'Χωρίς κενά παρακολούθησης σε αυτό το παράθυρο ✓',
    contentMix_covCauseRestart: 'επανεκκίνηση συστήματος',
    contentMix_covCauseOutage: 'διακοπή παρακολούθησης',
    contentMix_covNote: 'Τα ποσοστά περιεχομένου υπολογίζονται μόνο στον χρόνο ενεργής παρακολούθησης — τα κενά ΔΕΝ χρεώνονται στον σταθμό.',
    contentMix_covH: 'ω',
    contentMix_covM: 'λ',
    // Severity bands — used by BreakRow badge (Greek copy per operator request).
    severityBand_strong_gain: 'Μεγάλη Αύξηση',
    severityBand_minor_gain: 'Μικρή Αύξηση',
    severityBand_stable: 'Σταθερό',
    severityBand_minor_loss: 'Μικρή Πτώση',
    severityBand_significant_loss: 'Σημαντική Πτώση',
    severityBand_severe_loss: 'Μεγάλη Πτώση',
    severityBand_unknown: 'Άγνωστο',
    clfReport_potentialLost: 'Δυνητικά Χαμένα HITs',
    clfReport_potentialLost_hint: 'Από όσα τραγούδια βρέθηκαν, πόσα θα είχαμε χάσει αν εφαρμοζόταν gating. < 5 % = ασφαλές.',
    clfReport_crossTableTitle: 'Πίνακας: Classification × Shazam',
    clfReport_totalSamples: 'Σύνολο',
    clfReport_evaluable: 'Aξιολογούμενα',
    clfReport_classification: 'Classification',
    clfReport_hitRate: 'Hit Rate',
    clfReport_crossTableHint: 'Σε speech / noise σειρές: τα HITs είναι FALSE POSITIVES του "skip" — δηλαδή τραγούδια που θα είχαμε χάσει σε active mode.',
    clfReport_perStationTitle: 'Ανάλυση ανά σταθμό',
    clfReport_station: 'Σταθμός',
    clfReport_noStationData: 'Δεν υπάρχουν δεδομένα ακόμη.',
    clfReport_noSamplesTitle: 'Δεν υπάρχουν δείγματα ακόμη',
    clfReport_noSamplesHint: 'Ο classifier τρέχει σε shadow mode και θα συμπληρώσει δεδομένα καθώς οι σταθμοί παίζουν τραγούδια. Επιστρέψτε σε 48 ώρες για αξιόπιστα στατιστικά.',
    clfReport_window: 'Window',
    clkView_today: 'Σήμερα',
    clkView_yesterday: 'Χθες',
    clkView_durationLabel: 'Διάρκεια',
    clkView_listenerDeltaLabel: 'Μεταβολή ακροατών',
    clkView_atTime: 'στις',
    clkView_pdfReady: 'Το PDF είναι έτοιμο.',
    clkView_pdfError: 'Αποτυχία δημιουργίας PDF.',
    clkView_dataRetentionHint: 'Τα δεδομένα ρολογιών διατηρούνται για 2 έτη.',
    // Executive Summary (v2.13.20 operator copy refresh).
    execSum_title: 'Σύνοψη Ημέρας',
    execSum_worstBreaks: 'Χειρότερα Breaks',
    execSum_worstBreaks_subtitle: 'Τα 3 breaks με τη μεγαλύτερη απώλεια ακροατών',
    execSum_heroSongs: 'Κορυφαία Τραγούδια',
    execSum_heroSongs_subtitle: 'Τα 3 τραγούδια που κράτησαν περισσότερο τους ακροατές',
    execSum_villainSongs: 'Χειρότερα Τραγούδια',
    execSum_villainSongs_subtitle: 'Τα 3 τραγούδια που προκάλεσαν τις μεγαλύτερες αποχωρήσεις',
    execSum_bestBreaks: 'Καλύτερα Breaks',
    execSum_bestBreaks_subtitle: 'Τα 3 breaks που κράτησαν περισσότερο τους ακροατές',
    execSum_contentMixTitle: 'Music vs Talk/adv',
    execSum_noData: 'Δεν υπάρχουν διαθέσιμες πληροφορίες',
    execSum_breakLabel: 'Break',
    // v2.13.21 (2026-02): new break-detection taxonomy
    clkView_break: 'Break (15s–5m)',
    clkView_contentBlock: 'Content Block (5–15m)',
    clkView_programSegment: 'Show Segment (>15m)',
    execSum_showAnalysisTitle: 'Ανάλυση Εκπομπών',
    execSum_breaksTitle: 'Διαλείμματα',
    execSum_contentBlocksTitle: 'Ενότητες Περιεχομένου',
    execSum_programSegmentsTitle: 'Τμήματα Εκπομπής',
    execSum_count: 'Πλήθος',
    execSum_avgDuration: 'Μέση διάρκεια',
    execSum_shortest: 'Ελάχιστη',
    execSum_longest: 'Μέγιστη',
    execSum_bestLabel: 'Καλύτερο',
    execSum_worstLabel: 'Χειρότερο',
    execSum_noSegments: 'Καμία εγγραφή',
    // v2.13.22 — Break Intelligence dashboard
    breakIntel_recompute: 'Επανυπολογισμός',
    breakIntel_backfill: 'Backfill 14 ημερών',
    breakIntel_confirmBackfill: 'Να εκτελεστεί backfill 14 ημερών για αυτό το σταθμό;',
  },
  
  en: {
    // Header
    appTitle: 'Radio Solutions On Air',
    home: 'Home',
    aboutUs: 'About',
    logout: 'Logout',
    generate: 'Generate',
    renewSubscription: 'Renew Subscription',
    waiting: 'Waiting',
    contentCreationInProgress: 'Content Creation in progress...',
    pleaseWaitDontClose: 'Please wait. Do not close the app.',
    
    // About Page
    radioSolutionsApps: 'Radio Solutions Apps',
    forRadioProfessionals: 'For Owners, Managers, Producers, Playlisters & Sales Teams',
    dataYouNeed: 'The Data You Need, The Tools You Deserve',
    analyticsContentCharts: 'Analytics, Content & Charts for the modern radio station.',
    radioFinallyMeasured: 'Radio finally measured.',
    goToHome: 'Go to Home',
    goToApp: 'Go to App',
    contactUs: 'Contact Us',
    ourTools: 'Our Tools',
    toolsSuiteDescription: 'A complete suite of tools designed exclusively for radio stations',
    timeSaving: 'Save Time',
    timeSavingDesc: 'Automate content production and focus on the on-air part.',
    professionalResults: 'Professional Results',
    professionalResultsDesc: 'High-quality content ready for immediate on-air use.',
    reliableData: 'Reliable Data',
    reliableDataDesc: 'Updated charts and statistics from reliable sources.',
    readyToStart: 'Ready to start?',
    signUpToday: 'Sign up today and get access to all our tools',
    viewPackages: 'View Packages',
    freeTrial: 'Free Trial',
    onAirContent: 'On Air Content',
    dailyContent: 'Daily Content',
    onAirContentDesc: 'Ready-to-use content for radio broadcasts. Horoscopes, weather, trends, fun news and more.',
    
    // About Page - Demo Section
    toolsForRadio: 'Tools for radio,',
    withoutHeadache: 'without the headache',
    suiteForProfessionals: 'This suite is designed for radio professionals.',
    normalIfDifficult: 'If it seems a bit difficult at first, that\'s completely normal 😉',
    freeDemo: 'free walkthrough',
    freeDemoText: 'That\'s why we offer a {freeDemo} to show you simply and practically how you can use the tools in your daily routine.',
    wantDemo: 'I want a demo',
    noTechKnowledge: 'No technical knowledge required. We show you everything step by step.',
    seeToolsInAction: 'See Our Tools in Action',
    allInOneTool: 'Analytics, Daypart Analysis, Playlist Decisions - all in one tool',
    
    // Email Popup
    popupTitle: 'Want to really improve your radio station?',
    popupPlatformOffers: 'What the platform offers:',
    popupOnAirContent: 'Ready-to-use content for broadcasts',
    popupSongFinder: 'Find information about any song',
    popupTopCharts: 'The most popular songs on Greek radio',
    popupPlaylistAnalyzer: 'Playlist analysis by hour and day',
    popupSongsAnalyzer: 'Learn which songs keep listeners engaged',
    popupCalculators: 'Campaign & listener calculation',
    popupEmailPlaceholder: 'Your email...',
    popupSubmitting: 'Sending...',
    popupSubmitButton: 'I want to learn more',
    popupBottomTagline: 'You will receive information on how to improve your station.',
    popupSuccessTitle: 'Thank you!',
    popupSuccessMessage: 'You will receive more information soon.',
    continueWithoutSignup: 'Continue without signup',
    
    // Tool Subtitles
    campaignMetricsSubtitle: 'Campaign Metrics',
    audienceMetricsSubtitle: 'Audience Metrics',
    airplayChartsSubtitle: 'Airplay Charts',
    playlistAnalysisSubtitle: 'Playlist Analysis',
    daypartAnalysisSubtitle: 'Daypart Analysis',
    ourStationsSubtitle: 'Our Stations',
    
    // Tool Descriptions
    campaignAnalyzerDesc: 'Calculate the effectiveness of your advertising campaigns. Analyze reach and expected results based on scientific data.',
    listenerCalculatorDesc: 'Estimate your listener numbers based on various parameters. Ideal for audience measurement and advertiser reports.',
    radioTopSongsDesc: 'Top 1000 songs from Greek radio. Updated data with Greek and international hits, weekly airplay and trend analysis.',
    playlistAnalyzerDesc: 'Analyze your station\'s playlist. Upload CSV files and view statistics for songs, artists, and duration.',
    daypartAnalyzerDesc: 'Advanced Playlist analysis by daypart. See which songs fit best at each hour of the day.',
    daypartAnalyzerTitle: 'Playlist Daypart Analyzer',
    daypartAnalysisSubtitle: 'Playlist Daypart Analysis',
    daypartFeature1: 'Hourly playlist analysis',
    daypartFeature2: 'Song scoring',
    daypartFeature3: 'PDF reports',
    ourStationsDesc: 'Demo stations with various music formats for creating playlists for radio stations and In-Store businesses.',
    
    // Navigation Menu Labels
    navInfo: 'Info',
    navOnAirContent: 'On Air Content',
    navSongFinder: 'Song Finder',
    navCampaignCalculator: 'Campaign Calculator',
    navListenersCalculator: 'Listeners Calculator',
    navTopRadioCharts: 'Top Radio Charts',
    navStations: 'Stations',
    navPlaylistAnalyzer: 'Playlist Analyzer',
    navDaypartAnalyzer: 'Playlist Daypart Analyzer',
    navSongsAnalyzer: 'Songs Analyzer',
    navSongsAnalyzerPro: 'Songs Analyzer PRO',
    navContact: 'Contact',
    navAdmin: 'Admin',
    navPackets: 'Packets',
    navServices: 'Services',
    readMore: 'Read More',

    // ── Top Artists Chart (Phase B, 2026-02-24) ─────────────
    topArtistsTitle: 'Top Artists',
    topArtistsSubtitle: 'The most-played artists on Greek radio stations.',
    topArtistsScopeGreece: 'Greece',
    topArtistsScopeGlobal: 'Global',
    topArtistsRangeWeekly: 'Last 7 days',
    topArtistsRangeLastWeek: 'Previous week',
    topArtistsRangeThisMonth: 'This month',
    topArtistsRangeLastMonth: 'Last month',
    topArtistsRange3m: '3 months',
    topArtistsRange6m: '6 months',
    topArtistsRange12m: '12 months',
    topArtistsSearchPlaceholder: 'Search artist…',
    topArtistsExcel: 'Excel',
    topArtistsExcelDone: 'Excel downloaded',
    topArtistsExcelFailed: 'Excel export failed',
    topArtistsColArtist: 'Artist',
    topArtistsColPlays: 'Plays',
    topArtistsColStations: 'Stations',
    topArtistsCountLabel: 'artists',
    topArtistsEmpty: 'No artists found for this period.',
    topArtistsApiError: 'Connection problem',
    topArtistsRetry: 'Try again',
    topArtistsTrendLoading: 'Loading history…',
    topArtistsTrendHistory: 'Plays history',
    topArtistsMovement: 'Movement',
    topArtistsMovement7d: '7d vs previous 7d',
    topArtistsRecent7d: 'Recent 7d',
    topArtistsPrevious7d: 'Previous 7d',
    topArtistsInsufficientData: 'Insufficient data',
    topArtistsTopSong: 'Top song',
    topArtistsNoTopSong: 'No top song found for this period',
    topArtistsSeeAlsoPeoples: "See also: The People's Chart →",
    topArtistsSeoDescription: 'Top artists on Greek radio stations — real-time airplay data.',

    // ── Services Page (v2.10.2 / 2026-06-15) ─────────────────────
    servicesTitle: 'Services',
    servicesEyebrow: 'Services · Υπηρεσίες',
    servicesHeroTitle: 'Music Scheduling & Log Optimization',
    servicesHeroDesc: 'Beyond our tools, we provide specialized services that help radio stations grow their audience, improve their programming, and increase their revenue.',
    servicesCtaFreeEval: 'Request a Free Evaluation',
    servicesPreviewDesc: 'Beyond our tools, we provide specialized services that help radio stations grow their audience, improve their programming, and increase their revenue.',
    servicesOurServices: 'Our Services',
    servicesOurServicesSub: 'Professional expertise delivered by industry veterans of the radio world',
    svcIncludes: 'Includes:',
    svcLearnMore: 'Learn More',
    svc1Title: 'Music Programming & Format Consulting',
    svc1Desc: 'Optimize your music programming based on format, competition, and the preferences of your local audience.',
    svc1Bullet1: 'Format analysis',
    svc1Bullet2: 'Music strategy',
    svc1Bullet3: 'Rotation management',
    svc1Bullet4: 'Competitive analysis',
    svc1Bullet5: 'Music clock creation',
    svc1Bullet6: 'Rotation optimization',
    svc1Bullet7: 'Category management',
    svc1Bullet8: 'Daypart scheduling',
    svc1Bullet9: 'Weekly music review',
    svc2Title: 'Audience & Market Analysis',
    svc2Desc: 'We analyze the market and music trends so your station makes better decisions.',
    svc2Bullet1: 'Competitive analysis',
    svc2Bullet2: 'Music trends monitoring',
    svc2Bullet3: 'New releases reports',
    svc2Bullet4: 'Differentiation strategies',
    svc3Title: 'Radio Station Growth Consulting',
    svc3Desc: 'Growth consulting to increase audience, commercial value, and brand recognition.',
    svc3Bullet1: 'Station branding',
    svc3Bullet2: 'Positioning',
    svc3Bullet3: 'Contests and promotions',
    svc3Bullet4: 'Social media strategy',
    svc3Bullet5: 'Listener engagement',
    svc4Title: 'Ongoing Programming Support',
    svc4Desc: 'Continuous collaboration and support for stations seeking an external programming partner.',
    svc4Bullet1: 'Weekly communication',
    svc4Bullet2: 'Music programming evaluation',
    svc4Bullet3: 'Improvement proposals',
    svc4Bullet4: 'Producer support',
    svc4Bullet5: 'Results tracking',
    servicesOurProcess: 'Our Process',
    servicesOurProcessSub: 'How we deliver our services to enhance your station\u2019s sound',
    svcProcessStep1Title: 'Discovery',
    svcProcessStep1Desc: 'We start by understanding your format, audience, and goals through detailed consultation.',
    svcProcessStep2Title: 'Strategy',
    svcProcessStep2Desc: 'We design a customized scheduling strategy tailored to your specific needs.',
    svcProcessStep3Title: 'Implementation',
    svcProcessStep3Desc: 'We implement the strategy, optimizing logs, library, and clocks for maximum impact.',
    svcProcessStep4Title: 'Refinement',
    svcProcessStep4Desc: 'Continuous feedback and refinement ensure your station\u2019s sound remains optimized.',
    svcBenefitsTitle: 'Benefits for Your Station',
    svcBenefitsSub: 'Concrete outcomes you\u2019ll see after working with us',
    svcBenefit1: 'Higher audience numbers',
    svcBenefit2: 'Longer listener time-spent on your frequency',
    svcBenefit3: 'Increased advertising value and revenue',
    svcBenefit4: 'Music that keeps your audience tuned in',
    svcBenefit5: 'Fewer listener drop-offs from tiring or off-format choices',
    svcBenefit6: 'Better decisions through data and analytics',
    svcBenefit7: 'Clear differentiation from competitors',
    svcBenefit8: 'Continuous improvement of music programming',
    svcCtaEyebrow: 'Ready to improve your station?',
    svcCtaTitle: 'Want to improve your station\u2019s programming?',
    svcCtaDesc: 'Talk with us and we\u2019ll evaluate your format, music strategy, and growth potential — completely free of charge.',

    // Services Results / Case Study (animated counters)
    svcResultsEyebrow: 'Results · Case Studies',
    svcResultsTitle: 'Measurable results for our client stations',
    svcResultsSub: 'Average improvements after 3-6 months of working with our team',
    svcResultMetric1: 'Increase in TSL (Time Spent Listening)',
    svcResultMetric2: 'Audience growth',
    svcResultMetric3: 'Reduction in early drop',
    svcResultMetric4: 'Stations trusting us',
    svcResultsDisclaimer: 'Results based on listening-data analysis from stations that use our services. Figures vary depending on format and market.',
    svcTestimonialQuote: '"Working with Radio Solutions significantly raised our station\u2019s TSL and gave us a clear picture of which songs truly resonate with our audience."',
    svcTestimonialAuthor: 'Program Director',
    svcTestimonialStation: 'Partner radio station',
    
    // Tool Features
    campaignFeature1: 'ROI calculation',
    campaignFeature2: 'Reach analysis',
    campaignFeature3: 'Performance forecasts',
    listenerFeature1: 'Accurate estimates',
    listenerFeature2: 'Detailed reports',
    listenerFeature3: 'Period comparison',
    radioSongsFeature1: 'Greek & International',
    radioSongsFeature2: 'Weekly updates',
    radioSongsFeature3: 'Historical data',
    playlistFeature1: 'CSV import',
    playlistFeature2: 'Detailed statistics',
    playlistFeature3: 'Export reports',
    daypartFeature1: 'Hourly analysis',
    daypartFeature2: 'Scoring system',
    daypartFeature3: 'PDF reports',
    stationsFeature1: 'Various Music Formats',
    stationsFeature2: 'Radio & In-Store Playlists',
    stationsFeature3: 'Demo Listening',
    onAirFeature1: '40+ thematic sections',
    onAirFeature2: 'Daily updates',
    onAirFeature3: 'Ready for on-air use',
    
    // On Air Content Page
    onAirPageTitle: 'Ready-to-Use Radio Content',
    onAirPageSubtitle: 'Click a category to view sections',
    translatedContent: 'Translated content available',
    originalContent: 'Showing original content',
    sectionsAvailable: 'sections available',
    sections: 'Sections',
    updates: 'Updates',
    ready: 'Ready',
    refresh: 'Refresh',
    loadingContent: 'Loading content...',
    
    // Categories
    zodiacLifestyle: 'Zodiac & Lifestyle',
    zodiacLifestyleDesc: 'Daily horoscope, Sex & Relationships, Health & Wellness, Financial tips',
    newsTrends: 'News & Trends',
    newsTrendsDesc: 'Weird News, Good News, Sports News, Daily Trends, Weather, Research Says',
    entertainmentGames: 'Entertainment & Games',
    entertainmentGamesDesc: 'Radio contests, Word games, Debates, Truth or Myth',
    musicCharts: 'Music & Charts',
    musicChartsDesc: 'Apple Music Greece, YouTube Trending, Today in Music History',
    
    // Common
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    submit: 'Submit',
    download: 'Download',
    upload: 'Upload',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    admin: 'Admin',
    
    // Access Loading States
    accessLoading: 'Loading access permissions... Please wait.',
    accessSlow: 'Connection is a bit slow... Retrying. This usually takes up to 10 seconds.',
    accessRetrying: 'Retrying connection (attempt {count}/3)...',
    accessUsingCache: 'Slow connection. Using temporarily saved data.',
    accessError: 'Could not connect. Please refresh the page.',
    
    // Welcome Popup
    welcomeTitle: 'Welcome!',
    welcomeSubtitle: 'Make every broadcast a must listen!',
    alreadyHaveAccount: 'I already have an account - Login',
    loginHere: 'Login here',
    justWantToTry: 'Just want to try?',
    freeTrial24h: '48-hour Free Trial',
    createAccountFirst: 'Create an account to purchase a package',
    startFreeTrial: 'Login / Register',
    dontLookLikeOthers: "Don't look like everyone else",
    becomeReferenceStation: 'Become the reference station',
    makeEveryBroadcast: 'Make every broadcast',
    mustListen: 'must listen',
    tryFor24Hours: 'Try it for 48 hours',
    clickAnywhereToClose: 'Click anywhere outside or ESC to close',
    measureOptimizePerform: 'Measure. Optimize. Perform.',
    welcomeDescription: 'The first app that turns radio into a measurable media channel: campaign performance, audience data, playlist intelligence, and daily on-air content.',
    radioFinallyMeasured: 'Radio finally measured.',
    
    // Login
    login: 'Login',
    username: 'Username',
    password: 'Password',
    forgotPassword: 'Forgot my password',
    loginError: 'Login error',
    serverStarting: 'Server is starting... Please wait 10 seconds and try again.',
    serverStartingPleaseWait: '⏳ Server is starting... Please wait 10 seconds and try again.',
    rememberMe: 'Remember me',
    twoFactorAuth: '2FA Verification',
    enterOTP: 'Enter 2FA code',
    verify: 'Verify',
    invalid2FA: 'Invalid 2FA code',
    invalid2FACode: 'Invalid 2FA code',
    verificationError: 'Verification error',
    or: 'or',
    continueWithGoogle: 'Continue with Google',
    week: 'Week',
    noWeeksForMonth: 'No available weeks for {{month}}',
    noWeeksForYear: 'No available weeks for year {{year}}',
    chartsSavedWeekly: 'Charts are saved weekly',
    
    // Canonical Conflict Resolver
    loadConflictsError: 'Error loading conflicts',
    errorGeneric: 'Error',
    resolveError: 'Resolve error',
    overrideError: 'Override error',
    previewError: 'Preview error',
    autoResolveError: 'Auto-resolve error',
    cleanupPreviewError: 'Cleanup preview error',
    cleanupError: 'Cleanup error',
    repairPreviewError: 'Repair preview error',
    repairError: 'Repair error',
    refreshPreviewError: 'Refresh preview error',
    refreshError: 'Refresh error',
    loadingConflicts: 'Loading conflicts...',
    searchingUserDb: 'Searching User DB...',
    conflictDescription: 'until resolved manually. Select the canonical entry with the most plays or the most correct',
    
    // Trial Signup
    trialAccount: 'Trial Account',
    trialAccountDesc: '48-hour free access to all features',
    accountAccess: 'Login / Register',
    newUserTrialDesc: 'New user? Create an account with 48-hour free access!',
    email: 'Email',
    confirmPassword: 'Confirm Password',
    chooseUsername: 'Choose a username',
    minChars: 'At least 6 characters',
    repeatPassword: 'Repeat password',
    createTrialAccount: 'Create Trial Account',
    creatingAccount: 'Creating...',
    allFieldsRequired: 'All fields are required',
    passwordsDontMatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 6 characters',
    trialCreatedSuccess: 'Trial account created successfully!',
    trialExpiresIn: 'Trial expires in 48 hours',
    saveCredentials: 'Save your credentials:',
    goToApp: 'Go to app',
    
    // Signup Form
    createYourAccount: 'Create your account',
    createAccount: 'Create Account',
    musicFormat: 'Music Format',
    stationName: 'Station Name',
    stationNamePlaceholder: 'e.g. Radio Athens',
    frequency: 'Frequency',
    frequencyPlaceholder: 'e.g. 95.5 FM',
    region: 'Region',
    selectRegion: 'Select region',
    acceptTerms: 'I accept the terms of use',
    alreadyHaveAccountQuestion: 'Already have an account?',
    trialPeriod24h: 'Trial Period 24 Hours',
    freeAccessFor24h: 'Free access for 48 hours after registration!',
    fullAccessAllFeatures: 'Full access to all features',
    noCreditCardForTrial: 'No credit card required for trial',
    noAutoCharge: 'No automatic charge',
    afterTrialExpires: 'After trial expires',
    afterTrialInfo: 'After 48 hours, choose a subscription package to continue access.',
    noAutoChargeYouChoose: 'No automatic charge - You choose!',
    viewPackages: 'View Packages',
    hours: 'Hours',
    expires: 'Expires',
    whatIsIncluded: 'What\'s included',
    fullAccess: 'Full access to all features',
    radioContentCreation: 'Radio content creation',
    chatbotSupport: 'Chatbot support',
    accountLocksAfter: 'Account locks after 48 hours',
    redirectingToLogin: 'Redirecting to login page...',
    idealForDemo: 'Ideal for demos to potential customers',
    
    // Content
    contentFor: 'Content for',
    sections: 'sections',
    exportPDF: 'Export PDF',
    userGuide: 'User Guide',
    contentDate: 'Content',
    createdAt: 'Created',
    viewMode: 'View Mode',
    categoriesView: 'Categories',
    classicView: 'Classic',
    clickToViewSections: 'Click to view sections',
    
    // Categories - NEW 9 CATEGORIES
    morningCategory: '☀️ Morning (06:00-10:00)',
    daytimeCategory: '🌤️ Daytime (10:00-16:00)',
    afternoonCategory: '🌅 Afternoon (16:00-19:00)',
    eveningCategory: '🌙 Evening (19:00-24:00)',
    weekendCategory: '🎉 Weekend',
    zodiacLifestyleCategory: '✨ Zodiac & Lifestyle',
    newsEntertainmentCategory: '📰 News & Entertainment',
    gamesFunCategory: '🎮 Games & Fun',
    chartsCategory: '🎵 Charts',
    
    // Old categories (kept for backwards compatibility)
    information: 'Information',
    entertainment: 'Entertainment',
    music: 'Music',
    lifestyle: 'Lifestyle',
    special: 'Special',
    contestsGames: 'Contests & Games',
    dialoguesDiscussions: 'Dialogues & Discussions',
    chartsMusic: 'Charts & Music',
    
    // Footer
    quickLinks: 'Quick Links',
    campaignAnalyzer: 'Campaign Analyzer',
    listenerCalculator: 'Listener Calculator',
    playlistAnalyzer: 'Playlist Analyzer',
    daypartAnalyzer: 'Daypart Analyzer',
    ourStations: 'Our Stations',
    radioTopSongs: 'Top Radio Songs',
    contact: 'Contact',
    radioContentCreation: 'Radio content creation',
    legalPrivacy: 'Legal & Privacy',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    cookiePolicy: 'Cookie Policy',
    cookieSettings: 'Cookie Settings',
    allRightsReserved: 'All rights reserved',
    gdprCompliant: 'GDPR Compliant',
    euDataProtection: 'EU Data Protection',
    gdprNotice: 'Your personal data is protected according to GDPR (EU 2016/679) and Greek legislation.',
    loginForMoreOptions: 'Login for more options',
    
    // Pricing
    pricing: 'Packages & Subscriptions',
    monthly: 'Monthly',
    annual: 'Annual',
    subscribe: 'Subscribe',
    popular: 'Popular',
    chooseYourPackage: 'Choose Your Package',
    pricingDescription: 'Get access to premium tools for your radio station',
    currentPlan: 'Current Plan',
    upgrade: 'Upgrade',
    downgrade: 'Downgrade',
    per: 'per',
    month: 'month',
    year: 'year',
    selectWeek: 'Select Week',
    previousWeek: 'Previous Week',
    nextWeek: 'Next Week',
    optional: 'optional',
    savePercent: 'Save',
    featuresIncluded: 'Includes',
    
    // Cookies
    cookiesTitle: 'We use Cookies',
    cookiesDesc: 'We use cookies to improve your experience.',
    cookiesFullDesc: 'We use cookies to improve your experience. Some cookies are necessary for the website to function.',
    acceptAll: 'Accept All',
    reject: 'Reject',
    settings: 'Settings',
    necessaryCookies: 'Necessary Cookies',
    necessaryCookiesDesc: 'Essential for basic website functionality.',
    required: 'REQUIRED',
    analyticsCookies: 'Analytics Cookies',
    analyticsCookiesDesc: 'Help us understand how you use the website (Google Analytics).',
    functionalCookies: 'Functional Cookies',
    functionalCookiesDesc: 'Remember your preferences and improve user experience.',
    thirdPartyCookies: 'Third-Party Cookies',
    thirdPartyCookiesDesc: 'Used by external services (e.g., YouTube videos).',
    saveSettings: 'Save Settings',
    
    // Daypart Analyzer
    daypartTitle: 'Daypart Performance Analyzer',
    morning: 'Morning',
    drive: 'Drive Time',
    night: 'Night',
    overnight: 'Overnight',
    analyze: 'Analyze',
    results: 'Results',
    genreDistribution: 'Genre Distribution',
    decadeDistribution: 'Decade Distribution',
    
    // Labels
    power: 'POWER',
    secondary: 'SECONDARY',
    currents: 'CURRENTS',
    spreadMore: 'SPREAD MORE',
    slowDown: 'SLOW DOWN',
    sleeper: 'SLEEPER',
    cut: 'CUT',
    
    // Homepage Cards
    campaignAnalyzerDesc: 'Radio campaign optimization tool',
    campaignAnalyzerInfo: 'Calculate GRPs, Reach and Frequency for your campaign based on brand category, market position and duration.',
    campaignAnalyzerFullDesc: 'The Campaign Analyzer is a professional tool for planning radio advertising campaigns. It automatically calculates GRPs (Gross Rating Points), Reach (percentage of audience exposed to the message), and Frequency (average number of contacts per person). Based on your brand category and market position, it recommends the optimal number of spots for maximum effectiveness.',
    openCampaignAnalyzer: 'Open Campaign Analyzer',
    listenerCalculatorDesc: 'Listener calculation tool based on dayparts & weekly data',
    listenerCalculatorInfo: 'Calculate listening percentages, 95% CI, and listener estimates with FPC correction for each day and time zone.',
    listenerCalculatorFullDesc: 'The Listener Calculator converts listening percentages into actual listener numbers. It uses statistical methods (FPC correction, 95% Confidence Intervals) for accurate estimates. Enter rating data per day and time zone (daypart) and receive detailed results about your station\'s audience.',
    openListenerCalculator: 'Open Listener Calculator',
    playlistAnalyzerDesc: 'Playlist performance analysis tool with advanced scoring engine',
    playlistAnalyzerInfo: 'Analyze your playlist performance in detail based on TLH, Performances and Frequency.',
    playlistAnalyzerFullDesc: 'The Playlist Analyzer analyzes the performance of each song in your station\'s playlist. Upload a CSV with TLH (Time Listening Hours), Performances, and Frequency data. The system calculates scores and recommends decisions like POWER (excellent performance), SECONDARY (good), CURRENTS (new release), or CUT (remove).',
    openPlaylistAnalyzer: 'Open Playlist Analyzer',
    daypartAnalyzerDesc: 'Performance analyzer per time zone',
    daypartAnalyzerInfo: 'Analyze your playlist performance per daypart (morning, noon, afternoon, evening).',
    daypartAnalyzerFullDesc: 'The Daypart Analyzer is the premium version of the Playlist Analyzer. It analyzes each song\'s performance per time zone: Morning (06:00-10:00), Midday (10:00-15:00), Drive (15:00-19:00), Evening (19:00-24:00), and Overnight (00:00-06:00). Ideal for stations wanting to optimize rotation by hour.',
    songInfoFullDesc: 'The Song Information tool searches for information about any song: release year, record label, composers, lyricists, artist/band, and suggests broadcast texts (liners) for producers. Simply type the song title and click search.',
    openDaypartAnalyzer: 'Open Daypart Analyzer',
    premiumFeature: 'PREMIUM',
    upgradeToAccess: 'Upgrade to access',
    
    // Misc
    copyright: 'RADIO SOLUTIONS PROPERTY',
    copyrightTitle: 'RADIO SOLUTIONS PROPERTY',
    copyrightNotice: 'This content is provided exclusively to registered subscribers. Sharing or distribution to third parties is strictly prohibited and legally prosecuted.',
    generateNewContent: 'Generate New Content for better results!',
    contentCreationDuration: 'Creation duration: ~15 minutes | Auto: 00:01 daily',
    downloadAsPDF: 'Download as PDF',
    userInstructions: 'User Guide',
    waitForPdfDownload: 'Please wait up to 10 seconds for PDF download',
    generationDuration: 'Generation duration: ~15 minutes | Auto: 00:01 daily',
    waitForPDF: 'Please wait up to 10 seconds for PDF download to complete',
    pdfPassword: 'Password to open: your username',
    newContentAvailable: 'New content available!',
    pageWillRefresh: 'Page will refresh automatically in 5 seconds...',
    refreshNow: 'Refresh Now',
    multiLanguage: 'Multi-language',
    
    // Playlist Analyzer
    playlistAnalyzerTitle: 'Playlist Performance Analyzer',
    uploadCSV: 'Upload CSV',
    selectCSV: 'Select CSV',
    changeFile: 'Change',
    loadingFile: 'Loading...',
    tracksLoaded: 'Tracks loaded',
    radioFormat: 'Radio Format',
    formatAffectsWeights: 'Format affects weights and era multipliers',
    step1SelectFormat: 'Step 1: Select Format → Step 2: Upload CSV',
    selectFormatFirst: 'First select the correct Radio Format and then upload the CSV file for better results.',
    startAnalysis: 'Start Analysis',
    analyzing: 'Analyzing...',
    analysisComplete: 'Analysis complete!',
    analysisError: 'Analysis error',
    networkError: 'Connection error. Please try again.',
    exportToPDF: 'Export PDF',
    creatingPDF: 'Creating PDF...',
    pdfCreated: 'PDF created!',
    errorDownloadingPDF: 'Error downloading PDF',
    passwordToOpen: 'Password to open: your username',
    tracksAndDecisions: 'Tracks & Decisions',
    genres: 'Genres',
    decades: 'Decades',
    searchArtistTitle: 'Search Artist or Title...',
    clear: 'Clear',
    tracks: 'tracks',
    instructions: 'Instructions',
    csvFileStructure: 'CSV File Structure',
    csvMustContain: 'The CSV file must contain the following columns.',
    artistName: 'Artist name',
    trackTitle: 'Track title',
    frequency: 'Frequency',
    performances: 'Performances',
    columnExplanation: 'Column Explanation',
    missingColumns: 'What if columns are missing?',
    scoringProcess: 'Scoring Process',
    whatDataMeans: 'What the Data Means',
    radioFormatsAdjustments: 'Radio Formats & Adjustments',
    decisionLabels: 'Decision Labels',
    analyzingTracks: 'Analyzing tracks with format',
    largeFileWarning: 'large file - may take ~30-60 seconds',
    mediumFileWarning: '~20-30 seconds',
    analysisTimeout: 'Analysis took too long (>5 minutes). Try with a smaller CSV.',
    analysisRetrying: 'Analysis needs more time... Retrying',
    analysisLargeFileFailed: 'Large file failed after multiple attempts. Try splitting the CSV into smaller parts.',
    noTracksInPlaylist: 'No tracks in playlist',
    noTracks: 'No tracks',
    totalTracks: 'Total Tracks',
    avgScore: 'Average Score',
    power: 'Power',
    sleeper: 'Sleeper',
    totalPerformances: 'Total Performances',
    uploadingFile: 'Uploading file',
    importingTracks: 'Importing tracks to database...',
    enrichmentComplete: 'Enrichment Complete',
    added: 'Added',
    newSongs: 'new songs',
    updated: 'Updated',
    existing: 'existing',
    totalInDb: 'Total in database',
    importError: 'Import error',
    tryAgain: 'Try again',
    pleaseUploadCSV: 'Please upload a CSV file',
    uploadError: 'Error uploading file',
    pleaseUploadCSVFirst: 'Please upload a CSV file first',
    pleaseAnalyzeFirst: 'Please analyze first',
    loadingCSVFile: 'Loading CSV file... Please wait',
    columns: 'Columns',
    analysisSummary: 'Analysis Summary',
    totalRecords: 'Total Records',
    uniqueTracks: 'Unique Tracks',
    period: 'Period',
    daypartDistribution: 'Daypart Distribution',
    musicFormat: 'Music Format',
    // Admin section
    adminDbEnrichment: 'Admin: Song Database Enrichment',
    songsInDb: 'songs',
    artistsInDb: 'artists',
    songsWithYear: 'with year',
    uploadCsvInstructions: 'Upload CSV with columns: Artist, Title, Year (optional: Genre)',
    importInProgress: 'Import in progress...',
    addSongs: 'Add Songs',
    exportPDF: 'Export PDF',
    // Help modal
    eraMultiplier: 'Era Multiplier - Bonus for tracks that fit the format',
    newReleaseBonus: 'New Release Bonus - +10% for tracks ≤90 days old',
    
    // Daypart Analyzer specific
    daypartAnalyzerTitle: 'Daypart Performance Analyzer',
    usageInstructions: 'Usage Instructions',
    daypartIntro: 'The Playlist Daypart Analyzer analyzes your playlist performance by time zone. Upload your station\'s playlist CSV and see which songs perform best at each hour of the day.',
    csvUpload: 'CSV File Upload',
    csvMustContainFields: 'The CSV must contain the following columns:',
    csvFlexibleFormat: 'Required columns:',
    csvOptional: 'optional',
    csvColumnOrderNote: 'Column order does not matter. Various names are recognized (e.g., Artist, Performer, Singer)',
    allFieldsRequired: 'All fields are required for accurate analysis results',
    selectRadioFormat: 'Select Radio Format',
    selectYourFormat: 'Select your station format:',
    timeZones: 'Time Zones (Dayparts)',
    evaluationCategories: 'Evaluation Categories',
    powerDesc: 'Top tracks - play them often!',
    secondaryDesc: 'Second line - good performance',
    currentsDesc: 'Current hits - good flow',
    spreadMoreDesc: 'Increase frequency',
    slowDownDesc: 'Decrease frequency',
    sleeperDesc: 'Low performance - monitor',
    cutDesc: 'Candidate for removal',
    csvFormat: 'CSV Format',
    daypartHowItWorks: 'How it works',
    daypartHowItWorksDesc: 'The Daypart Analyzer analyzes your station\'s track performance by time zone (Morning, Drive, Night, Overnight). Based on TLH and Listeners data, it calculates scores and suggests decisions (POWER, SECONDARY, CURRENTS, etc.) for each track.',
    genreDecadeAnalysis: 'Genre & Decade Analysis',
    eachDaypartShows: 'Each daypart also shows:',
    requiresAdminEnrichment: 'Requires database enrichment from Admin',
    exportResults: 'Export Results',
    afterAnalysisExport: 'After analysis, you can export results to:',
    tips: 'Tips',
    tip1: 'Use at least one week of data for better results',
    tip2: 'Adjust weights per daypart in "Settings" according to your priorities',
    tip3: 'Check GOLD Analysis for your station\'s "golden" tracks',
    gotItLetsStart: 'Got it, let\'s start!',
    // Decision explanations
    decContinue: 'CONTINUE - Listeners love it!',
    decMaintain: 'MAINTAIN - Listeners stay tuned',
    decMaintainGood: 'MAINTAIN - Good listener acceptance',
    decReduce: 'REDUCE - Fewer plays per week',
    decRemove: 'REMOVE - Listeners change station!',
    decTired: 'Listeners are tired of it! REDUCE FREQUENCY!',
    decSecondLine: 'SECOND LINE - Don\'t select in prime zones',
    decLessPerDay: 'FEWER PLAYS/DAY',
    // Explanation translations for track results - ENGLISH
    decContinueAction: 'CONTINUE',
    decMaintainAction: 'MAINTAIN',
    decReduceAction: 'REDUCE',
    decRemoveAction: 'REMOVE',
    decIncreaseAction: 'INCREASE',
    decReduceImmediately: 'REDUCE IMMEDIATELY',
    decListenersLoveIt: 'Listeners love it',
    decListenersStay: 'Listeners stay tuned',
    decGoodAcceptance: 'Good listener acceptance',
    decReduceFrequency: 'Reduce frequency',
    decFewerPlaysWeek: 'Fewer plays/week',
    decNoPrimeZones: 'Don\'t select in prime zones',
    decListenersSwitch: 'Listeners switch station',
    decListenersTired: 'Listeners are tired of it',
    decSleeperDesc: 'Plays rarely but when it plays, listeners love it',
    decExcellentPerformance: 'Excellent performance',
    decTopTrack: 'Top track',
    decVeryGoodPerformance: 'Very good performance',
    decKeepIt: 'Keep it',
    decStableChoice: 'Stable choice',
    decPlaysTooOften: 'Plays too often',
    decLowInterest: 'Low listener interest',
    decHiddenHit: 'Hidden hit',
    decLikedButRare: 'Well-liked but plays rarely',
    decIncreasePlaybacks: 'Increase playbacks',
    decReduceSignificantly: 'Reduce frequency significantly',
    decContinueStrategy: 'Continue with current strategy',
    decNewRelease: 'New release',
    decDoesntFitFormat: 'doesn\'t fit the format',
    decBetterInOtherFormat: 'Would perform better in another format',
    
    // Radio Top Songs
    radioTopSongsTitle: 'Top Radio Songs',
    weeklyChart: 'Weekly Chart',
    position: 'Position',
    artist: 'Artist',
    title: 'Title',
    lastWeek: 'Last Week',
    weeksOnChart: 'Weeks',
    chartInfo: 'Chart Info',
    uploadNewChart: 'Upload New Chart',
    noChartData: 'No chart data available',
    allSongs: 'All',
    greekSongs: 'Greek',
    internationalSongs: 'International',
    totalSongs: 'Total Songs',
    source: 'Source',
    searchSongsArtists: 'Search songs & artists • View historical charts',
    browseChartsByWeek: 'Browse charts by week and month of the year',
    discoverMore: 'Discover More',
    searchSongArtist: 'Search for song or artist...',
    display: 'Display',
    saveCurrentChart: 'Save Current Chart',
    noChartDataForWeek: 'No data found for selected week. Loading current chart...',
    
    // Maintenance/Loading Screen
    preparingForYou: 'Preparing everything for you!',
    remainingTime: 'Remaining time',
    ready: 'Ready!',
    pageWillRefreshAuto: 'Page will refresh automatically in a few seconds...',
    completed: 'completed',
    contentBeingCreated: 'Your radio content is being created right now. Please wait...',
    whatsHappening: 'What\'s happening?',
    systemCreatingContent: 'The system is creating fresh, professional radio content',
    estimatedDuration: 'Estimated duration',
    minutes: 'minutes',
    pageRefreshAuto: 'Page will refresh automatically when complete',
    tipKeepTabOpen: 'Tip: Keep this tab open - refresh will happen automatically',
    
    // Pricing Page
    features: 'Features',
    price: 'Price',
    perMonth: '/month',
    perYear: '/year',
    currentPackage: 'Current Package',
    select: 'Select',
    pleaseWait: 'Please wait...',
    faq: 'Frequently Asked Questions',
    canChangePackage: 'Can I change my package?',
    canChangePackageAnswer: 'Yes, you can upgrade or downgrade your package at any time. The difference will be added or deducted from your next billing.',
    paymentMethods: 'What payment methods are supported?',
    paymentMethodsAnswer: 'We accept all credit/debit cards (Visa, Mastercard, American Express) through the secure Stripe platform.',
    hasTrial: 'Is there a trial period?',
    hasTrialAnswer: 'Yes! All new users have free access for 48 hours to all features.',
    paymentCancelled: 'Payment cancelled',
    checkEmailConfirmation: 'Check your email for payment confirmation',
    paymentSuccess: 'Payment completed successfully!',
    sessionExpired: 'Payment session expired',
    pleaseLoginFirst: 'Please login first',
    chargeForUpgrade: 'Charge €{amount} for upgrade',
    errorCreatingPayment: 'Error creating payment',
    errorLoadingPackages: 'Error loading packages',
    
    // Decision explanations (English)
    decContinue: 'CONTINUE - Listeners love it!',
    decMaintain: 'MAINTAIN - Listeners stay tuned',
    decMaintainGood: 'MAINTAIN - Good listener acceptance',
    decReduce: 'REDUCE - Fewer plays per week',
    decRemove: 'REMOVE - Listeners change station!',
    decTired: 'Listeners are tired of it! REDUCE FREQUENCY!',
    decSecondLine: 'SECOND LINE - Don\'t pick for prime time zones',
    decLessPerDay: 'FEWER PLAYS PER DAY',
    
    // Playlist Help Modal (English)
    helpCsvStructure: 'CSV File Structure',
    helpCsvMustContain: 'The CSV file must contain the following columns:',
    helpColumnExplanation: 'Column Explanation:',
    helpArtistName: 'Artist name (required)',
    helpTrackTitle: 'Track title (required)',
    helpFrequency: 'Play frequency (number)',
    helpPerformances: 'Total performances (number)',
    helpTLH: 'Total Listening Hours (decimal number)',
    helpMissingColumns: 'What happens if columns are missing?',
    helpMissingArtistTitle: 'The track will NOT be included in the analysis',
    helpMissingNumeric: 'Will be treated as 0 (zero)',
    helpAllNumericMissing: 'Score will be 0 - track will show as "CUT"',
    helpTip: 'Tip: For accurate analysis, make sure all columns have values. At least TLH is critical!',
    helpScoringProcess: 'Scoring Process (9 Steps)',
    helpStep1: 'Normalization (0-1) - Convert values to 0-1 scale',
    helpStep2: 'Base Weights - TLH 55%, Performances 30%, Frequency 15%',
    helpStep3: 'Format Adjustment - Weights based on radio type',
    helpStep4: 'Era Multiplier - Bonus for tracks that fit the format',
    helpStep5: 'New Release Bonus - +10% for tracks ≤90 days old',
    helpStep6: 'Rotation Penalty - Reduction for excessive play frequency',
    helpStep7: 'Rejection Penalty - Reduction if listeners change station',
    helpStep8: 'Fatigue Penalty - Reduction when TLH drops',
    helpStep9: 'Final Score - Scale 0-100',
    helpDataMeaning: 'What the Data Means',
    helpTLHDesc: 'Total time listeners spend on the track. High TLH = very popular!',
    helpPerformancesDesc: 'How many times the track played in the program',
    helpFrequencyDesc: 'How often it plays (times/day or week)',
    helpYearDesc: 'Release year (from MusicBrainz/Discogs)',
    helpGenreDesc: 'Music genre (Pop, Rock, Folk, etc.)',
    helpRadioFormats: 'Radio Formats & Adjustments',
    helpFormatIntro: 'Each format emphasizes data differently:',
    helpDecisionLabels: 'Main Decision Labels (RANKING-BASED)',
    helpDecisionIntro: 'Based on ranking position, not absolute score:',
    helpStrictMode: 'STRICT Mode (HOT AC, GHR, Greek Mainstream): 62.5% active, 37.5% CUT',
    helpRelaxedMode: 'RELAXED Mode (GOLD, AC): 57% active, 43% CUT',
    helpPowerLabel: 'Top 2-2.5%',
    helpSecondaryLabel: 'Next 4-5%',
    helpCurrentsLabel: 'Next 8-10%',
    helpSpreadMoreLabel: 'Next 16-17.5%',
    helpSlowDownLabel: 'Next 24-27.5%',
    helpRiskLabel: 'Next 37.5-46%',
    helpCutLabel: 'Remaining (37.5-43%)',
    helpGotIt: 'Got it, let\'s start!',
    
    // Help Modal - Special Labels
    helpSpecialLabels: 'Special Labels',
    helpSpecialLabelsIntro: 'Based on Frequency & TLH relationship:',
    helpSleeperTitle: 'Hidden Diamond',
    helpSleeperCriteria: 'Criteria: Low frequency (<35%) + High TLH (≥55%)',
    helpSleeperAction: 'Plays rarely but when it plays, listeners love it! INCREASE IT!',
    helpOverplayedTitle: 'Overplayed',
    helpOverplayedCriteria: 'Criteria: High frequency (≥65%) + Low TLH (<45%)',
    helpOverplayedAction: 'Listeners are tired of it! REDUCE FREQUENCY!',
    helpCsvFormat: 'CSV File Format',
    helpCsvFormatDesc: 'CSV file must contain these columns:',
    helpCsvExample: 'Example:',
    helpCsvStructureIntro: 'The CSV file must contain the following columns. Column names can be uppercase or lowercase.',
    
    // Soft Locks / Feature Gate
    lockedFeature: 'Locked Feature',
    upgradeForAccess: 'Upgrade for Access',
    orTryFree24h: 'Or try free for 48 hours',
    upgradeForAccessFeature: 'Upgrade your package to access this feature.',
    
    // Feature Info (locked cards)
    categoriesOnAirTitle: 'Topic Categories On Air',
    categoriesOnAirDesc: '9 categories of fresh content - Morning, Daytime, Afternoon, Evening, Weekend, Zodiac, News, Entertainment, Charts. New every day!',
    campaignAnalyzerTitleLong: 'Campaign Analyzer',
    campaignAnalyzerDescLong: 'Calculate the performance of your advertising campaigns. View reach, frequency, GRP and estimated revenue.',
    listenerCalculatorTitleLong: 'Listener Calculator',
    listenerCalculatorTitle: 'Listener Calculator',
    listenerCalculatorDescLong: 'Calculate the real audience of your station. Listener estimates per zone and day.',
    radioTopSongsTitleLong: 'Radio Top Songs',
    radioTopSongsDescLong: 'Find the top songs for your station. Greek & International charts with smart suggestions.',
    playlistAnalyzerTitleLong: 'Playlist Analyzer',
    playlistAnalyzerDescLong: 'Analyze your playlist by decades, genres and performance. POWER/SLEEPER song evaluation.',
    daypartAnalyzerTitleLong: 'Daypart Analyzer',
    daypartAnalyzerDescLong: 'Analyze your playlist performance per zone (morning, afternoon, evening). Genre & Decade distribution.',
    peoplesChartTitle: "The People's Chart",
    peoplesChartDesc: 'Top 300 chart shaped by listeners. Scoring based on retention, plays and early drop from the best stations.',
    monthlySupportTitle: 'Monthly Support',
    monthlySupportDesc: 'Technical support via email and chat with response within 24 hours.',
    prioritySupportTitle: 'Priority Support',
    prioritySupportDesc: 'Immediate technical support with priority. Response within 4 hours.',
    
    // Access Banner
    adminFullAccess: 'Admin - Full Access',
    trialPeriod: 'Trial Period',
    hoursRemaining: 'remaining',
    freeAccess: 'Free Access',
    subscriber: 'Subscriber',
    subscriptionExpired: 'Your subscription has expired',
    noActiveSubscription: 'No active subscription',
    
    // Help Modals
    helpGuide: 'Guide',
    helpInstructions: 'Instructions',
    howItWorks: 'How it works',
    helpListenerCalculator: 'Listener Calculator Guide',
    helpPlaylistAnalyzer: 'Playlist Analyzer Guide',
    helpDaypartAnalyzer: 'Daypart Analyzer Guide',
    
    // Campaign Calculator Page
    campaignAnalyzerPageTitle: 'Campaign Analyzer',
    campaignAnalyzerPageDesc: 'Radio campaign optimization tool',
    brandCategoryLabel: 'BRAND CATEGORY (ALPHABETICAL)',
    marketPositionLabel: 'BRAND MARKET POSITION',
    radioPrimaryLabel: 'RADIO AS PRIMARY MEDIUM?',
    campaignDurationLabel: 'CAMPAIGN DURATION (ACTIVE WEEKS)',
    pleaseSelect: 'Please select',
    spotsPerDay: 'Spots per Day',
    adjustSpotsPerDay: 'Adjust the number of spots for each day of the week',
    totalSpotsWeek: 'Total Spots/Week',
    calculateCampaign: 'Calculate Campaign',
    weeklyGRPs: 'Weekly GRPs',
    totalGRPs: 'Total GRPs',
    estimatedReach: 'Reach',
    avgFrequency: 'Avg. Frequency',
    weeklyProgress: 'Weekly Progress',
    dailyDistribution: 'Daily Distribution (Week 1)',
    strategicRecommendations: 'Strategic Recommendations',
    scenarioComparison: 'Scenario Comparison',
    exportPDFBtn: 'Export to PDF',
    pleaseWaitPDF: 'Please wait...',
    fillAllFields: 'Please fill in all fields',
    calculateFirst: 'Please calculate first by clicking "Calculate"',
    waitForPDFGen: 'Please wait up to 10 seconds for the file to be generated...',
    pleaseWait: 'Please wait...',
    exportCompleted: 'Export completed!',
    exportError: 'Error exporting to PDF',
    // Day names
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    // Brand categories
    foodDrinks: 'Food & Drinks',
    technology: 'Technology',
    fashionBeauty: 'Fashion & Beauty',
    automobiles: 'Automobiles',
    services: 'Services',
    retail: 'Retail',
    // Market positions
    marketLeader: 'Market Leader',
    challenger: 'Challenger',
    newEntry: 'New Entry',
    // Campaign durations
    weeks2: '2 weeks',
    weeks4: '4 weeks',
    weeks8: '8 weeks',
    weeks12: '12 weeks',
    weekLabel: 'Week',
    weekFull: 'Week',
    historicalData: 'Historical Data',
    showMore: 'Show More',
    noResultsFor: 'No results found for',
    chartSavedSuccess: 'Chart saved successfully!',
    year: 'Year',
    songsCount: 'Songs',
    noDataToSave: 'No data to save',
    adminOnlyFeature: 'You must be logged in as admin for this feature',
    adminOnlySaveChart: 'Only admin users can save charts',
    saveFailed: 'Save failed. Please try again.',
    spots: 'spots',
    recommendations: 'Recommendations & Improvements',
    totalSpots: 'Total Spots',
    // Recommendations - Dynamic messages with placeholders
    criticalLowFreq: 'CRITICAL: Very Low Frequency',
    criticalLowFreqMsg: 'Current frequency is insufficient. The message will not be retained in the audience\'s memory.',
    criticalLowFreqMsgDynamic: 'Current frequency ({freq}) is insufficient. The message will not be retained in the audience\'s memory.',
    recIncreaseSpotsTo: 'Suggested increase to {newWeeklySpots} spots/week ({extraSpots} extra spots) to reach Frequency {targetFreq} and {newGRPs} GRPs.',
    warningHighFreq: 'Warning: Very High Frequency',
    warningHighFreqMsg: 'Frequency is too high. Risk of "ad fatigue" and budget waste.',
    warningHighFreqMsgDynamic: 'Frequency ({freq}) is too high. Risk of "ad fatigue" and budget waste.',
    recReduceSpotsTo: 'You can reduce to {newWeeklySpots} spots/week and save costs while maintaining Frequency at {targetFreq}.',
    suggestionIncrease: 'Suggestion: Increase Effectiveness',
    suggestionIncreaseMsg: 'Your GRPs are below the ideal level (400+).',
    suggestionIncreaseMsgDynamic: 'Your GRPs ({grps}) are below the ideal level (400+). For better performance:',
    recOptionsAB: '• OPTION A: Increase duration to {option1_weeks} weeks → ~{option1_newGRPs} GRPs\n• OPTION B: Add {option2_spotsIncrease} spots/week ({option2_newWeeklySpots} total) → ~{option2_newGRPs} GRPs',
    excellentGRPs: 'Excellent GRPs',
    excellentGRPsMsg: 'Your GRPs are excellent! You have maximum coverage.',
    excellentGRPsMsgDynamic: 'Your GRPs ({grps}) are excellent! You have maximum coverage.',
    recWatchSaturation: 'Watch for audience saturation. You can maintain current levels or reduce slightly for savings.',
    optimalCampaign: 'Optimal Campaign!',
    optimalCampaignMsg: 'Your GRPs and Frequency are in the ideal range.',
    optimalCampaignMsgDynamic: 'Your GRPs ({grps}) and Frequency ({freq}) are in the ideal range.',
    recWellDesigned: 'Your campaign is well-designed and will have effective performance. Continue with this strategy!',
    strongCampaign: 'Very Strong Campaign!',
    strongCampaignMsg: 'Your GRPs are high. You will dominate your category.',
    strongCampaignMsgDynamic: 'Your GRPs ({grps}) are high. You will dominate your category.',
    recExcellentStrategy: 'Excellent strategy for brand awareness and market dominance!',
    perfectCampaign: 'Perfect Campaign!',
    perfectCampaignMsg: 'All your metrics are at optimal levels.',
    recBestBalance: 'Your campaign has the best possible cost-performance balance!',
    // Scenarios
    lessSpots: 'Less Spots (-30%)',
    currentStrategy: 'Current Strategy',
    shorterDuration: 'Shorter Duration (-2 wks)',
    lower: 'Lower',
    optimal: 'Optimal',
    medium: 'Medium',
    scenario: 'Scenario',
    efficiency: 'Efficiency',
    // Frequency & GRP Levels
    yourCampaign: 'Your campaign',
    freqInsufficient: 'Insufficient',
    freqVeryLow: 'Very low',
    freqIdeal: 'IDEAL - good awareness',
    freqVeryGood: 'Very good - strong recall',
    freqHigh: 'High - good but watch costs',
    freqTooHigh: 'Too high - risk of "ad fatigue"',
    grpLevels: 'GRP Levels (Gross Rating Points)',
    grpVeryLow: 'Very low - insufficient coverage',
    grpLow: 'Low - minimal market impact',
    grpGood: 'Good - initial awareness, suitable for maintenance',
    grpVeryGood: 'Very good - strong presence, effective campaign',
    grpHigh: 'High - category dominance',
    grpVeryHigh: 'Very high - maximum coverage, watch saturation',
    
    // Listener Calculator Page
    listenerCalcTitle: 'Listener Calculator',
    listenerCalcDesc: 'Real audience estimation tool',
    whatIsCalculator: 'What is the Calculator?',
    listenerCalcGuide: 'Listener Calculator Guide',
    listenerCalcWhat: 'What is the Listener Calculator & what does it do',
    listenerCalcWhatDesc: 'The Listener Calculator is a real streaming audience estimation tool for:',
    listenerCalcItems: 'Day,Daypart (time zone),Week,Combination of days & dayparts',
    listenerCalcNote: 'It doesn\'t just measure raw connections.',
    listenerCalcStatistical: 'It uses statistical projection so from a sample of listeners it calculates:',
    listenerCalcMetrics: 'Audience percentage,Estimated number of real listeners,Confidence Interval 95%,Weekly trend',
    listenerCalcTool: 'This transforms streaming data from "numbers" to a decision-making tool.',
    streamingAnalyticsTitle: 'Streaming Data Analyzer',
    streamingAnalyticsDesc: 'Upload CSV from your streaming provider for detailed audience analysis',
    listenerCalcAnalysis: 'Analysis & explanation of indicators',
    sampleTitle: 'Sample',
    sampleDesc: 'The number of users recorded (e.g. listeners, sessions, survey responses).',
    sampleTip: 'The larger the sample, the greater the accuracy.',
    positiveTitle: 'Positive',
    positiveDesc: 'The number of users meeting the criterion (e.g. listened more than X time).',
    positiveTip: 'Filters "random clicks" from real listeners.',
    populationTitle: 'Population',
    populationDesc: 'Total estimation of potential population (e.g. unique stream listeners).',
    populationTip: 'Used to convert percentage to actual listener count.',
    percentageTitle: 'Percentage (%)',
    percentageDesc: 'Positive / Sample',
    percentageTip: 'Shows how strong each daypart is relative to the total.',
    estimatedListenersTitle: 'Estimated Listeners',
    estimatedListenersDesc: 'Percentage × Population',
    estimatedListenersTip: 'The most critical indicator: How many people actually listen to the station in this zone.',
    ciTitle: 'CI 95% (Confidence Interval)',
    ciDesc: 'Statistical reliability range. Example: 18% – 22%',
    ciTip: 'Means with 95% certainty, real audience is within this range.',
    fpcTitle: 'FPC – Finite Population Correction',
    fpcDesc: 'Used when sample is large and population is finite (e.g. local station).',
    fpcTip: 'Dramatically improves result accuracy.',
    trendTitle: 'Weekly Trend (Chart)',
    trendDesc: 'Shows audience evolution per day, drops & increases.',
    trendTip: 'Identifies when something is NOT working.',
    howHelpsTitle: 'How it helps a radio station',
    costReduction: 'Cost Reduction',
    costReductionItems: 'Identify low-performing dayparts,Reduce unnecessary expenses on underperforming productions,Targeted changes instead of general investments',
    audienceIncrease: 'Audience Increase',
    audienceIncreaseItems: 'Optimize playlist per zone,Adjust content per hour,Strengthen strong dayparts,Fix weak ones before losing audience',
    playlistAdaptation: 'Playlist & Content Adaptation',
    playlistAdaptationItems: 'Different music flow in morning,Different in drive,Different in overnight',
    playlistAdaptationNote: 'The calculator shows where the listener gets tired.',
    proDataTitle: 'Professional data for advertisers',
    proDataItems: 'Performance proof per hour,Reliable numbers,Arguments for better rates',
    understoodClose: 'Got it, close',
    
    // Contact Form
    contactTitle: 'Contact',
    contactDesc: 'Fill out the form to contact us',
    firstName: 'First Name',
    lastName: 'Last Name',
    stationName: 'Station Name',
    region: 'Region',
    phone: 'Phone',
    email: 'Email',
    message: 'Message',
    attachFile: 'Attach file',
    sendMessage: 'Send Message',
    sending: 'Sending...',
    messageSent: 'Your message was sent successfully!',
    messageError: 'There was an error sending your message',
    requiredField: 'This field is required',
    invalidEmail: 'Please enter a valid email',
    invalidPhone: 'Please enter a valid phone number',
    selectRegion: 'Select region',
    contactInfo: 'Contact Information',
    nameRequired: 'Name is required',
    lastNameRequired: 'Last name is required',
    enterRealName: 'Please enter your real name',
    enterRealLastName: 'Please enter your real last name',
    minChars: 'Must have at least 2 characters',
    enterValidName: 'Please enter a valid name',
    stationRequired: 'Station name is required',
    regionRequired: 'Region is required',
    phoneRequired: 'Phone is required',
    emailRequired: 'Email is required',
    businessEmailRequired: 'Please use a business email',
    messageRequired: 'Message is required',
    minMessageLength: 'Message must have at least 10 characters',
    fileTooLarge: 'File is too large (max 5MB)',
    invalidFileType: 'Invalid file type',
    regionCyprus: 'Cyprus',
    regionAttica: 'Attica',
    regionThessaloniki: 'Thessaloniki',
    regionCentralMacedonia: 'Central Macedonia',
    regionWestMacedonia: 'West Macedonia',
    regionEastMacedoniaThrace: 'East Macedonia and Thrace',
    regionEpirus: 'Epirus',
    regionThessaly: 'Thessaly',
    regionIonianIslands: 'Ionian Islands',
    regionWestGreece: 'West Greece',
    regionCentralGreece: 'Central Greece',
    regionPeloponnese: 'Peloponnese',
    regionNorthAegean: 'North Aegean',
    regionSouthAegean: 'South Aegean',
    regionCrete: 'Crete',
    
    // Our Stations
    ourStationsTitle: 'Our Stations',
    ourStationsDesc: 'Demo stations with various music formats for creating playlists for radio stations and In-Store businesses.',
    listenLive: 'Listen Live',
    visitWebsite: 'Visit Website',
    
    // SongInfo
    songInfoTitle: 'Song Information',
    songInfoDesc: 'Search for information and broadcast suggestions for songs',
    artistLabel: 'Artist',
    titleLabel: 'Title',
    searchSongInfo: 'Search Information',
    searching: 'Searching...',
    tipLatinChars: 'Use Latin characters for better results',
    radioAnnouncement: 'Broadcast Suggestion',
    announcementTip: 'Use this text as a guide for presenting the song',
    fillArtistTitle: 'Please fill in Artist and Title',
    fillArtistTitleSearch: 'Fill in Artist and Title to search',
    infoFound: 'Information found!',
    searchError: 'Search error. Try again.',
    exampleArtist: 'e.g. Ed Sheeran',
    exampleTitle: 'e.g. Shape of You',
    
    // DaypartAnalyzer & Gold Analysis
    specialAnalysisForTracks: 'Special analysis for tracks',
    withAvailableYear: 'with available year',
    recommendations: 'Recommendations',
    goldHitDesc: 'Top gold - Keep in rotation',
    goldKeeperDesc: 'Valuable - Continue normally',
    goldRotateDesc: 'OK performance - Normal rotation',
    goldRestDesc: 'Tired - Break 1-2 months',
    goldDropDesc: 'Low performance - Replace',
    
    // Early Hit Predictor
    ehpTitle: 'Early Hit Predictor',
    ehpSubtitle: 'Radio Hit Prediction',
    ehpDescription: 'Early Hit Predictor identifies songs that show early signs of radio success. The system focuses on what is new to radio, not necessarily new releases.',
    ehpDescription2: 'Using first-week radio behavior across multiple stations, it estimates the likelihood that a song will develop into a radio hit.',
    ehpMetricsTitle: 'Metrics Explanation',
    ehpScoreLabel: 'EHP Score',
    ehpScoreDesc: 'Composite score (0-100) combining station spread, play velocity, TLH and daypart spread. Higher = greater probability of success.',
    ehpDaypartLabel: 'Daypart Spread',
    ehpDaypartDesc: 'How many dayparts the song plays in (1-5: Morning, Midday, Afternoon, Drive, Night). Greater spread = broader acceptance.',
    ehpRcsLabel: 'RCS Score',
    ehpRcsDesc: 'Release Confidence Score - likelihood of being a new release vs catalog. Based on radio age, velocity and station adoption.',
    ehpClarificationTitle: 'Important Clarification',
    ehpClarification: '"New to radio" does not always mean "new release". It means the first meaningful adoption by radio stations.',
    ehpNote: 'This is a prediction tool — not a chart ranking.',
    ehpFooterNote: 'Early Hit Predictor is a decision-support tool for music professionals, not a performance ranking or reporting chart.',
    ehpCategoryFilter: 'Category',
    ehpRefresh: 'Refresh',
    ehpNoResults: 'No predictions found',
    ehpNoResultsCategory: 'No songs in category',
    ehpNoResultsGeneral: 'No songs meet the eligibility criteria at this time.',
    ehpDetails: 'Details',
    ehpClose: 'Close',
    ehpCategoryStrong: 'STRONG',
    ehpCategoryGood: 'GOOD',
    ehpCategoryWeak: 'WEAK',
    ehpCategoryAll: 'All',
    ehpStrongTooltip: 'High probability of becoming a radio hit based on early radio behavior.',
    ehpGoodTooltip: 'Shows positive signs, but needs further support.',
    ehpWeakTooltip: 'Low probability based on current radio response.',
    ehpNewRelease: 'New Release',
    ehpRecentRelease: 'Recent Release',
    ehpCatalog: 'Catalog',
    ehpUnknownDate: 'Unknown date',
    ehpPlays: 'Plays',
    ehpTlh: 'TLH',
    ehpRcs: 'RCS',
    ehpDayparts: 'Dayparts',
    ehpSignalsNote: 'Supporting signals — used to explain the prediction, not for ranking.',
    
    // Compare Stations Page
    compareStationsTitle: 'Compare Radio Stations',
    compareStationsSubtitle: 'Station performance comparison',
    compareStationsDesc: 'Compare how two radio stations perform with the same music, based on audience reaction.',
    selectStation: 'Select station',
    noStationsAvailable: 'No stations available',
    selectTwoStations: 'Select two different stations to start the comparison.',
    compareButton: 'Compare Stations',
    comparing: 'Comparing...',
    noCommonSongs: 'No common songs found between the two stations.',
    noUniqueSongs: 'No unique songs.',
    playlistsCompletelyDifferent: 'Playlists are completely different.',
    songs: 'songs',
    plays: 'plays',
    commonSongsPerformance: 'Common Songs Performance',
    playlistDifferentiation: 'Playlist Differentiation',
    uniqueTo: 'Unique to',
    daypartBreakdown: 'Daypart Breakdown',
    daypartListenerReaction: 'Listener reaction by daypart',
    daypartComparisonNote: 'Comparison of listener reaction by daypart based on common songs.',
    aggregateMetricsNote: 'The above metrics are aggregated per station. There is no ranking or "winner".',
    clickForDaypart: 'Click on a song to see the daypart breakdown',
    stationComparisonDisclaimer: 'Compares stations to each other — not songs within a station. No ranking labels (POWER, GOLD, etc.) are used.',
    noAccessCompare: 'You do not have access to station comparison',
    
    // Compare Stations - Description boxes
    whatIsCompareStations: 'What is Compare Stations',
    compareStationsDescP1: 'The Compare Stations tool allows you to compare how two radio stations perform with their audience during the same time period.',
    compareStationsDescP2: 'The comparison is based on listener reaction metrics — not just radio broadcasts — and uses unified song identities to avoid duplicates or inconsistent results.',
    selectStationsAndPeriod: 'Select Stations & Time Period',
    timePeriod: 'Time Period',
    contactForAccess: 'To gain access to station comparison, please contact us.',
    contact: 'Contact',
    
    // Time windows
    previousWeek: 'Previous Week',
    last7Days: 'Last 7 Days',
    last14Days: 'Last 14 Days',
    last30Days: 'Last 30 Days',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    
    // Radio Chart / People's Chart
    radioChartTitle: 'The People\'s Chart',
    radioChartSubtitle: 'Songs that listeners hear until the end',
    radioChartDesc: 'Chart based on listener retention, not just plays.',
    noDataFound: 'No data found',
    noDataForPeriod: 'No data found for this period',
    chartComingSoon: 'Coming soon!',
    chartUnderConstruction: 'The chart shaped by listeners is under construction.',
    chartFromListeners: 'It comes from listeners who hear songs until the end, from the best radio stations in the country.',
    chartTopSongsDesc: 'songs that listeners don\'t change stations - they listen until the end, on the best stations in the country',
    chartDescription: 'Top 300 - Ranked by listener engagement across Greek radio stations',
    clickSongForTrend: 'Click on a song for 30-day trend',
    loginForFull300: 'Login for the full Top 300',
    periodYesterday: 'Yesterday',
    periodPrevWeek: 'Prev. Week (Mon-Sun)',
    period2Weeks: '2 Weeks',
    period3Weeks: '3 Weeks',
    period4Weeks: '4 Weeks (Month)',
    howChartCalculated: 'How the Chart is calculated',
    howChartRanked: 'How ranking is calculated:',
    scoredBy3Factors: 'Each song is scored based on 3 factors:',
    retentionDesc: 'How many listeners stayed until the end',
    playsDesc: 'How many times it was broadcast across all stations',
    earlyDropDesc: 'How many left early (lower = better)',
    excelDownloaded: 'Excel file downloaded successfully!',
    excelDownloadError: 'Error downloading Excel',
    connectionError: 'Connection error',
    chartLoadError: 'Error loading chart',
    stationsCount: 'stations',
    artistColumn: 'Artist',
    titleColumn: 'Title',
    stationsColumn: 'Stations',
    wantFullTop300: 'Want to see the full Top 300?',
    getAccessDesc: 'Get access to the full chart with 300 songs, detailed statistics and daily analysis per station.',
    viewPackagesBtn: 'View Packages',
    loginBtn: 'Login',
    freeTrial24hNew: 'Free 48-hour trial for new users',
    plays7Days: 'plays (7 days)',
    dayColumn: 'Day',
    timesColumn: 'Times',
    
    // Songs Analyzer
    songsAnalyzerTitle: 'Songs Analyzer',
    songsAnalyzerSubtitle: 'Detailed song analytics per station',
    songsAnalyzerMetricsNote: 'Metrics are based on stream stability and behavior analysis. No actual concurrent listeners are included.',
    liveAudienceTooltip: 'Metrics are based on real concurrent listeners from the station streaming server.\nThe analysis reflects the actual audience reaction to each song.',
    noAccessSongsAnalyzer: 'You do not have access',
    noDataForPeriodSongs: 'No data for the selected period',
    selectYesterdayForDaypart: 'Select "Yesterday" or another period to see daypart analysis.',
    noDataForDaypart: 'No data for this daypart',
    noDataDayparts: 'No daypart data for the selected period',
    
    // Early Hit Predictor
    ehpNoResults: 'No predictions found',
    ehpNoSongsInCategory: 'No songs in category',
    ehpNoEligibleSongs: 'No songs meet the eligibility criteria at this time.',

    // v2.9.203 — Plays vs Behavior Comparison
    pvbWhyDifferent: 'Why we are different',
    pvbTitlePartA: 'Simple Song Tracking',
    pvbVs: 'vs',
    pvbTitlePartB: 'Listener Behavior',
    pvbDescription: 'Tracking plays only shows what was broadcast. Analyzing listener behavior reveals',
    pvbWhatReallyWorks: 'what actually works',
    pvbDescriptionEnd: ', what keeps the audience tuned in, and which decisions drive higher ratings and revenue.',
    pvbRetentionStat: 'Listener retention increase on the frequency up to',
    pvbTraditionalApproach: 'Traditional approach',
    pvbSimpleSongTrackingPlays: 'Simple Song Tracking (Plays)',
    pvbFullAnalysis: 'Full Analysis',
    pvbSongAndBehavior: 'Song + Listener Behavior',
    pvbPlays1: 'How many times a song was played',
    pvbPlays2: 'Playlist & Rotation data only',
    pvbPlays3: 'No view of audience response',
    pvbPlays4: 'Unknown impact on listeners',
    pvbPlays5: 'Decisions based on assumptions',
    pvbPlays6: 'Measures what was played',
    pvbPlays7: 'Historical logging',
    pvbPlays8: 'Playlist statistics',
    pvbPlays9: 'Does not show why ratings go up or down',
    pvbPlays10: 'Limited data exploitation',
    pvbBehavior1: 'Real-time tracking of listener behavior',
    pvbBehavior2: 'Listener engagement at every moment',
    pvbBehavior3: 'Tune-in, Engagement, Tune-out and Retention measurement',
    pvbBehavior4: 'Analysis within your own format, schedule, programming and market',
    pvbBehavior5: 'Data-driven decisions based on real data',
    pvbBehavior6: 'Measures what worked and what performed',
    pvbBehavior7: 'Real-time insights',
    pvbBehavior8: 'Audience and behavior statistics',
    pvbBehavior9: 'Identifies what affects audience numbers',
    pvbBehavior10: 'Full data exploitation for station growth',
    pvbWantToKnowA: 'Want to know',
    pvbWhatReallyLiked: 'what your audience really loves',
    pvbWantToKnowB: '?',
    pvbContactPromo: 'Contact Radio Solutions for a demo of our listener-behavior analysis system.',
    pvbRequestDemo: 'Request a Demo',
    pvbTrustedByA: 'Trusted by',
    pvbStations: 'stations',

    // v2.9.203 — Songs Analyzer common UI
    saStreamUrlSuggestion: 'Suggest Stream URL',
    saSongs: 'Songs',
    burnWeek: "Week {{from}} - {{to}} · {{n}} songs",
    burnPeriodNote: "Last full week (Monday-Sunday)",
    burnSearch: "Search…",
    burnPage: "Page {{p}} / {{n}}",
    burnLoading: "Loading…",
    burnError: "Could not load data.",
    burnPending: "The weekly Burn analysis is being prepared. It updates every Monday after midnight.",
    burnEmpty: "No data for the last full week.",
    burnNoAudience: "No reliable listener data for this station.",
    burnAudienceWarn: "Few spins with listener measurements this week: results are indicative.",
    burnColArtist: "Artist",
    burnColTitle: "Title",
    burnColYear: "Year",
    burnColSpins: "Spins",
    burnCol4w: "4 wks",
    burnColBurn: "Burn",
    burnColDelta: "Delta",
    burnColTrend: "Trend",
    burnColStatus: "Status",
    burnTapHint: "Tap a status label for an explanation.",
    burnStIncreasing: "Increasing",
    burnStStable: "Stable",
    burnStDecreasing: "Decreasing",
    burnStHighExposure: "High exposure",
    burnTipHighWeeks: "At the station's top spin level: {{n}} of the 4 weeks.",
    burnTipStationChoice: "Shows the station's choice, not listener reaction.",
    burnAdvIncreasing: "The station plays it more and more.",
    burnAdvStable: "The station keeps the same spins.",
    burnAdvDecreasing: "The station is already lowering its spins.",
    burnAdvHighExposure: "Many weeks at the top level: risk of fatigue. If listener data exists, check Audience.",
    burnAirplayNote: "Airplay: shows only the station's choice (spins). It does not measure listeners.",
    burnTipWeekSpins: "This week ({{from}}-{{to}}): {{spins}} spins, {{diff}}.",
    burnTipMore: "{{n}} more than last week",
    burnTipLess: "{{n}} fewer than last week",
    burnTipSame: "same as last week",
    burnTipWeekLoss: "This week ({{from}}-{{to}}): when it plays, {{d}}% of listeners leave.",
    burnTipWeekGain: "This week ({{from}}-{{to}}): when it plays, listeners grow by {{d}}%.",
    burnSortHint: "Click a column title to sort.",
    burnLegendAirplay: "Burn 0-100 = rotation pressure: how many spins the station gives it versus its most-played songs, how many weeks it stayed at the top level and how far spins fell from the month peak. It does not measure listener reaction.",
    burnLegendAudience: "Audience: Delta = average listener change while the song plays. Green/yellow/red = the station's best/middle/worst third. Trend = compared with the previous 3 weeks.",
    burnStBurning: "Burning out",
    burnStTiring: "Wearing out",
    burnStRising: "Rising",
    burnStSteady: "Steady",
    burnStLosing: "Losing listeners",
    burnStNeutral: "Neutral",
    burnStHolding: "Holds listeners",
    burnTipLowSample: "Only {{n}} of {{total}} spins had listener measurements.",
    burnAdvBurning: "What to do: cut its spins or rest it for a while.",
    burnAdvTiring: "What to do: don't add spins, keep an eye on it.",
    burnAdvRising: "What to do: it has momentum and can take more spins.",
    burnAdvSteady: "What to do: no change.",
    burnAdvLosing: "What to do: check its airtime slot or cut its spins.",
    burnAdvNeutral: "What to do: no immediate change.",
    burnAdvHolding: "What to do: it performs well, keep it.",
    saBroadcasts: 'Broadcasts',
    saTabAll: 'All',
    saTabPrefecture: 'Prefecture',
    saListenerStats: 'Listener Statistics',
    saMoreStations: 'Want access to more stations?',
    saMoreStationsDesc: 'Contact us to add more stations to your account.',
    saContact: 'Contact',
    saExcel: 'Excel',
    saMetadataOnly: 'Metadata-only',
    saYesterdayFull: 'Yesterday (✅ Complete)',

    // v2.9.203 — Compare Stations page
    csTitle: 'Compare Radio Stations',
    csSubtitle: 'Station performance comparison',
    csWhatIs: 'What is Compare Stations',
    csWhatIsP1: 'The Compare Stations tool lets you compare how two radio stations perform with their audience during the same time period.',
    csWhatIsP2: 'The comparison is based on listener reaction metrics — not just broadcasts — and uses unified song identities to avoid duplicates or inconsistent results.',
    csSelectStations: 'Select Stations & Time Period',
    csModeStation: 'Station vs Station',
    csModeGroup: 'Group vs Group',
    csModeCategory: 'Category vs Category',
    csCategoryA: 'Category A',
    csCategoryB: 'Category B',
    csTimePeriod: 'Time Period',
    csSelectCategory: 'Select Category',
    csPeriod7d: '7 days',
    csPeriod14d: '14 days',
    csPeriod30d: '30 days',
    csCompareBtn: 'Compare Stations',
    csSelectTwo: 'Select two different stations to start the comparison.',

    // v2.9.205 — Performance Score Section (Music Performance)
    perfLoading: 'Loading…',
    perfNoData: 'Not enough data yet',
    perfNoDataMsg: 'Collect a bit more activity and we\'ll tell you how you\'re doing.',
    perfTierLocal: 'Your area',
    perfTierFormat: 'Same format nationwide',
    perfTierNational: 'National average',
    perfTierPersonal: 'Personal progress',
    perfPeriodLabel: 'Period:',
    perfPeriodFull: 'Last full week',
    perfPeriodTip: 'For a stable comparison the last completed week is always used',
    perfPersonalDescA: 'Personal progress',
    perfPersonalDescB: '— see your week-over-week trajectory.',
    perfCompareNationalA: 'Comparison with the',
    perfCompareNationalB: 'national average',
    perfCompareNationalC: 'of all stations on the platform.',
    perfCompareAvgA: 'Comparison with the',
    perfCompareAvgB: 'average',
    perfCompareAvgC: 'of',
    perfActivity: 'How often you play',
    perfVariety: 'Music variety',
    perfYou: 'You:',
    perfPerWeek: '/week',
    perfAvgNational: 'National avg:',
    perfAvgLocal: 'Your area avg:',
    perfAvgFormat: 'Same-format avg:',
    perfAvgGeneric: 'Average:',
    perfAvgPin: 'avg',
    perfAvgTooltip: 'Average',
    perfAdvice: 'Tip',
    perfDow: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'],

    // v2.9.205 — Daypart Legend / Songs Analyzer Daypart view
    daypartMetrics: 'Daypart Metrics',
    daypartSubtitle: 'Listener Reaction per Time Zone',
    daypartGuide: 'Guide',
    daypartMorning: 'Morning',
    daypartMidday: 'Midday',
    daypartAfternoon: 'Afternoon',
    daypartDrive: 'Drive Time',
    daypartEvening: 'Evening',
    daypartNight: 'Night',
    daypartPlays: 'plays',
    daypartSongsCount: 'songs',
    daypartSearch: 'Search song or artist…',
    daypartColPlays: 'Plays',
    daypartColSongs: 'Songs',
    daypartColTLH: 'TLH',
    daypartSortHint: 'Click headers to sort',

    // v2.9.205 — Era Chart
    eraChartTitle: 'Era Chart',
    eraChartSubtitle: 'Distribution by decade and year. Click a bar to filter the "All" tab.',
    eraChartPlays: 'plays',
    eraChartUnique: 'unique',
    eraChartTogglePlays: 'Plays',
    eraChartToggleVariety: 'Variety',
    eraChartYears: 'yrs',
    eraChartYear: 'yr',
    eraChartUnknownYear: 'Unknown year',
    eraChartFooterPlays: 'Metric: broadcasts · Total:',
    eraChartFooterUnique: 'Metric: unique songs · Total:',

    // v2.9.205 — Playlist Chart / Top Artists / Common columns
    colArtist: 'Artist',
    colTitle: 'Title',
    colPlays: 'Plays',
    colAvgListeners: 'Avg Listen.',
    colTLH: 'TLH',
    colRetention: 'Ret%',
    colEarly: 'Early',
    colLSI: 'LSI',
    colScore: 'Score',
    colAImpact: 'A.Impact',
    colYear: 'Year',
    colRank: 'Rank',
    topArtistsDiffSongs: 'different songs',
    playlistApply: 'Apply',
    playlistPrevWeek: 'Prev. Week',
    dowShort: ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'],
    // ─── i18n Batch #3 (v2.10.0+) — Songs Analyzer subcomponents ───
    i18nB3_morning_06_10: 'Morning 06-10',
    i18nB3_midday_10_15: 'Midday 10-15',
    i18nB3_drive_15_19: 'Afternoon 15-19',
    i18nB3_night_22_06: 'Night 22-06',
    i18nB3_all_day: 'All day',
    i18nB3_our_avg: 'Our Avg',
    i18nB3_numbers: 'Numbers',
    i18nB3_listener_stats: 'Listener Statistics',
    i18nB3_your_audience: 'Your audience',
    i18nB3_hour: 'Hour',
    i18nB3_listeners: 'listeners',
    i18nB3_avg_short: 'avg',
    i18nB3_loyal: 'Loyal',
    i18nB3_passing: 'Passing',
    i18nB3_normal: 'Normal',
    i18nB3_audience_exact: 'Exact data from the station server',
    i18nB3_audience_estimate: "Server doesn't provide full data — value is an estimate",
    i18nB3_audience_unavailable: "Your station's server doesn't provide this information yet.",
    i18nB3_audience_renewal: 'new audience arrives every hour (estimate)',
    i18nB3_unknown_year: 'Unknown year',
    i18nB3_expand: 'Expand',
    i18nB3_collapse: 'Collapse',
    i18nB3_day_mon: 'Mon',
    i18nB3_day_tue: 'Tue',
    i18nB3_day_wed: 'Wed',
    i18nB3_day_thu: 'Thu',
    i18nB3_day_fri: 'Fri',
    i18nB3_day_sat: 'Sat',
    i18nB3_day_sun: 'Sun',
    i18nB3_next_song: 'Next song',
    i18nB3_prev_song: 'Previous song',
    i18nB3_genre_artistic: 'Artistic',
    i18nB3_genre_intl: 'International / Foreign',
    i18nB3_genre_greek: 'Greek',
    i18nB3_genre_mixed: 'Mixed',
    i18nB3_genre_rock: 'Rock',
    i18nB3_group: 'Group',
    i18nB3_group_vs_group: 'Group vs Group',
    i18nB3_genre: 'Genre',
    i18nB3_genre_vs_genre: 'Genre vs Genre',
    i18nB3_close: 'Close',
    i18nB3_select_station: 'Select station',
    i18nB3_stations: 'Stations',
    i18nB3_station: 'Station',
    i18nB3_station_vs_station: 'Station vs Station',
    i18nB3_compare: 'Compare',
    i18nB3_not_run_yet: 'Not run yet',
    i18nB3_start_year_search: 'Start year search',
    i18nB3_just_now: 'Just now',
    i18nB3_never: 'Never',
    i18nB3_running: 'Running...',
    i18nB3_now: 'Now!',
    i18nB3_your_performance: 'Your performance',
    i18nB3_export_timeline_excel: 'Export timeline to Excel (.xlsx)',
    i18nB3_confirmed_fp: 'Confirmed by audio fingerprint',
    i18nB3_hide_gaps_hint: 'Hides small gaps caused by duration mismatches/crossfades. Default 5min.',
    i18nB3_async_analysis_in_progress: 'Async analysis in progress...',
    i18nB3_upload_csv_first: 'Please upload a CSV file first',
    i18nB3_connection_error_retry: 'Connection error. Please try again.',
    i18nB3_too_many_requests: 'Too many requests, retrying in 3s...',
    // ── Clock View (Programming Clocks) — added 2026-06-15
    clkView_listView: 'List',
    clkView_clockView: 'Clock',
    clkView_hourFrom: 'From',
    clkView_hourTo: 'To',
    clkView_exportPdf: 'Export PDF',
    clkView_exportingPdf: 'Generating PDF…',
    clkView_loadingClocks: 'Loading clocks…',
    clkView_noActiveHours: 'No active programming hours for this date.',
    clkView_emptyHour: 'No content for this hour.',
    clkView_songs: 'songs',
    clkView_breaks: 'breaks',
    clkView_song: 'Song',
    clkView_break: 'Break / Gap',
    clkView_listenersStart: 'Start',
    clkView_listenersEnd: 'End',
    clkView_listenersPeak: 'Peak',
    clkView_listenersAvg: 'Avg',
    clkView_retention: 'Retention',
    clkView_earlyDrop: 'Early Drop',
    clkView_lsi: 'Listener Score',
    clkView_score: 'Score',
    clkView_severitySevereLoss: 'Severe loss',
    clkView_severitySignificantLoss: 'Significant loss',
    clkView_severityMinorLoss: 'Minor loss',
    clkView_severityStable: 'Stable',
    clkView_severityMinorGain: 'Minor gain',
    clkView_severityStrongGain: 'Strong gain',
    clkView_severityUnknown: 'Unknown',
    clkView_netHour: 'Hour net',
    clkView_categoryPower: 'POWER',
    clkView_categorySecondary: 'SECONDARY',
    clkView_categoryCurrents: 'CURRENTS',
    clkView_categoryRecurrents: 'RECURRENTS',
    clkView_categoryGold: 'GOLD',
    clkView_categorySlowDown: 'SLOW DOWN',
    clkView_categoryCut: 'CUT',
    clkView_legendTitle: 'Legend',
    clkView_legendSongCategories: 'Song categories',
    clkView_legendBreakSeverity: 'Break severity',
    clkView_legendBreaksSingle: 'Breaks',
    clkView_listenersUnit: 'listeners',
    clkView_clickToSee: 'Click a slice on the clock for details',
    clkView_sparklineTitle: 'Listeners per 5 min',
    clkView_min: 'min',
    clkView_max: 'max',
    clkView_thisHourLabel: 'This hour',
    clkView_legendSongs: 'Songs',
    clkView_song: 'Music',
    clkView_legendHelp: 'Click any slice for details',
    clkView_talk: 'Talk',
    clkView_talks: 'talks',
    clkView_breakHint: '1-4 min @ slots :25 :30 :55 :00',
    clkView_talkHint: 'anything else',
    clkView_noData: 'no data',
    clkView_noDataHint: 'non-music content — under investigation',
    // ─── Classifier Shadow Report (v2.13.0) ───
    clfReport_title: 'Classifier Report (Shadow)',
    clfReport_subtitle: 'inaSpeechSegmenter validation against real Shazam attempts',
    clfReport_gateMode: 'Mode',
    clfReport_classifierReady: 'classifier ready',
    clfReport_classifierUnavail: 'classifier unavailable',
    clfReport_refresh: 'Refresh',
    clfReport_downloadCsv: 'Download CSV',
    clfReport_musicPct: 'Music %',
    clfReport_speechPct: 'Speech %',
    clfReport_speechMusicPct: 'Speech + Music %',
    clfReport_noisePct: 'Noise %',
    clfReport_potentialReduction: 'Potential Fingerprint Reduction',
    clfReport_potentialReduction_hint: 'How many Shazam calls would be saved if we enabled gating right now.',
    clfReport_actualReduction: 'Actual Fingerprint Reduction',
    clfReport_actualReduction_hint: 'Active gating ON: how many Shazam calls were actually suppressed in this window (SKIPPED / total real calls).',
    clfReport_callsSaved: 'Shazam Calls Saved',
    clfReport_callsSaved_hint: 'Actual number of calls blocked by active gating (SKIPPED column total).',
    // v2.13.19 (2026-02) — Content Mix view (per-station weekly breakdown).
    contentMix_tabLabel: 'Content',
    contentMix_currentWeek: 'Current Week',
    contentMix_previousWeek: 'Previous Week',
    contentMix_loading: 'Loading…',
    contentMix_noSamples: 'No information available',
    contentMix_music: 'Music',
    contentMix_speech: 'Speech',
    contentMix_mixed: 'Mixed (DJ/Ads)',
    contentMix_adsEstimate: 'Ads (est.)',
    contentMix_ads_hint: 'Heuristic: consecutive speech+music samples of 20-40s = likely ads.',
    contentMix_coverage: 'Coverage',
    contentMix_coverage_hint: 'Percentage of samples successfully classified (not timeout/error).',
    contentMix_hourlyTable: 'Per hour',
    contentMix_disclaimer: 'Mixed = speech over a music bed (DJ talkover OR ads). The ads estimate (~) uses 20-40s run heuristic — directional, not exact.',
    contentMix_covTitle: 'Monitoring coverage',
    contentMix_covGapsLabel: 'Not monitored',
    contentMix_covNoGaps: 'No monitoring gaps in this window ✓',
    contentMix_covCauseRestart: 'system restart',
    contentMix_covCauseOutage: 'monitoring outage',
    contentMix_covNote: 'Content percentages are computed only over actively-monitored time — gaps are NOT charged to the station.',
    contentMix_covH: 'h',
    contentMix_covM: 'm',
    severityBand_strong_gain: 'Strong Gain',
    severityBand_minor_gain: 'Minor Gain',
    severityBand_stable: 'Stable',
    severityBand_minor_loss: 'Minor Loss',
    severityBand_significant_loss: 'Significant Loss',
    severityBand_severe_loss: 'Severe Loss',
    severityBand_unknown: 'Unknown',
    clfReport_potentialLost: 'Potential Lost HITs',
    clfReport_potentialLost_hint: 'Of recognised songs, how many we would have missed under gating. < 5 % = safe.',
    clfReport_crossTableTitle: 'Cross-table: Classification × Shazam',
    clfReport_totalSamples: 'Total',
    clfReport_evaluable: 'Evaluable',
    clfReport_classification: 'Classification',
    clfReport_hitRate: 'Hit Rate',
    clfReport_crossTableHint: 'On speech / noise rows: HITs are false positives of the "skip" decision — songs we would have missed under active gating.',
    clfReport_perStationTitle: 'Per-station breakdown',
    clfReport_station: 'Station',
    clfReport_noStationData: 'No station data yet.',
    clfReport_noSamplesTitle: 'No samples yet',
    clfReport_noSamplesHint: 'The classifier is running in shadow mode and will accumulate data as stations play songs. Return in 48 hours for reliable statistics.',
    clfReport_window: 'Window',
    clkView_today: 'Today',
    clkView_yesterday: 'Yesterday',
    clkView_durationLabel: 'Duration',
    clkView_listenerDeltaLabel: 'Listener change',
    clkView_atTime: 'at',
    clkView_pdfReady: 'PDF is ready.',
    clkView_pdfError: 'Failed to generate PDF.',
    clkView_dataRetentionHint: 'Clock data is retained for 2 years.',
    // Executive Summary (v2.13.20 operator copy refresh).
    execSum_title: 'Day Summary',
    execSum_worstBreaks: 'Worst Breaks',
    execSum_worstBreaks_subtitle: 'Top 3 breaks with the biggest listener drops',
    execSum_heroSongs: 'Top Songs',
    execSum_heroSongs_subtitle: 'Top 3 songs that retained listeners the most',
    execSum_villainSongs: 'Worst Songs',
    execSum_villainSongs_subtitle: 'Top 3 songs that drove the most listeners away',
    execSum_bestBreaks: 'Best Breaks',
    execSum_bestBreaks_subtitle: 'Top 3 breaks that retained listeners the most',
    execSum_contentMixTitle: 'Music vs Talk/adv',
    execSum_noData: 'No information available',
    execSum_breakLabel: 'Break',
    // v2.13.21
    clkView_break: 'Break (15s–5m)',
    clkView_contentBlock: 'Content Block (5–15m)',
    clkView_programSegment: 'Show Segment (>15m)',
    execSum_showAnalysisTitle: 'Show Analysis',
    execSum_breaksTitle: 'Breaks',
    execSum_contentBlocksTitle: 'Content Blocks',
    execSum_programSegmentsTitle: 'Show Segments',
    execSum_count: 'Count',
    execSum_avgDuration: 'Avg duration',
    execSum_shortest: 'Shortest',
    execSum_longest: 'Longest',
    execSum_bestLabel: 'Best',
    execSum_worstLabel: 'Worst',
    execSum_noSegments: 'No entries',
    // v2.13.22 — Break Intelligence dashboard
    breakIntel_recompute: 'Recompute',
    breakIntel_backfill: '14d Backfill',
    breakIntel_confirmBackfill: 'Run 14-day backfill for this station?',
  },
  
  de: {
    // Header
    appTitle: 'Radio Solutions On Air',
    home: 'Startseite',
    aboutUs: 'Über uns',
    logout: 'Abmelden',
    generate: 'Generieren',
    renewSubscription: 'Abo erneuern',
    waiting: 'Warten',
    contentCreationInProgress: 'Inhaltserstellung läuft...',
    pleaseWaitDontClose: 'Bitte warten. Schließen Sie die App nicht.',
    
    // On Air Content
    onAirContent: 'On Air Inhalte',
    dailyContent: 'Tägliche Inhalte',
    onAirContentDesc: 'Fertige Inhalte für Radiosendungen. Horoskope, Wetter, Trends, lustige Nachrichten und mehr.',
    onAirPageTitle: 'Fertige Radio-Inhalte',
    onAirPageSubtitle: 'Klicken Sie auf eine Kategorie, um Abschnitte anzuzeigen',
    
    // About Page
    radioSolutionsApps: 'Radio Solutions Apps',
    forRadioProfessionals: 'Für Eigentümer, Manager, Produzenten, Playlisters & Vertriebsteams',
    dataYouNeed: 'Die Daten, die Sie brauchen, die Werkzeuge, die Sie verdienen',
    analyticsContentCharts: 'Analytics, Content & Charts für den modernen Radiosender.',
    radioFinallyMeasured: 'Radio finally measured.',
    goToHome: 'Zur Startseite',
    goToApp: 'Zur App',
    contactUs: 'Kontaktieren Sie uns',
    ourTools: 'Unsere Werkzeuge',
    toolsSuiteDescription: 'Eine komplette Suite von Werkzeugen, die exklusiv für Radiosender entwickelt wurde',
    timeSaving: 'Zeit sparen',
    timeSavingDesc: 'Automatisieren Sie die Content-Produktion und konzentrieren Sie sich auf die On-Air-Arbeit.',
    professionalResults: 'Professionelle Ergebnisse',
    professionalResultsDesc: 'Hochwertige Inhalte, die sofort on-air verwendet werden können.',
    reliableData: 'Zuverlässige Daten',
    reliableDataDesc: 'Aktuelle Charts und Statistiken aus zuverlässigen Quellen.',
    readyToStart: 'Bereit zum Starten?',
    signUpToday: 'Melden Sie sich heute an und erhalten Sie Zugang zu allen unseren Werkzeugen',
    viewPackages: 'Pakete ansehen',
    freeTrial: 'Kostenlose Testversion',
    toolsForRadio: 'Werkzeuge fürs Radio,',
    withoutHeadache: 'ohne Kopfschmerzen',
    suiteForProfessionals: 'Diese Suite ist für Radio-Profis konzipiert.',
    normalIfDifficult: 'Wenn es am Anfang etwas schwierig erscheint, ist das völlig normal 😉',
    freeDemo: 'kostenlose Führung',
    freeDemoText: 'Deshalb bieten wir eine {freeDemo} an, um Ihnen einfach und praktisch zu zeigen, wie Sie die Tools in Ihrem Alltag nutzen können.',
    wantDemo: 'Ich möchte eine Demo',
    noTechKnowledge: 'Keine technischen Kenntnisse erforderlich. Wir zeigen Ihnen alles Schritt für Schritt.',
    seeToolsInAction: 'Sehen Sie unsere Werkzeuge in Aktion',
    allInOneTool: 'Analytics, Daypart-Analyse, Playlist-Entscheidungen - alles in einem Tool',
    
    // Email Popup
    popupTitle: 'Möchten Sie Ihren Radiosender wirklich verbessern?',
    popupPlatformOffers: 'Was die Plattform bietet:',
    popupOnAirContent: 'Fertige Inhalte für Sendungen',
    popupSongFinder: 'Informationen zu jedem Song finden',
    popupTopCharts: 'Die beliebtesten Songs im griechischen Radio',
    popupPlaylistAnalyzer: 'Playlist-Analyse nach Stunde und Tag',
    popupSongsAnalyzer: 'Erfahren Sie, welche Songs Hörer binden',
    popupCalculators: 'Kampagnen- & Hörerberechnung',
    popupEmailPlaceholder: 'Ihre E-Mail...',
    popupSubmitting: 'Wird gesendet...',
    popupSubmitButton: 'Ich möchte mehr erfahren',
    popupBottomTagline: 'Sie erhalten Informationen zur Verbesserung Ihres Senders.',
    popupSuccessTitle: 'Danke!',
    popupSuccessMessage: 'Sie erhalten in Kürze weitere Informationen.',
    continueWithoutSignup: 'Ohne Anmeldung fortfahren',
    sectionsAvailable: 'Abschnitte verfügbar',
    sections: 'Abschnitte',
    updates: 'Updates',
    ready: 'Bereit',
    refresh: 'Aktualisieren',
    loadingContent: 'Inhalte werden geladen...',
    
    // Categories
    zodiacLifestyle: 'Sternzeichen & Lifestyle',
    zodiacLifestyleDesc: 'Tageshoroskop, Beziehungen, Gesundheit & Wellness, Finanztipps',
    newsTrends: 'Nachrichten & Trends',
    newsTrendsDesc: 'Kuriose News, Gute Nachrichten, Sport, Tägliche Trends, Wetter',
    entertainmentGames: 'Unterhaltung & Spiele',
    entertainmentGamesDesc: 'Radio-Wettbewerbe, Wortspiele, Debatten, Wahr oder Mythos',
    musicCharts: 'Musik & Charts',
    musicChartsDesc: 'Apple Music, YouTube Trending, Heute in der Musikgeschichte',
    
    // Common
    loading: 'Laden...',
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    submit: 'Absenden',
    download: 'Herunterladen',
    upload: 'Hochladen',
    search: 'Suche',
    filter: 'Filter',
    all: 'Alle',
    yes: 'Ja',
    no: 'Nein',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Zurück',
    admin: 'Admin',
    
    // Access Loading States
    accessLoading: 'Zugriffsrechte werden geladen... Bitte warten.',
    accessSlow: 'Verbindung ist etwas langsam... Erneuter Versuch. Dies dauert normalerweise bis zu 10 Sekunden.',
    accessRetrying: 'Verbindung wird erneut versucht (Versuch {count}/3)...',
    accessUsingCache: 'Langsame Verbindung. Temporär gespeicherte Daten werden verwendet.',
    accessError: 'Verbindung fehlgeschlagen. Bitte Seite neu laden.',
    
    // Welcome Popup
    welcomeTitle: 'Willkommen!',
    welcomeSubtitle: 'Machen Sie jede Sendung zum Muss!',
    alreadyHaveAccount: 'Ich habe bereits ein Konto - Anmelden',
    startFreeTrial: 'Kostenlose 24-Stunden-Testversion starten',
    dontLookLikeOthers: 'Seien Sie nicht wie alle anderen',
    becomeReferenceStation: 'Werden Sie der Referenzsender',
    makeEveryBroadcast: 'Machen Sie jede Sendung',
    mustListen: 'unverzichtbar',
    tryFor24Hours: '24 Stunden testen',
    clickAnywhereToClose: 'Klicken Sie außerhalb oder ESC zum Schließen',
    measureOptimizePerform: 'Measure. Optimize. Perform.',
    welcomeDescription: 'Die erste App, die Radio in einen messbaren Medienkanal verwandelt: Kampagnen-Performance, Publikumsdaten, Playlist-Intelligence und tägliche On-Air-Inhalte.',
    radioFinallyMeasured: 'Radio endlich messbar.',
    
    // Login
    login: 'Anmelden',
    username: 'Benutzername',
    password: 'Passwort',
    forgotPassword: 'Passwort vergessen',
    loginError: 'Anmeldefehler',
    serverStarting: 'Server startet... Bitte 10 Sekunden warten und erneut versuchen.',
    rememberMe: 'Angemeldet bleiben',
    twoFactorAuth: '2FA-Verifizierung',
    enterOTP: '2FA-Code eingeben',
    verify: 'Verifizieren',
    invalid2FA: 'Ungültiger 2FA-Code',
    
    // Trial Signup
    trialAccount: 'Testkonto',
    trialAccountDesc: '24-Stunden kostenloser Zugang zu allen Funktionen',
    email: 'E-Mail',
    confirmPassword: 'Passwort bestätigen',
    chooseUsername: 'Benutzernamen wählen',
    minChars: 'Mindestens 6 Zeichen',
    repeatPassword: 'Passwort wiederholen',
    createTrialAccount: 'Testkonto erstellen',
    creatingAccount: 'Erstellen...',
    allFieldsRequired: 'Alle Felder sind erforderlich',
    passwordsDontMatch: 'Passwörter stimmen nicht überein',
    passwordTooShort: 'Passwort muss mindestens 6 Zeichen haben',
    trialCreatedSuccess: 'Testkonto erfolgreich erstellt!',
    trialExpiresIn: 'Testversion endet in 24 Stunden',
    saveCredentials: 'Speichern Sie Ihre Zugangsdaten:',
    goToApp: 'Zur App',
    
    // Content
    contentFor: 'Inhalte für',
    sections: 'Abschnitte',
    exportPDF: 'PDF exportieren',
    userGuide: 'Benutzerhandbuch',
    contentDate: 'Inhalt',
    createdAt: 'Erstellt',
    viewMode: 'Ansichtsmodus',
    categoriesView: 'Kategorien',
    classicView: 'Klassisch',
    clickToViewSections: 'Klicken für Abschnitte',
    
    // Categories
    information: 'Information',
    entertainment: 'Unterhaltung',
    music: 'Musik',
    lifestyle: 'Lifestyle',
    special: 'Spezial',
    contestsGames: 'Wettbewerbe & Spiele',
    dialoguesDiscussions: 'Dialoge & Diskussionen',
    chartsMusic: 'Charts & Musik',
    
    // Footer
    quickLinks: 'Schnellzugriff',
    campaignAnalyzer: 'Kampagnenanalyse',
    listenerCalculator: 'Hörerrechner',
    playlistAnalyzer: 'Playlist-Analyzer',
    daypartAnalyzer: 'Daypart-Analyzer',
    ourStations: 'Unsere Sender',
    radioTopSongs: 'Top Radio Songs',
    contact: 'Kontakt',
    radioContentCreation: 'Erstellung von Radioinhalten',
    legalPrivacy: 'Rechtliches & Datenschutz',
    privacyPolicy: 'Datenschutzrichtlinie',
    termsOfService: 'Nutzungsbedingungen',
    cookiePolicy: 'Cookie-Richtlinie',
    cookieSettings: 'Cookie-Einstellungen',
    allRightsReserved: 'Alle Rechte vorbehalten',
    gdprCompliant: 'DSGVO-konform',
    euDataProtection: 'EU-Datenschutz',
    gdprNotice: 'Ihre personenbezogenen Daten sind gemäß DSGVO (EU 2016/679) geschützt.',
    loginForMoreOptions: 'Anmelden für mehr Optionen',
    
    // Navigation Menu Labels
    navInfo: 'Info',
    navOnAirContent: 'On Air Content',
    navSongFinder: 'Song Finder',
    navCampaignCalculator: 'Campaign Calculator',
    navListenersCalculator: 'Listeners Calculator',
    navTopRadioCharts: 'Top Radio Charts',
    navStations: 'Sender',
    navPlaylistAnalyzer: 'Playlist Analyzer',
    navDaypartAnalyzer: 'Playlist Daypart Analyzer',
    navSongsAnalyzer: 'Songs Analyzer',
    navSongsAnalyzerPro: 'Songs Analyzer PRO',
    navContact: 'Kontakt',
    navAdmin: 'Admin',
    navPackets: 'Pakete',
    navServices: 'Dienstleistungen',
    readMore: 'Mehr erfahren',

    // ── Services Page (v2.10.2 / 2026-06-15) ─────────────────────
    servicesTitle: 'Dienstleistungen',
    servicesEyebrow: 'Dienstleistungen · Services',
    servicesHeroTitle: 'Music Scheduling & Log Optimization',
    servicesHeroDesc: 'Über unsere Tools hinaus bieten wir spezialisierte Dienstleistungen, die Radiosendern helfen, ihre Hörerzahlen zu steigern, ihr Programm zu verbessern und ihre Einnahmen zu erhöhen.',
    servicesCtaFreeEval: 'Kostenlose Bewertung anfordern',
    servicesPreviewDesc: 'Über unsere Tools hinaus bieten wir spezialisierte Dienstleistungen, die Radiosendern helfen, ihre Hörerzahlen zu steigern, ihr Programm zu verbessern und ihre Einnahmen zu erhöhen.',
    servicesOurServices: 'Unsere Dienstleistungen',
    servicesOurServicesSub: 'Professionelles Know-how von erfahrenen Branchenexperten',
    svcIncludes: 'Beinhaltet:',
    svcLearnMore: 'Mehr erfahren',
    svc1Title: 'Music Programming & Format Consulting',
    svc1Desc: 'Optimierung Ihres Musikprogramms basierend auf Format, Wettbewerb und den Vorlieben Ihres lokalen Publikums.',
    svc1Bullet1: 'Formatanalyse',
    svc1Bullet2: 'Musikstrategie',
    svc1Bullet3: 'Rotation-Management',
    svc1Bullet4: 'Wettbewerbsanalyse',
    svc1Bullet5: 'Musik-Clock-Erstellung',
    svc1Bullet6: 'Rotation-Optimierung',
    svc1Bullet7: 'Kategorie-Management',
    svc1Bullet8: 'Daypart-Scheduling',
    svc1Bullet9: 'W\u00f6chentliches Musik-Review',
    svc2Title: 'Audience & Market Analysis',
    svc2Desc: 'Wir analysieren den Markt und die Musiktrends, damit Ihr Sender bessere Entscheidungen trifft.',
    svc2Bullet1: 'Wettbewerbsanalyse',
    svc2Bullet2: 'Musiktrend-Monitoring',
    svc2Bullet3: 'Berichte zu Neuerscheinungen',
    svc2Bullet4: 'Differenzierungsstrategien',
    svc3Title: 'Radio Station Growth Consulting',
    svc3Desc: 'Wachstumsberatung zur Steigerung von Hörerzahlen, Werbewert und Markenbekanntheit.',
    svc3Bullet1: 'Sender-Branding',
    svc3Bullet2: 'Positionierung',
    svc3Bullet3: 'Wettbewerbe und Promotions',
    svc3Bullet4: 'Social-Media-Strategie',
    svc3Bullet5: 'H\u00f6rerbindung',
    svc4Title: 'Ongoing Programming Support',
    svc4Desc: 'Kontinuierliche Zusammenarbeit und Unterst\u00fctzung f\u00fcr Sender, die einen externen Programmpartner suchen.',
    svc4Bullet1: 'W\u00f6chentliche Kommunikation',
    svc4Bullet2: 'Bewertung des Musikprogramms',
    svc4Bullet3: 'Verbesserungsvorschl\u00e4ge',
    svc4Bullet4: 'Unterst\u00fctzung der Produzenten',
    svc4Bullet5: 'Ergebnisverfolgung',
    servicesOurProcess: 'Unser Prozess',
    servicesOurProcessSub: 'Wie wir unsere Dienstleistungen erbringen, um den Sound Ihres Senders zu verbessern',
    svcProcessStep1Title: 'Entdeckung',
    svcProcessStep1Desc: 'Wir beginnen damit, Ihr Format, Ihr Publikum und Ihre Ziele in einem detaillierten Gespr\u00e4ch zu verstehen.',
    svcProcessStep2Title: 'Strategie',
    svcProcessStep2Desc: 'Wir entwickeln eine ma\u00dfgeschneiderte Scheduling-Strategie f\u00fcr Ihre individuellen Anforderungen.',
    svcProcessStep3Title: 'Umsetzung',
    svcProcessStep3Desc: 'Wir setzen die Strategie um und optimieren Logs, Bibliothek und Clocks f\u00fcr maximale Wirkung.',
    svcProcessStep4Title: 'Verfeinerung',
    svcProcessStep4Desc: 'Kontinuierliches Feedback und Verfeinerung sorgen daf\u00fcr, dass der Sound Ihres Senders optimal bleibt.',
    svcBenefitsTitle: 'Vorteile f\u00fcr Ihren Sender',
    svcBenefitsSub: 'Konkrete Ergebnisse, die Sie nach der Zusammenarbeit mit uns sehen werden',
    svcBenefit1: 'H\u00f6here H\u00f6rerzahlen',
    svcBenefit2: 'L\u00e4ngere Verweildauer Ihrer H\u00f6rer auf Ihrer Frequenz',
    svcBenefit3: 'Steigerung von Werbewert und Eink\u00fcnften',
    svcBenefit4: 'Musik, die Ihr Publikum am Empfang h\u00e4lt',
    svcBenefit5: 'Weniger H\u00f6rerabwanderung durch erm\u00fcdende oder unpassende Auswahl',
    svcBenefit6: 'Bessere Entscheidungen durch Daten und Analysen',
    svcBenefit7: 'Klare Differenzierung vom Wettbewerb',
    svcBenefit8: 'Kontinuierliche Verbesserung des Musikprogramms',
    svcCtaEyebrow: 'Bereit, Ihren Sender zu verbessern?',
    svcCtaTitle: 'M\u00f6chten Sie das Programm Ihres Senders verbessern?',
    svcCtaDesc: 'Sprechen Sie mit uns und wir bewerten kostenlos Ihr Format, Ihre Musikstrategie und die Wachstumspotenziale Ihres Senders.',

    // Services Results / Case Study (animated counters)
    svcResultsEyebrow: 'Ergebnisse · Fallstudien',
    svcResultsTitle: 'Messbare Ergebnisse für unsere Partner-Sender',
    svcResultsSub: 'Durchschnittliche Verbesserungen nach 3-6 Monaten Zusammenarbeit mit unserem Team',
    svcResultMetric1: 'Anstieg der TSL (Time Spent Listening)',
    svcResultMetric2: 'Hörerzuwachs',
    svcResultMetric3: 'Reduzierung des Early Drop',
    svcResultMetric4: 'Sender, die uns vertrauen',
    svcResultsDisclaimer: 'Ergebnisse basierend auf Hördatenanalysen von Sendern, die unsere Dienste nutzen. Werte variieren je nach Format und Markt.',
    svcTestimonialQuote: '\u201EDie Zusammenarbeit mit Radio Solutions hat die TSL unseres Senders deutlich gesteigert und uns ein klares Bild davon gegeben, welche Songs wirklich beim Publikum ankommen.\u201C',
    svcTestimonialAuthor: 'Programmchef',
    svcTestimonialStation: 'Partner-Radiosender',
    
    // Pricing
    pricing: 'Pakete & Abonnements',
    monthly: 'Monatlich',
    annual: 'Jährlich',
    subscribe: 'Abonnieren',
    popular: 'Beliebt',
    chooseYourPackage: 'Wählen Sie Ihr Paket',
    pricingDescription: 'Erhalten Sie Zugang zu Premium-Tools für Ihren Radiosender',
    currentPlan: 'Aktueller Plan',
    upgrade: 'Upgrade',
    downgrade: 'Downgrade',
    per: 'pro',
    month: 'Monat',
    year: 'Jahr',
    selectWeek: 'Woche auswählen',
    previousWeek: 'Vorherige Woche',
    nextWeek: 'Nächste Woche',
    optional: 'optional',
    savePercent: 'Sparen',
    featuresIncluded: 'Enthält',
    
    // Cookies
    cookiesTitle: 'Wir verwenden Cookies',
    cookiesDesc: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern.',
    cookiesFullDesc: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern. Einige Cookies sind für die Website-Funktion notwendig.',
    acceptAll: 'Alle akzeptieren',
    reject: 'Ablehnen',
    settings: 'Einstellungen',
    necessaryCookies: 'Notwendige Cookies',
    necessaryCookiesDesc: 'Für grundlegende Website-Funktionalität erforderlich.',
    required: 'ERFORDERLICH',
    analyticsCookies: 'Analyse-Cookies',
    analyticsCookiesDesc: 'Helfen uns zu verstehen, wie Sie die Website nutzen.',
    functionalCookies: 'Funktionale Cookies',
    functionalCookiesDesc: 'Speichern Ihre Einstellungen und verbessern die Benutzererfahrung.',
    thirdPartyCookies: 'Drittanbieter-Cookies',
    thirdPartyCookiesDesc: 'Werden von externen Diensten verwendet (z.B. YouTube).',
    saveSettings: 'Einstellungen speichern',
    
    // Daypart Analyzer
    daypartTitle: 'Daypart Performance Analyzer',
    morning: 'Morgen',
    drive: 'Drive Time',
    night: 'Nacht',
    overnight: 'Nachtprogramm',
    analyze: 'Analysieren',
    results: 'Ergebnisse',
    genreDistribution: 'Genre-Verteilung',
    decadeDistribution: 'Jahrzehnt-Verteilung',
    
    // Labels
    power: 'POWER',
    secondary: 'SECONDARY',
    currents: 'CURRENTS',
    spreadMore: 'SPREAD MORE',
    slowDown: 'SLOW DOWN',
    sleeper: 'SLEEPER',
    cut: 'CUT',
    
    // Homepage Cards
    campaignAnalyzerDesc: 'Radio-Kampagnen-Optimierungstool',
    campaignAnalyzerInfo: 'Berechnen Sie GRPs, Reichweite und Frequenz für Ihre Kampagne.',
    campaignAnalyzerFullDesc: 'Der Kampagnenanalyzer ist ein professionelles Werkzeug zur Planung von Radio-Werbekampagnen. Er berechnet automatisch GRPs (Gross Rating Points), Reichweite (Prozentsatz der Zielgruppe, die der Botschaft ausgesetzt ist) und Frequenz (durchschnittliche Anzahl der Kontakte pro Person). Basierend auf Ihrer Markenkategorie und Marktposition empfiehlt er die optimale Anzahl von Spots für maximale Effektivität.',
    openCampaignAnalyzer: 'Kampagnenanalyse öffnen',
    listenerCalculatorDesc: 'Hörerberechnungstool basierend auf Dayparts & wöchentlichen Daten',
    listenerCalculatorInfo: 'Berechnen Sie Hörprozentsätze und Hörerschätzungen.',
    listenerCalculatorFullDesc: 'Der Hörerrechner wandelt Hörprozentsätze in tatsächliche Hörerzahlen um. Er verwendet statistische Methoden (FPC-Korrektur, 95% Konfidenzintervalle) für genaue Schätzungen. Geben Sie Rating-Daten pro Tag und Zeitzone (Daypart) ein und erhalten Sie detaillierte Ergebnisse über das Publikum Ihres Senders.',
    openListenerCalculator: 'Hörerrechner öffnen',
    playlistAnalyzerDesc: 'Playlist-Performance-Analysetool',
    playlistAnalyzerInfo: 'Analysieren Sie Ihre Playlist-Performance detailliert.',
    playlistAnalyzerFullDesc: 'Der Playlist-Analyzer analysiert die Performance jedes Songs in der Playlist Ihres Senders. Laden Sie eine CSV mit TLH (Time Listening Hours), Performances und Frequenz-Daten hoch. Das System berechnet Scores und empfiehlt Entscheidungen wie POWER (ausgezeichnete Performance), SECONDARY (gut), CURRENTS (Neuerscheinung) oder CUT (entfernen).',
    openPlaylistAnalyzer: 'Playlist-Analyzer öffnen',
    daypartAnalyzerDesc: 'Performance-Analyzer pro Zeitzone',
    daypartAnalyzerInfo: 'Analysieren Sie die Playlist-Performance pro Daypart.',
    daypartAnalyzerFullDesc: 'Der Daypart-Analyzer ist die Premium-Version des Playlist-Analyzers. Er analysiert die Performance jedes Songs pro Zeitzone: Morning (06:00-10:00), Midday (10:00-15:00), Drive (15:00-19:00), Evening (19:00-24:00) und Overnight (00:00-06:00). Ideal für Sender, die die Rotation nach Stunden optimieren möchten.',
    songInfoFullDesc: 'Das Song-Information-Tool sucht Informationen zu jedem Song: Erscheinungsjahr, Plattenlabel, Komponisten, Texter, Künstler/Band und schlägt Broadcast-Texte (Liner) für Produzenten vor. Geben Sie einfach den Songtitel ein und klicken Sie auf Suchen.',
    openDaypartAnalyzer: 'Daypart-Analyzer öffnen',
    premiumFeature: 'PREMIUM',
    upgradeToAccess: 'Upgrade für Zugang',
    columns: 'Spalten',
    
    // Misc
    copyright: 'EIGENTUM VON RADIO SOLUTIONS',
    copyrightTitle: 'EIGENTUM VON RADIO SOLUTIONS',
    copyrightNotice: 'Dieser Inhalt ist ausschließlich für registrierte Abonnenten bestimmt.',
    generateNewContent: 'Neue Inhalte für bessere Ergebnisse generieren!',
    contentCreationDuration: 'Erstellungsdauer: ~15 Minuten | Auto: täglich 00:01',
    downloadAsPDF: 'Als PDF herunterladen',
    userInstructions: 'Benutzerhandbuch',
    waitForPdfDownload: 'Bitte bis zu 10 Sekunden warten für PDF-Download',
    generationDuration: 'Generierungsdauer: ~15 Minuten | Auto: täglich 00:01',
    waitForPDF: 'Bitte bis zu 10 Sekunden auf den PDF-Download warten',
    pdfPassword: 'Passwort: Ihr Benutzername',
    newContentAvailable: 'Neue Inhalte verfügbar!',
    pageWillRefresh: 'Seite wird in 5 Sekunden aktualisiert...',
    refreshNow: 'Jetzt aktualisieren',
    multiLanguage: 'Mehrsprachig',
    
    // Playlist Analyzer
    playlistAnalyzerTitle: 'Playlist Performance Analyzer',
    uploadCSV: 'CSV Hochladen',
    selectCSV: 'CSV Auswählen',
    changeFile: 'Ändern',
    loadingFile: 'Laden...',
    tracksLoaded: 'Tracks geladen',
    radioFormat: 'Radio Format',
    formatAffectsWeights: 'Das Format beeinflusst Gewichte und Epochen-Multiplikatoren',
    step1SelectFormat: 'Schritt 1: Format wählen → Schritt 2: CSV hochladen',
    selectFormatFirst: 'Wählen Sie zuerst das richtige Radio Format und laden Sie dann die CSV-Datei hoch.',
    startAnalysis: 'Analyse starten',
    analyzing: 'Analysiere...',
    analysisComplete: 'Analyse abgeschlossen!',
    analysisError: 'Analysefehler',
    networkError: 'Verbindungsfehler. Bitte versuchen Sie es erneut.',
    exportToPDF: 'PDF Export',
    creatingPDF: 'PDF erstellen...',
    pdfCreated: 'PDF erstellt!',
    errorDownloadingPDF: 'Fehler beim PDF-Download',
    passwordToOpen: 'Passwort: Ihr Benutzername',
    tracksAndDecisions: 'Tracks & Entscheidungen',
    genres: 'Genres',
    decades: 'Jahrzehnte',
    searchArtistTitle: 'Künstler oder Titel suchen...',
    clear: 'Löschen',
    tracks: 'Tracks',
    instructions: 'Anleitung',
    csvFileStructure: 'CSV-Dateistruktur',
    csvMustContain: 'Die CSV-Datei muss folgende Spalten enthalten.',
    artistName: 'Künstlername',
    trackTitle: 'Tracktitel',
    frequency: 'Frequenz',
    performances: 'Performances',
    columnExplanation: 'Spaltenerklärung',
    missingColumns: 'Was wenn Spalten fehlen?',
    scoringProcess: 'Bewertungsprozess',
    whatDataMeans: 'Was die Daten bedeuten',
    radioFormatsAdjustments: 'Radio Formate & Anpassungen',
    decisionLabels: 'Entscheidungs-Labels',
    
    // Daypart Analyzer specific
    daypartAnalyzerTitle: 'Daypart Performance Analyzer',
    usageInstructions: 'Gebrauchsanweisung',
    daypartIntro: 'Der Daypart Analyzer analysiert die Performance Ihrer Playlist nach Tageszeit.',
    csvUpload: 'CSV-Datei hochladen',
    csvMustContainFields: 'Die CSV muss folgende Spalten enthalten:',
    csvFlexibleFormat: 'Erforderliche Spalten:',
    csvOptional: 'optional',
    csvColumnOrderNote: 'Die Spaltenreihenfolge spielt keine Rolle. Verschiedene Namen werden erkannt (z.B. Artist, Performer, Künstler)',
    allFieldsRequired: 'Alle Felder sind für genaue Analyseergebnisse erforderlich',
    selectRadioFormat: 'Radio Format wählen',
    selectYourFormat: 'Wählen Sie Ihr Senderformat:',
    timeZones: 'Zeitzonen (Dayparts)',
    evaluationCategories: 'Bewertungskategorien',
    powerDesc: 'Top-Tracks - oft spielen!',
    secondaryDesc: 'Zweite Reihe - gute Performance',
    currentsDesc: 'Aktuelle Hits - guter Flow',
    spreadMoreDesc: 'Frequenz erhöhen',
    slowDownDesc: 'Frequenz verringern',
    sleeperDesc: 'Geringe Performance - beobachten',
    cutDesc: 'Kandidat für Entfernung',
    csvFormat: 'CSV-Format',
    daypartHowItWorks: 'Wie es funktioniert',
    daypartHowItWorksDesc: 'Der Daypart Analyzer analysiert die Track-Performance nach Tageszeit (Morning, Drive, Night, Overnight). Basierend auf TLH- und Listener-Daten berechnet er Scores und schlägt Entscheidungen vor (POWER, SECONDARY, CURRENTS, etc.).',
    genreDecadeAnalysis: 'Genre & Jahrzehnt Analyse',
    eachDaypartShows: 'Jeder Daypart zeigt auch:',
    requiresAdminEnrichment: 'Erfordert Datenbankanreicherung durch Admin',
    exportResults: 'Ergebnisse exportieren',
    afterAnalysisExport: 'Nach der Analyse können Sie exportieren zu:',
    tips: 'Tipps',
    tip1: 'Verwenden Sie mindestens eine Woche Daten für bessere Ergebnisse',
    tip2: 'Passen Sie die Gewichte pro Daypart in den Einstellungen an',
    tip3: 'Prüfen Sie die GOLD-Analyse für die "goldenen" Tracks',
    gotItLetsStart: 'Verstanden, los geht\'s!',
    
    // Radio Top Songs
    radioTopSongsTitle: 'Top Radio Songs',
    weeklyChart: 'Wochencharts',
    position: 'Position',
    artist: 'Künstler',
    title: 'Titel',
    lastWeek: 'Letzte Woche',
    weeksOnChart: 'Wochen',
    chartInfo: 'Chart Info',
    uploadNewChart: 'Neues Chart hochladen',
    noChartData: 'Keine Chart-Daten verfügbar',
    allSongs: 'Alle',
    greekSongs: 'Griechisch',
    internationalSongs: 'International',
    totalSongs: 'Gesamte Songs',
    source: 'Quelle',
    searchSongsArtists: 'Songs & Künstler suchen • Historische Charts ansehen',
    browseChartsByWeek: 'Charts nach Woche und Monat durchsuchen',
    discoverMore: 'Mehr entdecken',
    searchSongArtist: 'Song oder Künstler suchen...',
    display: 'Anzeigen',
    saveCurrentChart: 'Aktuelles Chart speichern',
    noChartDataForWeek: 'Keine Daten für die ausgewählte Woche gefunden. Aktuelles Chart wird geladen...',
    
    // Maintenance/Loading Screen
    preparingForYou: 'Wir bereiten alles für Sie vor!',
    remainingTime: 'Verbleibende Zeit',
    ready: 'Fertig!',
    pageWillRefreshAuto: 'Seite wird in wenigen Sekunden automatisch aktualisiert...',
    completed: 'abgeschlossen',
    contentBeingCreated: 'Ihr Radioinhalt wird gerade erstellt. Bitte warten...',
    whatsHappening: 'Was passiert?',
    systemCreatingContent: 'Das System erstellt frischen, professionellen Radioinhalt',
    estimatedDuration: 'Geschätzte Dauer',
    minutes: 'Minuten',
    pageRefreshAuto: 'Seite wird automatisch aktualisiert wenn fertig',
    tipKeepTabOpen: 'Tipp: Lassen Sie diesen Tab offen - Aktualisierung erfolgt automatisch',
    
    // Pricing Page
    features: 'Funktionen',
    price: 'Preis',
    perMonth: '/Monat',
    perYear: '/Jahr',
    currentPackage: 'Aktuelles Paket',
    select: 'Auswählen',
    pleaseWait: 'Bitte warten...',
    faq: 'Häufig gestellte Fragen',
    canChangePackage: 'Kann ich mein Paket wechseln?',
    canChangePackageAnswer: 'Ja, Sie können Ihr Paket jederzeit upgraden oder downgraden. Die Differenz wird bei der nächsten Abrechnung hinzugefügt oder abgezogen.',
    paymentMethods: 'Welche Zahlungsmethoden werden unterstützt?',
    paymentMethodsAnswer: 'Wir akzeptieren alle Kredit-/Debitkarten (Visa, Mastercard, American Express) über die sichere Stripe-Plattform.',
    hasTrial: 'Gibt es eine Testphase?',
    hasTrialAnswer: 'Ja! Alle neuen Benutzer haben 24 Stunden kostenlos Zugang zu allen Funktionen.',
    paymentCancelled: 'Zahlung abgebrochen',
    checkEmailConfirmation: 'Überprüfen Sie Ihre E-Mail für die Zahlungsbestätigung',
    paymentSuccess: 'Zahlung erfolgreich abgeschlossen!',
    sessionExpired: 'Zahlungssitzung abgelaufen',
    pleaseLoginFirst: 'Bitte melden Sie sich zuerst an',
    chargeForUpgrade: 'Gebühr €{amount} für Upgrade',
    errorCreatingPayment: 'Fehler beim Erstellen der Zahlung',
    errorLoadingPackages: 'Fehler beim Laden der Pakete',
    
    // Soft Locks / Feature Gate
    lockedFeature: 'Gesperrte Funktion',
    upgradeForAccess: 'Upgrade für Zugang',
    orTryFree24h: 'Oder 24 Stunden kostenlos testen',
    upgradeForAccessFeature: 'Upgraden Sie Ihr Paket für Zugang zu dieser Funktion.',
    
    // Feature Info (locked cards)
    categoriesOnAirTitle: 'Themenkategorien On Air',
    categoriesOnAirDesc: '9 Kategorien frischer Inhalte - Morgen, Mittag, Nachmittag, Abend, Wochenende, Horoskope, News, Entertainment, Charts. Täglich neu!',
    campaignAnalyzerTitleLong: 'Kampagnenanalyse',
    campaignAnalyzerDescLong: 'Berechnen Sie die Leistung Ihrer Werbekampagnen. Sehen Sie Reichweite, Frequenz, GRP und geschätzte Einnahmen.',
    listenerCalculatorTitleLong: 'Hörerrechner',
    listenerCalculatorDescLong: 'Berechnen Sie das echte Publikum Ihres Senders. Hörerschätzungen pro Zone und Tag.',
    radioTopSongsTitleLong: 'Radio Top Songs',
    radioTopSongsDescLong: 'Finden Sie die Top-Songs für Ihren Sender. Griechische & internationale Charts mit smarten Vorschlägen.',
    playlistAnalyzerTitleLong: 'Playlist Analyzer',
    playlistAnalyzerDescLong: 'Analysieren Sie Ihre Playlist nach Jahrzehnten, Genres und Performance. POWER/SLEEPER Song-Bewertung.',
    daypartAnalyzerTitleLong: 'Daypart Analyzer',
    daypartAnalyzerDescLong: 'Analysieren Sie die Performance Ihrer Playlist pro Zone. Genre & Jahrzehnt Verteilung.',
    monthlySupportTitle: 'Monatlicher Support',
    monthlySupportDesc: 'Technischer Support per E-Mail und Chat mit Antwort innerhalb von 24 Stunden.',
    prioritySupportTitle: 'Prioritäts-Support',
    prioritySupportDesc: 'Sofortiger technischer Support mit Priorität. Antwort innerhalb von 4 Stunden.',
    
    // Access Banner
    adminFullAccess: 'Admin - Voller Zugang',
    trialPeriod: 'Testphase',
    hoursRemaining: 'verbleibend',
    freeAccess: 'Kostenloser Zugang',
    subscriber: 'Abonnent',
    subscriptionExpired: 'Ihr Abonnement ist abgelaufen',
    noActiveSubscription: 'Kein aktives Abonnement',
    
    // Help Modals
    helpGuide: 'Anleitung',
    helpInstructions: 'Anweisungen',
    howItWorks: 'So funktioniert es',
    helpListenerCalculator: 'Hörer-Rechner Anleitung',
    helpPlaylistAnalyzer: 'Playlist Analyzer Anleitung',
    helpDaypartAnalyzer: 'Daypart Analyzer Anleitung',
    
    // Listener Calculator Page
    listenerCalcTitle: 'Hörer-Rechner',
    listenerCalcDesc: 'Tool zur Schätzung der realen Hörerzahl',
    whatIsCalculator: 'Was ist der Rechner?',
    listenerCalcGuide: 'Hörer-Rechner Anleitung',
    listenerCalcWhat: 'Was ist der Hörer-Rechner und was macht er',
    listenerCalcWhatDesc: 'Der Hörer-Rechner ist ein Tool zur Schätzung der realen Streaming-Hörerzahl für:',
    listenerCalcItems: 'Tag,Daypart (Zeitzone),Woche,Kombination von Tagen & Dayparts',
    listenerCalcNote: 'Er misst nicht nur rohe Verbindungen.',
    listenerCalcStatistical: 'Er verwendet statistische Projektion, um aus einer Stichprobe von Hörern zu berechnen:',
    listenerCalcMetrics: 'Hörer-Prozentsatz,Geschätzte Anzahl echter Hörer,Konfidenzintervall 95%,Wöchentlicher Trend',
    listenerCalcTool: 'Dies verwandelt Streaming-Daten von "Zahlen" in ein Entscheidungsinstrument.',
    streamingAnalyticsTitle: 'Streaming-Daten-Analysator',
    streamingAnalyticsDesc: 'Laden Sie CSV von Ihrem Streaming-Anbieter für detaillierte Zuhöreranalyse hoch',
    listenerCalcAnalysis: 'Analyse & Erklärung der Indikatoren',
    sampleTitle: 'Stichprobe',
    sampleDesc: 'Die Anzahl der erfassten Benutzer (z.B. Hörer, Sitzungen, Umfrageantworten).',
    sampleTip: 'Je größer die Stichprobe, desto größer die Genauigkeit.',
    positiveTitle: 'Positiv',
    positiveDesc: 'Die Anzahl der Benutzer, die das Kriterium erfüllen.',
    positiveTip: 'Filtert "zufällige Klicks" von echten Hörern.',
    populationTitle: 'Bevölkerung',
    populationDesc: 'Gesamtschätzung der potenziellen Bevölkerung.',
    populationTip: 'Wird verwendet, um den Prozentsatz in tatsächliche Hörerzahl umzurechnen.',
    percentageTitle: 'Prozentsatz (%)',
    percentageDesc: 'Positiv / Stichprobe',
    percentageTip: 'Zeigt, wie stark jeder Daypart im Verhältnis zum Gesamten ist.',
    estimatedListenersTitle: 'Geschätzte Hörer',
    estimatedListenersDesc: 'Prozentsatz × Bevölkerung',
    estimatedListenersTip: 'Der wichtigste Indikator: Wie viele Menschen hören tatsächlich den Sender in dieser Zone.',
    ciTitle: 'KI 95% (Konfidenzintervall)',
    ciDesc: 'Statistischer Zuverlässigkeitsbereich. Beispiel: 18% – 22%',
    ciTip: 'Bedeutet mit 95% Sicherheit, dass die tatsächliche Hörerzahl in diesem Bereich liegt.',
    fpcTitle: 'FPC – Finite Population Correction',
    fpcDesc: 'Wird verwendet, wenn die Stichprobe groß und die Bevölkerung begrenzt ist.',
    fpcTip: 'Verbessert drastisch die Genauigkeit der Ergebnisse.',
    trendTitle: 'Wöchentlicher Trend (Diagramm)',
    trendDesc: 'Zeigt die Hörerentwicklung pro Tag, Rückgänge & Anstiege.',
    trendTip: 'Identifiziert, wenn etwas NICHT funktioniert.',
    howHelpsTitle: 'Wie es einem Radiosender hilft',
    costReduction: 'Kostenreduzierung',
    costReductionItems: 'Identifizierung von Dayparts mit geringer Leistung,Reduzierung unnötiger Ausgaben,Gezielte Änderungen statt allgemeiner Investitionen',
    audienceIncrease: 'Publikumssteigerung',
    audienceIncreaseItems: 'Playlist pro Zone optimieren,Inhalte pro Stunde anpassen,Starke Dayparts stärken,Schwache vor Publikumsverlust korrigieren',
    playlistAdaptation: 'Playlist & Inhaltsanpassung',
    playlistAdaptationItems: 'Anderer Musikflow am Morgen,Anders während der Drive Time,Anders über Nacht',
    playlistAdaptationNote: 'Der Rechner zeigt, wo der Hörer müde wird.',
    proDataTitle: 'Professionelle Daten für Werbetreibende',
    proDataItems: 'Leistungsnachweis pro Stunde,Zuverlässige Zahlen,Argumente für bessere Preise',
    understoodClose: 'Verstanden, schließen',
    
    // Campaign Calculator Page
    campaignAnalyzerPageTitle: 'Kampagnen-Analyzer',
    campaignAnalyzerPageDesc: 'Werkzeug zur Optimierung von Radiokampagnen',
    brandCategoryLabel: 'MARKENKATEGORIE (ALPHABETISCH)',
    marketPositionLabel: 'MARKENPOSITION IM MARKT',
    radioPrimaryLabel: 'RADIO ALS PRIMÄRES MEDIUM?',
    campaignDurationLabel: 'KAMPAGNENDAUER (AKTIVE WOCHEN)',
    pleaseSelect: 'Bitte wählen',
    spotsPerDay: 'Spots pro Tag',
    adjustSpotsPerDay: 'Passen Sie die Anzahl der Spots für jeden Wochentag an',
    totalSpotsWeek: 'Gesamt Spots/Woche',
    calculateCampaign: 'Kampagne berechnen',
    weeklyGRPs: 'Wöchentliche GRPs',
    totalGRPs: 'Gesamt GRPs',
    estimatedReach: 'Reichweite',
    avgFrequency: 'Durchschnittl. Frequenz',
    weeklyProgress: 'Wöchentlicher Fortschritt',
    dailyDistribution: 'Tägliche Verteilung (Woche 1)',
    strategicRecommendations: 'Strategische Empfehlungen',
    scenarioComparison: 'Szenario-Vergleich',
    exportPDFBtn: 'Als PDF exportieren',
    pleaseWaitPDF: 'Bitte warten...',
    fillAllFields: 'Bitte füllen Sie alle Felder aus',
    calculateFirst: 'Bitte zuerst "Berechnen" klicken',
    waitForPDFGen: 'Bitte warten Sie bis zu 10 Sekunden für die Dateierstellung...',
    pleaseWait: 'Bitte warten...',
    exportCompleted: 'Export abgeschlossen!',
    exportError: 'Fehler beim PDF-Export',
    // Day names
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
    // Brand categories
    foodDrinks: 'Lebensmittel & Getränke',
    technology: 'Technologie',
    fashionBeauty: 'Mode & Schönheit',
    automobiles: 'Automobile',
    services: 'Dienstleistungen',
    retail: 'Einzelhandel',
    // Market positions
    marketLeader: 'Marktführer',
    challenger: 'Herausforderer',
    newEntry: 'Neueinsteiger',
    // Campaign durations
    weeks2: '2 Wochen',
    weeks4: '4 Wochen',
    weeks8: '8 Wochen',
    weeks12: '12 Wochen',
    weekLabel: 'Woche',
    weekFull: 'Woche',
    historicalData: 'Historische Daten',
    showMore: 'Mehr anzeigen',
    noResultsFor: 'Keine Ergebnisse gefunden für',
    chartSavedSuccess: 'Chart erfolgreich gespeichert!',
    year: 'Jahr',
    songsCount: 'Songs',
    noDataToSave: 'Keine Daten zum Speichern',
    adminOnlyFeature: 'Sie müssen als Admin angemeldet sein',
    adminOnlySaveChart: 'Nur Admin-Benutzer können Charts speichern',
    saveFailed: 'Speichern fehlgeschlagen. Bitte erneut versuchen.',
    spots: 'Spots',
    totalSpots: 'Gesamt Spots',
    
    // Admin Section
    adminDbEnrichment: 'Admin: Song-Datenbank Anreicherung',
    songsInDb: 'Songs',
    artistsInDb: 'Künstler',
    songsWithYear: 'mit Jahr',
    uploadCsvInstructions: 'CSV hochladen mit Spalten: Artist, Title, Year (optional: Genre)',
    importInProgress: 'Import läuft...',
    addSongs: 'Songs hinzufügen',
    
    // Contact Form
    contactTitle: 'Kontakt',
    contactDesc: 'Füllen Sie das Formular aus, um uns zu kontaktieren',
    firstName: 'Vorname',
    lastName: 'Nachname',
    stationName: 'Sendername',
    region: 'Region',
    phone: 'Telefon',
    email: 'E-Mail',
    message: 'Nachricht',
    attachFile: 'Datei anhängen',
    sendMessage: 'Nachricht senden',
    sending: 'Senden...',
    messageSent: 'Ihre Nachricht wurde erfolgreich gesendet!',
    messageError: 'Fehler beim Senden Ihrer Nachricht',
    requiredField: 'Dieses Feld ist erforderlich',
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail ein',
    invalidPhone: 'Bitte geben Sie eine gültige Telefonnummer ein',
    selectRegion: 'Region auswählen',
    contactInfo: 'Kontaktinformationen',
    nameRequired: 'Name ist erforderlich',
    lastNameRequired: 'Nachname ist erforderlich',
    enterRealName: 'Bitte geben Sie Ihren echten Namen ein',
    enterRealLastName: 'Bitte geben Sie Ihren echten Nachnamen ein',
    minChars: 'Muss mindestens 2 Zeichen haben',
    enterValidName: 'Bitte geben Sie einen gültigen Namen ein',
    stationRequired: 'Sendername ist erforderlich',
    regionRequired: 'Region ist erforderlich',
    phoneRequired: 'Telefon ist erforderlich',
    emailRequired: 'E-Mail ist erforderlich',
    businessEmailRequired: 'Bitte verwenden Sie eine geschäftliche E-Mail',
    messageRequired: 'Nachricht ist erforderlich',
    minMessageLength: 'Nachricht muss mindestens 10 Zeichen haben',
    fileTooLarge: 'Datei ist zu groß (max 5MB)',
    invalidFileType: 'Ungültiger Dateityp',
    regionCyprus: 'Zypern',
    regionAttica: 'Attika',
    regionThessaloniki: 'Thessaloniki',
    regionCentralMacedonia: 'Zentralmakedonien',
    regionWestMacedonia: 'Westmakedonien',
    regionEastMacedoniaThrace: 'Ostmakedonien und Thrakien',
    regionEpirus: 'Epirus',
    regionThessaly: 'Thessalien',
    regionIonianIslands: 'Ionische Inseln',
    regionWestGreece: 'Westgriechenland',
    regionCentralGreece: 'Zentralgriechenland',
    regionPeloponnese: 'Peloponnes',
    regionNorthAegean: 'Nördliche Ägäis',
    regionSouthAegean: 'Südliche Ägäis',
    regionCrete: 'Kreta',
    
    // Our Stations
    ourStationsTitle: 'Unsere Sender',
    ourStationsDesc: 'Demo-Sender mit verschiedenen Musikformaten zur Erstellung von Playlists für Radiosender und In-Store-Unternehmen.',
    listenLive: 'Live hören',
    visitWebsite: 'Website besuchen',
    
    // Campaign Analyzer Form
    brandCategoryLabel: 'MARKENKATEGORIE (ALPHABETISCH)',
    marketPositionLabel: 'MARKENPOSITION IM MARKT',
    radioPrimaryLabel: 'RADIO ALS PRIMÄRES MEDIUM?',
    campaignDurationLabel: 'KAMPAGNENDAUER (AKTIVE WOCHEN)',
    foodDrinks: 'Lebensmittel & Getränke',
    technology: 'Technologie',
    fashionBeauty: 'Mode & Schönheit',
    automobiles: 'Automobile',
    services: 'Dienstleistungen',
    retail: 'Einzelhandel',
    marketLeader: 'Marktführer',
    challenger: 'Herausforderer',
    newEntry: 'Neuer Marktteilnehmer',
    weeks2: '2 Wochen',
    weeks4: '4 Wochen',
    weeks8: '8 Wochen',
    weeks12: '12 Wochen',
    spotsPerDay: 'Spots pro Tag',
    weeklyGRPs: 'Wöchentliche GRPs',
    totalGRPs: 'Gesamt GRPs',
    estimatedReach: 'Geschätzte Reichweite',
    avgFrequency: 'Durchschnittliche Frequenz',
    weeklyProgress: 'Wöchentlicher Fortschritt',
    fillAllFields: 'Bitte alle Felder ausfüllen',
    calculateFirst: 'Bitte zuerst auf "Berechnen" klicken',
    waitForPDFGen: 'Bitte warten Sie bis zu 10 Sekunden für die PDF-Erstellung...',
    pleaseWait: 'Bitte warten...',
    exportCompleted: 'Export abgeschlossen!',
    exportError: 'Fehler beim PDF-Export',
    // Day names
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday: 'Sonntag',
    scenarioComparison: 'Szenario-Vergleich',
    lessSpots: 'Weniger Spots (-30%)',
    currentStrategy: 'Aktuelle Strategie',
    shorterDuration: 'Kürzere Dauer (-2 Wochen)',
    lower: 'Niedriger',
    optimal: 'Optimal',
    medium: 'Mittel',
    scenario: 'Szenario',
    efficiency: 'Effizienz',
    yourCampaign: 'Ihre Kampagne',
    calculateCampaign: 'Kampagne Berechnen',
    freqInsufficient: 'Unzureichend',
    freqVeryLow: 'Sehr niedrig',
    freqIdeal: 'IDEAL - gute Awareness',
    freqVeryGood: 'Sehr gut - starke Erinnerung',
    freqHigh: 'Hoch - gut, aber Kosten beachten',
    freqTooHigh: 'Zu hoch - Risiko von "ad fatigue"',
    grpLevels: 'GRP-Stufen (Gross Rating Points)',
    grpVeryLow: 'Sehr niedrig - unzureichende Abdeckung',
    grpLow: 'Niedrig - minimale Marktauswirkung',
    grpGood: 'Gut - erste Awareness, geeignet für Erhaltung',
    grpVeryGood: 'Sehr gut - starke Präsenz, effektive Kampagne',
    grpHigh: 'Hoch - Kategorie-Dominanz',
    grpVeryHigh: 'Sehr hoch - maximale Abdeckung, Sättigung beachten',
    recommendations: 'Empfehlungen & Verbesserungen',
    totalSpots: 'Gesamte Spots',
    criticalLowFreq: 'KRITISCH: Sehr Niedrige Frequenz',
    criticalLowFreqMsgDynamic: 'Aktuelle Frequenz ({freq}) ist unzureichend. Die Botschaft wird nicht im Gedächtnis der Zielgruppe bleiben.',
    recIncreaseSpotsTo: 'Empfohlene Erhöhung auf {newWeeklySpots} Spots/Woche ({extraSpots} zusätzliche Spots) um Frequenz {targetFreq} und {newGRPs} GRPs zu erreichen.',
    warningHighFreq: 'Warnung: Sehr Hohe Frequenz',
    warningHighFreqMsgDynamic: 'Frequenz ({freq}) ist zu hoch. Risiko von "ad fatigue" und Budgetverschwendung.',
    recReduceSpotsTo: 'Sie können auf {newWeeklySpots} Spots/Woche reduzieren und Kosten sparen bei Frequenz {targetFreq}.',
    suggestionIncrease: 'Vorschlag: Effektivität erhöhen',
    suggestionIncreaseMsgDynamic: 'Ihre GRPs ({grps}) liegen unter dem idealen Niveau (400+). Für bessere Leistung:',
    recOptionsAB: '• OPTION A: Dauer auf {option1_weeks} Wochen erhöhen → ~{option1_newGRPs} GRPs\n• OPTION B: {option2_spotsIncrease} Spots/Woche hinzufügen ({option2_newWeeklySpots} gesamt) → ~{option2_newGRPs} GRPs',
    excellentGRPs: 'Ausgezeichnete GRPs',
    excellentGRPsMsgDynamic: 'Ihre GRPs ({grps}) sind ausgezeichnet! Maximale Abdeckung.',
    recWatchSaturation: 'Achten Sie auf Zielgruppensättigung. Sie können das aktuelle Niveau beibehalten oder leicht reduzieren.',
    optimalCampaign: 'Optimale Kampagne!',
    optimalCampaignMsgDynamic: 'Ihre GRPs ({grps}) und Frequenz ({freq}) sind im idealen Bereich.',
    recWellDesigned: 'Ihre Kampagne ist gut gestaltet und wird effektiv sein. Weiter so!',
    strongCampaign: 'Sehr Starke Kampagne!',
    strongCampaignMsgDynamic: 'Ihre GRPs ({grps}) sind hoch. Sie werden Ihre Kategorie dominieren.',
    recExcellentStrategy: 'Ausgezeichnete Strategie für Brand Awareness und Marktdominanz!',
    perfectCampaign: 'Perfekte Kampagne!',
    perfectCampaignMsg: 'Alle Ihre Metriken sind auf optimalem Niveau.',
    recBestBalance: 'Ihre Kampagne hat das beste Kosten-Leistungs-Verhältnis!',
    
    // Decision explanations
    decContinue: 'WEITER SO - Die Hörer lieben es!',
    decMaintain: 'BEIBEHALTEN - Die Hörer bleiben dran',
    decMaintainGood: 'BEIBEHALTEN - Gute Hörerakzeptanz',
    decReduce: 'REDUZIEREN - Weniger Plays pro Woche',
    decRemove: 'ENTFERNEN - Die Hörer schalten um!',
    decTired: 'Die Hörer sind müde davon! FREQUENZ REDUZIEREN!',
    decSecondLine: 'ZWEITE REIHE - Nicht in Prime-Zeitzonen wählen',
    decLessPerDay: 'WENIGER PLAYS PRO TAG',
    // Explanation translations for track results
    decContinueAction: 'WEITER SO',
    decMaintainAction: 'BEIBEHALTEN',
    decReduceAction: 'REDUZIEREN',
    decRemoveAction: 'ENTFERNEN',
    decIncreaseAction: 'ERHÖHEN',
    decReduceImmediately: 'SOFORT REDUZIEREN',
    decListenersLoveIt: 'Die Hörer lieben es',
    decListenersStay: 'Die Hörer bleiben dran',
    decGoodAcceptance: 'Gute Hörerakzeptanz',
    decReduceFrequency: 'Frequenz reduzieren',
    decFewerPlaysWeek: 'Weniger Plays/Woche',
    decNoPrimeZones: 'Nicht in Prime-Zeitzonen wählen',
    decListenersSwitch: 'Die Hörer schalten um',
    decListenersTired: 'Die Hörer sind es müde',
    decSleeperDesc: 'Spielt selten aber wenn es spielt, lieben es die Hörer',
    decExcellentPerformance: 'Ausgezeichnete Leistung',
    decTopTrack: 'Top-Track',
    decVeryGoodPerformance: 'Sehr gute Leistung',
    decKeepIt: 'Behalten Sie es',
    decStableChoice: 'Stabile Wahl',
    decPlaysTooOften: 'Spielt zu oft',
    decLowInterest: 'Geringes Hörerinteresse',
    decHiddenHit: 'Versteckter Hit',
    decLikedButRare: 'Beliebt aber selten gespielt',
    decIncreasePlaybacks: 'Wiedergaben erhöhen',
    decReduceSignificantly: 'Frequenz deutlich reduzieren',
    decContinueStrategy: 'Mit aktueller Strategie fortfahren',
    decNewRelease: 'Neuerscheinung',
    decDoesntFitFormat: 'passt nicht zum Format',
    decBetterInOtherFormat: 'Würde in einem anderen Format besser abschneiden',
    
    // Analysis Summary
    analysisSummary: 'Analyse-Zusammenfassung',
    totalRecords: 'Gesamte Einträge',
    uniqueTracks: 'Einzigartige Tracks',
    period: 'Zeitraum',
    daypartDistribution: 'Daypart-Verteilung',
    musicFormat: 'Musikformat',
    analyzingTracks: 'Tracks werden analysiert mit Format',
    mediumFileWarning: '~20-30 Sekunden',
    largeFileWarning: 'große Datei - kann ~30-60 Sekunden dauern',
    analysisTimeout: 'Analyse hat zu lange gedauert (>5 Minuten). Versuchen Sie eine kleinere CSV.',
    analysisRetrying: 'Analyse braucht mehr Zeit... Wiederholung',
    analysisLargeFileFailed: 'Große Datei ist nach mehreren Versuchen fehlgeschlagen. Teilen Sie die CSV in kleinere Teile.',
    
    // SongInfo
    songInfoTitle: 'Song-Informationen',
    songInfoDesc: 'Suchen Sie Informationen und Ansagevorschläge für Songs',
    artistLabel: 'Künstler',
    titleLabel: 'Titel',
    searchSongInfo: 'Informationen Suchen',
    searching: 'Suche...',
    tipLatinChars: 'Verwenden Sie lateinische Zeichen für bessere Ergebnisse',
    radioAnnouncement: 'Ansage-Vorschlag',
    announcementTip: 'Verwenden Sie diesen Text als Leitfaden für die Song-Präsentation',
    fillArtistTitle: 'Bitte Artist und Titel eingeben',
    fillArtistTitleSearch: 'Geben Sie Artist und Titel für die Suche ein',
    infoFound: 'Informationen gefunden!',
    searchError: 'Suchfehler. Versuchen Sie es erneut.',
    exampleArtist: 'z.B. Ed Sheeran',
    exampleTitle: 'z.B. Shape of You',
    
    // DaypartAnalyzer & Gold Analysis
    specialAnalysisForTracks: 'Spezielle Analyse für Tracks',
    withAvailableYear: 'mit verfügbarem Jahr',
    recommendations: 'Empfehlungen',
    goldHitDesc: 'Top Gold - In Rotation behalten',
    goldKeeperDesc: 'Wertvoll - Normal fortsetzen',
    goldRotateDesc: 'OK Leistung - Normale Rotation',
    goldRestDesc: 'Ermüdet - Pause 1-2 Monate',
    goldDropDesc: 'Niedrige Leistung - Ersetzen',
    
    // Playlist Help Modal keys
    helpCsvStructure: 'CSV-Dateistruktur',
    helpCsvMustContain: 'Die CSV-Datei muss folgende Spalten enthalten:',
    helpColumnExplanation: 'Spaltenerklärung:',
    helpArtistName: 'Künstlername (erforderlich)',
    helpTrackTitle: 'Tracktitel (erforderlich)',
    helpFrequency: 'Wiedergabefrequenz (Zahl)',
    helpPerformances: 'Gesamte Performances (Zahl)',
    helpTLH: 'Total Listening Hours (Dezimalzahl)',
    helpMissingColumns: 'Was passiert wenn Spalten fehlen?',
    helpMissingArtistTitle: 'Der Track wird NICHT in die Analyse einbezogen',
    helpMissingNumeric: 'Wird als 0 (null) behandelt',
    helpAllNumericMissing: 'Score wird 0 - Track erscheint als "CUT"',
    helpTip: 'Tipp: Für genaue Analyse stellen Sie sicher, dass alle Spalten Werte haben. TLH ist besonders wichtig!',
    helpScoringProcess: 'Bewertungsprozess (9 Schritte)',
    helpStep1: 'Normalisierung (0-1) - Werte in 0-1 Skala umwandeln',
    helpStep2: 'Basis-Gewichte - TLH 55%, Performances 30%, Frequenz 15%',
    helpStep3: 'Format-Anpassung - Gewichte basierend auf Radiotyp',
    helpStep4: 'Epochen-Multiplikator - Bonus für formatpassende Tracks',
    helpStep5: 'Neuerscheinungs-Bonus - +10% für Tracks ≤90 Tage alt',
    helpStep6: 'Rotations-Strafe - Reduzierung bei übermäßiger Wiedergabe',
    helpStep7: 'Ablehnungs-Strafe - Reduzierung wenn Hörer umschalten',
    helpStep8: 'Ermüdungs-Strafe - Reduzierung wenn TLH sinkt',
    helpStep9: 'Endgültige Punktzahl - Skala 0-100',
    helpDataMeaning: 'Was die Daten bedeuten',
    helpTLHDesc: 'Gesamtzeit, die Hörer mit dem Track verbringen. Hohe TLH = sehr beliebt!',
    helpPerformancesDesc: 'Wie oft der Track im Programm gespielt wurde',
    helpFrequencyDesc: 'Wie oft er spielt (mal pro Tag oder Woche)',
    helpYearDesc: 'Erscheinungsjahr (von MusicBrainz/Discogs)',
    helpGenreDesc: 'Musikgenre (Pop, Rock, Folk, etc.)',
    helpRadioFormats: 'Radioformate & Anpassungen',
    helpFormatIntro: 'Jedes Format gewichtet Daten unterschiedlich:',
    helpDecisionLabels: 'Haupt-Entscheidungslabels (RANKING-BASIERT)',
    helpDecisionIntro: 'Basierend auf Rangposition, nicht absolutem Score:',
    helpStrictMode: 'STRENG Modus (HOT AC, GHR, Greek Mainstream): 62.5% aktiv, 37.5% CUT',
    helpRelaxedMode: 'ENTSPANNT Modus (GOLD, AC): 57% aktiv, 43% CUT',
    helpPowerLabel: 'Top 2-2.5%',
    helpSecondaryLabel: 'Nächste 4-5%',
    helpCurrentsLabel: 'Nächste 8-10%',
    helpSpreadMoreLabel: 'Nächste 16-17.5%',
    helpSlowDownLabel: 'Nächste 24-27.5%',
    helpRiskLabel: 'Nächste 37.5-46%',
    helpCutLabel: 'Verbleibende (37.5-43%)',
    helpGotIt: 'Verstanden, los geht\'s!',
    
    // Help Modal - Special Labels
    helpSpecialLabels: 'Spezielle Labels',
    helpSpecialLabelsIntro: 'Basierend auf Frequenz & TLH Verhältnis:',
    helpSleeperTitle: 'Versteckter Diamant',
    helpSleeperCriteria: 'Kriterien: Niedrige Frequenz (<35%) + Hohe TLH (≥55%)',
    helpSleeperAction: 'Spielt selten aber wenn es spielt, lieben es die Hörer! ERHÖHEN SIE ES!',
    helpOverplayedTitle: 'Überspielt',
    helpOverplayedCriteria: 'Kriterien: Hohe Frequenz (≥65%) + Niedrige TLH (<45%)',
    helpOverplayedAction: 'Die Hörer sind es leid! FREQUENZ REDUZIEREN!',
    helpCsvFormat: 'CSV-Dateiformat',
    helpCsvFormatDesc: 'CSV-Datei muss diese Spalten enthalten:',
    helpCsvExample: 'Beispiel:',
    helpCsvStructureIntro: 'Die CSV-Datei muss die folgenden Spalten enthalten. Spaltennamen können groß oder klein geschrieben sein.',
    
    // Compare Stations Page
    compareStationsTitle: 'Radiosender Vergleichen',
    compareStationsSubtitle: 'Senderleistungsvergleich',
    compareStationsDesc: 'Vergleichen Sie, wie zwei Radiosender mit derselben Musik abschneiden, basierend auf der Reaktion des Publikums.',
    selectStation: 'Sender wählen',
    noStationsAvailable: 'Keine Sender verfügbar',
    selectTwoStations: 'Wählen Sie zwei verschiedene Sender, um den Vergleich zu starten.',
    compareButton: 'Sender vergleichen',
    comparing: 'Vergleich läuft...',
    noCommonSongs: 'Keine gemeinsamen Songs zwischen den beiden Sendern gefunden.',
    noUniqueSongs: 'Keine einzigartigen Songs.',
    playlistsCompletelyDifferent: 'Die Playlists sind völlig unterschiedlich.',
    songs: 'Songs',
    plays: 'Plays',
    commonSongsPerformance: 'Leistung gemeinsamer Songs',
    playlistDifferentiation: 'Playlist-Differenzierung',
    uniqueTo: 'Einzigartig bei',
    daypartBreakdown: 'Aufschlüsselung nach Tageszeit',
    daypartListenerReaction: 'Hörerreaktion nach Tageszeit',
    aggregateMetricsNote: 'Die obigen Metriken sind pro Sender aggregiert. Es gibt keine Rangliste oder "Gewinner".',
    clickForDaypart: 'Klicken Sie auf einen Song, um die Tageszeit-Aufschlüsselung zu sehen',
    stationComparisonDisclaimer: 'Vergleicht Sender untereinander — nicht Songs innerhalb eines Senders. Keine Ranglisten-Labels (POWER, GOLD, etc.) werden verwendet.',
    noAccessCompare: 'Sie haben keinen Zugang zum Sendervergleich',
    whatIsCompareStations: 'Was ist Compare Stations',
    compareStationsDescP1: 'Das Compare Stations Tool ermöglicht es Ihnen zu vergleichen, wie zwei Radiosender bei ihrem Publikum im gleichen Zeitraum abschneiden.',
    compareStationsDescP2: 'Der Vergleich basiert auf Hörerreaktionsmetriken — nicht nur Radioübertragungen — und verwendet vereinheitlichte Song-Identitäten, um Duplikate oder inkonsistente Ergebnisse zu vermeiden.',
    selectStationsAndPeriod: 'Sender & Zeitraum auswählen',
    timePeriod: 'Zeitraum',
    contactForAccess: 'Um Zugang zum Sendervergleich zu erhalten, kontaktieren Sie uns bitte.',
    contact: 'Kontakt',
    previousWeek: 'Vorherige Woche',
    last7Days: 'Letzte 7 Tage',
    last14Days: 'Letzte 14 Tage',
    last30Days: 'Letzte 30 Tage',
    thisMonth: 'Dieser Monat',
    lastMonth: 'Letzter Monat',
    
    // Radio Chart
    radioChartTitle: 'The People\'s Chart',
    radioChartSubtitle: 'Songs, die Hörer bis zum Ende hören',
    noDataFound: 'Keine Daten gefunden',
    noDataForPeriod: 'Keine Daten für diesen Zeitraum gefunden',
    
    // Songs Analyzer
    songsAnalyzerTitle: 'Songs Analyzer',
    songsAnalyzerSubtitle: 'Detaillierte Song-Analysen pro Sender',
    songsAnalyzerMetricsNote: 'Metriken basieren auf Stream-Stabilität und Verhaltensanalyse. Keine tatsächlichen gleichzeitigen Hörer enthalten.',
    liveAudienceTooltip: 'Metriken basieren auf echten gleichzeitigen Hörern vom Streaming-Server des Senders.\nDie Analyse zeigt die tatsächliche Reaktion des Publikums auf jeden Song.',
    noAccessSongsAnalyzer: 'Sie haben keinen Zugang',
    noDataForPeriodSongs: 'Keine Daten für den gewählten Zeitraum',
    noDataDayparts: 'Keine Tageszeit-Daten für den gewählten Zeitraum',
    
    // Early Hit Predictor
    ehpNoResults: 'Keine Vorhersagen gefunden',
    ehpNoSongsInCategory: 'Keine Songs in der Kategorie',
    ehpNoEligibleSongs: 'Derzeit erfüllen keine Songs die Eignungskriterien.',

    // v2.9.203 — Plays vs Behavior Comparison
    pvbWhyDifferent: 'Warum wir anders sind',
    pvbTitlePartA: 'Einfache Songerfassung',
    pvbVs: 'vs',
    pvbTitlePartB: 'Hörerverhalten',
    pvbDescription: 'Die reine Play-Erfassung zeigt nur was gesendet wurde. Die Analyse des Hörerverhaltens offenbart',
    pvbWhatReallyWorks: 'was wirklich funktioniert',
    pvbDescriptionEnd: ', was Ihr Publikum bindet und welche Entscheidungen zu höheren Quoten und Umsätzen führen.',
    pvbRetentionStat: 'Hörerbindung an die Frequenz bis zu',
    pvbTraditionalApproach: 'Traditioneller Ansatz',
    pvbSimpleSongTrackingPlays: 'Einfache Songerfassung (Plays)',
    pvbFullAnalysis: 'Vollständige Analyse',
    pvbSongAndBehavior: 'Song + Hörerverhalten',
    pvbPlays1: 'Wie oft ein Song gespielt wurde',
    pvbPlays2: 'Nur Playlist- & Rotations-Daten',
    pvbPlays3: 'Keine Einsicht in die Publikumsreaktion',
    pvbPlays4: 'Unbekannter Einfluss auf die Hörer',
    pvbPlays5: 'Entscheidungen auf Vermutungen basierend',
    pvbPlays6: 'Misst was gespielt wurde',
    pvbPlays7: 'Historische Aufzeichnung',
    pvbPlays8: 'Playlist-Statistiken',
    pvbPlays9: 'Zeigt nicht, warum die Quote steigt oder fällt',
    pvbPlays10: 'Begrenzte Datenausnutzung',
    pvbBehavior1: 'Erfassung des Hörerverhaltens in Echtzeit',
    pvbBehavior2: 'Hörerengagement zu jedem Zeitpunkt',
    pvbBehavior3: 'Messung von Tune-in, Engagement, Tune-out und Retention',
    pvbBehavior4: 'Analyse innerhalb Ihres eigenen Formats, Programms und Marktes',
    pvbBehavior5: 'Datenbasierte Entscheidungen aufgrund realer Daten',
    pvbBehavior6: 'Misst was beliebt war und was performt hat',
    pvbBehavior7: 'Echtzeit-Insights',
    pvbBehavior8: 'Publikums- und Verhaltensstatistiken',
    pvbBehavior9: 'Identifiziert was die Quote beeinflusst',
    pvbBehavior10: 'Volle Datennutzung für Senderwachstum',
    pvbWantToKnowA: 'Möchten Sie wissen,',
    pvbWhatReallyLiked: 'was Ihren Hörern wirklich gefällt',
    pvbWantToKnowB: '?',
    pvbContactPromo: 'Kontaktieren Sie Radio Solutions für eine Vorführung unseres Hörerverhaltens-Analyse-Systems.',
    pvbRequestDemo: 'Demo anfordern',
    pvbTrustedByA: 'Vertrauen uns',
    pvbStations: 'Sender',

    // v2.9.203 — Songs Analyzer common UI
    saStreamUrlSuggestion: 'Stream-URL vorschlagen',
    saSongs: 'Songs',
    burnWeek: "Woche {{from}} - {{to}} · {{n}} Songs",
    burnPeriodNote: "Letzte volle Woche (Montag-Sonntag)",
    burnSearch: "Suchen…",
    burnPage: "Seite {{p}} / {{n}}",
    burnLoading: "Wird geladen…",
    burnError: "Daten konnten nicht geladen werden.",
    burnPending: "Die wöchentliche Burn-Analyse wird vorbereitet. Sie wird jeden Montag nach Mitternacht aktualisiert.",
    burnEmpty: "Keine Daten für die letzte volle Woche.",
    burnNoAudience: "Keine verlässlichen Hörerdaten für diesen Sender.",
    burnAudienceWarn: "Wenige Spins mit Hörermessungen diese Woche: Ergebnisse nur als Richtwert.",
    burnColArtist: "Künstler",
    burnColTitle: "Titel",
    burnColYear: "Jahr",
    burnColSpins: "Spins",
    burnCol4w: "4 Wo.",
    burnColBurn: "Burn",
    burnColDelta: "Delta",
    burnColTrend: "Trend",
    burnColStatus: "Status",
    burnTapHint: "Tippen Sie auf ein Status-Label für eine Erklärung.",
    burnStIncreasing: "Steigt",
    burnStStable: "Stabil",
    burnStDecreasing: "Sinkt",
    burnStHighExposure: "Hohe Rotation",
    burnTipHighWeeks: "Auf dem obersten Spin-Niveau des Senders: {{n}} von 4 Wochen.",
    burnTipStationChoice: "Zeigt die Auswahl des Senders, nicht die Reaktion der Hörer.",
    burnAdvIncreasing: "Der Sender spielt ihn immer öfter.",
    burnAdvStable: "Der Sender hält die gleichen Spins.",
    burnAdvDecreasing: "Der Sender reduziert die Spins bereits.",
    burnAdvHighExposure: "Viele Wochen auf höchstem Niveau: Ermüdungsrisiko. Wenn Hörerdaten vorliegen, prüfen Sie Audience.",
    burnAirplayNote: "Airplay: zeigt nur die Auswahl des Senders (Spins). Es misst keine Hörer.",
    burnTipWeekSpins: "Diese Woche ({{from}}-{{to}}): {{spins}} Spins, {{diff}}.",
    burnTipMore: "{{n}} mehr als letzte Woche",
    burnTipLess: "{{n}} weniger als letzte Woche",
    burnTipSame: "gleich wie letzte Woche",
    burnTipWeekLoss: "Diese Woche ({{from}}-{{to}}): wenn er läuft, gehen {{d}}% der Hörer.",
    burnTipWeekGain: "Diese Woche ({{from}}-{{to}}): wenn er läuft, kommen {{d}}% mehr Hörer.",
    burnSortHint: "Zum Sortieren auf einen Spaltentitel klicken.",
    burnLegendAirplay: "Burn 0-100 = Rotationsdruck: wie viele Spins der Sender im Vergleich zu seinen meistgespielten Songs vergibt, wie viele Wochen auf höchstem Niveau und wie stark die Spins seit dem Monatshoch gefallen sind. Misst keine Hörerreaktion.",
    burnLegendAudience: "Audience: Delta = durchschnittliche Hörerveränderung während der Song läuft. Grün/Gelb/Rot = bestes/mittleres/schlechtestes Drittel des Senders. Trend = Vergleich mit den 3 Vorwochen.",
    burnStBurning: "Verbrennt",
    burnStTiring: "Nutzt sich ab",
    burnStRising: "Steigend",
    burnStSteady: "Stabil",
    burnStLosing: "Verliert Hörer",
    burnStNeutral: "Neutral",
    burnStHolding: "Hält Hörer",
    burnTipLowSample: "Nur {{n}} von {{total}} Spins hatten Hörermessungen.",
    burnAdvBurning: "Was tun: Spins reduzieren oder den Song eine Weile pausieren.",
    burnAdvTiring: "Was tun: keine weiteren Spins, beobachten.",
    burnAdvRising: "Was tun: er hat Schwung und verträgt mehr Spins.",
    burnAdvSteady: "Was tun: keine Änderung.",
    burnAdvLosing: "Was tun: Sendezeit prüfen oder Spins reduzieren.",
    burnAdvNeutral: "Was tun: keine sofortige Änderung.",
    burnAdvHolding: "Was tun: er läuft gut, behalten.",
    saBroadcasts: 'Sendungen',
    saTabAll: 'Gesamt',
    saTabPrefecture: 'Region',
    saListenerStats: 'Hörerstatistiken',
    saMoreStations: 'Möchten Sie Zugang zu weiteren Sendern?',
    saMoreStationsDesc: 'Kontaktieren Sie uns, um weitere Sender zu Ihrem Konto hinzuzufügen.',
    saContact: 'Kontakt',
    saExcel: 'Excel',
    saMetadataOnly: 'Nur Metadaten',
    saYesterdayFull: 'Gestern (✅ Vollständig)',

    // v2.9.203 — Compare Stations page
    csTitle: 'Radiosender vergleichen',
    csSubtitle: 'Sender-Performance-Vergleich',
    csWhatIs: 'Was ist Compare Stations',
    csWhatIsP1: 'Das Compare-Stations-Tool ermöglicht es Ihnen, die Performance zweier Sender beim Publikum im selben Zeitraum zu vergleichen.',
    csWhatIsP2: 'Der Vergleich basiert auf Hörer-Reaktionsmetriken — nicht nur auf Sendungen — und nutzt einheitliche Song-Identitäten, um Duplikate oder inkonsistente Ergebnisse zu vermeiden.',
    csSelectStations: 'Sender & Zeitraum auswählen',
    csModeStation: 'Sender vs Sender',
    csModeGroup: 'Gruppe vs Gruppe',
    csModeCategory: 'Kategorie vs Kategorie',
    csCategoryA: 'Kategorie A',
    csCategoryB: 'Kategorie B',
    csTimePeriod: 'Zeitraum',
    csSelectCategory: 'Kategorie wählen',
    csPeriod7d: '7 Tage',
    csPeriod14d: '14 Tage',
    csPeriod30d: '30 Tage',
    csCompareBtn: 'Sender vergleichen',
    csSelectTwo: 'Wählen Sie zwei verschiedene Sender, um den Vergleich zu starten.',

    // v2.9.205 — Performance Score Section
    perfLoading: 'Laden…',
    perfNoData: 'Noch nicht genug Daten',
    perfNoDataMsg: 'Sammeln Sie etwas mehr Aktivität und wir sagen Ihnen, wie es läuft.',
    perfTierLocal: 'Ihre Region',
    perfTierFormat: 'Gleiches Format bundesweit',
    perfTierNational: 'Nationaler Durchschnitt',
    perfTierPersonal: 'Persönlicher Fortschritt',
    perfPeriodLabel: 'Zeitraum:',
    perfPeriodFull: 'Letzte volle Woche',
    perfPeriodTip: 'Für einen stabilen Vergleich wird immer die letzte abgeschlossene Woche verwendet',
    perfPersonalDescA: 'Persönlicher Fortschritt',
    perfPersonalDescB: '— sehen Sie Ihre Entwicklung Woche für Woche.',
    perfCompareNationalA: 'Vergleich mit dem',
    perfCompareNationalB: 'nationalen Durchschnitt',
    perfCompareNationalC: 'aller Sender auf der Plattform.',
    perfCompareAvgA: 'Vergleich mit dem',
    perfCompareAvgB: 'Durchschnitt',
    perfCompareAvgC: 'der',
    perfActivity: 'Wie oft Sie spielen',
    perfVariety: 'Musikvielfalt',
    perfYou: 'Sie:',
    perfPerWeek: '/Woche',
    perfAvgNational: 'Nat. Durchschnitt:',
    perfAvgLocal: 'Regionaler Ø:',
    perfAvgFormat: 'Format-Ø:',
    perfAvgGeneric: 'Durchschnitt:',
    perfAvgPin: 'Ø',
    perfAvgTooltip: 'Durchschnitt',
    perfAdvice: 'Tipp',
    perfDow: ['So','Mo','Di','Mi','Do','Fr','Sa'],

    // v2.9.205 — Daypart Legend
    daypartMetrics: 'Daypart-Metriken',
    daypartSubtitle: 'Hörerreaktion pro Zeitzone',
    daypartGuide: 'Anleitung',
    daypartMorning: 'Morgen',
    daypartMidday: 'Mittag',
    daypartAfternoon: 'Nachmittag',
    daypartDrive: 'Drive Time',
    daypartEvening: 'Abend',
    daypartNight: 'Nacht',
    daypartPlays: 'Plays',
    daypartSongsCount: 'Songs',
    daypartSearch: 'Song oder Künstler suchen…',
    daypartColPlays: 'Plays',
    daypartColSongs: 'Songs',
    daypartColTLH: 'TLH',
    daypartSortHint: 'Klicken Sie auf Überschriften zum Sortieren',

    // v2.9.205 — Era Chart
    eraChartTitle: 'Era Chart',
    eraChartSubtitle: 'Verteilung nach Jahrzehnt und Jahr. Klick auf eine Leiste filtert den "Gesamt"-Tab.',
    eraChartPlays: 'Plays',
    eraChartUnique: 'unique',
    eraChartTogglePlays: 'Plays',
    eraChartToggleVariety: 'Vielfalt',
    eraChartYears: 'J.',
    eraChartYear: 'J.',
    eraChartUnknownYear: 'Unbekanntes Jahr',
    eraChartFooterPlays: 'Metrik: Sendungen · Gesamt:',
    eraChartFooterUnique: 'Metrik: einzigartige Songs · Gesamt:',

    // v2.9.205 — Playlist Chart / Top Artists / Common columns
    colArtist: 'Künstler',
    colTitle: 'Titel',
    colPlays: 'Plays',
    colAvgListeners: 'Ø Hörer',
    colTLH: 'TLH',
    colRetention: 'Ret%',
    colEarly: 'Early',
    colLSI: 'LSI',
    colScore: 'Score',
    colAImpact: 'A.Impact',
    colYear: 'Jahr',
    colRank: 'Rang',
    topArtistsDiffSongs: 'unterschiedliche Songs',
    playlistApply: 'Anwenden',
    playlistPrevWeek: 'Letzte Woche',
    dowShort: ['Mo','Di','Mi','Do','Fr','Sa','So'],
    // ─── i18n Batch #3 (v2.10.0+) — Songs Analyzer subcomponents ───
    i18nB3_morning_06_10: 'Morgen 06-10',
    i18nB3_midday_10_15: 'Mittag 10-15',
    i18nB3_drive_15_19: 'Nachmittag 15-19',
    i18nB3_night_22_06: 'Nacht 22-06',
    i18nB3_all_day: 'Den ganzen Tag',
    i18nB3_our_avg: 'Unser Ø',
    i18nB3_numbers: 'Zahlen',
    i18nB3_listener_stats: 'Hörerstatistiken',
    i18nB3_your_audience: 'Dein Publikum',
    i18nB3_hour: 'Stunde',
    i18nB3_listeners: 'Hörer',
    i18nB3_avg_short: 'Ø',
    i18nB3_loyal: 'Treu',
    i18nB3_passing: 'Vorbeigehend',
    i18nB3_normal: 'Normal',
    i18nB3_audience_exact: 'Exakte Daten vom Server des Senders',
    i18nB3_audience_estimate: 'Server liefert keine vollständigen Daten — der Wert ist eine Schätzung',
    i18nB3_audience_unavailable: 'Der Server deines Senders liefert diese Information noch nicht.',
    i18nB3_audience_renewal: 'jede Stunde kommt neues Publikum (Schätzung)',
    i18nB3_unknown_year: 'Unbekanntes Jahr',
    i18nB3_expand: 'Erweitern',
    i18nB3_collapse: 'Einklappen',
    i18nB3_day_mon: 'Mo',
    i18nB3_day_tue: 'Di',
    i18nB3_day_wed: 'Mi',
    i18nB3_day_thu: 'Do',
    i18nB3_day_fri: 'Fr',
    i18nB3_day_sat: 'Sa',
    i18nB3_day_sun: 'So',
    i18nB3_next_song: 'Nächster Song',
    i18nB3_prev_song: 'Vorheriger Song',
    i18nB3_genre_artistic: 'Künstlerisch',
    i18nB3_genre_intl: 'International / Ausländisch',
    i18nB3_genre_greek: 'Griechisch',
    i18nB3_genre_mixed: 'Gemischt',
    i18nB3_genre_rock: 'Rock',
    i18nB3_group: 'Gruppe',
    i18nB3_group_vs_group: 'Gruppe vs Gruppe',
    i18nB3_genre: 'Genre',
    i18nB3_genre_vs_genre: 'Genre vs Genre',
    i18nB3_close: 'Schließen',
    i18nB3_select_station: 'Sender auswählen',
    i18nB3_stations: 'Sender',
    i18nB3_station: 'Sender',
    i18nB3_station_vs_station: 'Sender vs Sender',
    i18nB3_compare: 'Vergleichen',
    i18nB3_not_run_yet: 'Noch nicht ausgeführt',
    i18nB3_start_year_search: 'Jahres-Suche starten',
    i18nB3_just_now: 'Gerade eben',
    i18nB3_never: 'Nie',
    i18nB3_running: 'Läuft...',
    i18nB3_now: 'Jetzt!',
    i18nB3_your_performance: 'Deine Leistung',
    i18nB3_export_timeline_excel: 'Timeline als Excel exportieren (.xlsx)',
    i18nB3_confirmed_fp: 'Durch Audio-Fingerprint bestätigt',
    i18nB3_hide_gaps_hint: 'Versteckt kleine Lücken durch Duration-Mismatches/Crossfades. Standard 5min.',
    i18nB3_async_analysis_in_progress: 'Asynchrone Analyse läuft...',
    i18nB3_upload_csv_first: 'Bitte zuerst eine CSV-Datei hochladen',
    i18nB3_connection_error_retry: 'Verbindungsfehler. Bitte erneut versuchen.',
    i18nB3_too_many_requests: 'Zu viele Anfragen, neuer Versuch in 3s...',
    // ── Clock View (Programming Clocks) — added 2026-06-15
    clkView_listView: 'Liste',
    clkView_clockView: 'Uhr',
    clkView_hourFrom: 'Von',
    clkView_hourTo: 'Bis',
    clkView_exportPdf: 'PDF exportieren',
    clkView_exportingPdf: 'PDF wird erstellt…',
    clkView_loadingClocks: 'Uhren werden geladen…',
    clkView_noActiveHours: 'Keine aktiven Programmstunden für dieses Datum.',
    clkView_emptyHour: 'Kein Inhalt für diese Stunde.',
    clkView_songs: 'Lieder',
    clkView_breaks: 'Pausen',
    clkView_song: 'Lied',
    clkView_break: 'Pause / Unterbrechung',
    clkView_listenersStart: 'Start',
    clkView_listenersEnd: 'Ende',
    clkView_listenersPeak: 'Spitze',
    clkView_listenersAvg: 'Ø',
    clkView_retention: 'Bindung',
    clkView_earlyDrop: 'Früher Abgang',
    clkView_lsi: 'Hörer-Score',
    clkView_score: 'Punktzahl',
    clkView_severitySevereLoss: 'Schwerer Verlust',
    clkView_severitySignificantLoss: 'Erheblicher Verlust',
    clkView_severityMinorLoss: 'Kleiner Verlust',
    clkView_severityStable: 'Stabil',
    clkView_severityMinorGain: 'Kleiner Zuwachs',
    clkView_severityStrongGain: 'Starker Zuwachs',
    clkView_severityUnknown: 'Unbekannt',
    clkView_netHour: 'Stunden-Saldo',
    clkView_categoryPower: 'POWER',
    clkView_categorySecondary: 'SECONDARY',
    clkView_categoryCurrents: 'CURRENTS',
    clkView_categoryRecurrents: 'RECURRENTS',
    clkView_categoryGold: 'GOLD',
    clkView_categorySlowDown: 'SLOW DOWN',
    clkView_categoryCut: 'CUT',
    clkView_legendTitle: 'Legende',
    clkView_legendSongCategories: 'Lied-Kategorien',
    clkView_legendBreakSeverity: 'Pausen-Schwere',
    clkView_legendBreaksSingle: 'Pausen',
    clkView_listenersUnit: 'Hörer',
    clkView_clickToSee: 'Klicke ein Tortenstück für Details',
    clkView_sparklineTitle: 'Hörer alle 5 Min',
    clkView_min: 'min',
    clkView_max: 'max',
    clkView_thisHourLabel: 'Diese Stunde',
    clkView_legendSongs: 'Lieder',
    clkView_song: 'Musik',
    clkView_legendHelp: 'Klicke ein Tortenstück für Details',
    clkView_talk: 'Talk',
    clkView_talks: 'Talks',
    clkView_breakHint: '1-4 Min @ Slots :25 :30 :55 :00',
    clkView_talkHint: 'sonst',
    clkView_noData: 'keine Daten',
    clkView_noDataHint: 'Nicht-Musik-Inhalt — wird untersucht',
    // ─── Classifier Shadow Report (v2.13.0) ───
    clfReport_title: 'Classifier-Bericht (Schatten)',
    clfReport_subtitle: 'inaSpeechSegmenter-Validierung gegen echte Shazam-Aufrufe',
    clfReport_gateMode: 'Modus',
    clfReport_classifierReady: 'Classifier bereit',
    clfReport_classifierUnavail: 'Classifier nicht verfügbar',
    clfReport_refresh: 'Aktualisieren',
    clfReport_downloadCsv: 'CSV herunterladen',
    clfReport_musicPct: 'Musik %',
    clfReport_speechPct: 'Sprache %',
    clfReport_speechMusicPct: 'Sprache + Musik %',
    clfReport_noisePct: 'Rauschen %',
    clfReport_potentialReduction: 'Potenzielle Fingerprint-Reduktion',
    clfReport_potentialReduction_hint: 'Wie viele Shazam-Aufrufe würden wir bei Aktivierung des Gatings einsparen.',
    clfReport_potentialLost: 'Potenziell verlorene Treffer',
    clfReport_potentialLost_hint: 'Von erkannten Songs: wie viele würden wir verlieren? < 5 % = sicher.',
    clfReport_crossTableTitle: 'Kreuztabelle: Klassifikation × Shazam',
    clfReport_totalSamples: 'Gesamt',
    clfReport_evaluable: 'Bewertbar',
    clfReport_classification: 'Klassifikation',
    clfReport_hitRate: 'Trefferquote',
    clfReport_crossTableHint: 'In den Sprach-/Rauschen-Zeilen sind Treffer falsche Positive — Songs, die wir unter aktivem Gating verloren hätten.',
    clfReport_perStationTitle: 'Aufschlüsselung pro Sender',
    clfReport_station: 'Sender',
    clfReport_noStationData: 'Noch keine Senderdaten.',
    clfReport_noSamplesTitle: 'Noch keine Proben',
    clfReport_noSamplesHint: 'Der Classifier läuft im Schatten-Modus und sammelt Daten. Kehren Sie in 48 Stunden zurück für zuverlässige Statistiken.',
    clfReport_window: 'Zeitraum',
    clkView_today: 'Heute',
    clkView_yesterday: 'Gestern',
    clkView_durationLabel: 'Dauer',
    clkView_listenerDeltaLabel: 'Hörer-Änderung',
    clkView_atTime: 'um',
    clkView_pdfReady: 'PDF ist bereit.',
    clkView_pdfError: 'PDF-Erstellung fehlgeschlagen.',
    clkView_dataRetentionHint: 'Uhr-Daten werden 2 Jahre aufbewahrt.',
    // Executive Summary
    execSum_title: 'Tageszusammenfassung',
    execSum_worstBreaks: 'Schlimmste Pausen',
    execSum_worstBreaks_subtitle: 'Die 3 Pausen mit dem größten Hörerverlust',
    execSum_heroSongs: 'Top Publikumsmagnete',
    execSum_heroSongs_subtitle: 'Die 3 Lieder, die das Publikum am meisten vergrößert haben',
    execSum_villainSongs: 'Größte Publikumsverluste',
    execSum_villainSongs_subtitle: 'Die 3 Lieder, die die meisten Hörer vertrieben haben',
    execSum_bestBreaks: 'Beste Pausen',
    execSum_bestBreaks_subtitle: 'Die 3 Pausen, die das Publikum gehalten oder vergrößert haben',
    execSum_noData: 'Keine Daten verfügbar',
    execSum_breakLabel: 'Pause',
  },
  
  it: {
    // Header
    appTitle: 'Radio Solutions On Air',
    home: 'Home',
    aboutUs: 'Chi siamo',
    logout: 'Esci',
    generate: 'Genera',
    renewSubscription: 'Rinnova Abbonamento',
    waiting: 'Attesa',
    contentCreationInProgress: 'Creazione contenuti in corso...',
    pleaseWaitDontClose: 'Attendere. Non chiudere l\'app.',
    
    // On Air Content
    onAirContent: 'Contenuti On Air',
    dailyContent: 'Contenuti Giornalieri',
    onAirContentDesc: 'Contenuti pronti per trasmissioni radiofoniche. Oroscopi, meteo, trend, notizie divertenti e altro.',
    onAirPageTitle: 'Contenuti Radio Pronti all\'Uso',
    onAirPageSubtitle: 'Clicca su una categoria per vedere le sezioni',
    
    // About Page
    radioSolutionsApps: 'Radio Solutions Apps',
    forRadioProfessionals: 'Per Proprietari, Manager, Produttori, Playlisters & Team Vendite',
    dataYouNeed: 'I Dati di cui hai Bisogno, gli Strumenti che Meriti',
    analyticsContentCharts: 'Analytics, Content & Charts per la radio moderna.',
    radioFinallyMeasured: 'Radio finally measured.',
    goToHome: 'Vai alla Home',
    goToApp: 'Vai all\'App',
    contactUs: 'Contattaci',
    ourTools: 'I Nostri Strumenti',
    toolsSuiteDescription: 'Una suite completa di strumenti progettata esclusivamente per le stazioni radio',
    timeSaving: 'Risparmia Tempo',
    timeSavingDesc: 'Automatizza la produzione di contenuti e concentrati sulla parte on-air.',
    professionalResults: 'Risultati Professionali',
    professionalResultsDesc: 'Contenuti di alta qualità pronti per l\'uso immediato in onda.',
    reliableData: 'Dati Affidabili',
    reliableDataDesc: 'Classifiche e statistiche aggiornate da fonti affidabili.',
    readyToStart: 'Pronto per iniziare?',
    signUpToday: 'Registrati oggi e ottieni accesso a tutti i nostri strumenti',
    viewPackages: 'Vedi i Pacchetti',
    freeTrial: 'Prova Gratuita',
    toolsForRadio: 'Strumenti per la radio,',
    withoutHeadache: 'senza mal di testa',
    suiteForProfessionals: 'Questa suite è progettata per i professionisti della radio.',
    normalIfDifficult: 'Se all\'inizio sembra un po\' difficile, è del tutto normale 😉',
    freeDemo: 'tour gratuito',
    freeDemoText: 'Ecco perché offriamo un {freeDemo} per mostrarti in modo semplice e pratico come puoi usare gli strumenti nella tua routine quotidiana.',
    wantDemo: 'Voglio una demo',
    noTechKnowledge: 'Non sono richieste conoscenze tecniche. Ti mostriamo tutto passo dopo passo.',
    seeToolsInAction: 'Guarda i Nostri Strumenti in Azione',
    allInOneTool: 'Analytics, Analisi Daypart, Decisioni Playlist - tutto in uno strumento',
    
    // Email Popup
    popupTitle: 'Vuoi davvero migliorare la tua stazione radio?',
    popupPlatformOffers: 'Cosa offre la piattaforma:',
    popupOnAirContent: 'Contenuti pronti per le trasmissioni',
    popupSongFinder: 'Trova informazioni su qualsiasi brano',
    popupTopCharts: 'I brani più popolari nella radio greca',
    popupPlaylistAnalyzer: 'Analisi playlist per ora e giorno',
    popupSongsAnalyzer: 'Scopri quali brani mantengono gli ascoltatori',
    popupCalculators: 'Calcolo campagne e ascoltatori',
    popupEmailPlaceholder: 'La tua email...',
    popupSubmitting: 'Invio in corso...',
    popupSubmitButton: 'Voglio saperne di più',
    popupBottomTagline: 'Riceverai informazioni su come migliorare la tua stazione.',
    popupSuccessTitle: 'Grazie!',
    popupSuccessMessage: 'Riceverai presto maggiori informazioni.',
    continueWithoutSignup: 'Continua senza registrazione',
    sectionsAvailable: 'sezioni disponibili',
    sections: 'Sezioni',
    updates: 'Aggiornamenti',
    ready: 'Pronto',
    refresh: 'Aggiorna',
    loadingContent: 'Caricamento contenuti...',
    
    // Categories
    zodiacLifestyle: 'Zodiaco & Lifestyle',
    zodiacLifestyleDesc: 'Oroscopo del giorno, Relazioni, Salute & Benessere, Consigli finanziari',
    newsTrends: 'Notizie & Trend',
    newsTrendsDesc: 'Notizie curiose, Buone notizie, Sport, Trend del giorno, Meteo',
    entertainmentGames: 'Intrattenimento & Giochi',
    entertainmentGamesDesc: 'Contest radiofonici, Giochi di parole, Dibattiti, Vero o Falso',
    musicCharts: 'Musica & Classifiche',
    musicChartsDesc: 'Apple Music, YouTube Trending, Oggi nella storia della musica',
    
    // Common
    loading: 'Caricamento...',
    save: 'Salva',
    cancel: 'Annulla',
    close: 'Chiudi',
    submit: 'Invia',
    download: 'Scarica',
    upload: 'Carica',
    search: 'Cerca',
    filter: 'Filtro',
    all: 'Tutti',
    yes: 'Sì',
    no: 'No',
    back: 'Indietro',
    next: 'Avanti',
    previous: 'Precedente',
    admin: 'Admin',
    
    // Access Loading States
    accessLoading: 'Caricamento permessi di accesso... Attendere prego.',
    accessSlow: 'La connessione è un po\' lenta... Riprovo. Di solito ci vogliono fino a 10 secondi.',
    accessRetrying: 'Nuovo tentativo di connessione (tentativo {count}/3)...',
    accessUsingCache: 'Connessione lenta. Utilizzo dati salvati temporaneamente.',
    accessError: 'Impossibile connettersi. Aggiornare la pagina.',
    
    // Welcome Popup
    welcomeTitle: 'Benvenuto!',
    welcomeSubtitle: 'Rendi ogni trasmissione imperdibile!',
    alreadyHaveAccount: 'Ho già un account - Accedi',
    startFreeTrial: 'Inizia la prova gratuita di 24 ore',
    dontLookLikeOthers: 'Non sembrare come tutti gli altri',
    becomeReferenceStation: 'Diventa la stazione di riferimento',
    makeEveryBroadcast: 'Rendi ogni trasmissione',
    mustListen: 'imperdibile',
    tryFor24Hours: 'Provalo per 24 ore',
    clickAnywhereToClose: 'Clicca fuori o ESC per chiudere',
    measureOptimizePerform: 'Measure. Optimize. Perform.',
    welcomeDescription: 'La prima app che trasforma la radio in un canale media misurabile: performance delle campagne, dati del pubblico, playlist intelligence e contenuti on-air giornalieri.',
    radioFinallyMeasured: 'Radio finalmente misurata.',
    
    // Login
    login: 'Accedi',
    username: 'Nome utente',
    password: 'Password',
    forgotPassword: 'Password dimenticata',
    loginError: 'Errore di accesso',
    serverStarting: 'Server in avvio... Attendere 10 secondi e riprovare.',
    rememberMe: 'Ricordami',
    twoFactorAuth: 'Verifica 2FA',
    enterOTP: 'Inserisci codice 2FA',
    verify: 'Verifica',
    invalid2FA: 'Codice 2FA non valido',
    
    // Trial Signup
    trialAccount: 'Account di prova',
    trialAccountDesc: 'Accesso gratuito di 24 ore a tutte le funzionalità',
    email: 'Email',
    confirmPassword: 'Conferma Password',
    chooseUsername: 'Scegli un nome utente',
    minChars: 'Almeno 6 caratteri',
    repeatPassword: 'Ripeti la password',
    createTrialAccount: 'Crea Account di Prova',
    creatingAccount: 'Creazione...',
    allFieldsRequired: 'Tutti i campi sono obbligatori',
    passwordsDontMatch: 'Le password non corrispondono',
    passwordTooShort: 'La password deve avere almeno 6 caratteri',
    trialCreatedSuccess: 'Account di prova creato con successo!',
    trialExpiresIn: 'La prova scade tra 24 ore',
    saveCredentials: 'Salva le tue credenziali:',
    goToApp: 'Vai all\'app',
    
    // Content
    contentFor: 'Contenuto per',
    sections: 'sezioni',
    exportPDF: 'Esporta PDF',
    userGuide: 'Guida Utente',
    contentDate: 'Contenuto',
    createdAt: 'Creato',
    viewMode: 'Modalità visualizzazione',
    categoriesView: 'Categorie',
    classicView: 'Classica',
    clickToViewSections: 'Clicca per vedere le sezioni',
    
    // Categories
    information: 'Informazione',
    entertainment: 'Intrattenimento',
    music: 'Musica',
    lifestyle: 'Lifestyle',
    special: 'Speciale',
    contestsGames: 'Concorsi & Giochi',
    dialoguesDiscussions: 'Dialoghi & Discussioni',
    chartsMusic: 'Classifiche & Musica',
    
    // Footer
    quickLinks: 'Link Rapidi',
    campaignAnalyzer: 'Analizzatore Campagne',
    listenerCalculator: 'Calcolatore Ascoltatori',
    playlistAnalyzer: 'Analizzatore Playlist',
    daypartAnalyzer: 'Analizzatore Daypart',
    ourStations: 'Le nostre stazioni',
    radioTopSongs: 'Top Radio Songs',
    contact: 'Contatto',
    radioContentCreation: 'Creazione di contenuti radiofonici',
    legalPrivacy: 'Legale & Privacy',
    privacyPolicy: 'Informativa sulla Privacy',
    termsOfService: 'Termini di Servizio',
    cookiePolicy: 'Politica sui Cookie',
    cookieSettings: 'Impostazioni Cookie',
    allRightsReserved: 'Tutti i diritti riservati',
    gdprCompliant: 'Conforme GDPR',
    euDataProtection: 'Protezione Dati UE',
    gdprNotice: 'I tuoi dati personali sono protetti secondo il GDPR (UE 2016/679).',
    loginForMoreOptions: 'Accedi per più opzioni',
    
    // Navigation Menu Labels
    navInfo: 'Info',
    navOnAirContent: 'On Air Content',
    navSongFinder: 'Song Finder',
    navCampaignCalculator: 'Campaign Calculator',
    navListenersCalculator: 'Listeners Calculator',
    navTopRadioCharts: 'Top Radio Charts',
    navStations: 'Stazioni',
    navPlaylistAnalyzer: 'Playlist Analyzer',
    navDaypartAnalyzer: 'Playlist Daypart Analyzer',
    navSongsAnalyzer: 'Songs Analyzer',
    navSongsAnalyzerPro: 'Songs Analyzer PRO',
    navContact: 'Contatti',
    navAdmin: 'Admin',
    navPackets: 'Pacchetti',
    navServices: 'Servizi',
    readMore: 'Scopri di pi\u00f9',

    // ── Services Page (v2.10.2 / 2026-06-15) ─────────────────────
    servicesTitle: 'Servizi',
    servicesEyebrow: 'Servizi · Services',
    servicesHeroTitle: 'Music Scheduling & Log Optimization',
    servicesHeroDesc: 'Oltre ai nostri strumenti, offriamo servizi specializzati che aiutano le emittenti radio ad aumentare gli ascolti, migliorare la programmazione e incrementare i ricavi.',
    servicesCtaFreeEval: 'Richiedi una Valutazione Gratuita',
    servicesPreviewDesc: 'Oltre ai nostri strumenti, offriamo servizi specializzati che aiutano le emittenti radio ad aumentare gli ascolti, migliorare la programmazione e incrementare i ricavi.',
    servicesOurServices: 'I Nostri Servizi',
    servicesOurServicesSub: 'Competenza professionale di veterani del settore radiofonico',
    svcIncludes: 'Include:',
    svcLearnMore: 'Scopri di pi\u00f9',
    svc1Title: 'Music Programming & Format Consulting',
    svc1Desc: 'Ottimizzazione della programmazione musicale in base al format, alla concorrenza e alle preferenze del pubblico locale.',
    svc1Bullet1: 'Analisi del format',
    svc1Bullet2: 'Strategia musicale',
    svc1Bullet3: 'Gestione delle rotation',
    svc1Bullet4: 'Analisi competitiva',
    svc1Bullet5: 'Creazione di music clock',
    svc1Bullet6: 'Ottimizzazione delle rotation',
    svc1Bullet7: 'Gestione delle categorie',
    svc1Bullet8: 'Pianificazione daypart',
    svc1Bullet9: 'Revisione musicale settimanale',
    svc2Title: 'Audience & Market Analysis',
    svc2Desc: 'Analizziamo il mercato e le tendenze musicali affinch\u00e9 la tua emittente prenda decisioni migliori.',
    svc2Bullet1: 'Analisi della concorrenza',
    svc2Bullet2: 'Monitoraggio dei trend musicali',
    svc2Bullet3: 'Report sulle nuove uscite',
    svc2Bullet4: 'Strategie di differenziazione',
    svc3Title: 'Radio Station Growth Consulting',
    svc3Desc: 'Consulenza di crescita per aumentare ascolti, valore commerciale e riconoscibilit\u00e0.',
    svc3Bullet1: 'Branding dell\u2019emittente',
    svc3Bullet2: 'Posizionamento',
    svc3Bullet3: 'Concorsi e promozioni',
    svc3Bullet4: 'Strategia social media',
    svc3Bullet5: 'Engagement degli ascoltatori',
    svc4Title: 'Ongoing Programming Support',
    svc4Desc: 'Collaborazione e supporto continui per le emittenti che cercano un partner esterno di programmazione.',
    svc4Bullet1: 'Comunicazione settimanale',
    svc4Bullet2: 'Valutazione del programma musicale',
    svc4Bullet3: 'Proposte di miglioramento',
    svc4Bullet4: 'Supporto ai produttori',
    svc4Bullet5: 'Monitoraggio dei risultati',
    servicesOurProcess: 'Il Nostro Processo',
    servicesOurProcessSub: 'Come forniamo i nostri servizi per migliorare il suono della tua emittente',
    svcProcessStep1Title: 'Scoperta',
    svcProcessStep1Desc: 'Iniziamo comprendendo il tuo format, il pubblico e gli obiettivi attraverso una consulenza dettagliata.',
    svcProcessStep2Title: 'Strategia',
    svcProcessStep2Desc: 'Progettiamo una strategia di scheduling personalizzata sulle tue esigenze specifiche.',
    svcProcessStep3Title: 'Implementazione',
    svcProcessStep3Desc: 'Implementiamo la strategia, ottimizzando log, libreria e clock per il massimo impatto.',
    svcProcessStep4Title: 'Perfezionamento',
    svcProcessStep4Desc: 'Feedback e perfezionamento continui per mantenere ottimizzato il suono della tua emittente.',
    svcBenefitsTitle: 'Vantaggi per la tua emittente',
    svcBenefitsSub: 'Risultati concreti che vedrai dopo aver collaborato con noi',
    svcBenefit1: 'Maggiore ascolto',
    svcBenefit2: 'Tempo di permanenza degli ascoltatori pi\u00f9 lungo',
    svcBenefit3: 'Aumento del valore pubblicitario e dei ricavi',
    svcBenefit4: 'Musica che mantiene il pubblico sintonizzato',
    svcBenefit5: 'Minor abbandono degli ascoltatori per scelte stancanti',
    svcBenefit6: 'Decisioni migliori grazie a dati e analisi',
    svcBenefit7: 'Chiara differenziazione dalla concorrenza',
    svcBenefit8: 'Miglioramento continuo della programmazione musicale',
    svcCtaEyebrow: 'Pronto a migliorare la tua emittente?',
    svcCtaTitle: 'Vuoi migliorare il programma della tua emittente?',
    svcCtaDesc: 'Parla con noi e valuteremo gratuitamente il format, la strategia musicale e le potenzialit\u00e0 di crescita della tua emittente.',

    // Services Results / Case Study (animated counters)
    svcResultsEyebrow: 'Risultati · Case Studies',
    svcResultsTitle: 'Risultati misurabili per le emittenti partner',
    svcResultsSub: 'Miglioramenti medi dopo 3-6 mesi di collaborazione con il nostro team',
    svcResultMetric1: 'Aumento del TSL (Time Spent Listening)',
    svcResultMetric2: 'Crescita degli ascolti',
    svcResultMetric3: 'Riduzione dell\u2019early drop',
    svcResultMetric4: 'Emittenti che si affidano a noi',
    svcResultsDisclaimer: 'Risultati basati sull\u2019analisi dei dati di ascolto delle emittenti che utilizzano i nostri servizi. I valori variano in base a format e mercato.',
    svcTestimonialQuote: '\u00ABCollaborare con Radio Solutions ha aumentato sensibilmente il TSL della nostra emittente e ci ha dato un quadro chiaro di quali brani funzionano davvero con il pubblico.\u00BB',
    svcTestimonialAuthor: 'Direttore di programma',
    svcTestimonialStation: 'Emittente partner',
    
    // Pricing
    pricing: 'Pacchetti & Abbonamenti',
    monthly: 'Mensile',
    annual: 'Annuale',
    subscribe: 'Abbonati',
    popular: 'Popolare',
    chooseYourPackage: 'Scegli il tuo Pacchetto',
    pricingDescription: 'Ottieni accesso a strumenti premium per la tua radio',
    currentPlan: 'Piano Attuale',
    upgrade: 'Upgrade',
    downgrade: 'Downgrade',
    per: 'al',
    month: 'mese',
    year: 'anno',
    selectWeek: 'Seleziona Settimana',
    previousWeek: 'Settimana Precedente',
    nextWeek: 'Settimana Successiva',
    optional: 'opzionale',
    savePercent: 'Risparmia',
    featuresIncluded: 'Include',
    
    // Cookies
    cookiesTitle: 'Utilizziamo i Cookie',
    cookiesDesc: 'Utilizziamo i cookie per migliorare la tua esperienza.',
    cookiesFullDesc: 'Utilizziamo i cookie per migliorare la tua esperienza. Alcuni cookie sono necessari per il funzionamento del sito.',
    acceptAll: 'Accetta Tutti',
    reject: 'Rifiuta',
    settings: 'Impostazioni',
    necessaryCookies: 'Cookie Necessari',
    necessaryCookiesDesc: 'Essenziali per la funzionalità base del sito.',
    required: 'RICHIESTI',
    analyticsCookies: 'Cookie Analitici',
    analyticsCookiesDesc: 'Ci aiutano a capire come utilizzi il sito.',
    functionalCookies: 'Cookie Funzionali',
    functionalCookiesDesc: 'Ricordano le tue preferenze e migliorano l\'esperienza.',
    thirdPartyCookies: 'Cookie di Terze Parti',
    thirdPartyCookiesDesc: 'Utilizzati da servizi esterni (es. YouTube).',
    saveSettings: 'Salva Impostazioni',
    
    // Daypart Analyzer
    daypartTitle: 'Analizzatore Performance Daypart',
    morning: 'Mattina',
    drive: 'Drive Time',
    night: 'Sera',
    overnight: 'Notte',
    analyze: 'Analizza',
    results: 'Risultati',
    genreDistribution: 'Distribuzione Genere',
    decadeDistribution: 'Distribuzione Decennio',
    
    // Labels
    power: 'POWER',
    secondary: 'SECONDARY',
    currents: 'CURRENTS',
    spreadMore: 'SPREAD MORE',
    slowDown: 'SLOW DOWN',
    sleeper: 'SLEEPER',
    cut: 'CUT',
    
    // Homepage Cards
    campaignAnalyzerDesc: 'Strumento di ottimizzazione campagne radio',
    campaignAnalyzerInfo: 'Calcola GRPs, Reach e Frequency per la tua campagna.',
    campaignAnalyzerFullDesc: 'L\'Analizzatore Campagne è uno strumento professionale per la pianificazione di campagne pubblicitarie radiofoniche. Calcola automaticamente GRPs (Gross Rating Points), Reach (percentuale di pubblico esposto al messaggio) e Frequency (numero medio di contatti per persona). Basandosi sulla categoria del brand e posizione di mercato, raccomanda il numero ottimale di spot per la massima efficacia.',
    openCampaignAnalyzer: 'Apri Analizzatore Campagne',
    listenerCalculatorDesc: 'Strumento di calcolo ascoltatori basato su daypart',
    listenerCalculatorInfo: 'Calcola percentuali di ascolto e stime ascoltatori.',
    listenerCalculatorFullDesc: 'Il Calcolatore Ascoltatori converte le percentuali di ascolto in numeri reali di ascoltatori. Utilizza metodi statistici (correzione FPC, Intervalli di Confidenza 95%) per stime accurate. Inserisci i dati di rating per giorno e fascia oraria (daypart) e ricevi risultati dettagliati sul pubblico della tua stazione.',
    openListenerCalculator: 'Apri Calcolatore Ascoltatori',
    playlistAnalyzerDesc: 'Strumento di analisi performance playlist',
    playlistAnalyzerInfo: 'Analizza in dettaglio le performance della tua playlist.',
    playlistAnalyzerFullDesc: 'L\'Analizzatore Playlist analizza le performance di ogni canzone nella playlist della tua stazione. Carica un CSV con dati TLH (Time Listening Hours), Performances e Frequency. Il sistema calcola punteggi e raccomanda decisioni come POWER (performance eccellente), SECONDARY (buona), CURRENTS (nuova uscita) o CUT (rimuovere).',
    openPlaylistAnalyzer: 'Apri Analizzatore Playlist',
    daypartAnalyzerDesc: 'Analizzatore performance per fascia oraria',
    daypartAnalyzerInfo: 'Analizza le performance per daypart.',
    daypartAnalyzerFullDesc: 'L\'Analizzatore Daypart è la versione premium dell\'Analizzatore Playlist. Analizza le performance di ogni canzone per fascia oraria: Morning (06:00-10:00), Midday (10:00-15:00), Drive (15:00-19:00), Evening (19:00-24:00) e Overnight (00:00-06:00). Ideale per stazioni che vogliono ottimizzare la rotazione per ora.',
    songInfoFullDesc: 'Lo strumento Informazioni Canzoni cerca informazioni su qualsiasi canzone: anno di uscita, etichetta discografica, compositori, autori, artista/band, e suggerisce testi per annunci (liner) ai produttori. Basta digitare il titolo della canzone e cliccare cerca.',
    openDaypartAnalyzer: 'Apri Analizzatore Daypart',
    premiumFeature: 'PREMIUM',
    upgradeToAccess: 'Upgrade per accedere',
    columns: 'Colonne',
    
    // Misc
    copyright: 'PROPRIETÀ DI RADIO SOLUTIONS',
    copyrightTitle: 'PROPRIETÀ DI RADIO SOLUTIONS',
    copyrightNotice: 'Questo contenuto è riservato agli abbonati registrati.',
    generateNewContent: 'Genera nuovo contenuto per risultati migliori!',
    contentCreationDuration: 'Durata creazione: ~15 minuti | Auto: 00:01 giornaliero',
    downloadAsPDF: 'Scarica come PDF',
    userInstructions: 'Guida Utente',
    waitForPdfDownload: 'Attendere fino a 10 secondi per il download PDF',
    generationDuration: 'Durata generazione: ~15 minuti | Auto: 00:01 giornaliero',
    waitForPDF: 'Attendere fino a 10 secondi per il download PDF',
    pdfPassword: 'Password: il tuo username',
    newContentAvailable: 'Nuovo contenuto disponibile!',
    pageWillRefresh: 'La pagina si aggiornerà in 5 secondi...',
    refreshNow: 'Aggiorna Ora',
    multiLanguage: 'Multilingue',
    
    // Playlist Analyzer
    playlistAnalyzerTitle: 'Playlist Performance Analyzer',
    uploadCSV: 'Carica CSV',
    selectCSV: 'Seleziona CSV',
    changeFile: 'Cambia',
    loadingFile: 'Caricamento...',
    tracksLoaded: 'Tracce caricate',
    radioFormat: 'Formato Radio',
    formatAffectsWeights: 'Il formato influenza i pesi e i moltiplicatori di epoca',
    step1SelectFormat: 'Passo 1: Seleziona Formato → Passo 2: Carica CSV',
    selectFormatFirst: 'Seleziona prima il formato radio corretto e poi carica il file CSV.',
    startAnalysis: 'Inizia Analisi',
    analyzing: 'Analisi in corso...',
    analysisComplete: 'Analisi completata!',
    analysisError: 'Errore analisi',
    networkError: 'Errore di connessione. Riprova.',
    exportToPDF: 'Esporta PDF',
    creatingPDF: 'Creazione PDF...',
    pdfCreated: 'PDF creato!',
    errorDownloadingPDF: 'Errore durante il download del PDF',
    passwordToOpen: 'Password: il tuo username',
    tracksAndDecisions: 'Tracce & Decisioni',
    genres: 'Generi',
    decades: 'Decenni',
    searchArtistTitle: 'Cerca Artista o Titolo...',
    clear: 'Cancella',
    tracks: 'tracce',
    instructions: 'Istruzioni',
    csvFileStructure: 'Struttura File CSV',
    csvMustContain: 'Il file CSV deve contenere le seguenti colonne.',
    artistName: 'Nome artista',
    trackTitle: 'Titolo traccia',
    frequency: 'Frequenza',
    performances: 'Performance',
    columnExplanation: 'Spiegazione Colonne',
    missingColumns: 'E se mancano colonne?',
    scoringProcess: 'Processo di Valutazione',
    whatDataMeans: 'Cosa significano i dati',
    radioFormatsAdjustments: 'Formati Radio & Regolazioni',
    decisionLabels: 'Etichette Decisione',
    
    // Daypart Analyzer specific
    daypartAnalyzerTitle: 'Analizzatore Performance Daypart',
    usageInstructions: 'Istruzioni d\'Uso',
    daypartIntro: 'Il Daypart Analyzer analizza le performance della playlist per fascia oraria.',
    csvUpload: 'Caricamento File CSV',
    csvMustContainFields: 'Il CSV deve contenere le seguenti colonne:',
    csvFlexibleFormat: 'Colonne richieste:',
    csvOptional: 'opzionale',
    csvColumnOrderNote: 'L\'ordine delle colonne non conta. Vengono riconosciuti vari nomi (es. Artist, Performer, Artista)',
    allFieldsRequired: 'Tutti i campi sono obbligatori per risultati accurati',
    selectRadioFormat: 'Seleziona Formato Radio',
    selectYourFormat: 'Seleziona il formato della tua stazione:',
    timeZones: 'Fasce Orarie (Dayparts)',
    evaluationCategories: 'Categorie di Valutazione',
    powerDesc: 'Top tracce - riproduci spesso!',
    secondaryDesc: 'Seconda linea - buone performance',
    currentsDesc: 'Hit attuali - buon flusso',
    spreadMoreDesc: 'Aumenta frequenza',
    slowDownDesc: 'Diminuisci frequenza',
    sleeperDesc: 'Basse performance - monitora',
    cutDesc: 'Candidato per rimozione',
    csvFormat: 'Formato CSV',
    daypartHowItWorks: 'Come funziona',
    daypartHowItWorksDesc: 'Il Daypart Analyzer analizza le performance per fascia oraria (Morning, Drive, Night, Overnight). Basandosi su TLH e Listeners, calcola punteggi e suggerisce decisioni (POWER, SECONDARY, CURRENTS, ecc.).',
    genreDecadeAnalysis: 'Analisi Genere & Decennio',
    eachDaypartShows: 'Ogni daypart mostra anche:',
    requiresAdminEnrichment: 'Richiede arricchimento database da Admin',
    exportResults: 'Esporta Risultati',
    afterAnalysisExport: 'Dopo l\'analisi, puoi esportare in:',
    tips: 'Suggerimenti',
    tip1: 'Usa almeno una settimana di dati per migliori risultati',
    tip2: 'Regola i pesi per daypart nelle impostazioni',
    tip3: 'Controlla l\'analisi GOLD per le tracce "dorate"',
    gotItLetsStart: 'Capito, iniziamo!',
    
    // Radio Top Songs
    radioTopSongsTitle: 'Top Radio Songs',
    weeklyChart: 'Classifica Settimanale',
    position: 'Posizione',
    artist: 'Artista',
    title: 'Titolo',
    lastWeek: 'Settimana Scorsa',
    weeksOnChart: 'Settimane',
    chartInfo: 'Info Classifica',
    uploadNewChart: 'Carica Nuova Classifica',
    noChartData: 'Nessun dato classifica disponibile',
    allSongs: 'Tutti',
    greekSongs: 'Greco',
    internationalSongs: 'Internazionale',
    totalSongs: 'Canzoni Totali',
    source: 'Fonte',
    searchSongsArtists: 'Cerca canzoni e artisti • Vedi classifiche storiche',
    browseChartsByWeek: 'Sfoglia le classifiche per settimana e mese dell\'anno',
    discoverMore: 'Scopri di più',
    searchSongArtist: 'Cerca canzone o artista...',
    display: 'Mostra',
    saveCurrentChart: 'Salva Classifica Attuale',
    noChartDataForWeek: 'Nessun dato trovato per la settimana selezionata. Caricamento classifica attuale...',
    
    // Maintenance/Loading Screen
    preparingForYou: 'Stiamo preparando tutto per te!',
    remainingTime: 'Tempo rimanente',
    ready: 'Pronto!',
    pageWillRefreshAuto: 'La pagina si aggiornerà automaticamente tra pochi secondi...',
    completed: 'completato',
    contentBeingCreated: 'Il tuo contenuto radio è in fase di creazione. Attendere...',
    whatsHappening: 'Cosa sta succedendo?',
    systemCreatingContent: 'Il sistema sta creando contenuti radio freschi e professionali',
    estimatedDuration: 'Durata stimata',
    minutes: 'minuti',
    pageRefreshAuto: 'La pagina si aggiornerà automaticamente al completamento',
    tipKeepTabOpen: 'Suggerimento: Tieni questa scheda aperta - l\'aggiornamento avverrà automaticamente',
    
    // Pricing Page
    features: 'Funzionalità',
    price: 'Prezzo',
    perMonth: '/mese',
    perYear: '/anno',
    currentPackage: 'Pacchetto Attuale',
    select: 'Seleziona',
    pleaseWait: 'Attendere...',
    faq: 'Domande Frequenti',
    canChangePackage: 'Posso cambiare pacchetto?',
    canChangePackageAnswer: 'Sì, puoi fare upgrade o downgrade del tuo pacchetto in qualsiasi momento. La differenza verrà aggiunta o sottratta dalla prossima fatturazione.',
    paymentMethods: 'Quali metodi di pagamento sono supportati?',
    paymentMethodsAnswer: 'Accettiamo tutte le carte di credito/debito (Visa, Mastercard, American Express) tramite la piattaforma sicura Stripe.',
    hasTrial: 'C\'è un periodo di prova?',
    hasTrialAnswer: 'Sì! Tutti i nuovi utenti hanno accesso gratuito per 24 ore a tutte le funzionalità.',
    paymentCancelled: 'Pagamento annullato',
    checkEmailConfirmation: 'Controlla la tua email per la conferma del pagamento',
    paymentSuccess: 'Pagamento completato con successo!',
    sessionExpired: 'Sessione di pagamento scaduta',
    pleaseLoginFirst: 'Effettua prima il login',
    chargeForUpgrade: 'Addebito €{amount} per upgrade',
    errorCreatingPayment: 'Errore durante la creazione del pagamento',
    errorLoadingPackages: 'Errore caricamento pacchetti',
    
    // Soft Locks / Feature Gate
    lockedFeature: 'Funzionalità Bloccata',
    upgradeForAccess: 'Upgrade per Accesso',
    orTryFree24h: 'Oppure prova gratis per 24 ore',
    upgradeForAccessFeature: 'Fai upgrade del tuo pacchetto per accedere a questa funzionalità.',
    
    // Feature Info (locked cards)
    categoriesOnAirTitle: 'Categorie Temi On Air',
    categoriesOnAirDesc: '9 categorie di contenuti freschi - Mattina, Giorno, Pomeriggio, Sera, Weekend, Oroscopi, News, Entertainment, Charts. Nuovo ogni giorno!',
    campaignAnalyzerTitleLong: 'Analizzatore Campagne',
    campaignAnalyzerDescLong: 'Calcola le performance delle tue campagne pubblicitarie. Visualizza reach, frequency, GRP e ricavi stimati.',
    listenerCalculatorTitleLong: 'Calcolatore Ascoltatori',
    listenerCalculatorDescLong: 'Calcola il pubblico reale della tua stazione. Stime ascoltatori per zona e giorno.',
    radioTopSongsTitleLong: 'Radio Top Songs',
    radioTopSongsDescLong: 'Trova le migliori canzoni per la tua stazione. Classifiche greche e internazionali con suggerimenti smart.',
    playlistAnalyzerTitleLong: 'Playlist Analyzer',
    playlistAnalyzerDescLong: 'Analizza la tua playlist per decenni, generi e performance. Valutazione canzoni POWER/SLEEPER.',
    daypartAnalyzerTitleLong: 'Daypart Analyzer',
    daypartAnalyzerDescLong: 'Analizza le performance della playlist per fascia oraria. Distribuzione Genre & Decennio.',
    monthlySupportTitle: 'Supporto Mensile',
    monthlySupportDesc: 'Supporto tecnico via email e chat con risposta entro 24 ore.',
    prioritySupportTitle: 'Supporto Prioritario',
    prioritySupportDesc: 'Supporto tecnico immediato con priorità. Risposta entro 4 ore.',
    
    // Access Banner
    adminFullAccess: 'Admin - Accesso Completo',
    trialPeriod: 'Periodo di Prova',
    hoursRemaining: 'rimanenti',
    freeAccess: 'Accesso Gratuito',
    subscriber: 'Abbonato',
    subscriptionExpired: 'Il tuo abbonamento è scaduto',
    noActiveSubscription: 'Nessun abbonamento attivo',
    
    // Help Modals
    helpGuide: 'Guida',
    helpInstructions: 'Istruzioni',
    howItWorks: 'Come funziona',
    helpListenerCalculator: 'Guida Calcolatore Ascoltatori',
    helpPlaylistAnalyzer: 'Guida Playlist Analyzer',
    helpDaypartAnalyzer: 'Guida Daypart Analyzer',
    
    // Listener Calculator Page
    listenerCalcTitle: 'Calcolatore Ascoltatori',
    listenerCalcDesc: 'Strumento per stimare il pubblico reale',
    whatIsCalculator: 'Cos\'è il Calcolatore?',
    listenerCalcGuide: 'Guida Calcolatore Ascoltatori',
    listenerCalcWhat: 'Cos\'è il Calcolatore Ascoltatori e cosa fa',
    listenerCalcWhatDesc: 'Il Calcolatore Ascoltatori è uno strumento per stimare il pubblico reale dello streaming per:',
    listenerCalcItems: 'Giorno,Daypart (fascia oraria),Settimana,Combinazione di giorni e dayparts',
    listenerCalcNote: 'Non misura semplicemente le connessioni grezze.',
    listenerCalcStatistical: 'Usa la proiezione statistica per calcolare da un campione di ascoltatori:',
    listenerCalcMetrics: 'Percentuale di ascolto,Numero stimato di ascoltatori reali,Intervallo di confidenza 95%,Trend settimanale',
    listenerCalcTool: 'Questo trasforma i dati dello streaming da "numeri" a strumento decisionale.',
    streamingAnalyticsTitle: 'Analizzatore Dati Streaming',
    streamingAnalyticsDesc: 'Carica CSV dal tuo provider di streaming per analisi dettagliata del pubblico',
    listenerCalcAnalysis: 'Analisi e spiegazione degli indicatori',
    sampleTitle: 'Campione',
    sampleDesc: 'Il numero di utenti registrati (es. ascoltatori, sessioni, risposte al sondaggio).',
    sampleTip: 'Maggiore è il campione, maggiore è la precisione.',
    positiveTitle: 'Positivo',
    positiveDesc: 'Il numero di utenti che soddisfano il criterio.',
    positiveTip: 'Filtra i "clic casuali" dagli ascoltatori reali.',
    populationTitle: 'Popolazione',
    populationDesc: 'Stima totale della popolazione potenziale.',
    populationTip: 'Usato per convertire la percentuale in numero effettivo di ascoltatori.',
    percentageTitle: 'Percentuale (%)',
    percentageDesc: 'Positivo / Campione',
    percentageTip: 'Mostra quanto è forte ogni daypart rispetto al totale.',
    estimatedListenersTitle: 'Ascoltatori Stimati',
    estimatedListenersDesc: 'Percentuale × Popolazione',
    estimatedListenersTip: 'L\'indicatore più critico: Quante persone ascoltano realmente la stazione in questa zona.',
    ciTitle: 'IC 95% (Intervallo di Confidenza)',
    ciDesc: 'Intervallo di affidabilità statistica. Esempio: 18% – 22%',
    ciTip: 'Significa che con il 95% di certezza, il pubblico reale è entro questo intervallo.',
    fpcTitle: 'FPC – Correzione Popolazione Finita',
    fpcDesc: 'Usato quando il campione è grande e la popolazione è finita.',
    fpcTip: 'Migliora drasticamente la precisione dei risultati.',
    trendTitle: 'Trend Settimanale (Grafico)',
    trendDesc: 'Mostra l\'evoluzione del pubblico per giorno, cali e aumenti.',
    trendTip: 'Identifica quando qualcosa NON funziona.',
    howHelpsTitle: 'Come aiuta una stazione radio',
    costReduction: 'Riduzione Costi',
    costReductionItems: 'Identificare daypart a basse prestazioni,Ridurre spese inutili,Cambiamenti mirati invece di investimenti generali',
    audienceIncrease: 'Aumento Pubblico',
    audienceIncreaseItems: 'Ottimizzare playlist per zona,Adattare contenuti per ora,Rafforzare daypart forti,Correggere quelli deboli prima di perdere pubblico',
    playlistAdaptation: 'Adattamento Playlist e Contenuti',
    playlistAdaptationItems: 'Flusso musicale diverso al mattino,Diverso durante drive time,Diverso di notte',
    playlistAdaptationNote: 'Il calcolatore mostra dove l\'ascoltatore si stanca.',
    proDataTitle: 'Dati professionali per inserzionisti',
    proDataItems: 'Prova di prestazioni per ora,Numeri affidabili,Argomenti per tariffe migliori',
    understoodClose: 'Capito, chiudi',
    
    // Campaign Calculator Page
    campaignAnalyzerPageTitle: 'Analizzatore Campagne',
    campaignAnalyzerPageDesc: 'Strumento di ottimizzazione campagne radio',
    brandCategoryLabel: 'CATEGORIA MARCA (ALFABETICO)',
    marketPositionLabel: 'POSIZIONE DI MERCATO DEL BRAND',
    radioPrimaryLabel: 'RADIO COME MEZZO PRIMARIO?',
    campaignDurationLabel: 'DURATA CAMPAGNA (SETTIMANE ATTIVE)',
    pleaseSelect: 'Seleziona',
    spotsPerDay: 'Spot al Giorno',
    adjustSpotsPerDay: 'Regola il numero di spot per ogni giorno della settimana',
    totalSpotsWeek: 'Totale Spot/Settimana',
    calculateCampaign: 'Calcola Campagna',
    weeklyGRPs: 'GRP Settimanali',
    totalGRPs: 'GRP Totali',
    estimatedReach: 'Copertura',
    avgFrequency: 'Frequenza Media',
    weeklyProgress: 'Progressi Settimanali',
    dailyDistribution: 'Distribuzione Giornaliera (Settimana 1)',
    strategicRecommendations: 'Raccomandazioni Strategiche',
    scenarioComparison: 'Confronto Scenari',
    exportPDFBtn: 'Esporta in PDF',
    pleaseWaitPDF: 'Attendere...',
    fillAllFields: 'Compila tutti i campi',
    calculateFirst: 'Prima clicca "Calcola"',
    waitForPDFGen: 'Attendere fino a 10 secondi per la generazione del file...',
    pleaseWait: 'Attendere...',
    exportCompleted: 'Esportazione completata!',
    exportError: 'Errore nell\'esportazione PDF',
    // Day names
    monday: 'Lunedì',
    tuesday: 'Martedì',
    wednesday: 'Mercoledì',
    thursday: 'Giovedì',
    friday: 'Venerdì',
    saturday: 'Sabato',
    sunday: 'Domenica',
    // Brand categories
    foodDrinks: 'Cibo & Bevande',
    technology: 'Tecnologia',
    fashionBeauty: 'Moda & Bellezza',
    automobiles: 'Automobili',
    services: 'Servizi',
    retail: 'Vendita al Dettaglio',
    // Market positions
    marketLeader: 'Leader di Mercato',
    challenger: 'Sfidante',
    newEntry: 'Nuovo Ingresso',
    // Campaign durations
    weeks2: '2 settimane',
    weeks4: '4 settimane',
    weeks8: '8 settimane',
    weeks12: '12 settimane',
    weekLabel: 'Settimana',
    weekFull: 'Settimana',
    historicalData: 'Dati Storici',
    showMore: 'Mostra di più',
    noResultsFor: 'Nessun risultato trovato per',
    chartSavedSuccess: 'Classifica salvata con successo!',
    year: 'Anno',
    songsCount: 'Canzoni',
    noDataToSave: 'Nessun dato da salvare',
    adminOnlyFeature: 'Devi essere loggato come admin',
    adminOnlySaveChart: 'Solo gli admin possono salvare le classifiche',
    saveFailed: 'Salvataggio fallito. Riprova.',
    spots: 'spot',
    totalSpots: 'Spot Totali',
    
    // Admin Section
    adminDbEnrichment: 'Admin: Arricchimento Database Canzoni',
    songsInDb: 'canzoni',
    artistsInDb: 'artisti',
    songsWithYear: 'con anno',
    uploadCsvInstructions: 'Carica CSV con colonne: Artist, Title, Year (opzionale: Genre)',
    importInProgress: 'Importazione in corso...',
    addSongs: 'Aggiungi Canzoni',
    
    // Contact Form
    contactTitle: 'Contatto',
    contactDesc: 'Compila il modulo per contattarci',
    firstName: 'Nome',
    lastName: 'Cognome',
    stationName: 'Nome Stazione',
    region: 'Regione',
    phone: 'Telefono',
    email: 'Email',
    message: 'Messaggio',
    attachFile: 'Allega file',
    sendMessage: 'Invia Messaggio',
    sending: 'Invio...',
    messageSent: 'Il tuo messaggio è stato inviato con successo!',
    messageError: 'Errore nell\'invio del messaggio',
    requiredField: 'Questo campo è obbligatorio',
    invalidEmail: 'Inserisci un\'email valida',
    invalidPhone: 'Inserisci un numero di telefono valido',
    selectRegion: 'Seleziona regione',
    contactInfo: 'Informazioni di Contatto',
    nameRequired: 'Il nome è obbligatorio',
    lastNameRequired: 'Il cognome è obbligatorio',
    enterRealName: 'Inserisci il tuo vero nome',
    enterRealLastName: 'Inserisci il tuo vero cognome',
    minChars: 'Deve avere almeno 2 caratteri',
    enterValidName: 'Inserisci un nome valido',
    stationRequired: 'Il nome della stazione è obbligatorio',
    regionRequired: 'La regione è obbligatoria',
    phoneRequired: 'Il telefono è obbligatorio',
    emailRequired: 'L\'email è obbligatoria',
    businessEmailRequired: 'Usa un\'email aziendale',
    messageRequired: 'Il messaggio è obbligatorio',
    minMessageLength: 'Il messaggio deve avere almeno 10 caratteri',
    fileTooLarge: 'File troppo grande (max 5MB)',
    invalidFileType: 'Tipo di file non valido',
    regionCyprus: 'Cipro',
    regionAttica: 'Attica',
    regionThessaloniki: 'Salonicco',
    regionCentralMacedonia: 'Macedonia Centrale',
    regionWestMacedonia: 'Macedonia Occidentale',
    regionEastMacedoniaThrace: 'Macedonia Orientale e Tracia',
    regionEpirus: 'Epiro',
    regionThessaly: 'Tessaglia',
    regionIonianIslands: 'Isole Ionie',
    regionWestGreece: 'Grecia Occidentale',
    regionCentralGreece: 'Grecia Centrale',
    regionPeloponnese: 'Peloponneso',
    regionNorthAegean: 'Egeo Settentrionale',
    regionSouthAegean: 'Egeo Meridionale',
    regionCrete: 'Creta',
    
    // Our Stations
    ourStationsTitle: 'Le Nostre Stazioni',
    ourStationsDesc: 'Stazioni demo con vari formati musicali per creare playlist per stazioni radio e attività In-Store.',
    listenLive: 'Ascolta dal Vivo',
    visitWebsite: 'Visita Sito Web',
    
    // Campaign Analyzer Form
    brandCategoryLabel: 'CATEGORIA BRAND (ALFABETICO)',
    marketPositionLabel: 'POSIZIONE DEL BRAND NEL MERCATO',
    radioPrimaryLabel: 'RADIO COME MEZZO PRIMARIO?',
    campaignDurationLabel: 'DURATA CAMPAGNA (SETTIMANE ATTIVE)',
    foodDrinks: 'Cibo & Bevande',
    technology: 'Tecnologia',
    fashionBeauty: 'Moda & Bellezza',
    automobiles: 'Automobili',
    services: 'Servizi',
    retail: 'Vendita al Dettaglio',
    marketLeader: 'Leader di Mercato',
    challenger: 'Sfidante',
    newEntry: 'Nuovo Ingresso',
    weeks2: '2 settimane',
    weeks4: '4 settimane',
    weeks8: '8 settimane',
    weeks12: '12 settimane',
    spotsPerDay: 'Spot al Giorno',
    weeklyGRPs: 'GRP Settimanali',
    totalGRPs: 'GRP Totali',
    estimatedReach: 'Copertura Stimata',
    avgFrequency: 'Frequenza Media',
    weeklyProgress: 'Progresso Settimanale',
    fillAllFields: 'Compila tutti i campi',
    calculateFirst: 'Prima clicca su "Calcola"',
    waitForPDFGen: 'Attendi fino a 10 secondi per la generazione del PDF...',
    pleaseWait: 'Attendere prego...',
    exportCompleted: 'Esportazione completata!',
    exportError: 'Errore durante l\'esportazione PDF',
    // Day names
    monday: 'Lunedì',
    tuesday: 'Martedì',
    wednesday: 'Mercoledì',
    thursday: 'Giovedì',
    friday: 'Venerdì',
    saturday: 'Sabato',
    sunday: 'Domenica',
    scenarioComparison: 'Confronto Scenari',
    lessSpots: 'Meno Spot (-30%)',
    currentStrategy: 'Strategia Attuale',
    shorterDuration: 'Durata Più Breve (-2 sett.)',
    lower: 'Inferiore',
    optimal: 'Ottimale',
    medium: 'Medio',
    scenario: 'Scenario',
    efficiency: 'Efficienza',
    yourCampaign: 'La Tua Campagna',
    calculateCampaign: 'Calcola Campagna',
    freqInsufficient: 'Insufficiente',
    freqVeryLow: 'Molto bassa',
    freqIdeal: 'IDEALE - buona awareness',
    freqVeryGood: 'Molto buona - forte ricordo',
    freqHigh: 'Alta - buona ma attenzione ai costi',
    freqTooHigh: 'Troppo alta - rischio "ad fatigue"',
    grpLevels: 'Livelli GRP (Gross Rating Points)',
    grpVeryLow: 'Molto bassi - copertura insufficiente',
    grpLow: 'Bassi - impatto minimo sul mercato',
    grpGood: 'Buoni - awareness iniziale, adatti per mantenimento',
    grpVeryGood: 'Molto buoni - presenza forte, campagna efficace',
    grpHigh: 'Alti - dominanza di categoria',
    grpVeryHigh: 'Molto alti - copertura massima, attenzione alla saturazione',
    recommendations: 'Raccomandazioni & Miglioramenti',
    totalSpots: 'Spot Totali',
    criticalLowFreq: 'CRITICO: Frequenza Molto Bassa',
    criticalLowFreqMsgDynamic: 'La frequenza attuale ({freq}) è insufficiente. Il messaggio non resterà nella memoria del pubblico.',
    recIncreaseSpotsTo: 'Aumento consigliato a {newWeeklySpots} spot/settimana ({extraSpots} spot extra) per raggiungere Frequenza {targetFreq} e {newGRPs} GRP.',
    warningHighFreq: 'Attenzione: Frequenza Molto Alta',
    warningHighFreqMsgDynamic: 'La frequenza ({freq}) è troppo alta. Rischio di "ad fatigue" e spreco budget.',
    recReduceSpotsTo: 'Puoi ridurre a {newWeeklySpots} spot/settimana e risparmiare mantenendo Frequenza {targetFreq}.',
    suggestionIncrease: 'Suggerimento: Aumenta Efficacia',
    suggestionIncreaseMsgDynamic: 'I tuoi GRP ({grps}) sono sotto il livello ideale (400+). Per migliori prestazioni:',
    recOptionsAB: '• OPZIONE A: Aumenta la durata a {option1_weeks} settimane → ~{option1_newGRPs} GRP\n• OPZIONE B: Aggiungi {option2_spotsIncrease} spot/sett ({option2_newWeeklySpots} totali) → ~{option2_newGRPs} GRP',
    excellentGRPs: 'GRP Eccellenti',
    excellentGRPsMsgDynamic: 'I tuoi GRP ({grps}) sono eccellenti! Copertura massima.',
    recWatchSaturation: 'Attenzione alla saturazione del pubblico. Puoi mantenere i livelli attuali o ridurre leggermente.',
    optimalCampaign: 'Campagna Ottimale!',
    optimalCampaignMsgDynamic: 'I tuoi GRP ({grps}) e la Frequenza ({freq}) sono nel range ideale.',
    recWellDesigned: 'La tua campagna è ben progettata e avrà performance efficace. Continua così!',
    strongCampaign: 'Campagna Molto Forte!',
    strongCampaignMsgDynamic: 'I tuoi GRP ({grps}) sono alti. Dominerai la tua categoria.',
    recExcellentStrategy: 'Strategia eccellente per brand awareness e dominanza di mercato!',
    perfectCampaign: 'Campagna Perfetta!',
    perfectCampaignMsg: 'Tutte le tue metriche sono ai livelli ottimali.',
    recBestBalance: 'La tua campagna ha il miglior rapporto costo-performance!',
    
    // Decision explanations
    decContinue: 'CONTINUA - Gli ascoltatori lo adorano!',
    decMaintain: 'MANTIENI - Gli ascoltatori rimangono sintonizzati',
    decMaintainGood: 'MANTIENI - Buona accettazione degli ascoltatori',
    decReduce: 'RIDUCI - Meno riproduzioni a settimana',
    decRemove: 'RIMUOVI - Gli ascoltatori cambiano stazione!',
    decTired: 'Gli ascoltatori ne sono stanchi! RIDUCI LA FREQUENZA!',
    decSecondLine: 'SECONDA LINEA - Non selezionare in fasce orarie prime',
    decLessPerDay: 'MENO RIPRODUZIONI AL GIORNO',
    // Explanation translations for track results - ITALIAN
    decContinueAction: 'CONTINUA',
    decMaintainAction: 'MANTIENI',
    decReduceAction: 'RIDUCI',
    decRemoveAction: 'RIMUOVI',
    decIncreaseAction: 'AUMENTA',
    decReduceImmediately: 'RIDUCI IMMEDIATAMENTE',
    decListenersLoveIt: 'Gli ascoltatori lo adorano',
    decListenersStay: 'Gli ascoltatori rimangono sintonizzati',
    decGoodAcceptance: 'Buona accettazione degli ascoltatori',
    decReduceFrequency: 'Riduci la frequenza',
    decFewerPlaysWeek: 'Meno riproduzioni/settimana',
    decNoPrimeZones: 'Non selezionare in fasce orarie prime',
    decListenersSwitch: 'Gli ascoltatori cambiano stazione',
    decListenersTired: 'Gli ascoltatori ne sono stanchi',
    decSleeperDesc: 'Suona raramente ma quando suona, gli ascoltatori lo adorano',
    decExcellentPerformance: 'Prestazione eccellente',
    decTopTrack: 'Traccia top',
    decVeryGoodPerformance: 'Prestazione molto buona',
    decKeepIt: 'Tienilo',
    decStableChoice: 'Scelta stabile',
    decPlaysTooOften: 'Suona troppo spesso',
    decLowInterest: 'Basso interesse degli ascoltatori',
    decHiddenHit: 'Hit nascosto',
    decLikedButRare: 'Piaciuto ma suona raramente',
    decIncreasePlaybacks: 'Aumenta le riproduzioni',
    decReduceSignificantly: 'Riduci significativamente la frequenza',
    decContinueStrategy: 'Continua con la strategia attuale',
    decNewRelease: 'Nuova uscita',
    decDoesntFitFormat: 'non si adatta al formato',
    decBetterInOtherFormat: 'Andrebbe meglio in un altro formato',
    
    // Analysis Summary
    analysisSummary: 'Riepilogo Analisi',
    totalRecords: 'Totale Record',
    uniqueTracks: 'Tracce Uniche',
    period: 'Periodo',
    daypartDistribution: 'Distribuzione Daypart',
    musicFormat: 'Formato Musicale',
    analyzingTracks: 'Analisi tracce con formato',
    mediumFileWarning: '~20-30 secondi',
    largeFileWarning: 'file grande - potrebbe richiedere ~30-60 secondi',
    analysisTimeout: 'Analisi troppo lunga (>5 minuti). Prova con un CSV più piccolo.',
    analysisRetrying: 'L\'analisi richiede più tempo... Nuovo tentativo',
    analysisLargeFileFailed: 'File grande fallito dopo più tentativi. Prova a dividere il CSV in parti più piccole.',
    
    // SongInfo
    songInfoTitle: 'Informazioni Canzoni',
    songInfoDesc: 'Cerca informazioni e suggerimenti per annunci radiofonici',
    artistLabel: 'Artista',
    titleLabel: 'Titolo',
    searchSongInfo: 'Cerca Informazioni',
    searching: 'Ricerca...',
    tipLatinChars: 'Usa caratteri latini per risultati migliori',
    radioAnnouncement: 'Suggerimento Annuncio',
    announcementTip: 'Usa questo testo come guida per presentare la canzone',
    fillArtistTitle: 'Per favore inserisci Artista e Titolo',
    fillArtistTitleSearch: 'Inserisci Artista e Titolo per la ricerca',
    infoFound: 'Informazioni trovate!',
    searchError: 'Errore di ricerca. Riprova.',
    exampleArtist: 'es. Ed Sheeran',
    exampleTitle: 'es. Shape of You',
    
    // DaypartAnalyzer & Gold Analysis
    specialAnalysisForTracks: 'Analisi speciale per tracce',
    withAvailableYear: 'con anno disponibile',
    recommendations: 'Raccomandazioni',
    goldHitDesc: 'Top gold - Mantieni in rotazione',
    goldKeeperDesc: 'Di valore - Continua normalmente',
    goldRotateDesc: 'Prestazione OK - Rotazione normale',
    goldRestDesc: 'Stanche - Pausa 1-2 mesi',
    goldDropDesc: 'Bassa prestazione - Sostituisci',
    
    // Playlist Help Modal keys
    helpCsvStructure: 'Struttura File CSV',
    helpCsvMustContain: 'Il file CSV deve contenere le seguenti colonne:',
    helpColumnExplanation: 'Spiegazione Colonne:',
    helpArtistName: 'Nome artista (obbligatorio)',
    helpTrackTitle: 'Titolo traccia (obbligatorio)',
    helpFrequency: 'Frequenza di riproduzione (numero)',
    helpPerformances: 'Performance totali (numero)',
    helpTLH: 'Total Listening Hours (numero decimale)',
    helpMissingColumns: 'Cosa succede se mancano colonne?',
    helpMissingArtistTitle: 'La traccia NON verrà inclusa nell\'analisi',
    helpMissingNumeric: 'Verrà trattato come 0 (zero)',
    helpAllNumericMissing: 'Il punteggio sarà 0 - la traccia apparirà come "CUT"',
    helpTip: 'Suggerimento: Per un\'analisi accurata, assicurati che tutte le colonne abbiano valori. TLH è particolarmente importante!',
    helpScoringProcess: 'Processo di Valutazione (9 Passaggi)',
    helpStep1: 'Normalizzazione (0-1) - Converti valori in scala 0-1',
    helpStep2: 'Pesi Base - TLH 55%, Performance 30%, Frequenza 15%',
    helpStep3: 'Adattamento Formato - Pesi basati sul tipo di radio',
    helpStep4: 'Moltiplicatore Epoca - Bonus per tracce che si adattano al formato',
    helpStep5: 'Bonus Nuova Uscita - +10% per tracce ≤90 giorni',
    helpStep6: 'Penalità Rotazione - Riduzione per frequenza eccessiva',
    helpStep7: 'Penalità Rifiuto - Riduzione se gli ascoltatori cambiano',
    helpStep8: 'Penalità Stanchezza - Riduzione quando TLH scende',
    helpStep9: 'Punteggio Finale - Scala 0-100',
    helpDataMeaning: 'Cosa significano i dati',
    helpTLHDesc: 'Tempo totale che gli ascoltatori trascorrono sulla traccia. TLH alto = molto popolare!',
    helpPerformancesDesc: 'Quante volte la traccia è stata riprodotta nel programma',
    helpFrequencyDesc: 'Con che frequenza viene riprodotta (volte al giorno o settimana)',
    helpYearDesc: 'Anno di uscita (da MusicBrainz/Discogs)',
    helpGenreDesc: 'Genere musicale (Pop, Rock, Folk, ecc.)',
    helpRadioFormats: 'Formati Radio & Adattamenti',
    helpFormatIntro: 'Ogni formato pesa i dati in modo diverso:',
    helpDecisionLabels: 'Etichette Decisione Principali (BASATO SUL RANKING)',
    helpDecisionIntro: 'Basato sulla posizione in classifica, non sul punteggio assoluto:',
    helpStrictMode: 'Modalità STRETTA (HOT AC, GHR, Greek Mainstream): 62.5% attivi, 37.5% CUT',
    helpRelaxedMode: 'Modalità RILASSATA (GOLD, AC): 57% attivi, 43% CUT',
    helpPowerLabel: 'Top 2-2.5%',
    helpSecondaryLabel: 'Successivi 4-5%',
    helpCurrentsLabel: 'Successivi 8-10%',
    helpSpreadMoreLabel: 'Successivi 16-17.5%',
    helpSlowDownLabel: 'Successivi 24-27.5%',
    helpRiskLabel: 'Successivi 37.5-46%',
    helpCutLabel: 'Rimanenti (37.5-43%)',
    helpGotIt: 'Capito, iniziamo!',
    
    // Help Modal - Special Labels
    helpSpecialLabels: 'Etichette Speciali',
    helpSpecialLabelsIntro: 'Basato sulla relazione Frequenza & TLH:',
    helpSleeperTitle: 'Diamante Nascosto',
    helpSleeperCriteria: 'Criteri: Bassa frequenza (<35%) + Alto TLH (≥55%)',
    helpSleeperAction: 'Suona raramente ma quando suona, gli ascoltatori lo adorano! AUMENTALO!',
    helpOverplayedTitle: 'Troppo Suonato',
    helpOverplayedCriteria: 'Criteri: Alta frequenza (≥65%) + Basso TLH (<45%)',
    helpOverplayedAction: 'Gli ascoltatori ne sono stanchi! RIDUCI LA FREQUENZA!',
    helpCsvFormat: 'Formato File CSV',
    helpCsvFormatDesc: 'Il file CSV deve contenere queste colonne:',
    helpCsvExample: 'Esempio:',
    helpCsvStructureIntro: 'Il file CSV deve contenere le seguenti colonne. I nomi delle colonne possono essere maiuscoli o minuscoli.',
    
    // Compare Stations Page
    compareStationsTitle: 'Confronta Stazioni Radio',
    compareStationsSubtitle: 'Confronto prestazioni stazioni',
    compareStationsDesc: 'Confronta come due stazioni radio si comportano con la stessa musica, in base alla reazione del pubblico.',
    selectStation: 'Seleziona stazione',
    noStationsAvailable: 'Nessuna stazione disponibile',
    selectTwoStations: 'Seleziona due stazioni diverse per iniziare il confronto.',
    compareButton: 'Confronta Stazioni',
    comparing: 'Confronto in corso...',
    noCommonSongs: 'Nessun brano in comune trovato tra le due stazioni.',
    noUniqueSongs: 'Nessun brano unico.',
    playlistsCompletelyDifferent: 'Le playlist sono completamente diverse.',
    songs: 'brani',
    plays: 'plays',
    commonSongsPerformance: 'Prestazioni Brani in Comune',
    playlistDifferentiation: 'Differenziazione Playlist',
    uniqueTo: 'Unico per',
    daypartBreakdown: 'Analisi per Fascia Oraria',
    daypartListenerReaction: 'Reazione ascoltatori per fascia oraria',
    aggregateMetricsNote: 'Le metriche sopra sono aggregate per stazione. Non c\'è classifica o "vincitore".',
    clickForDaypart: 'Clicca su un brano per vedere l\'analisi per fascia oraria',
    stationComparisonDisclaimer: 'Confronta stazioni tra loro — non brani all\'interno di una stazione. Non vengono utilizzate etichette di classifica (POWER, GOLD, ecc.).',
    noAccessCompare: 'Non hai accesso al confronto stazioni',
    whatIsCompareStations: 'Cos\'è Compare Stations',
    compareStationsDescP1: 'Lo strumento Compare Stations ti permette di confrontare come due stazioni radio si comportano con il loro pubblico nello stesso periodo.',
    compareStationsDescP2: 'Il confronto si basa su metriche di reazione degli ascoltatori — non solo trasmissioni radio — e utilizza identità unificate dei brani per evitare duplicati o risultati inconsistenti.',
    selectStationsAndPeriod: 'Seleziona Stazioni & Periodo',
    timePeriod: 'Periodo',
    contactForAccess: 'Per ottenere accesso al confronto stazioni, contattaci.',
    contact: 'Contatto',
    previousWeek: 'Settimana Precedente',
    last7Days: 'Ultimi 7 Giorni',
    last14Days: 'Ultimi 14 Giorni',
    last30Days: 'Ultimi 30 Giorni',
    thisMonth: 'Questo Mese',
    lastMonth: 'Mese Scorso',
    
    // Radio Chart
    radioChartTitle: 'The People\'s Chart',
    radioChartSubtitle: 'I brani che gli ascoltatori ascoltano fino alla fine',
    noDataFound: 'Nessun dato trovato',
    noDataForPeriod: 'Nessun dato trovato per questo periodo',
    
    // Songs Analyzer
    songsAnalyzerTitle: 'Songs Analyzer',
    songsAnalyzerSubtitle: 'Analisi dettagliata brani per stazione',
    songsAnalyzerMetricsNote: 'Le metriche si basano sulla stabilità dello stream e analisi del comportamento. Non sono inclusi ascoltatori simultanei reali.',
    liveAudienceTooltip: 'Le metriche si basano su ascoltatori reali dal server di streaming della stazione.\nL\'analisi riflette la reazione reale del pubblico a ogni brano.',
    noAccessSongsAnalyzer: 'Non hai accesso',
    noDataForPeriodSongs: 'Nessun dato per il periodo selezionato',
    noDataDayparts: 'Nessun dato fascia oraria per il periodo selezionato',
    
    // Early Hit Predictor
    ehpNoResults: 'Nessuna previsione trovata',
    ehpNoSongsInCategory: 'Nessun brano nella categoria',
    ehpNoEligibleSongs: 'Al momento nessun brano soddisfa i criteri di idoneità.',

    // v2.9.203 — Plays vs Behavior Comparison
    pvbWhyDifferent: 'Perché siamo diversi',
    pvbTitlePartA: 'Conteggio Brani Semplice',
    pvbVs: 'vs',
    pvbTitlePartB: 'Comportamento Ascoltatori',
    pvbDescription: 'Il conteggio dei plays mostra solo cosa è stato trasmesso. L\'analisi del comportamento ascoltatori rivela',
    pvbWhatReallyWorks: 'ciò che funziona davvero',
    pvbDescriptionEnd: ', cosa tiene il pubblico sintonizzato e quali decisioni portano a maggiori ascolti e ricavi.',
    pvbRetentionStat: 'Aumento della permanenza ascoltatori sulla frequenza fino a',
    pvbTraditionalApproach: 'Approccio tradizionale',
    pvbSimpleSongTrackingPlays: 'Conteggio Brani Semplice (Plays)',
    pvbFullAnalysis: 'Analisi Completa',
    pvbSongAndBehavior: 'Brano + Comportamento Ascoltatori',
    pvbPlays1: 'Quante volte un brano è stato trasmesso',
    pvbPlays2: 'Solo dati di Playlist & Rotation',
    pvbPlays3: 'Nessuna visione della risposta del pubblico',
    pvbPlays4: 'Impatto sconosciuto sugli ascoltatori',
    pvbPlays5: 'Decisioni basate su supposizioni',
    pvbPlays6: 'Misura cosa è stato trasmesso',
    pvbPlays7: 'Registrazione storica',
    pvbPlays8: 'Statistiche della playlist',
    pvbPlays9: 'Non mostra perché gli ascolti salgono o scendono',
    pvbPlays10: 'Sfruttamento limitato dei dati',
    pvbBehavior1: 'Tracciamento del comportamento ascoltatori in tempo reale',
    pvbBehavior2: 'Engagement dell\'ascoltatore in ogni momento',
    pvbBehavior3: 'Misurazione di Tune-in, Engagement, Tune-out e Retention',
    pvbBehavior4: 'Analisi all\'interno del tuo formato, palinsesto, programmazione e mercato',
    pvbBehavior5: 'Decisioni data-driven basate su dati reali',
    pvbBehavior6: 'Misura cosa è piaciuto e cosa ha performato',
    pvbBehavior7: 'Insights in tempo reale',
    pvbBehavior8: 'Statistiche di pubblico e comportamento',
    pvbBehavior9: 'Identifica cosa influenza gli ascolti',
    pvbBehavior10: 'Pieno sfruttamento dei dati per la crescita dell\'emittente',
    pvbWantToKnowA: 'Vuoi sapere',
    pvbWhatReallyLiked: 'cosa piace davvero',
    pvbWantToKnowB: 'ai tuoi ascoltatori?',
    pvbContactPromo: 'Contatta Radio Solutions per una demo del nostro sistema di analisi del comportamento ascoltatori.',
    pvbRequestDemo: 'Richiedi una Demo',
    pvbTrustedByA: 'Si fidano di noi',
    pvbStations: 'stazioni',

    // v2.9.203 — Songs Analyzer common UI
    saStreamUrlSuggestion: 'Suggerisci URL Stream',
    saSongs: 'Brani',
    burnWeek: "Settimana {{from}} - {{to}} · {{n}} brani",
    burnPeriodNote: "Ultima settimana completa (lunedì-domenica)",
    burnSearch: "Cerca…",
    burnPage: "Pagina {{p}} / {{n}}",
    burnLoading: "Caricamento…",
    burnError: "Impossibile caricare i dati.",
    burnPending: "L'analisi Burn settimanale è in preparazione. Si aggiorna ogni lunedì dopo mezzanotte.",
    burnEmpty: "Nessun dato per l'ultima settimana completa.",
    burnNoAudience: "Nessun dato affidabile sugli ascoltatori per questa stazione.",
    burnAudienceWarn: "Pochi spins con misurazioni degli ascoltatori questa settimana: risultati indicativi.",
    burnColArtist: "Artista",
    burnColTitle: "Titolo",
    burnColYear: "Anno",
    burnColSpins: "Spins",
    burnCol4w: "4 sett.",
    burnColBurn: "Burn",
    burnColDelta: "Delta",
    burnColTrend: "Tendenza",
    burnColStatus: "Stato",
    burnTapHint: "Tocca un'etichetta di stato per una spiegazione.",
    burnStIncreasing: "In aumento",
    burnStStable: "Stabile",
    burnStDecreasing: "In calo",
    burnStHighExposure: "Alta esposizione",
    burnTipHighWeeks: "Al livello più alto di spins della stazione: {{n}} delle 4 settimane.",
    burnTipStationChoice: "Mostra la scelta della stazione, non la reazione degli ascoltatori.",
    burnAdvIncreasing: "La stazione lo suona sempre di più.",
    burnAdvStable: "La stazione mantiene gli stessi spins.",
    burnAdvDecreasing: "La stazione sta già riducendo gli spins.",
    burnAdvHighExposure: "Molte settimane al livello più alto: rischio di stanchezza. Se ci sono dati sugli ascoltatori, controlla Audience.",
    burnAirplayNote: "Airplay: mostra solo la scelta della stazione (spins). Non misura gli ascoltatori.",
    burnTipWeekSpins: "Questa settimana ({{from}}-{{to}}): {{spins}} spins, {{diff}}.",
    burnTipMore: "{{n}} in più della settimana scorsa",
    burnTipLess: "{{n}} in meno della settimana scorsa",
    burnTipSame: "come la settimana scorsa",
    burnTipWeekLoss: "Questa settimana ({{from}}-{{to}}): quando va in onda, se ne va il {{d}}% degli ascoltatori.",
    burnTipWeekGain: "Questa settimana ({{from}}-{{to}}): quando va in onda, gli ascoltatori crescono del {{d}}%.",
    burnSortHint: "Clicca sul titolo di una colonna per ordinare.",
    burnLegendAirplay: "Burn 0-100 = pressione di rotazione: quanti spins dà la stazione rispetto ai brani più suonati, quante settimane è rimasto al livello più alto e quanto sono calati gli spins dal picco del mese. Non misura la reazione degli ascoltatori.",
    burnLegendAudience: "Audience: Delta = variazione media degli ascoltatori mentre il brano va in onda. Verde/giallo/rosso = terzo migliore/medio/peggiore della stazione. Tendenza = confronto con le 3 settimane precedenti.",
    burnStBurning: "In burnout",
    burnStTiring: "Sta stancando",
    burnStRising: "In crescita",
    burnStSteady: "Stabile",
    burnStLosing: "Perde ascoltatori",
    burnStNeutral: "Neutro",
    burnStHolding: "Trattiene ascoltatori",
    burnTipLowSample: "Solo {{n}} su {{total}} spins avevano misurazioni degli ascoltatori.",
    burnAdvBurning: "Cosa fare: riduci gli spins o fallo riposare per un po'.",
    burnAdvTiring: "Cosa fare: non aumentare gli spins, tienilo d'occhio.",
    burnAdvRising: "Cosa fare: ha slancio e può reggere più spins.",
    burnAdvSteady: "Cosa fare: nessuna modifica.",
    burnAdvLosing: "Cosa fare: verifica la fascia oraria o riduci gli spins.",
    burnAdvNeutral: "Cosa fare: nessuna modifica immediata.",
    burnAdvHolding: "Cosa fare: funziona bene, mantienilo.",
    saBroadcasts: 'Trasmissioni',
    saTabAll: 'Totale',
    saTabPrefecture: 'Regione',
    saListenerStats: 'Statistiche Ascoltatori',
    saMoreStations: 'Vuoi accesso a più stazioni?',
    saMoreStationsDesc: 'Contattaci per aggiungere altre stazioni al tuo account.',
    saContact: 'Contatto',
    saExcel: 'Excel',
    saMetadataOnly: 'Solo metadati',
    saYesterdayFull: 'Ieri (✅ Completo)',

    // v2.9.203 — Compare Stations page
    csTitle: 'Confronta Stazioni Radio',
    csSubtitle: 'Confronto performance stazioni',
    csWhatIs: 'Cos\'è Compare Stations',
    csWhatIsP1: 'Lo strumento Compare Stations ti permette di confrontare come due stazioni radio performano con il loro pubblico nello stesso periodo.',
    csWhatIsP2: 'Il confronto si basa su metriche di reazione degli ascoltatori — non solo sulle trasmissioni — e usa identità di brano unificate per evitare duplicati o risultati incoerenti.',
    csSelectStations: 'Seleziona Stazioni & Periodo',
    csModeStation: 'Stazione vs Stazione',
    csModeGroup: 'Gruppo vs Gruppo',
    csModeCategory: 'Categoria vs Categoria',
    csCategoryA: 'Categoria A',
    csCategoryB: 'Categoria B',
    csTimePeriod: 'Periodo',
    csSelectCategory: 'Seleziona Categoria',
    csPeriod7d: '7 giorni',
    csPeriod14d: '14 giorni',
    csPeriod30d: '30 giorni',
    csCompareBtn: 'Confronta Stazioni',
    csSelectTwo: 'Seleziona due stazioni diverse per iniziare il confronto.',

    // v2.9.205 — Performance Score Section
    perfLoading: 'Caricamento…',
    perfNoData: 'Dati non ancora sufficienti',
    perfNoDataMsg: 'Raccogli un po\' più di attività e ti diremo come stai andando.',
    perfTierLocal: 'La tua area',
    perfTierFormat: 'Stesso formato nazionale',
    perfTierNational: 'Media nazionale',
    perfTierPersonal: 'Progresso personale',
    perfPeriodLabel: 'Periodo:',
    perfPeriodFull: 'Ultima settimana completa',
    perfPeriodTip: 'Per un confronto stabile si usa sempre l\'ultima settimana completata',
    perfPersonalDescA: 'Progresso personale',
    perfPersonalDescB: '— vedi la tua evoluzione settimana per settimana.',
    perfCompareNationalA: 'Confronto con la',
    perfCompareNationalB: 'media nazionale',
    perfCompareNationalC: 'di tutte le stazioni sulla piattaforma.',
    perfCompareAvgA: 'Confronto con la',
    perfCompareAvgB: 'media',
    perfCompareAvgC: 'delle',
    perfActivity: 'Quanto spesso suoni',
    perfVariety: 'Varietà musicale',
    perfYou: 'Tu:',
    perfPerWeek: '/settimana',
    perfAvgNational: 'Media naz.:',
    perfAvgLocal: 'Media area:',
    perfAvgFormat: 'Media formato:',
    perfAvgGeneric: 'Media:',
    perfAvgPin: 'media',
    perfAvgTooltip: 'Media',
    perfAdvice: 'Consiglio',
    perfDow: ['Dom','Lun','Mar','Mer','Gio','Ven','Sab'],

    // v2.9.205 — Daypart Legend
    daypartMetrics: 'Metriche Daypart',
    daypartSubtitle: 'Reazione Ascoltatori per Fascia Oraria',
    daypartGuide: 'Guida',
    daypartMorning: 'Mattina',
    daypartMidday: 'Mezzogiorno',
    daypartAfternoon: 'Pomeriggio',
    daypartDrive: 'Drive Time',
    daypartEvening: 'Sera',
    daypartNight: 'Notte',
    daypartPlays: 'plays',
    daypartSongsCount: 'brani',
    daypartSearch: 'Cerca brano o artista…',
    daypartColPlays: 'Plays',
    daypartColSongs: 'Brani',
    daypartColTLH: 'TLH',
    daypartSortHint: 'Clicca sui titoli per ordinare',

    // v2.9.205 — Era Chart
    eraChartTitle: 'Era Chart',
    eraChartSubtitle: 'Distribuzione per decennio e anno. Clicca una barra per filtrare la tab "Totale".',
    eraChartPlays: 'plays',
    eraChartUnique: 'unici',
    eraChartTogglePlays: 'Plays',
    eraChartToggleVariety: 'Varietà',
    eraChartYears: 'anni',
    eraChartYear: 'anno',
    eraChartUnknownYear: 'Anno sconosciuto',
    eraChartFooterPlays: 'Indicatore: trasmissioni · Totale:',
    eraChartFooterUnique: 'Indicatore: brani unici · Totale:',

    // v2.9.205 — Playlist Chart / Top Artists / Common columns
    colArtist: 'Artista',
    colTitle: 'Titolo',
    colPlays: 'Plays',
    colAvgListeners: 'Ø Ascolt.',
    colTLH: 'TLH',
    colRetention: 'Ret%',
    colEarly: 'Early',
    colLSI: 'LSI',
    colScore: 'Score',
    colAImpact: 'A.Impact',
    colYear: 'Anno',
    colRank: 'Rango',
    topArtistsDiffSongs: 'brani diversi',
    playlistApply: 'Applica',
    playlistPrevWeek: 'Sett. prec.',
    dowShort: ['Lun','Mar','Mer','Gio','Ven','Sab','Dom'],
    // ─── i18n Batch #3 (v2.10.0+) — Songs Analyzer subcomponents ───
    i18nB3_morning_06_10: 'Mattina 06-10',
    i18nB3_midday_10_15: 'Mezzogiorno 10-15',
    i18nB3_drive_15_19: 'Pomeriggio 15-19',
    i18nB3_night_22_06: 'Notte 22-06',
    i18nB3_all_day: 'Tutto il giorno',
    i18nB3_our_avg: 'Nostra media',
    i18nB3_numbers: 'Numeri',
    i18nB3_listener_stats: 'Statistiche ascoltatori',
    i18nB3_your_audience: 'Il tuo pubblico',
    i18nB3_hour: 'Ora',
    i18nB3_listeners: 'ascoltatori',
    i18nB3_avg_short: 'med.',
    i18nB3_loyal: 'Fedele',
    i18nB3_passing: 'Di passaggio',
    i18nB3_normal: 'Normale',
    i18nB3_audience_exact: 'Dati esatti dal server della stazione',
    i18nB3_audience_estimate: 'Il server non fornisce dati completi — il valore è una stima',
    i18nB3_audience_unavailable: 'Il server della tua stazione non fornisce ancora questa informazione.',
    i18nB3_audience_renewal: 'ogni ora arriva nuovo pubblico (stima)',
    i18nB3_unknown_year: 'Anno sconosciuto',
    i18nB3_expand: 'Espandi',
    i18nB3_collapse: 'Comprimi',
    i18nB3_day_mon: 'Lun',
    i18nB3_day_tue: 'Mar',
    i18nB3_day_wed: 'Mer',
    i18nB3_day_thu: 'Gio',
    i18nB3_day_fri: 'Ven',
    i18nB3_day_sat: 'Sab',
    i18nB3_day_sun: 'Dom',
    i18nB3_next_song: 'Prossimo brano',
    i18nB3_prev_song: 'Brano precedente',
    i18nB3_genre_artistic: 'Artistica',
    i18nB3_genre_intl: 'Internazionale / Estera',
    i18nB3_genre_greek: 'Greca',
    i18nB3_genre_mixed: 'Mista',
    i18nB3_genre_rock: 'Rock',
    i18nB3_group: 'Gruppo',
    i18nB3_group_vs_group: 'Gruppo vs Gruppo',
    i18nB3_genre: 'Genere',
    i18nB3_genre_vs_genre: 'Genere vs Genere',
    i18nB3_close: 'Chiudi',
    i18nB3_select_station: 'Seleziona stazione',
    i18nB3_stations: 'Stazioni',
    i18nB3_station: 'Stazione',
    i18nB3_station_vs_station: 'Stazione vs Stazione',
    i18nB3_compare: 'Confronta',
    i18nB3_not_run_yet: 'Non ancora eseguito',
    i18nB3_start_year_search: 'Avvia ricerca anni',
    i18nB3_just_now: 'Adesso',
    i18nB3_never: 'Mai',
    i18nB3_running: 'In esecuzione...',
    i18nB3_now: 'Ora!',
    i18nB3_your_performance: 'La tua performance',
    i18nB3_export_timeline_excel: 'Esporta timeline in Excel (.xlsx)',
    i18nB3_confirmed_fp: 'Confermato da audio fingerprint',
    i18nB3_hide_gaps_hint: 'Nasconde piccoli vuoti dovuti a duration mismatch/crossfade. Default 5min.',
    i18nB3_async_analysis_in_progress: 'Analisi asincrona in corso...',
    i18nB3_upload_csv_first: 'Carica prima un file CSV',
    i18nB3_connection_error_retry: 'Errore di connessione. Riprova.',
    i18nB3_too_many_requests: 'Troppe richieste, nuovo tentativo tra 3s...',
    // ── Clock View (Programming Clocks) — added 2026-06-15
    clkView_listView: 'Lista',
    clkView_clockView: 'Orologio',
    clkView_hourFrom: 'Da',
    clkView_hourTo: 'A',
    clkView_exportPdf: 'Esporta PDF',
    clkView_exportingPdf: 'Generazione PDF…',
    clkView_loadingClocks: 'Caricamento orologi…',
    clkView_noActiveHours: 'Nessuna ora di programmazione attiva per questa data.',
    clkView_emptyHour: 'Nessun contenuto per questa ora.',
    clkView_songs: 'brani',
    clkView_breaks: 'pause',
    clkView_song: 'Brano',
    clkView_break: 'Pausa / Interruzione',
    clkView_listenersStart: 'Inizio',
    clkView_listenersEnd: 'Fine',
    clkView_listenersPeak: 'Picco',
    clkView_listenersAvg: 'Media',
    clkView_retention: 'Mantenimento',
    clkView_earlyDrop: 'Abbandono precoce',
    clkView_lsi: 'Indice Ascoltatori',
    clkView_score: 'Punteggio',
    clkView_severitySevereLoss: 'Perdita grave',
    clkView_severitySignificantLoss: 'Perdita significativa',
    clkView_severityMinorLoss: 'Perdita minore',
    clkView_severityStable: 'Stabile',
    clkView_severityMinorGain: 'Aumento minore',
    clkView_severityStrongGain: 'Forte aumento',
    clkView_severityUnknown: 'Sconosciuto',
    clkView_netHour: 'Saldo ora',
    clkView_categoryPower: 'POWER',
    clkView_categorySecondary: 'SECONDARY',
    clkView_categoryCurrents: 'CURRENTS',
    clkView_categoryRecurrents: 'RECURRENTS',
    clkView_categoryGold: 'GOLD',
    clkView_categorySlowDown: 'SLOW DOWN',
    clkView_categoryCut: 'CUT',
    clkView_legendTitle: 'Legenda',
    clkView_legendSongCategories: 'Categorie brani',
    clkView_legendBreakSeverity: 'Gravità pausa',
    clkView_legendBreaksSingle: 'Pause',
    clkView_listenersUnit: 'ascoltatori',
    clkView_clickToSee: 'Clicca uno spicchio per i dettagli',
    clkView_sparklineTitle: 'Ascoltatori ogni 5 min',
    clkView_min: 'min',
    clkView_max: 'max',
    clkView_thisHourLabel: 'Questa ora',
    clkView_legendSongs: 'Brani',
    clkView_song: 'Musica',
    clkView_legendHelp: 'Clicca su uno spicchio per i dettagli',
    clkView_talk: 'Parlato',
    clkView_talks: 'parlati',
    clkView_breakHint: '1-4 min @ slot :25 :30 :55 :00',
    clkView_talkHint: 'tutto il resto',
    clkView_noData: 'nessun dato',
    clkView_noDataHint: 'contenuto non musicale — in fase di analisi',
    // ─── Classifier Shadow Report (v2.13.0) ───
    clfReport_title: 'Report Classifier (Ombra)',
    clfReport_subtitle: 'Validazione inaSpeechSegmenter su tentativi Shazam reali',
    clfReport_gateMode: 'Modalità',
    clfReport_classifierReady: 'classifier pronto',
    clfReport_classifierUnavail: 'classifier non disponibile',
    clfReport_refresh: 'Aggiorna',
    clfReport_downloadCsv: 'Scarica CSV',
    clfReport_musicPct: 'Musica %',
    clfReport_speechPct: 'Parlato %',
    clfReport_speechMusicPct: 'Parlato + Musica %',
    clfReport_noisePct: 'Rumore %',
    clfReport_potentialReduction: 'Riduzione potenziale Fingerprint',
    clfReport_potentialReduction_hint: 'Quante chiamate Shazam risparmieremmo attivando il gating ora.',
    clfReport_potentialLost: 'HIT potenzialmente persi',
    clfReport_potentialLost_hint: 'Tra i brani riconosciuti, quanti perderemmo. < 5 % = sicuro.',
    clfReport_crossTableTitle: 'Tabella incrociata: Classificazione × Shazam',
    clfReport_totalSamples: 'Totale',
    clfReport_evaluable: 'Valutabili',
    clfReport_classification: 'Classificazione',
    clfReport_hitRate: 'Hit Rate',
    clfReport_crossTableHint: 'Sulle righe parlato / rumore: gli HIT sono falsi positivi — brani che avremmo perso con gating attivo.',
    clfReport_perStationTitle: 'Analisi per stazione',
    clfReport_station: 'Stazione',
    clfReport_noStationData: 'Nessun dato per ora.',
    clfReport_noSamplesTitle: 'Nessun campione ancora',
    clfReport_noSamplesHint: 'Il classifier sta funzionando in modalità ombra. Tornate tra 48 ore per statistiche affidabili.',
    clfReport_window: 'Finestra',
    clkView_today: 'Oggi',
    clkView_yesterday: 'Ieri',
    clkView_durationLabel: 'Durata',
    clkView_listenerDeltaLabel: 'Variazione ascoltatori',
    clkView_atTime: 'alle',
    clkView_pdfReady: 'PDF pronto.',
    clkView_pdfError: 'Generazione PDF fallita.',
    clkView_dataRetentionHint: 'I dati degli orologi sono conservati per 2 anni.',
    // Executive Summary
    execSum_title: 'Riepilogo Giornaliero',
    execSum_worstBreaks: 'Peggiori Pause',
    execSum_worstBreaks_subtitle: 'Le 3 pause con la maggiore perdita di ascoltatori',
    execSum_heroSongs: 'Brani Vincenti',
    execSum_heroSongs_subtitle: 'I 3 brani che hanno fatto crescere di più il pubblico',
    execSum_villainSongs: 'Peggiori Cali di Pubblico',
    execSum_villainSongs_subtitle: 'I 3 brani che hanno allontanato più ascoltatori',
    execSum_bestBreaks: 'Migliori Pause',
    execSum_bestBreaks_subtitle: 'Le 3 pause che hanno trattenuto o aumentato il pubblico',
    execSum_noData: 'Nessun dato disponibile',
    execSum_breakLabel: 'Pausa',
  },
  
  es: {
    // Header
    appTitle: 'Radio Solutions On Air',
    home: 'Inicio',
    aboutUs: 'Acerca de',
    logout: 'Cerrar sesión',
    generate: 'Generar',
    renewSubscription: 'Renovar Suscripción',
    waiting: 'Esperando',
    contentCreationInProgress: 'Creación de contenido en progreso...',
    pleaseWaitDontClose: 'Por favor espere. No cierre la aplicación.',
    
    // On Air Content
    onAirContent: 'Contenido On Air',
    dailyContent: 'Contenido Diario',
    onAirContentDesc: 'Contenido listo para transmisiones de radio. Horóscopos, clima, tendencias, noticias divertidas y más.',
    onAirPageTitle: 'Contenido de Radio Listo para Usar',
    onAirPageSubtitle: 'Haz clic en una categoría para ver las secciones',
    
    // About Page
    radioSolutionsApps: 'Radio Solutions Apps',
    forRadioProfessionals: 'Para Propietarios, Gerentes, Productores, Playlisters y Equipos de Ventas',
    dataYouNeed: 'Los Datos que Necesitas, las Herramientas que Mereces',
    analyticsContentCharts: 'Analytics, Content & Charts para la estación de radio moderna.',
    radioFinallyMeasured: 'Radio finally measured.',
    goToHome: 'Ir a Inicio',
    goToApp: 'Ir a la App',
    contactUs: 'Contáctanos',
    ourTools: 'Nuestras Herramientas',
    toolsSuiteDescription: 'Una suite completa de herramientas diseñada exclusivamente para estaciones de radio',
    timeSaving: 'Ahorra Tiempo',
    timeSavingDesc: 'Automatiza la producción de contenido y concéntrate en la parte on-air.',
    professionalResults: 'Resultados Profesionales',
    professionalResultsDesc: 'Contenido de alta calidad listo para uso inmediato al aire.',
    reliableData: 'Datos Confiables',
    reliableDataDesc: 'Rankings y estadísticas actualizadas de fuentes confiables.',
    readyToStart: '¿Listo para empezar?',
    signUpToday: 'Regístrate hoy y obtén acceso a todas nuestras herramientas',
    viewPackages: 'Ver Paquetes',
    freeTrial: 'Prueba Gratuita',
    toolsForRadio: 'Herramientas para la radio,',
    withoutHeadache: 'sin dolores de cabeza',
    suiteForProfessionals: 'Esta suite está diseñada para profesionales de la radio.',
    normalIfDifficult: 'Si al principio parece un poco difícil, es completamente normal 😉',
    freeDemo: 'tour gratuito',
    freeDemoText: 'Por eso ofrecemos un {freeDemo} para mostrarte de manera simple y práctica cómo puedes usar las herramientas en tu rutina diaria.',
    wantDemo: 'Quiero una demo',
    noTechKnowledge: 'No se requieren conocimientos técnicos. Te mostramos todo paso a paso.',
    seeToolsInAction: 'Ve Nuestras Herramientas en Acción',
    allInOneTool: 'Analytics, Análisis Daypart, Decisiones de Playlist - todo en una herramienta',
    
    // Email Popup
    popupTitle: '¿Quieres mejorar realmente tu estación de radio?',
    popupPlatformOffers: 'Lo que ofrece la plataforma:',
    popupOnAirContent: 'Contenido listo para transmisiones',
    popupSongFinder: 'Encuentra información sobre cualquier canción',
    popupTopCharts: 'Las canciones más populares en la radio griega',
    popupPlaylistAnalyzer: 'Análisis de playlist por hora y día',
    popupSongsAnalyzer: 'Descubre qué canciones mantienen a los oyentes',
    popupCalculators: 'Cálculo de campañas y oyentes',
    popupEmailPlaceholder: 'Tu email...',
    popupSubmitting: 'Enviando...',
    popupSubmitButton: 'Quiero saber más',
    popupBottomTagline: 'Recibirás información sobre cómo mejorar tu estación.',
    popupSuccessTitle: '¡Gracias!',
    popupSuccessMessage: 'Recibirás más información pronto.',
    continueWithoutSignup: 'Continuar sin registro',
    sectionsAvailable: 'secciones disponibles',
    sections: 'Secciones',
    updates: 'Actualizaciones',
    ready: 'Listo',
    refresh: 'Actualizar',
    loadingContent: 'Cargando contenido...',
    
    // Categories
    zodiacLifestyle: 'Zodiaco & Estilo de Vida',
    zodiacLifestyleDesc: 'Horóscopo del día, Relaciones, Salud & Bienestar, Consejos financieros',
    newsTrends: 'Noticias & Tendencias',
    newsTrendsDesc: 'Noticias curiosas, Buenas noticias, Deportes, Tendencias del día, Clima',
    entertainmentGames: 'Entretenimiento & Juegos',
    entertainmentGamesDesc: 'Concursos de radio, Juegos de palabras, Debates, Verdad o Mito',
    musicCharts: 'Música & Rankings',
    musicChartsDesc: 'Apple Music, YouTube Trending, Hoy en la historia de la música',
    
    // Common
    loading: 'Cargando...',
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    submit: 'Enviar',
    download: 'Descargar',
    upload: 'Subir',
    search: 'Buscar',
    filter: 'Filtro',
    all: 'Todo',
    yes: 'Sí',
    no: 'No',
    back: 'Volver',
    next: 'Siguiente',
    previous: 'Anterior',
    admin: 'Admin',
    
    // Access Loading States
    accessLoading: 'Cargando permisos de acceso... Por favor espere.',
    accessSlow: 'La conexión está un poco lenta... Reintentando. Normalmente tarda hasta 10 segundos.',
    accessRetrying: 'Reintentando conexión (intento {count}/3)...',
    accessUsingCache: 'Conexión lenta. Usando datos guardados temporalmente.',
    accessError: 'No se pudo conectar. Por favor actualice la página.',
    
    // Welcome Popup
    welcomeTitle: '¡Bienvenido!',
    welcomeSubtitle: '¡Haz que cada emisión sea imprescindible!',
    alreadyHaveAccount: 'Ya tengo una cuenta - Iniciar sesión',
    startFreeTrial: 'Comenzar prueba gratuita de 24 horas',
    dontLookLikeOthers: 'No seas como todos los demás',
    becomeReferenceStation: 'Conviértete en la estación de referencia',
    makeEveryBroadcast: 'Haz que cada emisión sea',
    mustListen: 'imprescindible',
    tryFor24Hours: 'Pruébalo por 24 horas',
    clickAnywhereToClose: 'Haz clic fuera o ESC para cerrar',
    measureOptimizePerform: 'Measure. Optimize. Perform.',
    welcomeDescription: 'La primera app que convierte la radio en un canal de medios medible: rendimiento de campañas, datos de audiencia, inteligencia de playlists y contenido on-air diario.',
    radioFinallyMeasured: 'Radio finalmente medida.',
    
    // Login
    login: 'Iniciar sesión',
    username: 'Nombre de usuario',
    password: 'Contraseña',
    forgotPassword: 'Olvidé mi contraseña',
    loginError: 'Error de inicio de sesión',
    serverStarting: 'Servidor iniciando... Espere 10 segundos e intente de nuevo.',
    rememberMe: 'Recordarme',
    twoFactorAuth: 'Verificación 2FA',
    enterOTP: 'Ingrese código 2FA',
    verify: 'Verificar',
    invalid2FA: 'Código 2FA inválido',
    
    // Trial Signup
    trialAccount: 'Cuenta de prueba',
    trialAccountDesc: 'Acceso gratuito de 24 horas a todas las funciones',
    email: 'Email',
    confirmPassword: 'Confirmar Contraseña',
    chooseUsername: 'Elige un nombre de usuario',
    minChars: 'Al menos 6 caracteres',
    repeatPassword: 'Repite la contraseña',
    createTrialAccount: 'Crear Cuenta de Prueba',
    creatingAccount: 'Creando...',
    allFieldsRequired: 'Todos los campos son obligatorios',
    passwordsDontMatch: 'Las contraseñas no coinciden',
    passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
    trialCreatedSuccess: '¡Cuenta de prueba creada con éxito!',
    trialExpiresIn: 'La prueba expira en 24 horas',
    saveCredentials: 'Guarda tus credenciales:',
    goToApp: 'Ir a la app',
    
    // Content
    contentFor: 'Contenido para',
    sections: 'secciones',
    exportPDF: 'Exportar PDF',
    userGuide: 'Guía de Usuario',
    contentDate: 'Contenido',
    createdAt: 'Creado',
    viewMode: 'Modo de vista',
    categoriesView: 'Categorías',
    classicView: 'Clásica',
    clickToViewSections: 'Clic para ver secciones',
    
    // Categories
    information: 'Información',
    entertainment: 'Entretenimiento',
    music: 'Música',
    lifestyle: 'Estilo de vida',
    special: 'Especial',
    contestsGames: 'Concursos y Juegos',
    dialoguesDiscussions: 'Diálogos y Discusiones',
    chartsMusic: 'Charts y Música',
    
    // Footer
    quickLinks: 'Enlaces Rápidos',
    campaignAnalyzer: 'Analizador de Campañas',
    listenerCalculator: 'Calculadora de Oyentes',
    playlistAnalyzer: 'Analizador de Playlist',
    daypartAnalyzer: 'Analizador Daypart',
    ourStations: 'Nuestras estaciones',
    radioTopSongs: 'Top Radio Songs',
    contact: 'Contacto',
    radioContentCreation: 'Creación de contenido radiofónico',
    legalPrivacy: 'Legal y Privacidad',
    privacyPolicy: 'Política de Privacidad',
    termsOfService: 'Términos de Servicio',
    cookiePolicy: 'Política de Cookies',
    cookieSettings: 'Configuración de Cookies',
    allRightsReserved: 'Todos los derechos reservados',
    gdprCompliant: 'Compatible con GDPR',
    euDataProtection: 'Protección de Datos UE',
    gdprNotice: 'Tus datos personales están protegidos según el GDPR (UE 2016/679).',
    loginForMoreOptions: 'Inicia sesión para más opciones',
    
    // Navigation Menu Labels
    navInfo: 'Info',
    navOnAirContent: 'On Air Content',
    navSongFinder: 'Song Finder',
    navCampaignCalculator: 'Campaign Calculator',
    navListenersCalculator: 'Listeners Calculator',
    navTopRadioCharts: 'Top Radio Charts',
    navStations: 'Estaciones',
    navPlaylistAnalyzer: 'Playlist Analyzer',
    navDaypartAnalyzer: 'Playlist Daypart Analyzer',
    navSongsAnalyzer: 'Songs Analyzer',
    navSongsAnalyzerPro: 'Songs Analyzer PRO',
    navContact: 'Contacto',
    navAdmin: 'Admin',
    navPackets: 'Paquetes',
    navServices: 'Servicios',
    readMore: 'Leer m\u00e1s',

    // ── Services Page (v2.10.2 / 2026-06-15) ─────────────────────
    servicesTitle: 'Servicios',
    servicesEyebrow: 'Servicios · Services',
    servicesHeroTitle: 'Music Scheduling & Log Optimization',
    servicesHeroDesc: 'M\u00e1s all\u00e1 de nuestras herramientas, ofrecemos servicios especializados que ayudan a las emisoras de radio a aumentar su audiencia, mejorar su programaci\u00f3n y aumentar sus ingresos.',
    servicesCtaFreeEval: 'Solicita una Evaluaci\u00f3n Gratuita',
    servicesPreviewDesc: 'M\u00e1s all\u00e1 de nuestras herramientas, ofrecemos servicios especializados que ayudan a las emisoras de radio a aumentar su audiencia, mejorar su programaci\u00f3n y aumentar sus ingresos.',
    servicesOurServices: 'Nuestros Servicios',
    servicesOurServicesSub: 'Experiencia profesional ofrecida por veteranos de la industria radiof\u00f3nica',
    svcIncludes: 'Incluye:',
    svcLearnMore: 'M\u00e1s informaci\u00f3n',
    svc1Title: 'Music Programming & Format Consulting',
    svc1Desc: 'Optimizaci\u00f3n de la programaci\u00f3n musical en funci\u00f3n del formato, la competencia y las preferencias de la audiencia local.',
    svc1Bullet1: 'An\u00e1lisis de formato',
    svc1Bullet2: 'Estrategia musical',
    svc1Bullet3: 'Gesti\u00f3n de rotaciones',
    svc1Bullet4: 'An\u00e1lisis competitivo',
    svc1Bullet5: 'Creaci\u00f3n de music clocks',
    svc1Bullet6: 'Optimizaci\u00f3n de rotaciones',
    svc1Bullet7: 'Gesti\u00f3n de categor\u00edas',
    svc1Bullet8: 'Programaci\u00f3n por daypart',
    svc1Bullet9: 'Revisi\u00f3n musical semanal',
    svc2Title: 'Audience & Market Analysis',
    svc2Desc: 'Analizamos el mercado y las tendencias musicales para que tu emisora tome mejores decisiones.',
    svc2Bullet1: 'An\u00e1lisis de la competencia',
    svc2Bullet2: 'Monitoreo de tendencias musicales',
    svc2Bullet3: 'Informes de nuevos lanzamientos',
    svc2Bullet4: 'Estrategias de diferenciaci\u00f3n',
    svc3Title: 'Radio Station Growth Consulting',
    svc3Desc: 'Consultor\u00eda de crecimiento para aumentar la audiencia, el valor comercial y el reconocimiento de marca.',
    svc3Bullet1: 'Branding de la emisora',
    svc3Bullet2: 'Posicionamiento',
    svc3Bullet3: 'Concursos y promociones',
    svc3Bullet4: 'Estrategia en redes sociales',
    svc3Bullet5: 'Engagement de oyentes',
    svc4Title: 'Ongoing Programming Support',
    svc4Desc: 'Colaboraci\u00f3n y soporte continuos para emisoras que buscan un socio externo de programaci\u00f3n.',
    svc4Bullet1: 'Comunicaci\u00f3n semanal',
    svc4Bullet2: 'Evaluaci\u00f3n del programa musical',
    svc4Bullet3: 'Propuestas de mejora',
    svc4Bullet4: 'Soporte a productores',
    svc4Bullet5: 'Seguimiento de resultados',
    servicesOurProcess: 'Nuestro Proceso',
    servicesOurProcessSub: 'C\u00f3mo entregamos nuestros servicios para mejorar el sonido de tu emisora',
    svcProcessStep1Title: 'Descubrimiento',
    svcProcessStep1Desc: 'Comenzamos entendiendo tu formato, audiencia y objetivos a trav\u00e9s de una consultor\u00eda detallada.',
    svcProcessStep2Title: 'Estrategia',
    svcProcessStep2Desc: 'Dise\u00f1amos una estrategia de scheduling personalizada para tus necesidades espec\u00edficas.',
    svcProcessStep3Title: 'Implementaci\u00f3n',
    svcProcessStep3Desc: 'Implementamos la estrategia, optimizando logs, biblioteca y clocks para m\u00e1ximo impacto.',
    svcProcessStep4Title: 'Refinamiento',
    svcProcessStep4Desc: 'Feedback y refinamiento continuos para mantener el sonido de tu emisora siempre optimizado.',
    svcBenefitsTitle: 'Beneficios para tu emisora',
    svcBenefitsSub: 'Resultados concretos que ver\u00e1s tras colaborar con nosotros',
    svcBenefit1: 'Mayor audiencia',
    svcBenefit2: 'Mayor tiempo de permanencia de los oyentes en tu frecuencia',
    svcBenefit3: 'Aumento del valor publicitario y de los ingresos',
    svcBenefit4: 'M\u00fasica que mantiene a tu audiencia sintonizada',
    svcBenefit5: 'Menor abandono de oyentes por opciones cansinas',
    svcBenefit6: 'Mejores decisiones gracias a datos y anal\u00edticas',
    svcBenefit7: 'Diferenciaci\u00f3n clara frente a la competencia',
    svcBenefit8: 'Mejora continua de la programaci\u00f3n musical',
    svcCtaEyebrow: '\u00bfListo para mejorar tu emisora?',
    svcCtaTitle: '\u00bfQuieres mejorar la programaci\u00f3n de tu emisora?',
    svcCtaDesc: 'Habla con nosotros y evaluaremos gratuitamente tu formato, estrategia musical y posibilidades de crecimiento.',

    // Services Results / Case Study (animated counters)
    svcResultsEyebrow: 'Resultados · Casos de \u00e9xito',
    svcResultsTitle: 'Resultados medibles para nuestras emisoras cliente',
    svcResultsSub: 'Mejoras promedio tras 3-6 meses de trabajo con nuestro equipo',
    svcResultMetric1: 'Aumento del TSL (Time Spent Listening)',
    svcResultMetric2: 'Crecimiento de audiencia',
    svcResultMetric3: 'Reducci\u00f3n del early drop',
    svcResultMetric4: 'Emisoras que conf\u00edan en nosotros',
    svcResultsDisclaimer: 'Resultados basados en el an\u00e1lisis de datos de escucha de emisoras que utilizan nuestros servicios. Las cifras var\u00edan seg\u00fan formato y mercado.',
    svcTestimonialQuote: '\u00abTrabajar con Radio Solutions aument\u00f3 considerablemente el TSL de nuestra emisora y nos dio una imagen clara de qu\u00e9 canciones realmente conectan con la audiencia.\u00bb',
    svcTestimonialAuthor: 'Director de programaci\u00f3n',
    svcTestimonialStation: 'Emisora colaboradora',
    
    // Pricing
    pricing: 'Paquetes y Suscripciones',
    monthly: 'Mensual',
    annual: 'Anual',
    subscribe: 'Suscribirse',
    popular: 'Popular',
    chooseYourPackage: 'Elige tu Paquete',
    pricingDescription: 'Obtén acceso a herramientas premium para tu estación de radio',
    currentPlan: 'Plan Actual',
    upgrade: 'Mejorar',
    downgrade: 'Reducir',
    per: 'por',
    month: 'mes',
    year: 'año',
    selectWeek: 'Seleccionar Semana',
    previousWeek: 'Semana Anterior',
    nextWeek: 'Semana Siguiente',
    optional: 'opcional',
    savePercent: 'Ahorra',
    featuresIncluded: 'Incluye',
    
    // Cookies
    cookiesTitle: 'Usamos Cookies',
    cookiesDesc: 'Usamos cookies para mejorar tu experiencia.',
    cookiesFullDesc: 'Usamos cookies para mejorar tu experiencia. Algunas cookies son necesarias para el funcionamiento del sitio.',
    acceptAll: 'Aceptar Todo',
    reject: 'Rechazar',
    settings: 'Configuración',
    necessaryCookies: 'Cookies Necesarias',
    necessaryCookiesDesc: 'Esenciales para la funcionalidad básica del sitio.',
    required: 'REQUERIDAS',
    analyticsCookies: 'Cookies de Análisis',
    analyticsCookiesDesc: 'Nos ayudan a entender cómo usas el sitio.',
    functionalCookies: 'Cookies Funcionales',
    functionalCookiesDesc: 'Recuerdan tus preferencias y mejoran la experiencia.',
    thirdPartyCookies: 'Cookies de Terceros',
    thirdPartyCookiesDesc: 'Utilizadas por servicios externos (ej. YouTube).',
    saveSettings: 'Guardar Configuración',
    
    // Daypart Analyzer
    daypartTitle: 'Analizador de Rendimiento Daypart',
    morning: 'Mañana',
    drive: 'Drive Time',
    night: 'Noche',
    overnight: 'Madrugada',
    analyze: 'Analizar',
    results: 'Resultados',
    genreDistribution: 'Distribución de Género',
    decadeDistribution: 'Distribución por Década',
    
    // Labels
    power: 'POWER',
    secondary: 'SECONDARY',
    currents: 'CURRENTS',
    spreadMore: 'SPREAD MORE',
    slowDown: 'SLOW DOWN',
    sleeper: 'SLEEPER',
    cut: 'CUT',
    
    // Homepage Cards
    campaignAnalyzerDesc: 'Herramienta de optimización de campañas de radio',
    campaignAnalyzerInfo: 'Calcula GRPs, Alcance y Frecuencia para tu campaña.',
    campaignAnalyzerFullDesc: 'El Analizador de Campañas es una herramienta profesional para planificar campañas publicitarias de radio. Calcula automáticamente GRPs (Gross Rating Points), Alcance (porcentaje de audiencia expuesta al mensaje) y Frecuencia (número promedio de contactos por persona). Basándose en la categoría de tu marca y posición en el mercado, recomienda el número óptimo de spots para máxima efectividad.',
    openCampaignAnalyzer: 'Abrir Analizador de Campañas',
    listenerCalculatorDesc: 'Herramienta de cálculo de oyentes basada en dayparts',
    listenerCalculatorInfo: 'Calcula porcentajes de audiencia y estimaciones de oyentes.',
    listenerCalculatorFullDesc: 'La Calculadora de Oyentes convierte porcentajes de audiencia en números reales de oyentes. Utiliza métodos estadísticos (corrección FPC, Intervalos de Confianza 95%) para estimaciones precisas. Ingresa datos de rating por día y franja horaria (daypart) y recibe resultados detallados sobre la audiencia de tu estación.',
    openListenerCalculator: 'Abrir Calculadora de Oyentes',
    playlistAnalyzerDesc: 'Herramienta de análisis de rendimiento de playlist',
    playlistAnalyzerInfo: 'Analiza el rendimiento de tu playlist en detalle.',
    playlistAnalyzerFullDesc: 'El Analizador de Playlist analiza el rendimiento de cada canción en la playlist de tu estación. Sube un CSV con datos TLH (Time Listening Hours), Performances y Frequency. El sistema calcula puntuaciones y recomienda decisiones como POWER (rendimiento excelente), SECONDARY (bueno), CURRENTS (nuevo lanzamiento) o CUT (eliminar).',
    openPlaylistAnalyzer: 'Abrir Analizador de Playlist',
    daypartAnalyzerDesc: 'Analizador de rendimiento por franja horaria',
    daypartAnalyzerInfo: 'Analiza el rendimiento por daypart.',
    daypartAnalyzerFullDesc: 'El Analizador Daypart es la versión premium del Analizador de Playlist. Analiza el rendimiento de cada canción por franja horaria: Morning (06:00-10:00), Midday (10:00-15:00), Drive (15:00-19:00), Evening (19:00-24:00) y Overnight (00:00-06:00). Ideal para estaciones que quieren optimizar la rotación por hora.',
    songInfoFullDesc: 'La herramienta Información de Canciones busca información sobre cualquier canción: año de lanzamiento, sello discográfico, compositores, letristas, artista/banda, y sugiere textos para locución (liners) a los productores. Simplemente escribe el título de la canción y haz clic en buscar.',
    openDaypartAnalyzer: 'Abrir Analizador Daypart',
    premiumFeature: 'PREMIUM',
    upgradeToAccess: 'Mejora para acceder',
    columns: 'Columnas',
    
    // Misc
    copyright: 'PROPIEDAD DE RADIO SOLUTIONS',
    copyrightTitle: 'PROPIEDAD DE RADIO SOLUTIONS',
    copyrightNotice: 'Este contenido está reservado exclusivamente a suscriptores registrados.',
    generateNewContent: '¡Genera nuevo contenido para mejores resultados!',
    contentCreationDuration: 'Duración de creación: ~15 minutos | Auto: 00:01 diario',
    downloadAsPDF: 'Descargar como PDF',
    userInstructions: 'Guía de Usuario',
    waitForPdfDownload: 'Espere hasta 10 segundos para la descarga del PDF',
    generationDuration: 'Duración de generación: ~15 minutos | Auto: 00:01 diario',
    waitForPDF: 'Espere hasta 10 segundos para completar la descarga del PDF',
    pdfPassword: 'Contraseña: tu nombre de usuario',
    newContentAvailable: '¡Nuevo contenido disponible!',
    pageWillRefresh: 'La página se actualizará en 5 segundos...',
    refreshNow: 'Actualizar Ahora',
    multiLanguage: 'Multilingüe',
    
    // Playlist Analyzer
    playlistAnalyzerTitle: 'Playlist Performance Analyzer',
    uploadCSV: 'Subir CSV',
    selectCSV: 'Seleccionar CSV',
    changeFile: 'Cambiar',
    loadingFile: 'Cargando...',
    tracksLoaded: 'Pistas cargadas',
    radioFormat: 'Formato de Radio',
    formatAffectsWeights: 'El formato afecta los pesos y multiplicadores de época',
    step1SelectFormat: 'Paso 1: Selecciona Formato → Paso 2: Sube CSV',
    selectFormatFirst: 'Primero selecciona el formato de radio correcto y luego sube el archivo CSV.',
    startAnalysis: 'Iniciar Análisis',
    analyzing: 'Analizando...',
    analysisComplete: '¡Análisis completado!',
    analysisError: 'Error de análisis',
    networkError: 'Error de conexión. Por favor, inténtalo de nuevo.',
    exportToPDF: 'Exportar PDF',
    creatingPDF: 'Creando PDF...',
    pdfCreated: '¡PDF creado!',
    errorDownloadingPDF: 'Error al descargar PDF',
    passwordToOpen: 'Contraseña: tu nombre de usuario',
    tracksAndDecisions: 'Pistas y Decisiones',
    genres: 'Géneros',
    decades: 'Décadas',
    searchArtistTitle: 'Buscar Artista o Título...',
    clear: 'Limpiar',
    tracks: 'pistas',
    instructions: 'Instrucciones',
    csvFileStructure: 'Estructura del Archivo CSV',
    csvMustContain: 'El archivo CSV debe contener las siguientes columnas.',
    artistName: 'Nombre del artista',
    trackTitle: 'Título de la pista',
    frequency: 'Frecuencia',
    performances: 'Reproducciones',
    columnExplanation: 'Explicación de Columnas',
    missingColumns: '¿Qué pasa si faltan columnas?',
    scoringProcess: 'Proceso de Puntuación',
    whatDataMeans: 'Qué significan los datos',
    radioFormatsAdjustments: 'Formatos de Radio y Ajustes',
    decisionLabels: 'Etiquetas de Decisión',
    
    // Daypart Analyzer specific
    daypartAnalyzerTitle: 'Analizador de Rendimiento Daypart',
    usageInstructions: 'Instrucciones de Uso',
    daypartIntro: 'El Daypart Analyzer analiza el rendimiento de tu playlist por franja horaria.',
    csvUpload: 'Subir Archivo CSV',
    csvMustContainFields: 'El CSV debe contener las siguientes columnas:',
    csvFlexibleFormat: 'Columnas requeridas:',
    csvOptional: 'opcional',
    csvColumnOrderNote: 'El orden de las columnas no importa. Se reconocen varios nombres (ej. Artist, Performer, Artista)',
    allFieldsRequired: 'Todos los campos son obligatorios para resultados precisos',
    selectRadioFormat: 'Seleccionar Formato de Radio',
    selectYourFormat: 'Selecciona el formato de tu estación:',
    timeZones: 'Franjas Horarias (Dayparts)',
    evaluationCategories: 'Categorías de Evaluación',
    powerDesc: 'Mejores pistas - ¡reproducir frecuentemente!',
    secondaryDesc: 'Segunda línea - buen rendimiento',
    currentsDesc: 'Hits actuales - buen flujo',
    spreadMoreDesc: 'Aumentar frecuencia',
    slowDownDesc: 'Disminuir frecuencia',
    sleeperDesc: 'Bajo rendimiento - monitorear',
    cutDesc: 'Candidato para eliminación',
    csvFormat: 'Formato CSV',
    daypartHowItWorks: 'Cómo funciona',
    daypartHowItWorksDesc: 'El Daypart Analyzer analiza el rendimiento por franja horaria (Morning, Drive, Night, Overnight). Basándose en TLH y Listeners, calcula puntuaciones y sugiere decisiones (POWER, SECONDARY, CURRENTS, etc.).',
    genreDecadeAnalysis: 'Análisis de Género y Década',
    eachDaypartShows: 'Cada daypart también muestra:',
    requiresAdminEnrichment: 'Requiere enriquecimiento de base de datos por Admin',
    exportResults: 'Exportar Resultados',
    afterAnalysisExport: 'Después del análisis, puedes exportar a:',
    tips: 'Consejos',
    tip1: 'Usa al menos una semana de datos para mejores resultados',
    tip2: 'Ajusta los pesos por daypart en la configuración',
    tip3: 'Revisa el análisis GOLD para las pistas "doradas"',
    gotItLetsStart: '¡Entendido, empecemos!',
    
    // Radio Top Songs
    radioTopSongsTitle: 'Top Radio Songs',
    weeklyChart: 'Lista Semanal',
    position: 'Posición',
    artist: 'Artista',
    title: 'Título',
    lastWeek: 'Semana Pasada',
    weeksOnChart: 'Semanas',
    chartInfo: 'Info del Ranking',
    uploadNewChart: 'Subir Nuevo Ranking',
    noChartData: 'No hay datos de ranking disponibles',
    allSongs: 'Todos',
    greekSongs: 'Griegos',
    internationalSongs: 'Internacionales',
    totalSongs: 'Total de Canciones',
    source: 'Fuente',
    searchSongsArtists: 'Busca canciones y artistas • Ver rankings históricos',
    browseChartsByWeek: 'Navega por los rankings por semana y mes del año',
    discoverMore: 'Descubre Más',
    searchSongArtist: 'Buscar canción o artista...',
    display: 'Mostrar',
    saveCurrentChart: 'Guardar Ranking Actual',
    noChartDataForWeek: 'No se encontraron datos para la semana seleccionada. Cargando ranking actual...',
    
    // Maintenance/Loading Screen
    preparingForYou: '¡Preparando todo para ti!',
    remainingTime: 'Tiempo restante',
    ready: '¡Listo!',
    pageWillRefreshAuto: 'La página se actualizará automáticamente en unos segundos...',
    completed: 'completado',
    contentBeingCreated: 'Tu contenido de radio se está creando ahora mismo. Por favor espera...',
    whatsHappening: '¿Qué está pasando?',
    systemCreatingContent: 'El sistema está creando contenido de radio fresco y profesional',
    estimatedDuration: 'Duración estimada',
    minutes: 'minutos',
    pageRefreshAuto: 'La página se actualizará automáticamente cuando termine',
    tipKeepTabOpen: 'Consejo: Mantén esta pestaña abierta - la actualización se hará automáticamente',

    // Pricing Page - Missing keys
    features: 'Funcionalidades',
    price: 'Precio',
    perMonth: '/mes',
    perYear: '/año',
    currentPackage: 'Paquete Actual',
    select: 'Seleccionar',
    pleaseWait: 'Espere...',
    paymentCancelled: 'Pago cancelado',
    checkEmailConfirmation: 'Revise su correo para confirmación de pago',
    paymentSuccess: '¡Pago completado exitosamente!',
    sessionExpired: 'La sesión de pago expiró',
    pleaseLoginFirst: 'Por favor inicie sesión primero',
    chargeForUpgrade: 'Cargo €{amount} por mejora',
    errorCreatingPayment: 'Error al crear el pago',
    errorLoadingPackages: 'Error al cargar paquetes',
    faq: 'Preguntas Frecuentes',
    canChangePackage: '¿Puedo cambiar de paquete?',
    canChangePackageAnswer: 'Sí, puedes mejorar o reducir tu paquete en cualquier momento. La diferencia se añadirá o restará de tu próximo cargo.',
    paymentMethods: '¿Qué métodos de pago se aceptan?',
    paymentMethodsAnswer: 'Aceptamos todas las tarjetas de crédito/débito (Visa, Mastercard, American Express) a través de la plataforma segura Stripe.',
    hasTrial: '¿Hay un período de prueba?',
    hasTrialAnswer: '¡Sí! Todos los nuevos usuarios tienen acceso gratuito por 24 horas a todas las funcionalidades.',

    // FeatureGate - Missing keys
    lockedFeature: 'Función Bloqueada',
    upgradeForAccess: 'Mejorar para Acceder',
    orTryFree24h: 'O prueba gratis por 24 horas',
    upgradeForAccessFeature: 'Mejora tu paquete para acceder a esta función.',
    hoursRemaining: 'horas restantes',
    adminFullAccess: 'Administrador - Acceso Completo',
    trialPeriod: 'Período de Prueba',
    freeAccess: 'Acceso Gratuito',
    subscriber: 'Suscriptor',
    subscriptionExpired: 'Tu suscripción ha expirado',
    noActiveSubscription: 'Sin suscripción activa',
    
    // Help Modals
    helpGuide: 'Guía',
    helpInstructions: 'Instrucciones',
    howItWorks: 'Cómo funciona',
    helpListenerCalculator: 'Guía del Calculador de Oyentes',
    helpPlaylistAnalyzer: 'Guía del Analizador de Playlist',
    helpDaypartAnalyzer: 'Guía del Analizador de Daypart',
    
    // Listener Calculator Page
    listenerCalcTitle: 'Calculadora de Oyentes',
    listenerCalcDesc: 'Herramienta de estimación de audiencia real',
    whatIsCalculator: '¿Qué es la Calculadora?',
    listenerCalcGuide: 'Guía del Calculador de Oyentes',
    listenerCalcWhat: 'Qué es la Calculadora de Oyentes y qué hace',
    listenerCalcWhatDesc: 'La Calculadora de Oyentes es una herramienta para estimar la audiencia real del streaming para:',
    listenerCalcItems: 'Día,Daypart (franja horaria),Semana,Combinación de días y dayparts',
    listenerCalcNote: 'No mide simplemente conexiones en bruto.',
    listenerCalcStatistical: 'Usa proyección estadística para calcular desde una muestra de oyentes:',
    listenerCalcMetrics: 'Porcentaje de audiencia,Número estimado de oyentes reales,Intervalo de confianza 95%,Tendencia semanal',
    listenerCalcTool: 'Esto transforma los datos del streaming de "números" a una herramienta de decisión.',
    streamingAnalyticsTitle: 'Analizador de Datos de Streaming',
    streamingAnalyticsDesc: 'Cargue CSV de su proveedor de streaming para análisis detallado de audiencia',
    listenerCalcAnalysis: 'Análisis y explicación de indicadores',
    sampleTitle: 'Muestra',
    sampleDesc: 'El número de usuarios registrados (ej. oyentes, sesiones, respuestas de encuesta).',
    sampleTip: 'Cuanto mayor sea la muestra, mayor será la precisión.',
    positiveTitle: 'Positivo',
    positiveDesc: 'El número de usuarios que cumplen el criterio.',
    positiveTip: 'Filtra los "clics aleatorios" de los oyentes reales.',
    populationTitle: 'Población',
    populationDesc: 'Estimación total de la población potencial.',
    populationTip: 'Se usa para convertir el porcentaje en número real de oyentes.',
    percentageTitle: 'Porcentaje (%)',
    percentageDesc: 'Positivo / Muestra',
    percentageTip: 'Muestra qué tan fuerte es cada daypart respecto al total.',
    estimatedListenersTitle: 'Oyentes Estimados',
    estimatedListenersDesc: 'Porcentaje × Población',
    estimatedListenersTip: 'El indicador más crítico: Cuántas personas escuchan realmente la estación en esta zona.',
    ciTitle: 'IC 95% (Intervalo de Confianza)',
    ciDesc: 'Rango de fiabilidad estadística. Ejemplo: 18% – 22%',
    ciTip: 'Significa que con 95% de certeza, la audiencia real está dentro de este rango.',
    fpcTitle: 'FPC – Corrección de Población Finita',
    fpcDesc: 'Se usa cuando la muestra es grande y la población es finita.',
    fpcTip: 'Mejora drásticamente la precisión de los resultados.',
    trendTitle: 'Tendencia Semanal (Gráfico)',
    trendDesc: 'Muestra la evolución de la audiencia por día, caídas y aumentos.',
    trendTip: 'Identifica cuándo algo NO funciona.',
    howHelpsTitle: 'Cómo ayuda a una estación de radio',
    costReduction: 'Reducción de Costos',
    costReductionItems: 'Identificar dayparts de bajo rendimiento,Reducir gastos innecesarios,Cambios específicos en lugar de inversiones generales',
    audienceIncrease: 'Aumento de Audiencia',
    audienceIncreaseItems: 'Optimizar playlist por zona,Adaptar contenido por hora,Fortalecer dayparts fuertes,Corregir débiles antes de perder audiencia',
    playlistAdaptation: 'Adaptación de Playlist y Contenido',
    playlistAdaptationItems: 'Flujo musical diferente en la mañana,Diferente en drive time,Diferente de noche',
    playlistAdaptationNote: 'La calculadora muestra dónde se cansa el oyente.',
    proDataTitle: 'Datos profesionales para anunciantes',
    proDataItems: 'Prueba de rendimiento por hora,Números confiables,Argumentos para mejores tarifas',
    understoodClose: 'Entendido, cerrar',
    
    // Campaign Calculator Page
    campaignAnalyzerPageTitle: 'Analizador de Campañas',
    campaignAnalyzerPageDesc: 'Herramienta de optimización de campañas de radio',
    brandCategoryLabel: 'CATEGORÍA DE MARCA (ALFABÉTICO)',
    marketPositionLabel: 'POSICIÓN DE MERCADO DE LA MARCA',
    radioPrimaryLabel: '¿RADIO COMO MEDIO PRIMARIO?',
    campaignDurationLabel: 'DURACIÓN DE CAMPAÑA (SEMANAS ACTIVAS)',
    pleaseSelect: 'Selecciona',
    spotsPerDay: 'Spots por Día',
    adjustSpotsPerDay: 'Ajusta el número de spots para cada día de la semana',
    totalSpotsWeek: 'Total Spots/Semana',
    calculateCampaign: 'Calcular Campaña',
    weeklyGRPs: 'GRPs Semanales',
    totalGRPs: 'GRPs Totales',
    estimatedReach: 'Alcance',
    avgFrequency: 'Frecuencia Promedio',
    weeklyProgress: 'Progreso Semanal',
    dailyDistribution: 'Distribución Diaria (Semana 1)',
    strategicRecommendations: 'Recomendaciones Estratégicas',
    scenarioComparison: 'Comparación de Escenarios',
    exportPDFBtn: 'Exportar a PDF',
    pleaseWaitPDF: 'Espera...',
    fillAllFields: 'Por favor completa todos los campos',
    calculateFirst: 'Primero haz clic en "Calcular"',
    waitForPDFGen: 'Espera hasta 10 segundos para generar el archivo...',
    pleaseWait: 'Por favor espera...',
    exportCompleted: '¡Exportación completada!',
    exportError: 'Error al exportar PDF',
    // Day names
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo',
    // Brand categories
    foodDrinks: 'Comida y Bebidas',
    technology: 'Tecnología',
    fashionBeauty: 'Moda y Belleza',
    automobiles: 'Automóviles',
    services: 'Servicios',
    retail: 'Comercio Minorista',
    // Market positions
    marketLeader: 'Líder del Mercado',
    challenger: 'Retador',
    newEntry: 'Nuevo Ingreso',
    // Campaign durations
    weeks2: '2 semanas',
    weeks4: '4 semanas',
    weeks8: '8 semanas',
    weeks12: '12 semanas',
    weekLabel: 'Semana',
    weekFull: 'Semana',
    historicalData: 'Datos Históricos',
    showMore: 'Mostrar más',
    noResultsFor: 'No se encontraron resultados para',
    chartSavedSuccess: '¡Lista guardada con éxito!',
    year: 'Año',
    songsCount: 'Canciones',
    noDataToSave: 'No hay datos para guardar',
    adminOnlyFeature: 'Debes iniciar sesión como admin',
    adminOnlySaveChart: 'Solo los admin pueden guardar listas',
    saveFailed: 'Error al guardar. Inténtalo de nuevo.',
    spots: 'spots',
    totalSpots: 'Spots Totales',
    
    // Admin Section
    adminDbEnrichment: 'Admin: Enriquecimiento Base de Datos de Canciones',
    songsInDb: 'canciones',
    artistsInDb: 'artistas',
    songsWithYear: 'con año',
    uploadCsvInstructions: 'Sube CSV con columnas: Artist, Title, Year (opcional: Genre)',
    importInProgress: 'Importación en progreso...',
    addSongs: 'Agregar Canciones',
    
    // Contact Form
    contactTitle: 'Contacto',
    contactDesc: 'Completa el formulario para contactarnos',
    firstName: 'Nombre',
    lastName: 'Apellido',
    stationName: 'Nombre de Estación',
    region: 'Región',
    phone: 'Teléfono',
    email: 'Email',
    message: 'Mensaje',
    attachFile: 'Adjuntar archivo',
    sendMessage: 'Enviar Mensaje',
    sending: 'Enviando...',
    messageSent: '¡Tu mensaje fue enviado exitosamente!',
    messageError: 'Error al enviar tu mensaje',
    requiredField: 'Este campo es obligatorio',
    invalidEmail: 'Por favor ingresa un email válido',
    invalidPhone: 'Por favor ingresa un teléfono válido',
    selectRegion: 'Selecciona región',
    contactInfo: 'Información de Contacto',
    nameRequired: 'El nombre es obligatorio',
    lastNameRequired: 'El apellido es obligatorio',
    enterRealName: 'Por favor ingresa tu nombre real',
    enterRealLastName: 'Por favor ingresa tu apellido real',
    minChars: 'Debe tener al menos 2 caracteres',
    enterValidName: 'Por favor ingresa un nombre válido',
    stationRequired: 'El nombre de la estación es obligatorio',
    regionRequired: 'La región es obligatoria',
    phoneRequired: 'El teléfono es obligatorio',
    emailRequired: 'El email es obligatorio',
    businessEmailRequired: 'Por favor usa un email de negocios',
    messageRequired: 'El mensaje es obligatorio',
    minMessageLength: 'El mensaje debe tener al menos 10 caracteres',
    fileTooLarge: 'Archivo muy grande (máx 5MB)',
    invalidFileType: 'Tipo de archivo no válido',
    regionCyprus: 'Chipre',
    regionAttica: 'Ática',
    regionThessaloniki: 'Salónica',
    regionCentralMacedonia: 'Macedonia Central',
    regionWestMacedonia: 'Macedonia Occidental',
    regionEastMacedoniaThrace: 'Macedonia Oriental y Tracia',
    regionEpirus: 'Épiro',
    regionThessaly: 'Tesalia',
    regionIonianIslands: 'Islas Jónicas',
    regionWestGreece: 'Grecia Occidental',
    regionCentralGreece: 'Grecia Central',
    regionPeloponnese: 'Peloponeso',
    regionNorthAegean: 'Egeo Norte',
    regionSouthAegean: 'Egeo Sur',
    regionCrete: 'Creta',
    
    // Our Stations
    ourStationsTitle: 'Nuestras Estaciones',
    ourStationsDesc: 'Estaciones demo con varios formatos musicales para crear playlists para estaciones de radio y negocios In-Store.',
    listenLive: 'Escuchar en Vivo',
    visitWebsite: 'Visitar Sitio Web',

    // Feature Info keys
    categoriesOnAirTitle: 'Categorías de Temas On Air',
    categoriesOnAirDesc: '9 categorías de contenido fresco - Mañana, Día, Tarde, Noche, Fin de semana, Horóscopos, News, Entertainment, Charts. ¡Nuevo cada día!',
    campaignAnalyzerTitleLong: 'Analizador de Campañas',
    campaignAnalyzerDescLong: 'Calcula el rendimiento de tus campañas publicitarias. Ver alcance, frecuencia, GRP e ingresos estimados.',
    listenerCalculatorTitleLong: 'Calculadora de Oyentes',
    listenerCalculatorDescLong: 'Calcula la audiencia real de tu estación. Estimaciones de oyentes por franja y día.',
    radioTopSongsTitleLong: 'Top Radio Songs',
    radioTopSongsDescLong: 'Encuentra las mejores canciones para tu estación. Charts griegos e internacionales con sugerencias inteligentes.',
    playlistAnalyzerTitleLong: 'Analizador de Playlist',
    playlistAnalyzerDescLong: 'Analiza tu playlist por décadas, géneros y rendimiento. Evaluación de canciones POWER/SLEEPER.',
    daypartAnalyzerTitleLong: 'Analizador Daypart',
    daypartAnalyzerDescLong: 'Analiza el rendimiento de tu playlist por franja horaria (mañana, mediodía, noche). Distribución de género y década.',
    monthlySupportTitle: 'Soporte Mensual',
    monthlySupportDesc: 'Soporte técnico por email y chat con respuesta en 24 horas.',
    prioritySupportTitle: 'Soporte Prioritario',
    prioritySupportDesc: 'Soporte técnico inmediato con prioridad. Respuesta en 4 horas.',
    
    // Campaign Analyzer Form
    brandCategoryLabel: 'CATEGORÍA DE MARCA (ALFABÉTICO)',
    marketPositionLabel: 'POSICIÓN DE MARCA EN EL MERCADO',
    radioPrimaryLabel: '¿RADIO COMO MEDIO PRIMARIO?',
    campaignDurationLabel: 'DURACIÓN DE CAMPAÑA (SEMANAS ACTIVAS)',
    foodDrinks: 'Comida & Bebidas',
    technology: 'Tecnología',
    fashionBeauty: 'Moda & Belleza',
    automobiles: 'Automóviles',
    services: 'Servicios',
    retail: 'Venta al Por Menor',
    marketLeader: 'Líder de Mercado',
    challenger: 'Desafiante',
    newEntry: 'Nueva Entrada',
    weeks2: '2 semanas',
    weeks4: '4 semanas',
    weeks8: '8 semanas',
    weeks12: '12 semanas',
    spotsPerDay: 'Spots por Día',
    weeklyGRPs: 'GRPs Semanales',
    totalGRPs: 'GRPs Totales',
    estimatedReach: 'Alcance Estimado',
    avgFrequency: 'Frecuencia Media',
    weeklyProgress: 'Progreso Semanal',
    fillAllFields: 'Por favor complete todos los campos',
    calculateFirst: 'Por favor primero haga clic en "Calcular"',
    waitForPDFGen: 'Por favor espere hasta 10 segundos para la generación del PDF...',
    pleaseWait: 'Por favor espere...',
    exportCompleted: '¡Exportación completada!',
    exportError: 'Error al exportar a PDF',
    // Day names
    monday: 'Lunes',
    tuesday: 'Martes',
    wednesday: 'Miércoles',
    thursday: 'Jueves',
    friday: 'Viernes',
    saturday: 'Sábado',
    sunday: 'Domingo',
    scenarioComparison: 'Comparación de Escenarios',
    lessSpots: 'Menos Spots (-30%)',
    currentStrategy: 'Estrategia Actual',
    shorterDuration: 'Duración Más Corta (-2 sem.)',
    lower: 'Menor',
    optimal: 'Óptimo',
    medium: 'Medio',
    scenario: 'Escenario',
    efficiency: 'Eficiencia',
    yourCampaign: 'Tu Campaña',
    calculateCampaign: 'Calcular Campaña',
    freqInsufficient: 'Insuficiente',
    freqVeryLow: 'Muy baja',
    freqIdeal: 'IDEAL - buena awareness',
    freqVeryGood: 'Muy buena - fuerte recuerdo',
    freqHigh: 'Alta - buena pero cuidado con los costos',
    freqTooHigh: 'Demasiado alta - riesgo de "ad fatigue"',
    grpLevels: 'Niveles de GRP (Gross Rating Points)',
    grpVeryLow: 'Muy bajos - cobertura insuficiente',
    grpLow: 'Bajos - impacto mínimo en el mercado',
    grpGood: 'Buenos - awareness inicial, adecuados para mantenimiento',
    grpVeryGood: 'Muy buenos - presencia fuerte, campaña efectiva',
    grpHigh: 'Altos - dominancia de categoría',
    grpVeryHigh: 'Muy altos - cobertura máxima, cuidado con la saturación',
    recommendations: 'Recomendaciones & Mejoras',
    totalSpots: 'Spots Totales',
    criticalLowFreq: 'CRÍTICO: Frecuencia Muy Baja',
    criticalLowFreqMsgDynamic: 'La frecuencia actual ({freq}) es insuficiente. El mensaje no quedará en la memoria del público.',
    recIncreaseSpotsTo: 'Aumento sugerido a {newWeeklySpots} spots/semana ({extraSpots} spots extra) para alcanzar Frecuencia {targetFreq} y {newGRPs} GRPs.',
    warningHighFreq: 'Advertencia: Frecuencia Muy Alta',
    warningHighFreqMsgDynamic: 'La frecuencia ({freq}) es demasiado alta. Riesgo de "ad fatigue" y desperdicio de presupuesto.',
    recReduceSpotsTo: 'Puedes reducir a {newWeeklySpots} spots/semana y ahorrar costos manteniendo Frecuencia en {targetFreq}.',
    suggestionIncrease: 'Sugerencia: Aumentar Efectividad',
    suggestionIncreaseMsgDynamic: 'Tus GRPs ({grps}) están por debajo del nivel ideal (400+). Para mejor rendimiento:',
    recOptionsAB: '• OPCIÓN A: Aumentar duración a {option1_weeks} semanas → ~{option1_newGRPs} GRPs\n• OPCIÓN B: Agregar {option2_spotsIncrease} spots/sem ({option2_newWeeklySpots} total) → ~{option2_newGRPs} GRPs',
    excellentGRPs: 'GRPs Excelentes',
    excellentGRPsMsgDynamic: '¡Tus GRPs ({grps}) son excelentes! Cobertura máxima.',
    recWatchSaturation: 'Cuidado con la saturación del público. Puedes mantener los niveles actuales o reducir ligeramente.',
    optimalCampaign: '¡Campaña Óptima!',
    optimalCampaignMsgDynamic: 'Tus GRPs ({grps}) y Frecuencia ({freq}) están en el rango ideal.',
    recWellDesigned: '¡Tu campaña está bien diseñada y tendrá rendimiento efectivo. Continúa así!',
    strongCampaign: '¡Campaña Muy Fuerte!',
    strongCampaignMsgDynamic: 'Tus GRPs ({grps}) son altos. Dominarás tu categoría.',
    recExcellentStrategy: '¡Estrategia excelente para brand awareness y dominancia de mercado!',
    perfectCampaign: '¡Campaña Perfecta!',
    perfectCampaignMsg: 'Todas tus métricas están en niveles óptimos.',
    recBestBalance: '¡Tu campaña tiene el mejor equilibrio costo-rendimiento!',
    
    // Decision explanations
    decContinue: 'CONTINÚA - ¡Los oyentes lo aman!',
    decMaintain: 'MANTÉN - Los oyentes se quedan sintonizados',
    decMaintainGood: 'MANTÉN - Buena aceptación de los oyentes',
    decReduce: 'REDUCE - Menos reproducciones por semana',
    decRemove: 'ELIMINA - ¡Los oyentes cambian de estación!',
    decTired: '¡Los oyentes están cansados! ¡REDUCE LA FRECUENCIA!',
    decSecondLine: 'SEGUNDA LÍNEA - No seleccionar en horarios prime',
    decLessPerDay: 'MENOS REPRODUCCIONES POR DÍA',
    // Explanation translations for track results
    decContinueAction: 'CONTINÚA',
    decMaintainAction: 'MANTÉN',
    decReduceAction: 'REDUCE',
    decRemoveAction: 'ELIMINA',
    decListenersLoveIt: 'Los oyentes lo aman',
    decListenersStay: 'Los oyentes se quedan sintonizados',
    decGoodAcceptance: 'Buena aceptación de los oyentes',
    decReduceFrequency: 'Reduce la frecuencia',
    decFewerPlaysWeek: 'Menos reproducciones/semana',
    decNoPrimeZones: 'No seleccionar en horarios prime',
    decListenersSwitch: 'Los oyentes cambian de estación',
    decListenersTired: 'Los oyentes están cansados',
    decSleeperDesc: 'Suena poco pero cuando suena, los oyentes lo aman',
    decExcellentPerformance: 'Rendimiento excelente',
    decTopTrack: 'Pista top',
    decVeryGoodPerformance: 'Muy buen rendimiento',
    decKeepIt: 'Mantenlo',
    decStableChoice: 'Elección estable',
    decPlaysTooOften: 'Suena demasiado seguido',
    decLowInterest: 'Bajo interés de los oyentes',
    decHiddenHit: 'Hit oculto',
    decLikedButRare: 'Gustado pero suena poco',
    decIncreasePlaybacks: 'Aumenta las reproducciones',
    decReduceSignificantly: 'Reduce significativamente la frecuencia',
    decContinueStrategy: 'Continúa con la estrategia actual',
    decNewRelease: 'Nuevo lanzamiento',
    decDoesntFitFormat: 'no se ajusta al formato',
    decBetterInOtherFormat: 'Funcionaría mejor en otro formato',
    decIncreaseAction: 'AUMENTA',
    decReduceImmediately: 'REDUCE INMEDIATAMENTE',
    
    // Analysis Summary
    analysisSummary: 'Resumen de Análisis',
    totalRecords: 'Registros Totales',
    uniqueTracks: 'Pistas Únicas',
    period: 'Período',
    daypartDistribution: 'Distribución por Daypart',
    musicFormat: 'Formato Musical',
    analyzingTracks: 'Analizando pistas con formato',
    mediumFileWarning: '~20-30 segundos',
    largeFileWarning: 'archivo grande - puede tomar ~30-60 segundos',
    analysisTimeout: 'El análisis tardó demasiado (>5 minutos). Intenta con un CSV más pequeño.',
    analysisRetrying: 'El análisis necesita más tiempo... Reintentando',
    analysisLargeFileFailed: 'El archivo grande falló después de varios intentos. Intenta dividir el CSV en partes más pequeñas.',
    
    // SongInfo
    songInfoTitle: 'Información de Canciones',
    songInfoDesc: 'Busca información y sugerencias de locución para canciones',
    artistLabel: 'Artista',
    titleLabel: 'Título',
    searchSongInfo: 'Buscar Información',
    searching: 'Buscando...',
    tipLatinChars: 'Usa caracteres latinos para mejores resultados',
    radioAnnouncement: 'Sugerencia de Locución',
    announcementTip: 'Usa este texto como guía para presentar la canción',
    fillArtistTitle: 'Por favor ingresa Artista y Título',
    fillArtistTitleSearch: 'Ingresa Artista y Título para buscar',
    infoFound: '¡Información encontrada!',
    searchError: 'Error de búsqueda. Intenta de nuevo.',
    exampleArtist: 'ej. Ed Sheeran',
    exampleTitle: 'ej. Shape of You',
    
    // DaypartAnalyzer & Gold Analysis
    specialAnalysisForTracks: 'Análisis especial para pistas',
    withAvailableYear: 'con año disponible',
    recommendations: 'Recomendaciones',
    goldHitDesc: 'Top gold - Mantener en rotación',
    goldKeeperDesc: 'Valiosos - Continuar normalmente',
    goldRotateDesc: 'Rendimiento OK - Rotación normal',
    goldRestDesc: 'Cansados - Descanso 1-2 meses',
    goldDropDesc: 'Bajo rendimiento - Reemplazar',
    
    // Playlist Help Modal keys
    helpCsvStructure: 'Estructura del Archivo CSV',
    helpCsvMustContain: 'El archivo CSV debe contener las siguientes columnas:',
    helpColumnExplanation: 'Explicación de Columnas:',
    helpArtistName: 'Nombre del artista (obligatorio)',
    helpTrackTitle: 'Título de la pista (obligatorio)',
    helpFrequency: 'Frecuencia de reproducción (número)',
    helpPerformances: 'Reproducciones totales (número)',
    helpTLH: 'Total Listening Hours (número decimal)',
    helpMissingColumns: '¿Qué pasa si faltan columnas?',
    helpMissingArtistTitle: 'La pista NO será incluida en el análisis',
    helpMissingNumeric: 'Se tratará como 0 (cero)',
    helpAllNumericMissing: 'El puntaje será 0 - la pista aparecerá como "CUT"',
    helpTip: 'Consejo: Para un análisis preciso, asegúrate de que todas las columnas tengan valores. ¡TLH es especialmente importante!',
    helpScoringProcess: 'Proceso de Puntuación (9 Pasos)',
    helpStep1: 'Normalización (0-1) - Convertir valores a escala 0-1',
    helpStep2: 'Pesos Base - TLH 55%, Performances 30%, Frecuencia 15%',
    helpStep3: 'Ajuste de Formato - Pesos según el tipo de radio',
    helpStep4: 'Multiplicador de Época - Bonus para pistas que encajan con el formato',
    helpStep5: 'Bonus Nuevo Lanzamiento - +10% para pistas ≤90 días',
    helpStep6: 'Penalización de Rotación - Reducción por frecuencia excesiva',
    helpStep7: 'Penalización de Rechazo - Reducción si los oyentes cambian',
    helpStep8: 'Penalización de Fatiga - Reducción cuando baja el TLH',
    helpStep9: 'Puntuación Final - Escala 0-100',
    helpDataMeaning: 'Qué significan los datos',
    helpTLHDesc: 'Tiempo total que los oyentes pasan en la pista. TLH alto = ¡muy popular!',
    helpPerformancesDesc: 'Cuántas veces se reprodujo la pista en el programa',
    helpFrequencyDesc: 'Con qué frecuencia se reproduce (veces por día o semana)',
    helpYearDesc: 'Año de lanzamiento (de MusicBrainz/Discogs)',
    helpGenreDesc: 'Género musical (Pop, Rock, Folk, etc.)',
    helpRadioFormats: 'Formatos de Radio & Ajustes',
    helpFormatIntro: 'Cada formato pondera los datos de forma diferente:',
    helpDecisionLabels: 'Etiquetas de Decisión Principal (BASADO EN RANKING)',
    helpDecisionIntro: 'Basado en posición de ranking, no en puntuación absoluta:',
    helpStrictMode: 'Modo ESTRICTO (HOT AC, GHR, Greek Mainstream): 62.5% activos, 37.5% CUT',
    helpRelaxedMode: 'Modo RELAJADO (GOLD, AC): 57% activos, 43% CUT',
    helpPowerLabel: 'Top 2-2.5%',
    helpSecondaryLabel: 'Siguientes 4-5%',
    helpCurrentsLabel: 'Siguientes 8-10%',
    helpSpreadMoreLabel: 'Siguientes 16-17.5%',
    helpSlowDownLabel: 'Siguientes 24-27.5%',
    helpRiskLabel: 'Siguientes 37.5-46%',
    helpCutLabel: 'Restantes (37.5-43%)',
    helpGotIt: '¡Entendido, empecemos!',
    
    // Help Modal - Special Labels
    helpSpecialLabels: 'Etiquetas Especiales',
    helpSpecialLabelsIntro: 'Basado en la relación Frecuencia & TLH:',
    helpSleeperTitle: 'Diamante Oculto',
    helpSleeperCriteria: 'Criterios: Baja frecuencia (<35%) + Alto TLH (≥55%)',
    helpSleeperAction: '¡Suena poco pero cuando suena, los oyentes lo aman! ¡AUMÉNTALO!',
    helpOverplayedTitle: 'Sobrepuesto',
    helpOverplayedCriteria: 'Criterios: Alta frecuencia (≥65%) + Bajo TLH (<45%)',
    helpOverplayedAction: '¡Los oyentes están cansados! ¡REDUCE LA FRECUENCIA!',
    helpCsvFormat: 'Formato de Archivo CSV',
    helpCsvFormatDesc: 'El archivo CSV debe contener estas columnas:',
    helpCsvExample: 'Ejemplo:',
    helpCsvStructureIntro: 'El archivo CSV debe contener las siguientes columnas. Los nombres de las columnas pueden estar en mayúsculas o minúsculas.',
    
    // Compare Stations Page
    compareStationsTitle: 'Comparar Estaciones de Radio',
    compareStationsSubtitle: 'Comparación de rendimiento de estaciones',
    compareStationsDesc: 'Compara cómo se desempeñan dos estaciones de radio con la misma música, según la reacción de la audiencia.',
    selectStation: 'Seleccionar estación',
    noStationsAvailable: 'No hay estaciones disponibles',
    selectTwoStations: 'Selecciona dos estaciones diferentes para iniciar la comparación.',
    compareButton: 'Comparar Estaciones',
    comparing: 'Comparando...',
    noCommonSongs: 'No se encontraron canciones en común entre las dos estaciones.',
    noUniqueSongs: 'No hay canciones únicas.',
    playlistsCompletelyDifferent: 'Las playlists son completamente diferentes.',
    songs: 'canciones',
    plays: 'plays',
    commonSongsPerformance: 'Rendimiento de Canciones en Común',
    playlistDifferentiation: 'Diferenciación de Playlist',
    uniqueTo: 'Único en',
    daypartBreakdown: 'Desglose por Franja Horaria',
    daypartListenerReaction: 'Reacción de oyentes por franja horaria',
    aggregateMetricsNote: 'Las métricas anteriores son agregadas por estación. No hay clasificación ni "ganador".',
    clickForDaypart: 'Haz clic en una canción para ver el desglose por franja horaria',
    stationComparisonDisclaimer: 'Compara estaciones entre sí — no canciones dentro de una estación. No se utilizan etiquetas de clasificación (POWER, GOLD, etc.).',
    noAccessCompare: 'No tienes acceso a la comparación de estaciones',
    whatIsCompareStations: 'Qué es Compare Stations',
    compareStationsDescP1: 'La herramienta Compare Stations te permite comparar cómo se desempeñan dos estaciones de radio con su audiencia durante el mismo período.',
    compareStationsDescP2: 'La comparación se basa en métricas de reacción de oyentes — no solo transmisiones de radio — y utiliza identidades de canciones unificadas para evitar duplicados o resultados inconsistentes.',
    selectStationsAndPeriod: 'Seleccionar Estaciones y Período',
    timePeriod: 'Período',
    contactForAccess: 'Para obtener acceso a la comparación de estaciones, contáctanos.',
    contact: 'Contacto',
    previousWeek: 'Semana Anterior',
    last7Days: 'Últimos 7 Días',
    last14Days: 'Últimos 14 Días',
    last30Days: 'Últimos 30 Días',
    thisMonth: 'Este Mes',
    lastMonth: 'Mes Pasado',
    
    // Radio Chart
    radioChartTitle: 'The People\'s Chart',
    radioChartSubtitle: 'Las canciones que los oyentes escuchan hasta el final',
    noDataFound: 'No se encontraron datos',
    noDataForPeriod: 'No se encontraron datos para este período',
    
    // Songs Analyzer
    songsAnalyzerTitle: 'Songs Analyzer',
    songsAnalyzerSubtitle: 'Análisis detallado de canciones por estación',
    songsAnalyzerMetricsNote: 'Las métricas se basan en la estabilidad del stream y análisis de comportamiento. No se incluyen oyentes simultáneos reales.',
    liveAudienceTooltip: 'Las métricas se basan en oyentes reales del servidor de streaming de la estación.\nEl análisis refleja la reacción real del público a cada canción.',
    noAccessSongsAnalyzer: 'No tienes acceso',
    noDataForPeriodSongs: 'No hay datos para el período seleccionado',
    noDataDayparts: 'No hay datos de franja horaria para el período seleccionado',
    
    // Early Hit Predictor
    ehpNoResults: 'No se encontraron predicciones',
    ehpNoSongsInCategory: 'No hay canciones en la categoría',
    ehpNoEligibleSongs: 'Actualmente ninguna canción cumple los criterios de elegibilidad.',

    // v2.9.203 — Plays vs Behavior Comparison
    pvbWhyDifferent: 'Por qué somos diferentes',
    pvbTitlePartA: 'Conteo Simple de Canciones',
    pvbVs: 'vs',
    pvbTitlePartB: 'Comportamiento de Oyentes',
    pvbDescription: 'El conteo de plays muestra solo lo que se emitió. El análisis del comportamiento de los oyentes revela',
    pvbWhatReallyWorks: 'lo que realmente funciona',
    pvbDescriptionEnd: ', lo que mantiene a la audiencia sintonizada y qué decisiones impulsan mayores audiencias e ingresos.',
    pvbRetentionStat: 'Aumento de la permanencia de oyentes en la frecuencia de hasta',
    pvbTraditionalApproach: 'Enfoque tradicional',
    pvbSimpleSongTrackingPlays: 'Conteo Simple de Canciones (Plays)',
    pvbFullAnalysis: 'Análisis Completo',
    pvbSongAndBehavior: 'Canción + Comportamiento de Oyentes',
    pvbPlays1: 'Cuántas veces se reprodujo una canción',
    pvbPlays2: 'Solo datos de Playlist y Rotación',
    pvbPlays3: 'Sin visión de la respuesta del público',
    pvbPlays4: 'Impacto desconocido en los oyentes',
    pvbPlays5: 'Decisiones basadas en suposiciones',
    pvbPlays6: 'Mide lo que se reprodujo',
    pvbPlays7: 'Registro histórico',
    pvbPlays8: 'Estadísticas de playlist',
    pvbPlays9: 'No muestra por qué sube o baja la audiencia',
    pvbPlays10: 'Aprovechamiento limitado de los datos',
    pvbBehavior1: 'Seguimiento del comportamiento de oyentes en tiempo real',
    pvbBehavior2: 'Engagement del oyente en cada momento',
    pvbBehavior3: 'Medición de Tune-in, Engagement, Tune-out y Retention',
    pvbBehavior4: 'Análisis dentro de tu propio formato, programación y mercado',
    pvbBehavior5: 'Decisiones data-driven basadas en datos reales',
    pvbBehavior6: 'Mide qué gustó y qué funcionó',
    pvbBehavior7: 'Insights en tiempo real',
    pvbBehavior8: 'Estadísticas de audiencia y comportamiento',
    pvbBehavior9: 'Identifica qué afecta a la audiencia',
    pvbBehavior10: 'Aprovechamiento completo de los datos para el crecimiento de la emisora',
    pvbWantToKnowA: '¿Quieres saber',
    pvbWhatReallyLiked: 'qué les gusta realmente',
    pvbWantToKnowB: 'a tus oyentes?',
    pvbContactPromo: 'Contacta con Radio Solutions para una demo de nuestro sistema de análisis del comportamiento de los oyentes.',
    pvbRequestDemo: 'Solicitar Demo',
    pvbTrustedByA: 'Confían en nosotros',
    pvbStations: 'emisoras',

    // v2.9.203 — Songs Analyzer common UI
    saStreamUrlSuggestion: 'Sugerir URL de Stream',
    saSongs: 'Canciones',
    burnWeek: "Semana {{from}} - {{to}} · {{n}} canciones",
    burnPeriodNote: "Última semana completa (lunes-domingo)",
    burnSearch: "Buscar…",
    burnPage: "Página {{p}} / {{n}}",
    burnLoading: "Cargando…",
    burnError: "No se pudieron cargar los datos.",
    burnPending: "El análisis Burn semanal se está preparando. Se actualiza cada lunes después de medianoche.",
    burnEmpty: "No hay datos de la última semana completa.",
    burnNoAudience: "No hay datos fiables de oyentes para esta emisora.",
    burnAudienceWarn: "Pocos spins con medición de oyentes esta semana: resultados orientativos.",
    burnColArtist: "Artista",
    burnColTitle: "Título",
    burnColYear: "Año",
    burnColSpins: "Spins",
    burnCol4w: "4 sem.",
    burnColBurn: "Burn",
    burnColDelta: "Delta",
    burnColTrend: "Tendencia",
    burnColStatus: "Estado",
    burnTapHint: "Toque una etiqueta de estado para ver la explicación.",
    burnStIncreasing: "En aumento",
    burnStStable: "Estable",
    burnStDecreasing: "En descenso",
    burnStHighExposure: "Alta exposición",
    burnTipHighWeeks: "En el nivel más alto de spins de la emisora: {{n}} de las 4 semanas.",
    burnTipStationChoice: "Muestra la elección de la emisora, no la reacción de los oyentes.",
    burnAdvIncreasing: "La emisora la pone cada vez más.",
    burnAdvStable: "La emisora mantiene los mismos spins.",
    burnAdvDecreasing: "La emisora ya está reduciendo sus spins.",
    burnAdvHighExposure: "Muchas semanas en el nivel más alto: riesgo de cansancio. Si hay datos de oyentes, revise Audience.",
    burnAirplayNote: "Airplay: muestra solo la elección de la emisora (spins). No mide oyentes.",
    burnTipWeekSpins: "Esta semana ({{from}}-{{to}}): {{spins}} spins, {{diff}}.",
    burnTipMore: "{{n}} más que la semana pasada",
    burnTipLess: "{{n}} menos que la semana pasada",
    burnTipSame: "igual que la semana pasada",
    burnTipWeekLoss: "Esta semana ({{from}}-{{to}}): cuando suena, se va el {{d}}% de los oyentes.",
    burnTipWeekGain: "Esta semana ({{from}}-{{to}}): cuando suena, los oyentes aumentan un {{d}}%.",
    burnSortHint: "Haga clic en el título de una columna para ordenar.",
    burnLegendAirplay: "Burn 0-100 = presión de rotación: cuántos spins le da la emisora frente a sus más emitidas, cuántas semanas siguió en el nivel más alto y cuánto bajaron los spins desde el pico del mes. No mide la reacción de los oyentes.",
    burnLegendAudience: "Audience: Delta = cambio medio de oyentes mientras suena la canción. Verde/amarillo/rojo = tercio mejor/medio/peor de la emisora. Tendencia = comparación con las 3 semanas anteriores.",
    burnStBurning: "Quemándose",
    burnStTiring: "Cansando",
    burnStRising: "En alza",
    burnStSteady: "Estable",
    burnStLosing: "Pierde oyentes",
    burnStNeutral: "Neutral",
    burnStHolding: "Retiene oyentes",
    burnTipLowSample: "Solo {{n}} de {{total}} spins tuvieron medición de oyentes.",
    burnAdvBurning: "Qué hacer: reduzca sus spins o déjela descansar un tiempo.",
    burnAdvTiring: "Qué hacer: no aumente sus spins, vigílela.",
    burnAdvRising: "Qué hacer: tiene impulso y puede admitir más spins.",
    burnAdvSteady: "Qué hacer: ningún cambio.",
    burnAdvLosing: "Qué hacer: revise su franja horaria o reduzca sus spins.",
    burnAdvNeutral: "Qué hacer: ningún cambio inmediato.",
    burnAdvHolding: "Qué hacer: funciona bien, manténgala.",
    saBroadcasts: 'Emisiones',
    saTabAll: 'Total',
    saTabPrefecture: 'Región',
    saListenerStats: 'Estadísticas de Oyentes',
    saMoreStations: '¿Quieres acceso a más emisoras?',
    saMoreStationsDesc: 'Contáctanos para añadir más emisoras a tu cuenta.',
    saContact: 'Contacto',
    saExcel: 'Excel',
    saMetadataOnly: 'Solo metadatos',
    saYesterdayFull: 'Ayer (✅ Completo)',

    // v2.9.203 — Compare Stations page
    csTitle: 'Comparar Emisoras',
    csSubtitle: 'Comparación de rendimiento de emisoras',
    csWhatIs: 'Qué es Compare Stations',
    csWhatIsP1: 'La herramienta Compare Stations te permite comparar cómo dos emisoras de radio se desempeñan con su audiencia en el mismo período.',
    csWhatIsP2: 'La comparación se basa en métricas de reacción de los oyentes — no solo en emisiones — y utiliza identidades de canción unificadas para evitar duplicados o resultados inconsistentes.',
    csSelectStations: 'Seleccionar Emisoras y Período',
    csModeStation: 'Emisora vs Emisora',
    csModeGroup: 'Grupo vs Grupo',
    csModeCategory: 'Categoría vs Categoría',
    csCategoryA: 'Categoría A',
    csCategoryB: 'Categoría B',
    csTimePeriod: 'Período',
    csSelectCategory: 'Seleccionar Categoría',
    csPeriod7d: '7 días',
    csPeriod14d: '14 días',
    csPeriod30d: '30 días',
    csCompareBtn: 'Comparar Emisoras',
    csSelectTwo: 'Selecciona dos emisoras diferentes para iniciar la comparación.',

    // v2.9.205 — Performance Score Section
    perfLoading: 'Cargando…',
    perfNoData: 'Aún no hay datos suficientes',
    perfNoDataMsg: 'Reúne un poco más de actividad y te diremos cómo vas.',
    perfTierLocal: 'Tu zona',
    perfTierFormat: 'Mismo formato a nivel nacional',
    perfTierNational: 'Promedio nacional',
    perfTierPersonal: 'Progreso personal',
    perfPeriodLabel: 'Periodo:',
    perfPeriodFull: 'Última semana completa',
    perfPeriodTip: 'Para una comparación estable se usa siempre la última semana completada',
    perfPersonalDescA: 'Progreso personal',
    perfPersonalDescB: '— ve tu evolución semana a semana.',
    perfCompareNationalA: 'Comparación con el',
    perfCompareNationalB: 'promedio nacional',
    perfCompareNationalC: 'de todas las emisoras de la plataforma.',
    perfCompareAvgA: 'Comparación con el',
    perfCompareAvgB: 'promedio',
    perfCompareAvgC: 'de',
    perfActivity: 'Con qué frecuencia suenas',
    perfVariety: 'Variedad musical',
    perfYou: 'Tú:',
    perfPerWeek: '/semana',
    perfAvgNational: 'Prom. nac.:',
    perfAvgLocal: 'Prom. zona:',
    perfAvgFormat: 'Prom. formato:',
    perfAvgGeneric: 'Promedio:',
    perfAvgPin: 'prom.',
    perfAvgTooltip: 'Promedio',
    perfAdvice: 'Consejo',
    perfDow: ['Dom','Lun','Mar','Mié','Jue','Vie','Sáb'],

    // v2.9.205 — Daypart Legend
    daypartMetrics: 'Métricas Daypart',
    daypartSubtitle: 'Reacción de Oyentes por Franja Horaria',
    daypartGuide: 'Guía',
    daypartMorning: 'Mañana',
    daypartMidday: 'Mediodía',
    daypartAfternoon: 'Tarde',
    daypartDrive: 'Drive Time',
    daypartEvening: 'Atardecer',
    daypartNight: 'Noche',
    daypartPlays: 'plays',
    daypartSongsCount: 'canciones',
    daypartSearch: 'Buscar canción o artista…',
    daypartColPlays: 'Plays',
    daypartColSongs: 'Canciones',
    daypartColTLH: 'TLH',
    daypartSortHint: 'Clic en los encabezados para ordenar',

    // v2.9.205 — Era Chart
    eraChartTitle: 'Era Chart',
    eraChartSubtitle: 'Distribución por década y año. Haz clic en una barra para filtrar en "Total".',
    eraChartPlays: 'plays',
    eraChartUnique: 'únicas',
    eraChartTogglePlays: 'Plays',
    eraChartToggleVariety: 'Variedad',
    eraChartYears: 'años',
    eraChartYear: 'año',
    eraChartUnknownYear: 'Año desconocido',
    eraChartFooterPlays: 'Indicador: emisiones · Total:',
    eraChartFooterUnique: 'Indicador: canciones únicas · Total:',

    // v2.9.205 — Playlist Chart / Top Artists / Common columns
    colArtist: 'Artista',
    colTitle: 'Título',
    colPlays: 'Plays',
    colAvgListeners: 'Ø Oyent.',
    colTLH: 'TLH',
    colRetention: 'Ret%',
    colEarly: 'Early',
    colLSI: 'LSI',
    colScore: 'Score',
    colAImpact: 'A.Impact',
    colYear: 'Año',
    colRank: 'Rango',
    topArtistsDiffSongs: 'canciones diferentes',
    playlistApply: 'Aplicar',
    playlistPrevWeek: 'Sem. ant.',
    dowShort: ['Lun','Mar','Mié','Jue','Vie','Sáb','Dom'],
    // ─── i18n Batch #3 (v2.10.0+) — Songs Analyzer subcomponents ───
    i18nB3_morning_06_10: 'Mañana 06-10',
    i18nB3_midday_10_15: 'Mediodía 10-15',
    i18nB3_drive_15_19: 'Tarde 15-19',
    i18nB3_night_22_06: 'Noche 22-06',
    i18nB3_all_day: 'Todo el día',
    i18nB3_our_avg: 'Nuestra prom.',
    i18nB3_numbers: 'Números',
    i18nB3_listener_stats: 'Estadísticas de oyentes',
    i18nB3_your_audience: 'Tu audiencia',
    i18nB3_hour: 'Hora',
    i18nB3_listeners: 'oyentes',
    i18nB3_avg_short: 'prom.',
    i18nB3_loyal: 'Fiel',
    i18nB3_passing: 'De paso',
    i18nB3_normal: 'Normal',
    i18nB3_audience_exact: 'Datos exactos del servidor de la estación',
    i18nB3_audience_estimate: 'El servidor no proporciona datos completos — valor estimado',
    i18nB3_audience_unavailable: 'El servidor de tu estación no proporciona esta información todavía.',
    i18nB3_audience_renewal: 'nueva audiencia llega cada hora (estimación)',
    i18nB3_unknown_year: 'Año desconocido',
    i18nB3_expand: 'Expandir',
    i18nB3_collapse: 'Contraer',
    i18nB3_day_mon: 'Lun',
    i18nB3_day_tue: 'Mar',
    i18nB3_day_wed: 'Mié',
    i18nB3_day_thu: 'Jue',
    i18nB3_day_fri: 'Vie',
    i18nB3_day_sat: 'Sáb',
    i18nB3_day_sun: 'Dom',
    i18nB3_next_song: 'Siguiente canción',
    i18nB3_prev_song: 'Canción anterior',
    i18nB3_genre_artistic: 'Artística',
    i18nB3_genre_intl: 'Internacional / Extranjera',
    i18nB3_genre_greek: 'Griega',
    i18nB3_genre_mixed: 'Mixta',
    i18nB3_genre_rock: 'Rock',
    i18nB3_group: 'Grupo',
    i18nB3_group_vs_group: 'Grupo vs Grupo',
    i18nB3_genre: 'Género',
    i18nB3_genre_vs_genre: 'Género vs Género',
    i18nB3_close: 'Cerrar',
    i18nB3_select_station: 'Seleccionar estación',
    i18nB3_stations: 'Estaciones',
    i18nB3_station: 'Estación',
    i18nB3_station_vs_station: 'Estación vs Estación',
    i18nB3_compare: 'Comparar',
    i18nB3_not_run_yet: 'Aún no ejecutado',
    i18nB3_start_year_search: 'Iniciar búsqueda de años',
    i18nB3_just_now: 'Ahora mismo',
    i18nB3_never: 'Nunca',
    i18nB3_running: 'En ejecución...',
    i18nB3_now: '¡Ahora!',
    i18nB3_your_performance: 'Tu rendimiento',
    i18nB3_export_timeline_excel: 'Exportar timeline a Excel (.xlsx)',
    i18nB3_confirmed_fp: 'Confirmado por audio fingerprint',
    i18nB3_hide_gaps_hint: 'Oculta pequeños huecos por duration mismatches/crossfades. Predeterminado 5min.',
    i18nB3_async_analysis_in_progress: 'Análisis asíncrono en curso...',
    i18nB3_upload_csv_first: 'Por favor sube primero un archivo CSV',
    i18nB3_connection_error_retry: 'Error de conexión. Por favor inténtalo de nuevo.',
    i18nB3_too_many_requests: 'Demasiadas solicitudes, reintentando en 3s...',
    // ── Clock View (Programming Clocks) — added 2026-06-15
    clkView_listView: 'Lista',
    clkView_clockView: 'Reloj',
    clkView_hourFrom: 'Desde',
    clkView_hourTo: 'Hasta',
    clkView_exportPdf: 'Exportar PDF',
    clkView_exportingPdf: 'Generando PDF…',
    clkView_loadingClocks: 'Cargando relojes…',
    clkView_noActiveHours: 'No hay horas de programación activas para esta fecha.',
    clkView_emptyHour: 'Sin contenido para esta hora.',
    clkView_songs: 'canciones',
    clkView_breaks: 'cortes',
    clkView_song: 'Canción',
    clkView_break: 'Corte / Pausa',
    clkView_listenersStart: 'Inicio',
    clkView_listenersEnd: 'Fin',
    clkView_listenersPeak: 'Pico',
    clkView_listenersAvg: 'Promedio',
    clkView_retention: 'Retención',
    clkView_earlyDrop: 'Abandono temprano',
    clkView_lsi: 'Índice de oyentes',
    clkView_score: 'Puntuación',
    clkView_severitySevereLoss: 'Pérdida severa',
    clkView_severitySignificantLoss: 'Pérdida significativa',
    clkView_severityMinorLoss: 'Pérdida menor',
    clkView_severityStable: 'Estable',
    clkView_severityMinorGain: 'Ganancia menor',
    clkView_severityStrongGain: 'Ganancia fuerte',
    clkView_severityUnknown: 'Desconocido',
    clkView_netHour: 'Saldo de hora',
    clkView_categoryPower: 'POWER',
    clkView_categorySecondary: 'SECONDARY',
    clkView_categoryCurrents: 'CURRENTS',
    clkView_categoryRecurrents: 'RECURRENTS',
    clkView_categoryGold: 'GOLD',
    clkView_categorySlowDown: 'SLOW DOWN',
    clkView_categoryCut: 'CUT',
    clkView_legendTitle: 'Leyenda',
    clkView_legendSongCategories: 'Categorías de canciones',
    clkView_legendBreakSeverity: 'Gravedad de pausa',
    clkView_legendBreaksSingle: 'Pausas',
    clkView_listenersUnit: 'oyentes',
    clkView_clickToSee: 'Haz clic en una porción del reloj para ver detalles',
    clkView_sparklineTitle: 'Oyentes por 5 min',
    clkView_min: 'mín',
    clkView_max: 'máx',
    clkView_thisHourLabel: 'Esta hora',
    clkView_legendSongs: 'Canciones',
    clkView_song: 'Música',
    clkView_legendHelp: 'Haz clic en cualquier porción para ver detalles',
    clkView_talk: 'Habla',
    clkView_talks: 'hablas',
    clkView_breakHint: '1-4 min @ slot :25 :30 :55 :00',
    clkView_talkHint: 'cualquier otro',
    clkView_noData: 'sin datos',
    clkView_noDataHint: 'contenido no musical — en investigación',
    // ─── Classifier Shadow Report (v2.13.0) ───
    clfReport_title: 'Informe Classifier (Sombra)',
    clfReport_subtitle: 'Validación de inaSpeechSegmenter contra intentos reales de Shazam',
    clfReport_gateMode: 'Modo',
    clfReport_classifierReady: 'classifier listo',
    clfReport_classifierUnavail: 'classifier no disponible',
    clfReport_refresh: 'Actualizar',
    clfReport_downloadCsv: 'Descargar CSV',
    clfReport_musicPct: 'Música %',
    clfReport_speechPct: 'Habla %',
    clfReport_speechMusicPct: 'Habla + Música %',
    clfReport_noisePct: 'Ruido %',
    clfReport_potentialReduction: 'Reducción potencial Fingerprint',
    clfReport_potentialReduction_hint: 'Cuántas llamadas Shazam ahorraríamos si activáramos el gating.',
    clfReport_potentialLost: 'HITs potencialmente perdidos',
    clfReport_potentialLost_hint: 'De canciones reconocidas, cuántas perderíamos. < 5 % = seguro.',
    clfReport_crossTableTitle: 'Tabla cruzada: Clasificación × Shazam',
    clfReport_totalSamples: 'Total',
    clfReport_evaluable: 'Evaluables',
    clfReport_classification: 'Clasificación',
    clfReport_hitRate: 'Hit Rate',
    clfReport_crossTableHint: 'En filas habla / ruido: los HIT son falsos positivos — canciones que habríamos perdido con gating activo.',
    clfReport_perStationTitle: 'Desglose por estación',
    clfReport_station: 'Estación',
    clfReport_noStationData: 'Aún no hay datos.',
    clfReport_noSamplesTitle: 'Aún no hay muestras',
    clfReport_noSamplesHint: 'El classifier corre en modo sombra. Vuelve en 48 horas para estadísticas fiables.',
    clfReport_window: 'Ventana',
    clkView_today: 'Hoy',
    clkView_yesterday: 'Ayer',
    clkView_durationLabel: 'Duración',
    clkView_listenerDeltaLabel: 'Cambio de oyentes',
    clkView_atTime: 'a las',
    clkView_pdfReady: 'PDF listo.',
    clkView_pdfError: 'No se pudo generar el PDF.',
    clkView_dataRetentionHint: 'Los datos de los relojes se conservan 2 años.',
    // Executive Summary
    execSum_title: 'Resumen del Día',
    execSum_worstBreaks: 'Peores Pausas',
    execSum_worstBreaks_subtitle: 'Las 3 pausas con la mayor pérdida de oyentes',
    execSum_heroSongs: 'Canciones Ganadoras',
    execSum_heroSongs_subtitle: 'Las 3 canciones que más hicieron crecer el público',
    execSum_villainSongs: 'Peores Caídas de Audiencia',
    execSum_villainSongs_subtitle: 'Las 3 canciones que ahuyentaron más oyentes',
    execSum_bestBreaks: 'Mejores Pausas',
    execSum_bestBreaks_subtitle: 'Las 3 pausas que retuvieron o aumentaron el público',
    execSum_noData: 'Sin datos disponibles',
    execSum_breakLabel: 'Pausa',
  },
};

export const getTranslation = (lang, key) => {
  // Fallback to English (not Greek) for international users
  return translations[lang]?.[key] || translations['en']?.[key] || key;
};

export default translations;
